<template>
  <span v-resize="checkMobile">
    <!-- <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading> -->
    <v-card>
      <!-- Заменяем старый заголовок на новый компонент -->
      <BookingHeader v-if="cardSections" :booking="booking" :isMobile="isMobile" :isLoading="isLoading"
        :initial-section="cardSections.leads" :initial-entity-id="cardSectionsEntityId"
        :isLoadingSaveState="isLoadingSaveState" :connected="connected" :bookings_states="bookingStatesForCard"
        @go-back="goBack" @get-history="getBookingHistory" @save-state="saveBookingState"
        @add-task="taskDialog = true"
        @download-icalendar="downloadIcalendar" />
      <v-divider class="mt-2"></v-divider>
      <!-- FT-193 REQ-06/07 (CTR-05): остановленное автопродление — блок-предупреждение на всю ширину шапки, под заголовком
           и над колонками; причина и действия (manager+). Строка «Автопродление: статус» в левой колонке остаётся. -->
      <v-alert v-if="booking.id && periodicRenewalIsStopped" dense border="left" colored-border type="warning"
        icon="mdi-alert-outline" elevation="1" class="periodic-renewal-alert mx-3 mt-3 mb-0"
        data-testid="periodic-renewal-alert">
        <div class="d-flex flex-wrap align-center" style="gap: 8px 16px;">
          <div class="flex-grow-1" style="flex-basis: 320px; min-width: 0;">
            <div class="warning--text font-weight-medium">{{ $t("bookings.periodic_renewal.stopped_title") }}</div>
            <div data-testid="periodic-renewal-alert-reason">{{ periodicBlockReasonText }}</div>
          </div>
          <div v-if="canResumePeriodicRenewal || canRetryPeriodicTopup" class="d-flex flex-wrap justify-end ml-auto"
            style="gap: 8px;">
            <v-btn v-if="canResumePeriodicRenewal" x-small outlined color="primary"
              :loading="isLoadingPeriodicAction" @click="resumePeriodicRenewal()" data-testid="periodic-resume">
              {{ $t("bookings.periodic_renewal.resume") }}
            </v-btn>
            <v-btn v-if="canRetryPeriodicTopup" x-small outlined color="primary"
              :loading="isLoadingPeriodicAction" @click="retryPeriodicTopup()" data-testid="periodic-retry-topup">
              <v-icon x-small left>mdi-refresh</v-icon>
              {{ $t("bookings.periodic_renewal.retry_topup") }}
            </v-btn>
          </div>
        </div>
      </v-alert>
      <deposit-hold-block v-if="booking.id && booking.deposit_hold" :booking-id="booking.id"
        :hold="booking.deposit_hold" :currency="currency" @updated="onDepositHoldUpdated" />
      <!-- Начальная загрузка не удалась (обычно обрыв мобильной сети) — вместо
           пустой карточки даём повторить запрос без перезагрузки страницы -->
      <load-failed-retry v-if="loadFailed && !booking.id && !isLoading" @retry="loadCardData()" />
      <!-- FT-076: задачи по брони — секция видна только если есть задачи (иначе скрыта,
           создание из иконки в шапке). Паддинг внутри v-show, пустого места нет. -->
      <v-card-text v-if="booking.id && cardSections" class="pt-2 pb-0" :style="isMobile ? 'padding: 5px !important;' : ''">
        <task-card-section class="mx-3" taskable-type="Booking" :taskable-id="booking.id"
          :initial-section="cardSections.tasks" :initial-users-section="cardSections.task_users"
          :initial-entity-id="cardSectionsEntityId" />
      </v-card-text>
      <task-form-dialog v-model="taskDialog" taskable-type="Booking" :taskable-id="booking.id" @saved="onTaskSaved" />
      <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
        <!-- <v-container grid-list-md>
          <v-layout row wrap> -->
        <v-flex md12 :class="isMobile ? 'mx-3' : 'd-flex mx-3'">
          <!-- Keep hydrated children alive during same-id reloads; loading still hides the column. -->
          <v-flex v-if="!isLoading || cardSections" v-show="!isLoading" xs12 md4 class="start-tour-booking-2">
            <v-alert v-if="show_audited_price_alert" dense outlined prominent type="warning" class="mt-3">
              {{ $t("bookings.audited_price_alert") }}
              <v-flex class="text-right py-2">
                <v-btn @click="applyCurrentPrices()" outlined x-small color="secondary">
                  {{ $t('bookings.apply_current_prices') }}
                </v-btn>
              </v-flex>
            </v-alert>
            <v-alert v-if="this.booking && this.booking.apply_current_prices && !show_audited_price_alert" dense
              outlined prominent type="warning" class="mt-3">
              {{ $t("bookings.audited_price_alert_on_creating_prices") }}
              <v-flex class="text-right py-2">
                <v-btn @click="applyCurrentPrices()" outlined x-small color="secondary">
                  {{ $t('bookings.apply_on_creating_prices') }}
                </v-btn>
              </v-flex>
            </v-alert>
            <v-alert v-if="showManualEditingAlert" dense outlined prominent type="warning" class="mt-3"
              v-tooltip="{
                content: $t('tooltips.manual_editing'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
              {{ $t("bookings.manual_editing") }}
            </v-alert>
            <v-alert v-if="booking && booking.agent_id && !isAgent" dense outlined prominent type="warning"
              class="mt-3">
              {{ $t("agents.created_agents") }}
            </v-alert>
            <div v-if="booking.serial_number">
              {{ $t("bookings.serial_number") }}: {{ booking.serial_number }}
            </div>
            <div v-if="booking.source" v-tooltip="{
              content: $t('tooltips.booking_source'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }">
              {{ $t("custom.created") }}:
              {{ formatCreatedAt(booking.created_at) }} |
              <span v-if="!booking.user_id">{{ booking.source ? booking.source : "?" }}</span>
              <span v-else>{{ findWorker(booking.user_id) }}</span>
            </div>
            <div v-if="booking.vseprokaty_id">
              {{ $t("agregator.agregator_id") }}: {{ booking.vseprokaty_id }}
            </div>
            <div v-if="booking.localrent_id">
              Localrent ID: {{ booking.localrent_id }}
            </div>
            <div v-if="booking.fast_booking">
              {{ $t("agregator.fast_booking") }}: +
            </div>
            <div v-if="booking.vseprokaty_id && !booking.fast_booking">
              {{ $t("agregator.fast_booking") }}: -
            </div>
            <div v-if="booking.agent_id">
              {{ $t("agents.agent") }} {{ $t("custom.number") }}
              <router-link :to="{ path: `/agent_card/${booking.agent_id}` }">
                {{ booking.agent_id }}
              </router-link>
            </div>
            <div v-if="booking.updater" v-tooltip="{
              content: $t('tooltips.last_updator'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }">
              {{ $t("custom.updator") }}:
              {{ formatCreatedAt(booking.updated_at) }} |
              {{ findWorker(booking.updater) }}
            </div>
            <div v-if="booking.state_updater" v-tooltip="{
              content: $t('tooltips.last_status'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }">
              {{ $t("bookings.give_status") }}:
              {{ findWorker(booking.state_updater) }}
            </div>
            <div v-if="booking.start_worker_id" v-tooltip="{
              content: $t('tooltips.checkiner'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }">
              {{ $t("bookings.checkiner") }}:
              {{ findWorker(booking.start_worker_id) }}
            </div>
            <div v-if="booking.end_worker_id" v-tooltip="{
              content: $t('tooltips.checkouter'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }">
              {{ $t("bookings.checkouter") }}:
              {{ findWorker(booking.end_worker_id) }}
            </div>
            <v-divider class="my-2"></v-divider>
            <div v-if="!booking.entity && booking.client" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("custom.client") }}:
              <router-link :to="{ path: `/clients/${booking.client_id}` }">{{ clientFullName(booking.client) }}</router-link>
                <v-icon small v-if="booking.client.problems" color="error" :title="$t('clients.bad_warn')" class="ml-2">mdi-alert-circle</v-icon>
                <v-icon small :title="$t('clients.link_to_client_page')" :aria-label="$t('clients.link_to_client_page')" :aria-describedby="clientPageLinkBlocked ? 'client-page-link-reason' : null" :disabled="clientPageLinkLoading || clientPageLinkBlocked" class="ml-2" :style="clientPageLinkBlocked ? '' : 'cursor: pointer;'" @click="copyClientPageLink">mdi-link-variant</v-icon>
                <!-- FT-200 REQ-07: причина видимым текстом рядом — её видно без наведения и читает скринридер. -->
                <div v-if="clientPageLinkBlocked" id="client-page-link-reason" class="text-caption text--secondary">{{ $t('client_page.staff_link.no_last_name') }}. {{ $t('client_page.staff_link.no_last_name_hint') }}</div>
            </div>
            <div v-else :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("custom.client") }}:
              <router-link :to="{ path: `/clients/${booking.client_id}` }">{{ booking.entity_name }}</router-link>
            </div>
            <div v-if="!booking.entity && booking.client && booking.client.phone" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("custom.phone") }}:
              <a :href="telHref(booking.client.phone)">
                {{ formatPhone(booking.client.phone) }}
              </a>
              <v-icon small v-if="booking.client.phone" :title="$t('clients.whatsapp_link')" class="ml-2" style="cursor: pointer;" @click="goToWhatsapp(booking.client)">mdi-whatsapp</v-icon>
            </div>
            <div v-else :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("custom.phone") }}:
              <a v-if="set_client.entity_phone" :href="telHref(set_client.entity_phone)">
                {{ formatPhone(set_client.entity_phone) }}
              </a>
              <span v-else> - </span>
            </div>
            <div v-if="set_client.balance && (set_client.balance > 0 || set_client.balance < 0)" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("other.balance") }}:
              <span v-if="set_client.balance >= 0">{{ safeParseFloat(set_client.balance) }}</span>
              <span v-else>⚠️&nbsp;{{ safeParseFloat(set_client.balance) }}</span>
            </div>
            <div v-if="isTaxiMode && booking.taxi_payment_model" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("taxi.payment_models.payment_model") }}: {{ showTaxiPaymentModel(booking.taxi_payment_model) }}
            </div>
            <div v-if="isTaxiMode && booking.commission_percent" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ $t("taxi.payment_models.commission_percent") }}: {{ booking.commission_percent }}
            </div>
            <v-divider class="my-2"></v-divider>
            <div>
              {{ $t("custom.car_long", { msg: object_name_for_label }) }}:
              <router-link :to="{ path: `/cars/${booking.car_id}` }">
                {{ booking.car_name }} - {{ booking.car_code }}
              </router-link>
            </div>
            <div>{{ $t("bookings.start_date") }}: {{ booking.start_date }}</div>
            <div>{{ $t("bookings.end_date") }}: {{ booking.end_date }}</div>
            <div v-if="!booking.hourly && !booking.weekly && !booking.monthly">{{ $t("custom.days") }}: {{ booking.days
            }}</div>
            <div v-if="booking.hourly">{{ $t("custom.hours") }}: {{ booking.hourly_hours }}</div>
            <div v-if="booking.weekly">{{ $t("custom.weeks") }}: {{ booking.weekly_weeks }}</div>
            <div v-if="booking.monthly">{{ $t("custom.months") }}: {{ booking.monthly_months }}</div>
            <div v-if="booking.additional_hours > 0">
              {{ $t("bookings.add_hours") }}: {{ booking.additional_hours }}
            </div>
            <div v-if="booking.payments_type == 'periodic'">
              {{ $t("bookings.booking_payments_period") }}:
              <span v-if="booking.payments_period == 'daily'">
                {{ $t("bookings.payments_period_daily") }}
              </span>
              <span v-if="booking.payments_period == 'weekly'">
                {{ $t("bookings.payments_period_weekly") }}
              </span>
              <span v-if="booking.payments_period == 'monthly'">
                {{ $t("bookings.payments_period_monthly") }}
              </span>
            </div>
            <div v-if="booking.payments_type == 'periodic' && booking.last_balanced_at">
              {{ $t("bookings.last_auto_prolong") }}: {{ formatCreatedAt(booking.last_balanced_at) }}
            </div>
            <!-- FT-193 REQ-06 (CTR-02): состояние автопродления — только для чтения, считает сервер -->
            <div v-if="booking.payments_type == 'periodic' && booking.periodic_renewal_state"
              data-testid="periodic-renewal-state">
              {{ $t("bookings.periodic_renewal.label") }}:
              <v-chip x-small label :color="periodicRenewalStateColor" class="ml-1">{{ periodicRenewalStateLabel }}</v-chip>
            </div>
            <div v-if="booking.payments_type == 'periodic' && periodicFundingLabel" data-testid="periodic-funding-source">
              {{ $t("bookings.periodic_funding") }}: {{ periodicFundingLabel }}
            </div>
            <div>
              {{ $t("bookings.checkin") }}: {{ booking.location_start }}
            </div>
            <div>{{ $t("bookings.checkout") }}: {{ booking.location_end }}</div>
            <div v-if="!booking.technical">
              {{ $t("bookings.current_price") }}: {{ safeParseFloat(booking.selected_price) }}
            </div>
            <div v-if="!booking.technical && booking.sale_cash">
              {{ $t("bookings.sale") }}: {{ booking.sale_cash }}
            </div>
            <div v-if="!booking.technical && booking.sale">
              {{ $t("bookings.sale") }}: {{ booking.sale }}%
            </div>
            <div v-if="!booking.technical && booking.rental_cost_sale">
              {{ $t("bookings.rental_cost_sale") }}: {{ booking.rental_cost_sale }}%
            </div>
            <div v-if="!booking.technical && booking.rental_cost_sale_cash">
              {{ $t("bookings.rental_cost_sale") }}: {{ booking.rental_cost_sale_cash }}
            </div>
            <div v-if="booking.tariff_id">
              {{ $t("bookings.tariff") }}: {{ findTariff(booking.tariff_id) }}
            </div>
            <div v-if="booking.selected_price != booking.start_price &&
              booking.start_price != 0
            ">
              {{ $t("bookings.start_price") }}: {{ safeParseFloat(booking.start_price) }}
            </div>
            <v-divider v-if="booking.chair ||
              booking.chair_less_1_year ||
              booking.booster ||
              booking.navigator ||
              booking.mp3 ||
              booking.charger ||
              booking.wifi_router
            " class="mt-2 mb-2"></v-divider>
            <h3 v-if="booking.chair ||
              booking.chair_less_1_year ||
              booking.booster ||
              booking.navigator ||
              booking.mp3 ||
              booking.charger ||
              booking.wifi_router
            ">
              {{ $t("bookings.add_equipment") }}
            </h3>
            <div v-if="booking.chair">
              {{ $t("bookings.baby_chair") }} - {{ booking.chairs_quantity }}
            </div>
            <div v-if="booking.chair_less_1_year">
              {{ $t("bookings.small_baby_chair") }} -
              {{ booking.chairs_quantity }}
            </div>
            <div v-if="booking.booster">
              {{ $t("bookings.booster") }} - {{ booking.boosters_quantity }}
            </div>
            <div v-if="booking.navigator">{{ $t("bookings.navigator") }}</div>
            <div v-if="booking.mp3">{{ $t("bookings.mp3") }}</div>
            <div v-if="booking.charger">{{ $t("bookings.charger") }}</div>
            <div v-if="booking.wifi_router">{{ $t("bookings.wifi") }}</div>
            <div v-if="booking.other_equipment">
              {{ booking.other_equipment }}
            </div>
            <!-- FT-183: страховки скрыты для типа техники компании -->
            <template v-if="showInsurance">
              <h3 v-if="booking.kasko ||
                booking.super_kasko ||
                booking.theft ||
                booking.no_franchise
              ">
                {{ $t("bookings.add_insurance") }}
              </h3>
              <div v-if="booking.kasko">{{ $t("bookings.kasko") }}</div>
              <div v-if="booking.super_kasko">
                {{ $t("bookings.super_kasko") }}
              </div>
              <div v-if="booking.theft">
                {{ $t("bookings.theft_insurance") }}
              </div>
              <div v-if="booking.no_franchise">
                {{ $t("bookings.no_franchise") }}
              </div>
            </template>
            <v-divider class="mt-2 mb-2"></v-divider>
            <!-- <h3 v-if="!booking.technical">{{ $t("bookings.calculate") }}</h3> -->
            <!-- FT-173 STEP-22 (F13, REQ-12): «За аренду» — часть блока цены,
                 которую занимает панель договора выкупа (booking.rental_cost
                 у договорного бронирования не отражает реальную стоимость —
                 её ведёт контракт). -->
            <div v-if="!booking.technical && booking.aggr_commission == 0 && !showRentToOwnPanel" class="font-weight-bold">
              {{ $t("bookings.rental_cost") }}: {{ safeParseFloat(booking.rental_cost) }}
            </div>
            <div v-if="!booking.technical && booking.aggr_commission > 0 && !showRentToOwnPanel" class="font-weight-bold">
              {{ $t("bookings.rental_cost") }}: {{ booking.rental_cost
              }} - {{ booking.aggr_commission }} = {{ (booking.rental_cost - booking.aggr_commission) }}
            </div>
            <div class="font-weight-bold" v-if="booking.hours_cost > 0 && !booking.technical">
              {{ $t("bookings.hours_cost") }}: {{ safeParseFloat(booking.hours_cost) }}
            </div>
            <div class="font-weight-bold" v-if="booking.hours_cost_end > 0 && !booking.technical">
              {{ $t("bookings.hours_cost_end") }}: {{ safeParseFloat(booking.hours_cost_end) }}
            </div>
            <div class="font-weight-bold" v-if="booking.delivery > 0 && !booking.technical">
              {{ $t("bookings.delivery") }}: {{ safeParseFloat(booking.delivery) }}
            </div>
            <div class="font-weight-bold" v-if="booking.delivery_end > 0 && !booking.technical">
              {{ $t("bookings.checkout") }}: {{ safeParseFloat(booking.delivery_end) }}
            </div>
            <!-- UAT 2026-08-07: рядом с каталожными допами FT-102 легаси-сумма
                 называется «Другое оборудование» — иначе две одинаковые строки -->
            <div class="font-weight-bold" v-if="booking.equipment > 0 && !booking.technical">
              {{ $t("bookings.other_equipment") }}: {{ safeParseFloat(booking.equipment) }}
            </div>
            <!-- FT-102: каталожное оборудование — сумма + детальный список строк -->
            <div class="font-weight-bold" v-if="booking.addons_cost > 0 && !booking.technical">
              {{ $t("booking_addons.title") }}: {{ safeParseFloat(booking.addons_cost) }}
              <div v-for="line in ft102Lines" :key="'ft102l' + line.id"
                class="font-weight-regular grey--text" style="padding-left: 12px">
                {{ line.name }} × {{ line.quantity }} = {{ safeParseFloat(line.total) }}
                <span v-if="line.deposit > 0">· {{ $t("booking_addons.deposit_short") }} {{ safeParseFloat(line.deposit * line.quantity) }}</span>
              </div>
            </div>
            <div class="font-weight-bold" v-if="booking.clean_payment > 0 && !booking.technical">
              {{ $t("bookings.clean") }}: {{ safeParseFloat(booking.clean_payment) }}
            </div>
            <div class="font-weight-bold" v-if="booking.damage > 0 && !booking.technical">
              {{ $t("bookings.damages") }}: {{ safeParseFloat(booking.damage) }}
            </div>
            <div class="font-weight-bold" v-if="booking.gas > 0">
              {{ $t("bookings.for_gas") }}: {{ safeParseFloat(booking.gas) }}
            </div>
            <div class="font-weight-bold" v-if="booking.add_drivers_cost > 0">
              {{ $t("bookings.for_add_drivers") }}: {{ safeParseFloat(booking.add_drivers_cost) }}
            </div>
            <div class="font-weight-bold" v-if="booking.insurance > 0">
              {{ $t("bookings.for_add_insurance") }}: {{ safeParseFloat(booking.insurance) }}
            </div>
            <div class="font-weight-bold" v-if="booking.fine > 0">
              {{ $t("bookings.for_fines") }}: {{ safeParseFloat(booking.fine) }}
            </div>
            <div class="font-weight-bold" v-if="booking.other > 0">
              {{ $t("bookings.for_other") }}: {{ safeParseFloat(booking.other) }}
            </div>
            <div class="font-weight-bold" v-if="booking.other_end > 0">
              {{ $t("bookings.for_other_end") }}: {{ safeParseFloat(booking.other_end) }}
            </div>
            <div class="font-weight-bold" v-if="booking.mileage_cost > 0">
              {{ $t("bookings.mileage_cost") }}: {{ safeParseFloat(booking.mileage_cost) }}
            </div>
            <div class="font-weight-bold" v-if="booking.aggr_commission > 0">
              <!-- <v-icon>mdi-alpha-a-circle-outline</v-icon> -->
              {{ $t("bookings.aggr_commission") }}: {{ safeParseFloat(booking.aggr_commission) }}
            </div>
            <!-- FT-173 STEP-15 (REQ-12): блок цены и статуса оплаты — только у
                 обычного бронирования. У договорного (booking.rent_to_own)
                 его место занимает панель договора выкупа. -->
            <template v-if="!showRentToOwnPanel">
              <div class="font-weight-bold" v-if="!booking.technical">
                {{ $t("bookings.deposit") }}: {{ safeParseFloat(currentDeposit()) }}
              </div>
              <div class="subtitle-1 font-weight-bold" v-if="!booking.technical">
                {{ $t("custom.total") }}:
                {{ safeParseFloat(bookingTotalPreview) }}
              </div>
              <v-divider class="mt-2 mb-2"></v-divider>
              <div :class="'subtitle-1 font-weight-bold ' +
                `${calculatePayments(booking) == $t('bookings.paid')
                  ? 'success--text'
                  : ''
                }`
                " v-if="!booking.technical">
                {{ $t("bookings.paid") }}: {{ safeParseFloat(calculatePaymentsSum(booking)) }}
              </div>
            </template>
            <template v-else>
              <rent-to-own-panel
                v-if="cardSections"
                ref="rentToOwnPanel"
                :booking="booking"
                :initial-section="cardSections.rent_to_own_contracts"
                :initial-entity-id="cardSectionsEntityId"
                @accept-payment="paymentStart"
                @contract-loaded="onRentToOwnContractLoaded"
              ></rent-to-own-panel>
            </template>
            <v-divider v-if="calculateRentPaymentsSum(booking) > 0 &&
              booking.rental_cost > 0 &&
              booking.days > 0
            " class="mt-2 mb-2"></v-divider>
            <v-progress-linear v-if="calculateRentPaymentsSum(booking) > 0 &&
              booking.rental_cost > 0 &&
              booking.days > 0 && !booking.technical && !booking.hourly && !booking.weekly && !booking.monthly
            " :value="progressPercent" :color="progressPercent == 100 ? 'success' : 'warning'" rounded height="20">
              <strong class="white--text">{{ paidDays }} {{ $t("other.from") }} {{ booking.days }} {{
                $tc("bookings.days_plural", booking.days) }}</strong>
            </v-progress-linear>
            <v-progress-linear v-if="calculateRentPaymentsSum(booking) > 0 &&
              booking.rental_cost > 0 &&
              booking.hourly_hours > 0 && !booking.technical && booking.hourly
            " :value="progressPercent" :color="progressPercent == 100 ? 'success' : 'warning'" rounded height="20">
              <strong class="white--text">{{ paidHours }} {{ $t("other.from") }} {{ booking.hourly_hours }}
                {{ $tc("bookings.hours_plural", booking.hourly_hours) }}</strong>
            </v-progress-linear>
            <v-progress-linear v-if="calculateRentPaymentsSum(booking) > 0 &&
              booking.rental_cost > 0 &&
              booking.weekly_weeks > 0 && !booking.technical && booking.weekly
            " :value="progressPercent" :color="progressPercent == 100 ? 'success' : 'warning'" rounded height="20">
              <strong class="white--text">{{ paidWeeks }} {{ $t("other.from") }} {{ booking.weekly_weeks }}
                {{ $tc("bookings.weeks_plural", booking.weekly_weeks) }}</strong>
            </v-progress-linear>
            <v-progress-linear v-if="calculateRentPaymentsSum(booking) > 0 &&
              booking.rental_cost > 0 &&
              booking.monthly_months > 0 && !booking.technical && booking.monthly
            " :value="progressPercent" :color="progressPercent == 100 ? 'success' : 'warning'" rounded height="20">
              <strong class="white--text">{{ paidMonths }} {{ $t("other.from") }} {{ booking.monthly_months }}
                {{ $tc("bookings.months_plural", booking.monthly_months) }}</strong>
            </v-progress-linear>
            <v-divider class="mt-2 mb-2"></v-divider>
            <div v-if="(booking.description &&
              booking.description != '' &&
              booking.description != ' ') || booking.failure_reason
            ">
              <h3>{{ $t("bookings.description") }}</h3>
              <p v-if="booking.description">{{ booking.description }}</p>
              <p v-if="booking.failure_reason">{{ booking.failure_reason }}</p>
            </div>
            <div v-if="add_drivers && add_drivers.length > 0">
              <h3>{{ $t("bookings.add_drivers") }}</h3>
              <ul v-for="driver in add_drivers" :key="driver.id">
                <li>
                  <router-link :to="{ path: `/clients/${driver.id}` }">{{ clientFullName(driver) }}</router-link>
                </li>
              </ul>
            </div>
            <div v-if="booking.in_rent || booking.ride">
              {{ $t("bookings.clean_start") }}:
              <v-icon color="green" v-if="booking.clean_start">
                mdi-plus
              </v-icon>
              <v-icon color="red" v-else> mdi-minus </v-icon>
            </div>
            <div v-if="booking.ride">
              {{ $t("bookings.clean_end") }}:
              <v-icon color="green" v-if="booking.clean_end"> mdi-plus </v-icon>
              <v-icon color="red" v-else> mdi-minus </v-icon>
            </div>
            <!-- FT-183: топливо скрыто для типа техники компании -->
            <template v-if="showFuel">
              <div v-if="(booking.in_rent || booking.ride) && !booking.gas_start_full
              ">
                {{ $t("bookings.gas_start") }}: {{ booking.gas_start }}
              </div>
              <div v-if="(booking.in_rent || booking.ride) && booking.gas_start_full">
                {{ $t("bookings.gas_start_full") }}
              </div>
              <div v-if="!booking.gas_end_full && booking.ride">
                {{ $t("bookings.gas_end_short") }}: {{ booking.gas_end }}
              </div>
              <div v-if="booking.gas_end_full && booking.ride">
                {{ $t("bookings.gas_end_full") }}
              </div>
            </template>
            <!-- FT-183: пробег скрыт для типа техники компании -->
            <template v-if="showMileage">
              <div v-if="(booking.in_rent || booking.ride) && booking.start_mileage > 0
              ">
                {{ $t("bookings.mileage_start") }}: {{ booking.start_mileage }}
                {{ $t("custom.km") }}
              </div>
              <div v-if="booking.end_mileage > 0">
                {{ $t("bookings.mileage_end") }}: {{ booking.end_mileage }}
                {{ $t("custom.km") }}
              </div>
              <div v-if="booking.booking_mileage > 0">
                {{ $t("bookings.booking_mileage") }}:
                {{ booking.booking_mileage }}
                {{ $t("custom.km") }}
              </div>
              <div v-if="booking.booking_mileage > 0">
                {{ $t("bookings.average_mileage") }}:
                {{ parseFloat((booking.booking_mileage / booking.days).toFixed(2)) }}
                {{ $t("bookings.km_day") }}
              </div>
            </template>
            <v-divider class="mt-2 mb-2"
              v-if="!booking.technical_check_start || !booking.technical_check_end"></v-divider>
            <div v-if="!booking.technical_check_start">
              <v-icon small color="red"> mdi-airplane-takeoff </v-icon>
              {{ booking.technical_check_start_comment }}
            </div>
            <div v-if="!booking.technical_check_end">
              <v-icon small color="warning"> mdi-home </v-icon>
              {{ booking.technical_check_end_comment }}
            </div>
          </v-flex>
          <v-flex v-else xs12 md4>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
          </v-flex>
          <div xs12 md1 class="vl"></div>
          <v-flex v-if="!isLoading" xs12 md4>
            <h2 v-if="booking.counts && booking.counts.length == 0" class="text-center">
              {{ $t("bookings.no_counts") }}
            </h2>
            <v-expansion-panels v-if="booking.counts && booking.counts.length != 0" v-model="paymentsPanel"
              class="start-tour-booking-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 class="mb-0 d-flex">
                    {{ $t("bookings.counts") }}
                    <download-excel :data="booking.counts" v-if="booking &&
                      booking.counts &&
                      booking.counts.length > 0 &&
                      isStaff
                    ">
                      <v-icon class="ml-1" style="cursor: pointer" color="success">
                        mdi-file-excel-outline
                      </v-icon>
                    </download-excel>
                  </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="counts_headers"
                    :items="booking.counts"
                    dense
                    :items-per-page="10"
                    :loading="isLoading"
                    :loading-text="$t('custom.loading_table')"
                    :class="!isMobile ? '' : 'is-mobile'"
                    :footer-props="tableFooterProps([10, 20, 50, -1])"
                  >
                    <template v-slot:item="{ item }">
                      <tr :class="item.operation ? '' : 'red--text'">
                        <td :class="item.canceled ? 'text-center text-decoration-line-through' : 'text-center'">
                          {{ item.id }}
                          <agent-marker record-type="Count" :record-id="item.id" />
                        </td>
                        <td class="text-center">
                          {{ formatCreatedAt(item.created_at) }}
                        </td>
                        <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                          {{ item.operation ? "" : "-" }}{{ item.sum }}{{ findCurrencySymbol(item.currency_id) }}
                          <span v-if="item.rate && (item.rate != 1 && item.rate != 0) && item.rate != null">
                            ({{ item.rated_sum }})
                          </span>
                        </td>
                        <td v-else class="text-center">
                          {{ item.operation ? "" : "-" }}{{ item.sum }}{{ currency }}
                        </td>
                        <td class="text-center" v-if="item.cash">
                          <v-icon class="text-center" color="success" v-tooltip="{
                            content: $t('money.cash'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-cash
                          </v-icon>
                        </td>
                        <td class="text-center" v-if="item.cashless">
                          <v-icon class="text-center" color="warning" v-tooltip="{
                            content: $t('money.terminal'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-contactless-payment-circle-outline
                          </v-icon>
                        </td>
                        <td class="text-center" v-if="item.entity">
                          <v-icon class="text-center" color="secondary" v-tooltip="{
                            content: $t('money.to_entity'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-bank
                          </v-icon>
                        </td>
                        <td class="text-center" v-if="item.cash_card">
                          <v-icon class="text-center" color="info" v-tooltip="{
                            content: $t('money.card_to_card'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-credit-card-check-outline
                          </v-icon>
                        </td>
                        <td class="text-center" v-if="item.client_balance">
                          <v-icon class="text-center" color="error" v-tooltip="{
                            content: $t('money.client_balance'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-account-arrow-right
                          </v-icon>
                        </td>
                        <td :class="item.canceled ? 'text-center text-decoration-line-through' : 'text-center'">
                          {{ translateCountGroup(item.group) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      {{ $t("custom.no_data_in_table") }}
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- Card payments -->
            <v-expansion-panels v-if="tinkoff_payments && tinkoff_payments.length != 0" v-model="tinkoffPaymentsPanel">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 class="mb-0 d-flex">{{ $t("bookings.card_payments") }}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table :headers="tinkoff_headers" dense :items="tinkoff_payments" :loading="isLoading"
                    :loading-text="$t('custom.loading_table')" :items-per-page="10" :sort-by="['updated_at']"
                    :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([10, 20, 50, -1])">
                    <template slot="item" slot-scope="props">
                      <tr :class="tinkoffPaymentCompleted(props.item) ? 'success' : ''">
                        <!-- <td class="text-center">
                          {{ props.item.id }}
                        </td>
                        <td class="text-center">
                          {{ formatCreatedAt(props.item.created_at) }}
                        </td> -->
                        <td class="text-center">
                          {{ props.item.sum / 100.0 }}
                        </td>
                        <td class="text-center">
                          {{ props.item.status }}
                        </td>
                        <td class="text-center">
                          {{ props.item.card_number }}
                        </td>
                        <td class="text-center">
                          {{ props.item.payment_id }}
                        </td>
                        <!-- FT-193 REQ-09 (CTR-05): исход платежа; «исход неизвестен» (stale) manager+ фиксирует вручную -->
                        <td class="text-center" data-testid="tinkoff-outcome-cell">
                          <v-chip v-if="props.item.outcome" x-small label :color="tinkoffOutcomeColor(props.item.outcome)"
                            :title="tinkoffStaleTitle(props.item)">
                            {{ tinkoffOutcomeLabel(props.item.outcome) }}
                          </v-chip>
                          <span v-else>—</span>
                          <v-btn v-if="canResolveTinkoffPayment(props.item)" x-small outlined color="primary" class="ml-2"
                            @click="openTinkoffResolve(props.item)" data-testid="tinkoff-resolve">
                            {{ $t("tinkoff.resolve") }}
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      {{ $t("custom.no_data_in_table") }}
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- Продления -->
            <v-expansion-panels v-if="prolongs && prolongs.length != 0" v-model="prolongsPanel" class="mt-2">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 class="mb-0 d-flex">
                    {{ $t("bookings.prolongs") }}
                    <download-excel :data="prolongs" v-if="prolongs &&
                      prolongs.length > 0 &&
                      isStaff
                    ">
                      <v-icon class="ml-1" style="cursor: pointer" color="success">
                        mdi-file-excel-outline
                      </v-icon>
                    </download-excel>
                  </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="computedProlongsHeaders"
                    :items="prolongs"
                    dense
                    :items-per-page="10"
                    :loading="isLoading"
                    :loading-text="$t('custom.loading_table')"
                    :class="!isMobile ? '' : 'is-mobile'"
                    :footer-props="tableFooterProps([10, 20, 50, -1])"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td class="text-center">
                          {{ formatPrologDate(item.last_date) }}
                        </td>
                        <td class="text-center">
                          <v-chip small :color="item.automatic ? 'info' : 'default'" :text-color="item.automatic ? 'white' : ''">
                            <v-icon v-if="item.automatic" small left>mdi-robot-outline</v-icon>
                            <v-icon v-else small left>mdi-account-outline</v-icon>
                            {{ item.automatic ? $t('prolongs.automatic') : $t('prolongs.manual') }}
                          </v-chip>
                        </td>
                        <td class="text-center" v-if="!booking.hourly && !booking.weekly && !booking.monthly">
                          {{ item.prolong_days }}
                        </td>
                        <td class="text-center" v-if="booking.hourly">
                          {{ item.prolong_hours }}
                        </td>
                        <td class="text-center" v-if="booking.weekly">
                          {{ item.prolong_weeks }}
                        </td>
                        <td class="text-center" v-if="booking.monthly">
                          {{ item.prolong_months }}
                        </td>
                        <td class="text-center">
                          <span v-if="item.old_price !== item.new_price" v-tooltip="{
                            content: $t('prolongs.price_changed', { old: item.old_price, new: item.new_price }),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            <span class="text-decoration-line-through" :class="$vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text text--darken-1'">{{ item.old_price }}</span>
                            → {{ item.new_price }}
                          </span>
                          <span v-else>{{ item.new_price }}</span>
                        </td>
                        <td class="text-center" v-if="!booking.hourly && !booking.weekly && !booking.monthly">
                          {{ item.new_price * item.prolong_days }}
                        </td>
                        <td class="text-center" v-if="booking.hourly">
                          {{ item.new_price * item.prolong_hours }}
                        </td>
                        <td class="text-center" v-if="booking.weekly">
                          {{ item.new_price * item.prolong_weeks }}
                        </td>
                        <td class="text-center" v-if="booking.monthly">
                          {{ item.new_price * item.prolong_months }}
                        </td>
                        <td class="text-center">
                          <v-icon v-if="canAnnulProlong(item)" @click="deleteProlong(item)" data-cy="annul-prolong" class="text-center"
                            color="warning" v-tooltip="{
                              content: $t('bookings.annul_prolong'),
                              placement: 'bottom-center',
                              classes: ['warning'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                            mdi-delete-outline
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      {{ $t("custom.no_data_in_table") }}
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- Подарки -->
            <v-expansion-panels v-if="gifts && gifts.length != 0" v-model="giftsPanel" class="mt-2">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 v-if="!booking.hourly && !booking.weekly && !booking.monthly" class="mb-0 d-flex">
                    {{ $t("gifts.title") }}
                  </h2>
                  <h2 v-if="booking.hourly" class="mb-0 d-flex">
                    {{ $t("gifts.hourly_title") }}
                  </h2>
                  <h2 v-if="booking.weekly" class="mb-0 d-flex">
                    {{ $t("gifts.weekly_title") }}
                  </h2>
                  <h2 v-if="booking.monthly" class="mb-0 d-flex">
                    {{ $t("gifts.monthly_title") }}
                  </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="computedGiftsHeaders"
                    :items="gifts"
                    dense
                    :items-per-page="10"
                    :loading="isLoading"
                    :loading-text="$t('custom.loading_table')"
                    :class="!isMobile ? '' : 'is-mobile'"
                    :footer-props="tableFooterProps([10, 20, 50, -1])"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td class="text-center">
                          {{ formatPrologDate(item.created_at) }}
                        </td>
                        <td v-if="!booking.hourly && !booking.weekly && !booking.monthly" class="text-center">
                          {{
                            item.gift_type == 0
                              ? $t("gifts.days")
                              : $t("gifts.hours")
                          }}
                        </td>
                        <td class="text-center">
                          {{ item.count }}
                        </td>
                        <td class="text-center">
                          {{ item.price }}
                        </td>
                        <td class="text-center">
                          <v-icon v-if="canEditGifts" @click="deleteGift(item)" class="text-center" color="warning" v-tooltip="{
                            content: $t('gifts.delete'),
                            placement: 'bottom-center',
                            classes: ['warning'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-delete-outline
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      {{ $t("custom.no_data_in_table") }}
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <v-flex v-else xs12 md4>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
          </v-flex>
          <div xs12 md1 class="vl"></div>
          <!-- Управление бронированием -->
          <v-flex v-if="!isLoading" xs12 md3 class="mx-auto start-tour-booking-4">
            <h3 class="headline text-center" nowrap>
              {{ $t("bookings.control") }}
            </h3>
            <!-- FT-173 STEP-22 (F13, REQ-12): кнопка «Оплатить»/статус-пилюля
                 («ОПЛАЧЕНО» и т.п.) — часть блока цены и статуса оплаты,
                 которую занимает панель договора выкупа; paymentStart()
                 открывает общий диалог оплаты брони, не связанный с
                 контуром договора (платёж по контракту — «Принять платёж»
                 внутри самой rent-to-own-panel). -->
            <!-- FT-173 решение USER D3 (REQ-12): у закрытого договора
                 (terminated/completed) ряд оплаты возвращается под панелью —
                 возврат залога и сальдо идут штатным PaymentDialog с
                 привязкой к бронированию. Блок цены выше остаётся скрыт. -->
            <v-row justify="space-around" class="mb-3 mt-2" v-if="showBookingPaymentRow">
              <v-btn :small="isMobile ? true : false" outlined color="primary" v-if="!booking.in_rent &&
                booking.counts &&
                booking.counts.length === 0 &&
                !booking.technical
              " @click="paymentStart(booking)" data-testid="booking-pay">{{ $t("bookings.pay") }}</v-btn>
              <v-btn :small="isMobile ? true : false" :color="selectColorPaid(booking)" v-if="(booking.counts && booking.counts.length > 0) ||
                (booking.in_rent && !booking.technical)
              " @click="paymentStart(booking)" data-testid="booking-payment-status" :title="`${calculatePayments(booking) != $t('bookings.paid') ? $t('bookings.part_paid') : $t('bookings.full_paid') }`">{{ calculatePayments(booking) }}</v-btn>
            </v-row>
            <v-row justify="space-around" class="mb-3 mt-2">
              <v-icon color="green" v-if="canProlongBooking" size="30" @click="prolongDialog = true" :title="$t('bookings.prolong')">
                mdi-history
              </v-icon>
              <v-icon v-if="canCheckoutCar" @click="showArrivalDialog = true" size="30" :title="$t('bookings.checkout_car')" data-testid="booking-checkout">
                mdi-home
              </v-icon>
              <v-btn icon :loading="isLoadingCheckinCar" v-if="canCheckinCar"
                @click="checkPayments()" :title="$t('bookings.checkin_car')">
                <v-icon size="30">mdi-airplane-takeoff</v-icon>
              </v-btn>
              <v-btn icon :loading="isLoadingEditBooking" @click="editBooking()" :title="$t('bookings.edit_booking')" data-testid="edit-booking-btn">
                <v-icon color="grey darken-2" size="30">mdi-pencil-outline</v-icon>
              </v-btn>
              <!-- FT-198 REQ-04: закрыть удержание залога; только сотрудникам и только при удержании -->
              <v-btn icon v-if="canReturnDeposit" :loading="isLoadingDepositReturned"
                @click="confirmReturnDeposit()" :title="$t('bookings.deposit_returned_action')" data-testid="deposit-returned-btn">
                <v-icon color="green" size="30">mdi-cash-refund</v-icon>
              </v-btn>
              <v-icon color="green" size="30"
                v-if="!booking.active && !booking.archive && !booking.failure && !booking.vseprokaty_id && !booking.ride"
                @click="activateBooking(booking)" :title="$t('bookings.activate_booking')">
                mdi-caps-lock
              </v-icon>
              <v-icon color="green" size="30" v-if="$store.getters.getCompany &&
                $store.getters.getCompany.company &&
                $store.getters.getCompany.company.word_templates && !$store.getters.getCompany.company.docx_templates_on &&
                !booking.entity &&
                isStaff
              " @click="generateDoc(booking)" :title="$t('bookings.generate_docs')">
                mdi-file-document-outline
              </v-icon>
              <v-icon color="green" size="30" v-if="$store.getters.getCompany &&
                $store.getters.getCompany.company &&
                $store.getters.getCompany.company.word_templates && !$store.getters.getCompany.company.docx_templates_on &&
                booking.entity &&
                isStaff
              " @click="generateDocEntity(booking)" :title="$t('bookings.generate_docs')">
                mdi-file-document-outline
              </v-icon>
              <v-menu min-width="300px" max-width="400px" max-height="300px" offset-y v-if="$store.getters.getCompany &&
                $store.getters.getCompany.company &&
                $store.getters.getCompany.company.docx_templates_on && isStaff
              ">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon
                    :loading="isLoadingGetDocxTemplates || isLoadingGenerateDocxTemplates">
                    <v-icon color="green" size="30" @click="getDocxTemplates()" :title="$t('bookings.generate_docs')">
                      mdi-file-document-plus-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list style="overflow-y: auto;">
                  <v-list-item v-for="(docx_template, index) in docx_templates" :key="index"
                    @click="generateDocxTemplates(docx_template, booking)" style="cursor: pointer;">
                    <v-list-item-title style="white-space: normal; word-wrap: break-word;">
                      {{ docx_template.name }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon v-if="canEditGifts" color="blue-grey" size="25" @click="show_gifts_dialog = true" :title="$t('gifts.tooltip')">
                mdi-gift-outline
              </v-icon>
              <v-icon size="30" v-if="$store.getters.getCompany &&
                $store.getters.getCompany.company &&
                ($store.getters.getCompany.company.new_templates || $store.getters.getCompany.company.pdf_templates) &&
                isStaff
              " color="primary" @click="showSignPad = true" :title="$t('docuseal.sign_as_client')">
                mdi-draw
              </v-icon>
              <PdfDocuments
                v-if="showPdfDocuments"
                :booking="booking" :client="client" :is-native="isNative" @document-created="handleDocumentCreated"
                @document-deleted="handleDocumentDeleted" @error="setError"
                @generating-start="(name) => { isPdfGenerating = true; pdfGeneratingTemplateName = name; }"
                @generating-end="isPdfGenerating = false" />
              <!-- Кнопка OkiDoki -->
              <v-icon 
                v-if="$store.getters.getCompany && $store.getters.getCompany.company && $store.getters.getCompany.company.okidoki_enabled && companySecretSet('okidoki_api_key') && isStaff"
                size="30" 
                color="purple"
                @click="showOkidokiDialog = true"
                :title="$t('okidoki.tooltip_send')">
                mdi-file-certificate-outline
              </v-icon>

              <!-- Кнопка DocuSeal -->
              <v-icon 
                v-if="$store.getters.getCompany && $store.getters.getCompany.company && $store.getters.getCompany.company.docuseal_enabled && companySecretSet('docuseal_api_key') && isStaff && booking.client && (booking.client.email || booking.client.phone)"
                size="30" 
                color="blue"
                @click="showDocusealDialog = true"
                :title="$t('docuseal.tooltip_send')">
                mdi-file-certificate-outline
              </v-icon>
              <v-btn icon :loading="isLoadingArchiveBooking" v-if="(!booking.active && !booking.archive)"
                @click="archiveBooking(booking)" :title="$t('bookings.archivate_booking')">
                <v-icon color="error" size="30">mdi-archive-arrow-down</v-icon>
              </v-btn>
              <v-btn icon :loading="isLoadingUnarchiveBooking" v-if="!booking.active && booking.archive"
                @click="unarchiveBooking(booking)" :title="$t('bookings.unarchivate_booking')" data-testid="unarchive-booking-btn">
                <v-icon color="grey" size="30">mdi-archive-arrow-up</v-icon>
              </v-btn>
              <v-icon color="light-blue accent-3" size="28" v-if="booking.active || booking.ride"
                @click="uploadPhotosDialog = true" :title="$t('bookings.upload_photos')">
                mdi-camera
              </v-icon>
              <booking-act-icon
                v-if="cardSections"
                :booking-id="booking.id"
                :initial-section="cardSections.damage_control_act"
                :initial-entity-id="cardSectionsEntityId"
              />
              <v-icon v-if="canDeleteBooking" size="30" color="red darken-2"
                @click="deleteBooking(booking)" :title="$t('bookings.delete_booking')">
                mdi-delete-forever
              </v-icon>
            </v-row>
            <hr class="mb-2 mt-2" />
            <h3 class="headline text-center"
              v-if="!booking.technical && !booking.vseprokaty_id && booking.source != 'Localrent' && !booking.localrent_id">
              {{ $t("bookings.notifications") }}
            </h3>
            <v-row class="mt-1" justify="space-around"
              v-if="!booking.technical && !booking.vseprokaty_id && booking.source != 'Localrent' && !booking.localrent_id">
              <v-btn class="mb-2" small :disabled="sendEmail == false &&
                sendMessenger == false &&
                sendSms == false
                " :color="booking.send_accept_email ? 'grey' : 'success'" @click="acceptBooking()"
                :loading="isLoadingAcceptBooking">
                {{ $t("bookings.send_approve") }}
              </v-btn>
              <v-btn class="mb-2" small :disabled="sendEmail == false &&
                sendMessenger == false &&
                sendSms == false
                " :color="booking.send_custom_email ? 'grey' : 'primary'" @click="
                  getEmailTemplates(),
                  getTemplates(),
                  (showEmailTemplates = true),
                  (showCustomEmailDialog = true)
                  " v-tooltip="{
                    content: $t('bookings.send_client'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">{{ $t("bookings.from_template") }}</v-btn>
              <!-- <v-btn
                    class="mb-2"
                    small
                    :color="booking.send_cancel_email ? 'grey' : 'success'"
                    @click="cancelBookingFewDaysEmail()"
                    >Отказ меньше 2-х</v-btn
                  > -->
              <v-btn class="mb-2" small :disabled="sendEmail == false &&
                sendMessenger == false &&
                sendSms == false
                " :color="booking.send_cancel_email ? 'grey' : 'warning'" @click="cancelBookingNotCarsEmail()"
                :loading="isLoadingDeclineBooking">{{
                  $t("bookings.decline_simple") }}</v-btn>
            </v-row>
            <v-row class="mb-3" justify="space-around"
              v-if="!booking.technical && !booking.vseprokaty_id && booking.source != 'Localrent' && !booking.localrent_id">
              <v-switch v-model="sendEmail" @change="checkEmail()" class="mt-0 mr-1 mr-1" label="Email" dense
                hide-details></v-switch>
              <v-switch v-model="sendMessenger" @change="checkMessenger()" class="mt-0 mr-1 mr-1" :label="$t('custom.messengers')"
                :disabled="$store.getters.getCompany.company
                  ? !($store.getters.getCompany.company.whatsapp || $store.getters.getCompany.company.telegram_green_api_enabled || $store.getters.getCompany.company.max_enabled)
                  : false
                  " dense hide-details></v-switch>
              <!-- <v-switch
                v-model="sendSms"
                @change="checkSms()"
                class="mt-0 mr-1 mr-1"
                :label="$t('custom.sms')"
                :disabled="true"
                dense
                hide-details
              ></v-switch> -->
            </v-row>
            <v-flex v-if="!booking.active && booking.vseprokaty_id && !booking.fast_booking && !booking.failure"
              class="text-center">
              <countdown :time="hour_timer">
                <template slot-scope="props">{{ $t('agregator.countdown_for_decision') }}：{{ props.minutes }} {{
                  $t('agregator.minutes') }}, {{ props.seconds }} {{ $t('agregator.seconds') }}</template>
              </countdown>
            </v-flex>
            <v-row class="mt-1" justify="space-around" v-if="booking.vseprokaty_id && !booking.active">
              <v-btn class="mb-2" :disabled="booking.fast_booking || booking.failure || booking.accepted
                " color="success" @click="acceptInAgregator()">
                {{ $t("bookings.send_approve") }}
              </v-btn>
              <v-btn class="mb-2" :disabled="booking.fast_booking || booking.failure || booking.accepted
                " color="warning" @click="cancelInAgregator()">{{ $t("bookings.decline_simple") }}</v-btn>
            </v-row>
            <hr class="mb-2 mt-3" v-if="!booking.technical && booking.vseprokaty_id" />
            <h3 class="headline text-center my-2" v-if="!booking.technical && booking.vseprokaty_id">
              {{ $t("custom.messages") }}
            </h3>
            <v-card v-if="!booking.technical &&
              booking.vseprokaty_id &&
              messages &&
              messages.length > 0
            " height="200" class="overflow-auto">
              <v-flex :key="index" v-for="(item, index) in messages" class="my-2 mx-2">
                <v-alert class="mb-1" border="left" :color="item && item.sender == 'User' ? 'info' : 'blue-grey'" dark
                  dense :icon="selectIcon(item.sender)">
                  <v-flex>
                    <div style="white-space: pre-line">{{ item.text }}</div>
                  </v-flex>
                </v-alert>
                <v-flex class="caption text-right">
                  {{ formatPrologDate(item.created_at) }}
                </v-flex>
              </v-flex>
            </v-card>
            <v-alert v-if="booking.vseprokaty_id && messages && messages.length == 0" class="my-2" border="top"
              colored-border type="info" elevation="2">
              {{ $t("agregator.no_new_messages") }}
            </v-alert>
            <v-card v-if="!booking.technical &&
              booking.vseprokaty_id &&
              !booking.failure &&
              !booking.ride
            " class="mt-2 mb-4 py-2">
              <v-flex class="d-flex">
                <v-textarea v-model.trim="new_message" @keypress="checkEnter($event, booking.id)" class="mx-2"
                  :label="$t('messages.text')" rows="1" auto-grow :counter="500"></v-textarea>
                <v-btn class="ma-2" @click="sendMessage(booking.id)" icon>
                  <v-icon v-if="!send_message_loading" large color="secondary">mdi-send-circle-outline</v-icon>
                  <v-progress-circular class="my-auto" v-else indeterminate color="secondary"
                    size="20"></v-progress-circular>
                </v-btn>
              </v-flex>
            </v-card>
            <!-- FT-019: loading state during PDF generation masks html2pdf flash artifacts -->
            <template v-if="isPdfGenerating">
              <hr class="mb-2 mt-3" />
              <h3 class="headline text-center">
                {{ $t("bookings.documents") }}
              </h3>
              <v-row class="mt-2" justify="center">
                <v-col cols="12" sm="10" md="8">
                  <v-card flat outlined class="text-center pa-6">
                    <v-progress-circular indeterminate color="amber" size="48" width="3" class="mb-4" />
                    <div class="text-subtitle-1 mb-1">{{ $t('pdf_docs.generating') }}</div>
                    <div class="text-caption text--secondary mb-4">
                      {{ $t('bookings.template') }}: {{ pdfGeneratingTemplateName }}
                    </div>
                    <v-progress-linear indeterminate color="amber" rounded height="3"
                      class="mx-auto" style="max-width: 300px;" />
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <hr class="mb-2 mt-3" v-else-if="booking.generated_documents &&
              booking.generated_documents.length
            " />
            <h3 class="headline text-center" v-if="!isPdfGenerating && booking.generated_documents &&
              booking.generated_documents.length
            ">
              {{ $t("bookings.documents") }}
            </h3>
            <v-row class="mt-1" justify="space-around" v-if="!isPdfGenerating && !booking.technical">
              <v-simple-table dense v-if="booking.generated_documents &&
                booking.generated_documents.length
              ">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center" style="white-space: nowrap;">
                        {{ $t("custom.created") }}
                      </th>
                      <th class="text-center">
                        {{ $t("bookings.template") }}
                      </th>
                      <th class="text-center" style="width: 60px;">
                        {{ $t('okidoki.status') }}
                      </th>
                      <th class="text-center" style="white-space: nowrap;">
                        {{ $t("bookings.control") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="document in generated_documents" :key="document.id">
                      <td class="text-center" style="white-space: nowrap;">
                        {{ formatCreatedAt(document.created_at) }}
                      </td>
                      <td class="text-center">
                        {{ document.name }}
                      </td>
                      <td class="text-center">
                        <!-- Статус для документов OkiDoki -->
                        <v-chip v-if="document.okidoki_contract_id" 
                          small
                          :color="getOkidokiStatusColor(document.okidoki_status)"
                          text-color="white">
                          <v-icon left small>{{ getOkidokiStatusIcon(document.okidoki_status) }}</v-icon>
                          {{ getOkidokiStatusText(document.okidoki_status) }}
                        </v-chip>
                        <!-- Статус для документов DocuSeal -->
                        <div v-else-if="document.docuseal_submission_id" style="font-size: 12px;">
                          <v-chip small :color="getDocusealStatusColor(document.docuseal_status)" text-color="white">
                            {{ getDocusealDetailedStatusText(document) }}
                          </v-chip>
                        </div>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center" style="white-space: nowrap;">
                        <div class="d-inline-flex align-center" style="gap: 4px;">
                        <!-- Кнопки для документов OkiDoki -->
                        <template v-if="document.okidoki_contract_id">
                          <!-- Ссылка на подписание (если не подписан) -->
                          <v-btn icon 
                            v-if="document.okidoki_status !== 'Подписан' && document.okidoki_status !== 'signed' && document.okidoki_link"
                            @click="openSigningLink(document.okidoki_link)"
                            :title="$t('okidoki.open_signing_link')">
                            <v-icon color="purple">mdi-file-sign</v-icon>
                          </v-btn>
                          <!-- Скачать подписанный (если подписан) -->
                          <v-btn icon
                            v-if="(document.okidoki_status === 'Подписан' || document.okidoki_status === 'signed') && document.link"
                            @click="downloadSignedDocBottom(document.download_url || document.link), selectedDocumentId = document.id"
                            :loading="isLoadingDownloadSignedDoc && document.id == selectedDocumentId"
                            :title="$t('okidoki.download_signed')">
                            <v-icon color="green">mdi-file-download</v-icon>
                          </v-btn>
                          <!-- Удалить -->
                          <v-btn icon @click="deleteSignedDoc(document.id), selectedDocumentId = document.id"
                            :loading="isLoadingDeleteSignedDoc && document.id == selectedDocumentId">
                            <v-icon color="error">mdi-delete-forever</v-icon>
                          </v-btn>
                        </template>
                        
                        <!-- Кнопки для документов DocuSeal -->
                        <template v-else-if="document.docuseal_submission_id">
                          <!-- Кнопка подписания для компании -->
                          <v-btn icon 
                            v-if="document.docuseal_company_link && !document.docuseal_company_signed_at"
                            @click="openSigningLink(document.docuseal_company_link)"
                            color="primary"
                            :title="$t('docuseal.sign_as_company')">
                            <v-icon>mdi-draw</v-icon>
                          </v-btn>
                          <!-- Ссылка на просмотр submission (если компания уже подписала) -->
                          <v-btn icon 
                            v-else-if="document.docuseal_link"
                            @click="openSigningLink(document.docuseal_link)"
                            :title="$t('docuseal.open_submission_link')">
                            <v-icon color="purple">mdi-file-eye</v-icon>
                          </v-btn>
                          <!-- Скачать подписанный PDF (если все подписали) -->
                          <v-btn icon 
                            v-if="document.docuseal_status === 'completed' && document.link"
                            @click="downloadDocusealDocument(document.link)"
                            :title="$t('docuseal.download_signed')">
                            <v-icon color="green">mdi-file-download</v-icon>
                          </v-btn>
                          <!-- Удалить -->
                          <v-btn icon @click="deleteSignedDoc(document.id), selectedDocumentId = document.id"
                            :loading="isLoadingDeleteSignedDoc && document.id == selectedDocumentId">
                            <v-icon color="error">mdi-delete-forever</v-icon>
                          </v-btn>
                        </template>
                        
                        <!-- Кнопки для обычных документов -->
                        <template v-else>
                          <v-btn icon @click="downloadSignedDocBottom(document.download_url || document.link), selectedDocumentId = document.id"
                            :loading="isLoadingDownloadSignedDoc && document.id == selectedDocumentId">
                            <v-icon>mdi-file-download</v-icon>
                          </v-btn>
                          <v-btn icon @click="sendSignedDocument(document.id), selectedDocumentId = document.id"
                            :loading="isLoadingSendSignedDoc && document.id == selectedDocumentId"
                            :disabled="client && client.email == '' || client && client.email == null">
                            <v-icon color="success">mdi-email-arrow-right-outline</v-icon>
                          </v-btn>
                          <v-btn icon @click="deleteSignedDoc(document.id), selectedDocumentId = document.id"
                            :loading="isLoadingDeleteSignedDoc && document.id == selectedDocumentId">
                            <v-icon color="error">mdi-delete-forever</v-icon>
                          </v-btn>
                        </template>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
          </v-flex>
          <v-flex v-else xs12 md4>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-three-line" v-if="!isMobile"></v-skeleton-loader>
          </v-flex>
        </v-flex>
        <!-- Долги -->
        <booking-debts v-if="booking && booking.id && debts && debts_headers" :debts="debts" :booking-id="booking.id"
          :is-loading="isLoading" :debts_headers="debts_headers" />
        <!-- Штрафы -->
        <booking-fines v-if="showFines" :entity="booking.entity" :fines="fines" :fines_headers="fines_headers" :is-loading="isLoading"
          :deposit-hold="booking.deposit_hold"
          @deposit-hold-updated="onDepositHoldUpdated"
          @translate-fines-state="translateFinesState" />
        <!-- Счета -->
        <booking-invoices :invoices="invoices" :is-loading="isLoading" :isMobile="isMobile" />
      </v-card-text>
    </v-card>
    <!-- Выдача -->
    <departure-dialog v-model="departureDialog" :booking="booking" :isMobile="isMobile"
      @check-departure-mileage="checkDepartureMileage" :is-loading="isLoadingActiveRent"></departure-dialog>
    <!-- Редактирование -->
    <v-dialog v-model="editDialog" :retain-focus="false" fullscreen persistent hide-overlay
      transition="dialog-bottom-transition">
      <v-card :loading="isLoadingEditSave">
        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-card-title :class="isMobile ? 'pt-10' : ''">
              <span class="headline">{{ $t("custom.editing") }}</span>
              <v-icon :class="pricingReady ? 'ml-2 green--text' : 'ml-2 grey--text'" :disabled="!pricingReady"
                @click="editSave()" data-testid="edit-save-icon">
                mdi-content-save-all-outline
              </v-icon>
              <v-spacer></v-spacer>
              <!-- FT-108 DEC-02: панельные флаги + даты/тариф — в едином
                   ft108ResetEditSections(); остальное (getBooking, editDialog,
                   manualEditing, warning*) осталось в цепочке как было -->
              <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click.stop="
                getBooking(),
                (editDialog = false),
                (manualEditing = false),
                (warningAddOneDay = false),
                (warningLessThenDay = false),
                ft108ResetEditSections()
                ">
                mdi-close
              </v-icon>
            </v-card-title>
            <v-container :style="isMobile ? 'padding: 5px !important;' : ''">
              <!-- FT-108: sticky-сводка (REQ-01, REQ-02) -->
              <div class="ft108-summary">
              <v-layout row wrap>
                <!-- FT-108: раскладка строки — только scoped-CSS
                     (.ft108-headline: flex + wrap), без isMobile-тернарника.
                     isMobile залипает (checkMobile по v-resize читает
                     $vuetify.breakpoint, который обновляется с debounce ~200ms:
                     после ресайза окна mobile→desktop последний вызов видит
                     устаревший xs/sm и isMobile остаётся true) — на desktop
                     строка рассыпалась в столбик. CSS от ширины не залипает. -->
                <v-flex xs12 sm12 md12 class="ft108-headline align-center" justify="space-between">
                  <h2 class="m-0 p-0 text-center align-center">
                    {{ $t("bookings.booking") }} {{ $t("custom.number")
                    }}{{ booking.id }}
                  </h2>
                  <!-- FT-184 REQ-12: метка «через агента» (без метки не рисуется) -->
                  <agent-marker record-type="Booking" :record-id="booking.id" />
                  <!-- FT-108: статус-чипы, не дублирующие тумблеры (REQ-01).
                       Собраны в одну группу: на узком экране шапка расходится
                       по строкам (номер / статусы / режим), и статусам нужна
                       своя строка целиком. Отступ между чипами даёт gap
                       группы, а не ml-2 на каждом: utility-марджин отбивал бы
                       первый чип от левого края собственной строки. -->
                  <div v-if="ft108HasStatusChips" class="ft108-status-chips">
                    <v-chip v-if="booking.in_rent" x-small outlined color="success">
                      {{ $t("bookings.in_rent") }}
                    </v-chip>
                    <v-chip v-if="booking.archive" x-small outlined>
                      {{ $t("custom.archive") }}
                    </v-chip>
                    <v-chip v-if="!booking.technical" x-small outlined :color="selectColorPaid(booking)">
                      {{ calculatePayments(booking) }}
                    </v-chip>
                    <!-- Активность, которую отсюда менять нельзя (выданная,
                         архивная, интеграционная бронь), показывается ЧИПОМ, а
                         не погашенным сегментом: disabled-текст Vuetify даёт
                         2.7:1 на тёмной теме, и состояние — единственное, что
                         этот контрол сообщает, — становилось нечитаемым.
                         Мёртвый контрол вдобавок не объяснял, почему мёртв.
                         Место чипа — здесь, среди статусов: это не настройка, а
                         состояние, и рядом с сегментом расчёта он слипался с
                         ним в один ком на узком экране (USER 2026-08-24). -->
                    <v-chip v-if="activeControlMode === 'chip'" x-small outlined
                      :color="booking.active ? (booking.ride ? 'warning' : 'success') : ''"
                      :title="$t('bookings.active_locked_hint')" data-testid="ft108-active-chip">
                      {{ booking.active ? $t("bookings.active") : $t("bookings.not_active") }}
                    </v-chip>
                  </div>
                  <v-spacer></v-spacer>
                  <!-- FT-108 v2: обе настройки шапки — один контрол-идиома:
                       сегмент «одно из двух», где вариант сам себя называет
                       («Активная» / «Не активная», «Авто расчёт» / «Ручной
                       расчёт») — отдельная метка перед сегментом не нужна.
                       Раньше это были два тумблера с длинными подписями, а
                       режим расчёта вдобавок задавался ВТОРЫМ контролом в
                       конце формы («Изменить данные вручную») — теперь одним.
                       :disabled — на КНОПКАХ, не на группе: у v-btn-toggle в
                       Vuetify 2 такого prop нет (он осел бы атрибутом на div и
                       запрет был бы декоративным), disabled умеет
                       groupable-миксин самих v-btn. -->
                  <div class="ft108-modes">
                    <!-- Какой контрол показывать, решает activeControlMode:
                         ветвление жило в шаблоне и дважды теряло путь. Вариант
                         'chip' (менять активность нельзя) живёт не здесь, а в
                         группе статус-чипов выше: сегментов в этом блоке тогда
                         остаётся один — расчёт. -->
                    <!-- бронь «на выезде»: снять активность может только админ,
                         вариант помечен предупреждающим цветом (паритет
                         прежнего warning-тумблера) -->
                    <v-btn-toggle v-if="activeControlMode === 'toggle_ride'" class="ft108-mode-toggle"
                      color="warning" :value="booking.active ? 'on' : 'off'" mandatory dense
                      :key="'active-tg-ride-' + modeSwitchKey"
                      @change="selectBookingActive" data-testid="ft108-active-mode">
                      <v-btn value="on" small>{{ $t("bookings.active") }}</v-btn>
                      <v-btn value="off" small>{{ $t("bookings.not_active") }}</v-btn>
                    </v-btn-toggle>
                    <!-- :key — как у сегмента расчёта: при СИНХРОННОМ откате
                         (guest/partner) prop :value не меняется вовсе, а внутреннее
                         состояние v-btn-toggle уже перещёлкнулось, и кнопка
                         осталась бы нажатой навсегда (ревью 2026-08-11). -->
                    <v-btn-toggle v-else-if="activeControlMode === 'toggle'" class="ft108-mode-toggle"
                      :value="booking.active ? 'on' : 'off'"
                      mandatory dense :key="'active-tg-' + modeSwitchKey"
                      @change="selectBookingActive" data-testid="ft108-active-mode">
                      <v-btn value="on" small>{{ $t("bookings.active") }}</v-btn>
                      <v-btn value="off" small>{{ $t("bookings.not_active") }}</v-btn>
                    </v-btn-toggle>
                    <!-- :key на modeSwitchKey — как у прежних тумблеров: при
                         отмене confirm состояние не меняется, и сегмент нужно
                         перемонтировать, иначе визуально останется нажатым
                         вариант, который оператор отменил. -->
                    <v-btn-toggle class="ft108-mode-toggle" :value="calculationMode" mandatory dense
                      :key="'calc-tg-' + modeSwitchKey" @change="selectCalculationMode"
                      data-testid="ft108-calc-mode">
                      <!-- Два разных запрета. «Авто» гаснет у архива и броней
                           интеграций: движку их пересчитывать нельзя. «Ручной»
                           гаснет только у архива — бронь завершена, её суммы не
                           меняются вовсе (решение USER 2026-08-11); у Localrent
                           и внешних ручная правка остаётся единственным входом
                           и обязана иметь видимый выход (строка ниже). -->
                      <v-btn value="auto" small :disabled="calcModeDisabled">{{ $t("bookings.calc_mode_auto") }}</v-btn>
                      <v-btn value="manual" small :disabled="calcManualDisabled">{{ $t("bookings.calc_manual") }}</v-btn>
                    </v-btn-toggle>
                  </div>
                </v-flex>
                <!-- DEC-19: frozen-режим (сохранена вручную, ручной выключен,
                     авто не включён). Раньше это был широкий оранжевый алерт
                     «Суммы зафиксированы вручную. Включите автоматический
                     расчёт, чтобы пересчитать» — вторая половина фразы
                     дублировала сегмент режима прямо над ней. Осталась тихая
                     строка состояния и действие, которого в сегменте нет:
                     открыть поля сумм, не включая пересчёт. -->
                <!-- Отказ сервера на смене активности: всплывашка в углу живёт
                     3 секунды и не связана с контролом, который «отскочил»
                     обратно. Строка ставится там же, где контрол. -->
                <v-flex v-if="activeStateError" xs12 sm12 md12 class="py-0">
                  <div class="ft108-mode-hint ft108-mode-hint--error" data-testid="ft108-active-error">
                    <v-icon x-small color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
                    {{ activeStateError }}
                  </div>
                </v-flex>
                <!-- FT-173 STEP-17 (REQ-13): договорное бронирование — деньги
                     ведёт договор выкупа, не эта форма. Замок с подсказкой
                     занимает место frozen/manual-строк ниже: rentToOwnLocked
                     идёт первым в цепочке v-if/v-else-if, поэтому обе старые
                     ветки для такого бронирования не показываются вовсе (их
                     собственные гейты дополнительно несут ту же проверку —
                     см. manualEntryAvailable, manualFreezeAvailable). -->
                <v-flex v-if="rentToOwnLocked" xs12 sm12 md12 class="py-0">
                  <div class="ft108-mode-hint" data-testid="ft108-rent-to-own-hint">
                    <v-icon x-small color="warning" class="mr-1">mdi-lock-outline</v-icon>
                    {{ $t("bookings.rent_to_own_locked_hint") }}
                  </div>
                </v-flex>
                <!-- Условие шире frozen: у брони интеграции (only_manual_editing,
                     Localrent) при загрузке гасят auto_calculate, а manual_editing
                     на сервере false, поэтому frozenManualMode не срабатывает — и
                     без этой строки вход в ручную правку исчезал совсем, хотя для
                     такой брони это ЕДИНСТВЕННЫЙ способ править цены (сегмент
                     расчёта у неё заблокирован целиком). -->
                <v-flex v-else-if="amountsLockedFromEngine" xs12 sm12 md12 class="py-0">
                  <div class="ft108-mode-hint" data-testid="ft108-frozen-hint">
                    <v-icon x-small color="warning" class="mr-1">mdi-lock-outline</v-icon>
                    {{ booking.manual_editing ? $t("bookings.manual_frozen_short") : $t("bookings.manual_only_short") }}
                    <!-- Архиву вход в ручную правку не предлагаем: суммы
                         завершённой брони в форме неизменны вовсе (решение USER
                         2026-08-11). Тем же предикатом гаснет кнопка «Ручной» в
                         сегменте — до ревью 2026-08-17 запрет держался только
                         там, а отсюда архив входил в правку в два клика. Строка
                         состояния остаётся: она объясняет, почему суммы
                         неизменны. -->
                    <button v-if="manualEntryAvailable" type="button" class="ft108-hint-action"
                      @click="onManualSwitchToggle(true)">
                      {{ $t("bookings.edit_data_manual") }}
                    </button>
                  </div>
                </v-flex>
                <!-- DEC-19, обратный переход MANUAL → FROZEN. Сегмент его не
                     выражает («Вручную» уже выбрано), а решение это не
                     косметическое: в MANUAL editSave шлёт manual_price и всю
                     ручную панель, в FROZEN — не шлёт ничего про суммы
                     (absent). Прежний тумблер «Изменить данные вручную» давал
                     переход побочно, будучи вторым контролом режима; здесь он
                     стал явным действием.
                     Условие — ровно те случаи, где вотчер manualEditing даёт
                     frozen, а не возврат к авторасчёту: бронь сохранена вручную
                     ЛИБО авторасчёт ей запрещён (Localrent, внешняя). Без
                     второго слагаемого вход в ручную правку у брони интеграции
                     был бы дверью без ручки с той стороны (ревью 2026-08-11). -->
                <v-flex v-else-if="manualFreezeAvailable" xs12 sm12 md12
                  class="py-0">
                  <div class="ft108-mode-hint" data-testid="ft108-manual-hint">
                    <v-icon x-small color="warning" class="mr-1">mdi-exclamation-thick</v-icon>
                    {{ $t("bookings.manual_editing_short") }}
                    <button type="button" class="ft108-hint-action" @click="onManualSwitchToggle(false)">
                      {{ $t("bookings.freeze_amounts") }}
                    </button>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <!-- FT-108 v2: состав суммы строкой слагаемых вместо прозы.
                       Из прежней фразы убраны клиент (дублировал заголовок
                       панели «Клиент», ссылка на карточку переехала туда),
                       тариф (панель «Тариф и скидка») и число суток (панель
                       «Даты и место»): в шапке остались только деньги, которых
                       в заголовках панелей нет. Расчёт «3 × 4000» стоит при
                       аренде — это не повтор дат, а само вычисление. -->
                  <div class="ft108-totals" data-testid="ft108-totals">
                    <span v-for="part in ft108Summary.parts" :key="part.key" class="ft108-t">
                      {{ part.label }}
                      <b>
                        <template v-if="part.math">{{ part.math }} = </template>{{ part.value }}{{ currency }}
                      </b>
                      <!-- Равенство «3 × 4000 = 12000» ломается на сезонах,
                           продлениях и скидке. Тогда количество и цену за
                           единицу печатаем подписями (ровно как прежняя проза,
                           теми же ключами): в свёрнутой форме этих чисел больше
                           нигде нет — заголовок «Даты и место» показывает даты
                           и адреса, а не число суток. -->
                      <span v-if="part.key === 'rent' && !part.math && part.count" class="ft108-rate">
                        {{ part.count }} {{ $t(ft108RentUnitLabels.count) }},
                        {{ $t(ft108RentUnitLabels.price) }} {{ part.price }}{{ currency }}
                      </span>
                    </span>
                    <!-- «Расчёт стоимости» (сезоны, поправки на даты) относится к расчёту,
                         поэтому стоит в его строке текстовой кнопкой. Полноширинной полосой
                         с шевроном читался как восьмая панель секций, хотя живёт в шапке.
                         Перед итогом, а не после: иначе строка заканчивалась
                         мелкой ссылкой против тяжёлого сегмента строкой выше. -->
                    <button v-if="ft108HasSeasons" type="button" class="ft108-seasons-toggle"
                      :aria-expanded="String(ft108ShowSeasons)" data-testid="ft108-seasons-toggle"
                      @click="ft108ShowSeasons = !ft108ShowSeasons">
                      {{ $t("bookings.price_breakdown") }}
                      <v-icon x-small>{{ ft108ShowSeasons ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                    </button>
                    <span class="ft108-t ft108-grand">
                      {{ $t("bookings.total") }}
                      <b data-testid="ft108-grand">{{ ft108Summary.grand }}{{ currency }}</b>
                      <!-- Пояснение только когда слагаемые не складываются в итог
                           (ручной режим, скидка) — иначе оно повторяло бы то, что
                           и так стоит слева. -->
                      <span v-if="!ft108Summary.partsExplainGrand" class="ft108-grand-parts">
                        {{ $t("bookings.without_deposit") }} {{ ft108Summary.total }}{{ currency }}
                      </span>
                    </span>
                  </div>
                  <!-- Почему добавлены сутки. Причину сообщает движок (units.extra_day_reason):
                       клиентская пере-реализация правил врала — сравнение `>` против `>=` в
                       движке и другая цена дня-носителя. Старое общее предупреждение остаётся
                       фоллбеком для путей без свежей квоты (ручной/замороженный режим). -->
                  <div v-if="extraDayReasonText" class="red--text">
                    {{ extraDayReasonText }}
                  </div>
                  <div v-else-if="!hasEngineQuote && (warningAddOneDay ||
                    (booking.additional_hours > 0 &&
                      booking.additional_hours * set_car.price_hour >
                      booking.selected_price) ||
                    checkHoursLimit)
                  " class="red--text">
                    {{ $t("bookings.add_day") }}
                  </div>
                  <div v-if="warningLessThenDay" class="red--text">
                    {{ $t("bookings.less_then_day") }}
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 v-if="ft108HasSeasons && ft108ShowSeasons" class="py-0">
                  <div class="ft108-seasons">
                        <div class="grey--text text-caption" data-cy="edit_season_mode" :data-mode="seasonModeKeyValue">
                          {{ $t("bookings.season_mode_label") }}: {{ seasonModeText }}
                        </div>
                        <v-simple-table dense>
                          <template v-slot:default>
                            <tbody>
                              <tr v-for="item in selected_seasons" :key="item.index">
                                <th class="text-left">
                                  <template v-if="item.isProlong">
                                    {{ $t("bookings.prolong_segment_row") }}
                                  </template>
                                  <template v-else>
                                    {{ item.season.start_date }} -
                                    {{ item.season.end_date }}
                                    <span v-if="item.isBase" class="grey--text font-weight-regular">
                                      ({{ $t("bookings.base_prices_row") }})
                                    </span>
                                  </template>
                                </th>
                                <td class="text-left" :data-cy="item.isBase ? 'edit_days_in_base' : 'edit_days_in_season'">
                                  {{ item.days }}
                                </td>
                                <td class="text-right" :data-cy="item.isBase ? 'edit_price_in_base' : 'edit_price_in_season'">
                                  {{ item.price }}
                                  <!-- FT-216 REQ-04, OQ-04: процент поправки на даты — суффикс в ячейке цены -->
                                  <span v-if="item.adjustmentPercent" class="grey--text text-caption ml-1" data-cy="edit_adjustment_percent"
                                    :title="$t('dynamic_pricing.adjustment_hint')">{{ item.adjustmentPercent }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                  </div>
                </v-flex>
              </v-layout>
              </div>
              <!-- /FT-108: конец sticky-сводки -->
              <!-- FT-108 (REQ-03, CON-01..03): тумблеры «Редактировать X»
                   заменены 7 eager-панелями в порядке EDIT_SECTIONS; раскрытие =
                   OR существующих edit-флагов через computed-прокси
                   ft108OpenPanels (editPanels.js), тела секций перенесены как
                   есть — v-model/handlers не менялись. -->
              <v-expansion-panels multiple v-model="ft108OpenPanels" class="ft108-panels">
                <!-- Панель «Клиент» (showEditClient) -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-client">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.client") }}</span>
                      <span v-if="ft108IsDirty('client')" class="ft108-dot"></span>
                      <!-- role-видимость — тот же паттерн, что у ссылки на
                           клиента в сводке (guest/partner не видят ФИО) -->
                      <!-- FT-108 v2: ссылка на карточку клиента переехала сюда
                           из прозы сводки — это была её единственная функция,
                           которой нет у заголовка панели. @click.native.stop:
                           иначе клик по ссылке ещё и раскрывал бы панель. -->
                      <span class="ft108-panel-val" :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        ">
                        <router-link v-if="booking.client_id" :to="{ path: `/clients/${booking.client_id}` }"
                          @click.native.stop>{{ ft108ClientValue() }}</router-link>
                        <template v-else>{{ ft108ClientValue() }}</template>
                      </span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <v-layout row wrap>
                <v-flex xs12 sm12 md8>
                  <div class="d-flex" v-if="showEditClient">
                    <v-autocomplete v-model="client" item-text="fullname" item-value="id" :loading="isLoadingClients"
                      :search-input.sync="searchClient" flat hide-no-data hide-details clearable
                      :label="$t('bookings.select_client')" :items="clients" prepend-icon="mdi-account-box"
                      return-object :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        ">
                    </v-autocomplete>
                    <!-- <v-icon class='mt-3' @click="newClientDialog = true">mdi-account-plus-outline</v-icon> -->
                  </div>
                  <!-- FT-108 (репорт USER): условие !showEditClient снято —
                       открытая панель держит showEditClient = true, и без этого
                       текущий клиент брони не был виден нигде (только пустой
                       autocomplete «выбрать другого»). Disabled-поле показывает
                       текущего клиента всегда; v-if по booking.entity сохранены. -->
                  <v-text-field slot="activator" :value="client ? clientFullName(client) : ''"
                    :label="$t('bookings.client')" disabled v-if="!booking.entity" :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  <v-text-field slot="activator" :value="client && client.entity_name ? client.entity_name : ''" :label="$t('bookings.client')" disabled
                    v-if="booking.entity"></v-text-field>
                </v-flex>
              </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Панель «Объект (авто)» (editCar) -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-car">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-car</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.car", { msg: object_name_for_label }) }}</span>
                      <span v-if="ft108IsDirty('car')" class="ft108-dot"></span>
                      <span class="ft108-panel-val">{{ booking.car_code }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <v-layout row wrap>
                <v-flex xs12 sm12 md8 v-if="!editCar">
                  <v-text-field :label="$t('bookings.car', { msg: object_name_for_label })" :value="booking.car_code" disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md8 v-if="editCar">
                  <v-autocomplete v-model="set_car" item-text="code" item-value="id" @change="
                    calculateCost(), warnIfCarDatesOverlap(set_car, booking)
                    " :loading="isLoadingCars" :search-input.sync="searchCar" text hide-no-data hide-details
                    :label="$t('custom.select_car')" :items="cars" return-object>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Панель «Даты и место» (editDate + editPlace; side-effect
                     открытия setDataToEditDate — в editPanels.js) -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-dates">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.panel_dates_place") }}</span>
                      <span v-if="ft108IsDirty('dates')" class="ft108-dot"></span>
                      <span class="ft108-panel-val">{{ ft108DatesValue() }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <!-- Плавающая база (решение USER 2026-07-16): даты брони с
                   продлениями МОЖНО менять — пересчитывается только
                   базовый период, сегменты продлений держат свои цены
                   (сервер: prolong_segments=true в превью). Замок остался
                   только на смене типа аренды и на конце, срезающем
                   продлённый период (сервер отвечает 422). -->
              <!-- FT-108: hint продлений вынесен из !editDate-ветки — при
                   открытой панели editDate = true и ветка скрыта, а hint
                   актуален именно во время правки дат -->
              <div v-if="prolongs && prolongs.length > 0" class="caption grey--text">
                {{ $t("bookings.prolongs_flex_dates_hint") }}
              </div>
              <v-layout row wrap>
                <v-flex xs12 sm4 md4 v-if="!editDate">
                  <v-text-field :label="$t('bookings.start_date_big')" :value="booking.start_date"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4 v-if="!editDate">
                  <v-text-field :label="$t('bookings.end_date_big')" :value="booking.end_date" disabled></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="editDate">
                <v-flex xs12 md8 class="p-0" v-if="start_date_not_formated && end_date_not_formated">
                  <v-flex md12 class="d-flex p-0">
                    <vc-date-picker v-model="start_date_not_formated" mode="dateTime" :masks="masks" is24hr
                      class="flex d-flex md12 p-0" timezone="UTC" :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
                      <template v-slot="{ inputValue, inputEvents, isDragging }">
                        <v-flex md12 :class="isMobile ? '' : 'd-flex'">
                          <v-text-field :class="isDragging
                            ? 'text-gray-600 mr-2 p-0'
                            : 'text-gray-900 mr-2 p-0'
                            " :value="inputValue" v-on="inputEvents" :label="$t('bookings.start_date_big')" readonly
                            hide-details></v-text-field>
                        </v-flex>
                      </template>
                    </vc-date-picker>
                    <vc-date-picker v-model="end_date_not_formated" mode="dateTime" :masks="masks" :min-date="minDate()"
                      is24hr class="flex d-flex md12 p-0" timezone="UTC" :locale="$i18n.locale"
                      :is-dark="$vuetify.theme.dark">
                      <template v-slot="{ inputValue, inputEvents, isDragging }">
                        <v-flex md12 :class="isMobile ? '' : 'd-flex'">
                          <v-text-field :class="isDragging
                            ? 'text-gray-600 p-0'
                            : 'text-gray-900 p-0'
                            " :value="inputValue" v-on="inputEvents" :label="$t('bookings.end_date_big')" readonly
                            hide-details></v-text-field>
                        </v-flex>
                      </template>
                    </vc-date-picker>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-row wrap class="mt-4">
                <v-flex xs12 sm5 md5>
                  <v-text-field :disabled="!editPlace" @input="editExtra = true" v-model="booking.location_start"
                    :label="$t('bookings.start_place')" prepend-icon="mdi-map-marker"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-text-field :disabled="!editPlace" @input="editExtra = true" v-model="booking.location_end"
                    :label="$t('bookings.end_place')" prepend-icon="mdi-map-marker"></v-text-field>
                </v-flex>
              </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Панель «Тариф и скидка» (editTariff + editSale; side-effect
                     открытия getTariffs — в editPanels.js). Хвост DEC-01:
                     booking_payments_type/period и выбор агента живут в теле
                     этой панели со своими точными условиями (REQ-06). -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-tariff">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-percent</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.panel_tariff_sale") }}</span>
                      <span v-if="ft108IsDirty('tariff')" class="ft108-dot"></span>
                      <span class="ft108-panel-val">{{ ft108TariffValue() }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <v-layout row wrap justify-space-between class="align-center">
                <v-flex v-if="!booking.hourly && !booking.weekly && !booking.monthly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale" :value="booking.sale"
                    @blur="calculateCost()" :label="$t('bookings.edit_sale_percent')"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.hourly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale" :value="booking.sale"
                    @blur="calculateCost()" :label="$t('bookings.edit_sale_percent_hourly')"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.weekly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale" :value="booking.sale"
                    @blur="calculateCost()" :label="$t('bookings.edit_sale_percent_weekly')"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.monthly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale" :value="booking.sale"
                    @blur="calculateCost()" :label="$t('bookings.edit_sale_percent_monthly')"></v-text-field>
                </v-flex>
                <v-flex v-if="!booking.hourly && !booking.weekly && !booking.monthly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale_cash" :value="booking.sale_cash"
                    @blur="calculateCost()" :label="$t('bookings.edit_sale_rub', { msg: currency })"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.hourly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale_cash" :value="booking.sale_cash"
                    @blur="calculateCost()"
                    :label="$t('bookings.edit_sale_rub_hourly', { msg: currency })"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.weekly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale_cash" :value="booking.sale_cash"
                    @blur="calculateCost()"
                    :label="$t('bookings.edit_sale_rub_weekly', { msg: currency })"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.monthly" xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.sale_cash" :value="booking.sale_cash"
                    @blur="calculateCost()"
                    :label="$t('bookings.edit_sale_rub_monthly', { msg: currency })"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.rental_cost_sale"
                    :value="booking.rental_cost_sale" @blur="calculateCost()"
                    :label="$t('bookings.edit_sale_rent_percent')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field :disabled="!editSale" v-model.number="booking.rental_cost_sale_cash"
                    :value="booking.rental_cost_sale_cash" @blur="calculateCost()" :label="$t('bookings.edit_sale_rent_rub', { msg: currency })
                      "></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select :disabled="!editTariff" v-model="selected_tariff_id" :items="tariffs" item-text="fullname"
                    item-value="id" :label="selected_tariff_id
                      ? $t('bookings.tariff')
                      : $t('bookings.no_tariff')
                      " clearable></v-select>
                </v-flex>
                <v-row>
                  <!-- <v-col cols="12" v-if="company.id == 4 || company.id == 5 || company.id == 11072">
                    <v-select v-model="booking_payments_type" :items="booking_payments_types"
                      :disabled="booking.technical" :label="$t('bookings.booking_payments_type')" dense hide-details>
                    </v-select>
                  </v-col>
                  <v-col cols="12"
                    v-if="booking_payments_type == 'periodic' && !booking.hourly && !booking.weekly && !booking.monthly">
                    <v-select v-model="booking_payments_period" :items="booking_payments_periods"
                      :disabled="booking.technical" :label="$t('bookings.booking_payments_period')" dense hide-details>
                    </v-select>
                  </v-col> -->
                  <!-- FT-193 REQ-07: источник списания автопродления; карта — только при рабочем терминале компании -->
                  <v-col cols="12" v-if="showPeriodicFundingEdit">
                    <v-select v-model="edit_periodic_funding" :items="periodic_fundings"
                      :label="$t('bookings.periodic_funding')" dense hide-details data-testid="periodic-funding-edit">
                    </v-select>
                  </v-col>
                  <v-col cols="12" v-if="company && company.can_select_agents">
                    <v-select v-model="booking.agent_id" :items="agents" item-text="name" item-value="id"
                      :label="$t('agents.select_agent')" :loading="isLoadingGetAgents" dense hide-details
                      :disabled="booking.technical" clearable>
                    </v-select>
                  </v-col>
                </v-row>
              </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Панель «Услуги и оборудование» (editExtra + editInsurance +
                     editEquipment). :disabled-биндинги полей на флаги оставлены
                     намеренно — страховка от рассинхрона (при открытой панели
                     все флаги true, поля активны). -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-services">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-package-variant</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.add_services") }}</span>
                      <span v-if="ft108IsDirty('services')" class="ft108-dot"></span>
                      <span class="ft108-panel-val">{{ ft108ServicesValue() }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <v-layout row wrap justify-space-between class="align-center">
                <!-- FT-102 (SC-08, решение USER 2026-08-05): при активном каталоге
                     оборудования легаси-галочки прячем — иначе на экране два
                     «оборудования». Бронь, где легаси-позиции уже проставлены
                     (старые брони), блок сохраняет: иначе их нечем снять. -->
                <v-flex md12 :class="isMobile ? 'align-center' : 'd-flex align-center'" justify-space-between
                  v-if="ft102CatalogCount === 0 || ft102HasLegacyEquipment">
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.baby_chair')"
                    v-model="booking.chair"></v-checkbox>
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.small_baby_chair')"
                    v-model="booking.chair_less_1_year"></v-checkbox>
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.booster')"
                    v-model="booking.booster"></v-checkbox>
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.navigator')"
                    v-model="booking.navigator"></v-checkbox>
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.wifi')"
                    v-model="booking.wifi_router"></v-checkbox>
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.mp3')" v-model="booking.mp3"></v-checkbox>
                  <v-checkbox :disabled="!editEquipment" :label="$t('bookings.charger')"
                    v-model="booking.charger"></v-checkbox>
                </v-flex>
                <v-flex md12 :class="isMobile ? 'align-center' : 'd-flex align-center'" justify-space-between
                  v-if="editEquipment && (ft102CatalogCount === 0 || ft102HasLegacyEquipment)">
                  <v-text-field :disabled="!editEquipment" v-model="booking.chairs_quantity"
                    :label="$t('bookings.baby_chair_qnt')" prepend-icon="mdi-map-marker"></v-text-field>
                  <v-text-field :disabled="!editEquipment" v-model="booking.boosters_quantity"
                    :label="$t('bookings.booster_qnt')" prepend-icon="mdi-map-marker"></v-text-field>
                </v-flex>
                <v-flex md12 :class="isMobile ? 'align-center' : 'd-flex align-center'" justify-space-between v-if="showInsurance">
                  <v-checkbox :disabled="!editInsurance" :label="$t('bookings.kasko')"
                    v-model="booking.kasko"></v-checkbox>
                  <v-checkbox :disabled="!editInsurance" :label="$t('bookings.super_kasko')"
                    v-model="booking.super_kasko"></v-checkbox>
                  <v-checkbox :disabled="!editInsurance" :label="$t('bookings.theft')"
                    v-model="booking.theft"></v-checkbox>
                  <v-checkbox :disabled="!editInsurance" :label="$t('bookings.no_franchise')"
                    v-model="booking.no_franchise"></v-checkbox>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field v-model.number="booking.delivery" :value="booking.delivery" @input="calculateCost()"
                    :disabled="!editExtra" :label="$t('bookings.delivery')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field v-model.number="booking.delivery_end" :value="booking.delivery_end"
                    @input="calculateCost()" :disabled="!editExtra" :label="$t('bookings.checkout')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <!-- UAT 2026-08-07: поле стоит в одной секции с панелью
                       каталожных допов FT-102 («Оборудование») — легаси-сумма
                       названа «Другое оборудование», иначе два денежных ввода
                       с одинаковым лейблом на одном экране. -->
                  <v-text-field v-model.number="booking.equipment" :value="booking.equipment" :disabled="!editExtra"
                    @input="calculateCost()" :label="$t('bookings.other_equipment')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field v-model.number="booking.clean_payment" :value="booking.clean_payment"
                    :disabled="!editExtra" @input="calculateCost()" :label="$t('bookings.clean')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1 v-if="showInsurance">
                  <v-text-field v-model.number="booking.insurance" :value="booking.insurance" @input="calculateCost()"
                    :disabled="!editExtra" :label="$t('bookings.insurance')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1 v-if="showFines">
                  <v-text-field v-model.number="booking.fine" :value="booking.fine" @input="calculateCost()"
                    :disabled="!editExtra" :label="$t('bookings.fines')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field v-model.number="booking.damage" :value="booking.damage" @input="calculateCost()"
                    :disabled="!editExtra" :label="$t('add_services.damages')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field v-model.number="booking.add_drivers_cost" :value="booking.add_drivers_cost"
                    @input="calculateCost()" :disabled="!editExtra"
                    :label="$t('bookings.add_drivers_small')"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field v-model.number="booking.other" :value="booking.other" :disabled="!editExtra"
                    @input="calculateCost()" :label="$t('bookings.other')"></v-text-field>
                </v-flex>
                <!-- FT-102: бронируемые допы (live: прямой CRUD строк с перепроверкой остатка) -->
                <v-flex xs12>
                  <booking-addons-panel v-if="booking && booking.id" :booking-id="booking.id"
                    :start-date="booking.start_date" :end-date="booking.end_date"
                    :units="ft102Units" :disabled="!editExtra"
                    :marketplace="Boolean(booking.vseprokaty_id)"
                    @server-addons-cost="ft102OnServerAddonsCost"
                    @addons-deposit-changed="ft102OnAddonsDepositChanged"
                    @addons-loaded="ft102CatalogCount = $event"
                    @lines-changed="ft102FetchLines()">
                  </booking-addons-panel>
                </v-flex>
              </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Панель «Информация» (showDescription). v-if на textarea
                     оставлены: панель открыта → флаг true → рендер. -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-info">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-note-text-outline</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.add_info") }}</span>
                      <span v-if="ft108IsDirty('info')" class="ft108-dot"></span>
                      <span class="ft108-panel-val">{{ ft108InfoValue() }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-flex xs12>
                    <v-textarea v-model="booking.description" v-if="showDescription" clearable auto-grow rows="1"
                      :label="$t('bookings.add_info_big')" data-testid="booking-description"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="booking.custom_field_1" v-if="showDescription" clearable auto-grow rows="1"
                      :label="$t('bookings.add_field_1')"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="booking.custom_field_2" v-if="showDescription" clearable auto-grow rows="1"
                      :label="$t('bookings.add_field_2')"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="booking.custom_field_3" v-if="showDescription" clearable auto-grow rows="1"
                      :label="$t('bookings.add_field_3')"></v-textarea>
                  </v-flex>
                </v-flex>
              </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Панель «Водители» (showAddDrivers) -->
                <v-expansion-panel>
                  <v-expansion-panel-header data-testid="ft108-panel-drivers">
                    <div class="ft108-panel-head">
                      <v-icon small class="mr-2">mdi-card-account-details-outline</v-icon>
                      <span class="ft108-panel-title">{{ $t("bookings.drivers") }}</span>
                      <span v-if="ft108IsDirty('drivers')" class="ft108-dot"></span>
                      <span class="ft108-panel-val">{{ ft108DriversValue() }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 v-if="showAddDrivers">
                  <h4 class="mt-2">
                    {{ $t("bookings.add_drivers_short") }}
                  </h4>
                  <v-flex class="d-flex align-center" md12 v-for="driver, index in selected_add_drivers" :key="index">
                    <v-text-field :value="driver && driver.fullname ? driver.fullname : ''"
                      :label="$t('bookings.add_driver_short')" readonly hide-details hide-no-data></v-text-field>
                    <v-btn icon @click="removeAddDriver(driver)" class="mt-2">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                  <div class="d-flex">
                    <v-autocomplete @change="addDriver($event)" item-text="fullname" item-value="id"
                      :loading="isLoadingClientsAddDriver" :search-input.sync="searchClientAddDriver" text hide-no-data
                      hide-details clearable @click:clear="searchClientAddDriver = ''" no-filter return-object
                      :label="$t('bookings.select_client')" :items="search_add_drivers" prepend-icon="mdi-account-box"
                      :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        ">
                    </v-autocomplete>
                  </div>
                </v-flex>
              </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- /FT-108: конец панелей. Ниже — хвост в сегодняшнем
                   порядке (DEC-01): тумблер manualEditing (режим всей формы,
                   не секция), manual-блоки, quote-баннеры, actions. Свитчи
                   showDescription/showAddDrivers удалены — их роль у панелей. -->
              <v-layout row wrap v-if="manualEditing" class="align-center">
                <v-flex md12>
                  <p>
                    <span class="red--text">{{
                      $t("bookings.attention")
                      }}</span>
                    {{ $t("bookings.warn_manual") }}
                    {{ $t("bookings.warn_manual_dates") }}
                  </p>
                </v-flex>
                <!-- FT-173 STEP-22 (F1, REQ-13): manualEditing взводится
                     сервером сам (manual_editing: true) для договорного
                     бронирования — поля ниже readonly (:readonly="rentToOwnLocked"),
                     подсказка объясняет почему (тот же паттерн, что
                     ft108-rent-to-own-hint у сегмента режима расчёта). -->
                <v-flex v-if="rentToOwnLocked" xs12 sm12 md12 class="py-0">
                  <div class="ft108-mode-hint" data-testid="ft108-manual-fields-locked-hint">
                    <v-icon x-small color="warning" class="mr-1">mdi-lock-outline</v-icon>
                    {{ $t("bookings.rent_to_own_locked_hint") }}
                  </div>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-if="!booking.hourly && !booking.weekly && !booking.monthly"
                    v-model.number="booking.days" :value="booking.days"
                    :label="$t('bookings.days_count')"></v-text-field>
                  <v-text-field :readonly="rentToOwnLocked" v-if="booking.hourly" v-model.number="booking.hourly_hours"
                    :value="booking.hourly_hours" :label="$t('bookings.hours_count')"></v-text-field>
                  <v-text-field :readonly="rentToOwnLocked" v-if="booking.weekly" v-model.number="booking.weekly_weeks"
                    :value="booking.weekly_weeks" :label="$t('bookings.weeks_count')"></v-text-field>
                  <v-text-field :readonly="rentToOwnLocked" v-if="booking.monthly" v-model.number="booking.monthly_months"
                    :value="booking.monthly_months" :label="$t('bookings.months_count')"></v-text-field>
                </v-flex>
                <v-flex v-if="!booking.hourly && !booking.weekly && !booking.monthly" xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.selected_price" :value="booking.selected_price"
                    :label="$t('bookings.day_price')"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.hourly" xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.selected_price" :value="booking.selected_price"
                    :label="$t('bookings.hour_price')"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.weekly" xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.selected_price" :value="booking.selected_price"
                    :label="$t('bookings.week_price')"></v-text-field>
                </v-flex>
                <v-flex v-if="booking.monthly" xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.selected_price" :value="booking.selected_price"
                    :label="$t('bookings.month_price')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.rental_cost" :value="booking.rental_cost"
                    :label="$t('bookings.cost_for_day')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.total" :value="booking.total"
                    :label="$t('bookings.cost_without_deposit')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-if="!booking.hourly && !booking.weekly && !booking.monthly"
                    v-model.number="booking.deposit" :value="booking.deposit"
                    :label="$t('bookings.deposit')" @input="ft102DepositTouched = true"></v-text-field>
                  <v-text-field :readonly="rentToOwnLocked" v-if="booking.hourly" v-model.number="booking.hourly_deposit"
                    :value="booking.hourly_deposit" :label="$t('bookings.deposit')"
                    @input="ft102DepositTouched = true"></v-text-field>
                  <v-text-field :readonly="rentToOwnLocked" v-if="booking.weekly" v-model.number="booking.weekly_deposit"
                    :value="booking.weekly_deposit" :label="$t('bookings.deposit')"
                    @input="ft102DepositTouched = true"></v-text-field>
                  <v-text-field :readonly="rentToOwnLocked" v-if="booking.monthly" v-model.number="booking.monthly_deposit"
                    :value="booking.monthly_deposit" :label="$t('bookings.deposit')"
                    @input="ft102DepositTouched = true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="!booking.hourly && !booking.weekly && !booking.monthly">
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.additional_hours" :value="booking.additional_hours"
                    :label="$t('bookings.add_hours_count')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="!booking.hourly && !booking.weekly && !booking.monthly">
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.price_hour" :value="booking.price_hour"
                    :label="$t('bookings.price_for_hour')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="!booking.hourly && !booking.weekly && !booking.monthly">
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.hours_cost" :value="booking.hours_cost"
                    :label="$t('bookings.total_for_hours')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.delivery" :value="booking.delivery"
                    :label="$t('bookings.delivery')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.delivery_end" :value="booking.delivery_end"
                    :label="$t('bookings.checkout')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.equipment" :value="booking.equipment"
                    :label="$t('bookings.add_equipment')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="showInsurance">
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.insurance" :value="booking.insurance"
                    :label="$t('bookings.add_insurance')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.add_drivers_cost" :value="booking.add_drivers_cost"
                    :label="$t('bookings.add_drivers_short')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2 v-if="showFines">
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.fine" :value="booking.fine"
                    :label="$t('bookings.fines')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.clean_payment" :value="booking.clean_payment"
                    :label="$t('bookings.clean')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.damage" :value="booking.damage"
                    :label="$t('add_services.damages')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.other" :value="booking.other"
                    :label="$t('bookings.other')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2 v-if="showMileage">
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.mileage_cost" :value="booking.mileage_cost"
                    :label="$t('bookings.mileage_cost')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="manualEditing" class="align-center">
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="booking.last_name" :label="$t('bookings.client_lastname')" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="booking.first_name" :label="$t('bookings.client_name')" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="booking.middle_name" :label="$t('bookings.client_middlename')" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="manualEditing && checkAdmin()" class="align-center">
                <v-flex xs12 sm3 md3>
                  <v-checkbox v-model="booking.clean_start" :disabled="booking.archive"
                    :label="$t('bookings.clean_start')" class="mt-0 pt-0 mr-1" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-checkbox v-model="booking.clean_end" :disabled="booking.archive" :label="$t('bookings.clean_end')"
                    class="mt-0 pt-0 mr-1" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="showFuel">
                  <v-checkbox v-model="booking.gas_start_full" class="mt-0 mr-1" :label="$t('bookings.gas_start_short')"
                    dense hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="showFuel">
                  <v-checkbox v-model="booking.gas_end_full" class="mt-0" :label="$t('bookings.gas_end_short')"
                    dense hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 sm3 md4 v-if="showFuel">
                  <v-text-field v-model="booking.gas_start" :label="$t('bookings.gas_start_short')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4 v-if="showFuel">
                  <v-text-field v-model="booking.gas_end" :label="$t('bookings.gas_end_short')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4 v-if="showMileage">
                  <v-text-field v-model.number="booking.start_mileage"
                    :label="$t('bookings.mileage_start')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4 v-if="showMileage">
                  <v-text-field v-model.number="booking.end_mileage" :label="$t('bookings.mileage_end')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4 v-if="showMileage">
                  <v-text-field v-model.number="booking.booking_mileage"
                    :label="$t('bookings.booking_mileage')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4>
                  <v-text-field :readonly="rentToOwnLocked" v-model.number="booking.start_price"
                    :label="$t('bookings.created_price')"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- FT-084 STEP-12 (FM-07): server-quote status banners, same
                   states/keys as NewBooking.vue (STEP-11). Индикация
                   «расчёт цены» живёт в кнопке Сохранить (:loading) —
                   отдельная временная строка сдвигала кнопки при каждом
                   пересчёте (manual QA 2026-07-13). -->
              <v-row v-if="!manualEditing && quoteStatus === 'error'">
                <v-col cols="12">
                  <v-alert type="error" dense text data-cy="edit_quote_error">{{ $t("bookings.quote_error") }}</v-alert>
                </v-col>
              </v-row>
              <!-- FT-166: причина по типу аренды + путь к исправлению, те же
                   ключи, что в NewBooking.vue. -->
              <v-row v-if="!manualEditing && quoteStatus === 'no_price'">
                <v-col cols="12">
                  <v-alert type="warning" dense text data-cy="edit_quote_no_price">
                    <div>{{ $t(noPriceMessageKey) }}</div>
                    <div v-if="noPriceCanTryDaily" class="mt-1">{{ $t("bookings.quote_no_price_try_daily") }}</div>
                    <a v-if="isStaff && carPricesHref" :href="carPricesHref" target="_blank" rel="noopener"
                      class="d-inline-block mt-1" data-cy="edit_quote_no_price_link" @click="onOpenCarPrices"
                    @auxclick="onOpenCarPrices">
                      {{ $t("bookings.quote_no_price_open_prices") }}
                    </a>
                    <div v-else class="mt-1">{{ $t("bookings.quote_no_price_ask_admin") }}</div>
                  </v-alert>
                </v-col>
              </v-row>
              <!-- Плавающая база (2026-07-16): новый конец срезает продлённый
                   период / попытка сменить тип аренды брони с продлениями —
                   сервер отвечает 422, Save заблокирован (pricingReady). -->
              <v-row v-if="!manualEditing && quoteStatus === 'prolongs_base_degenerate'">
                <v-col cols="12">
                  <v-alert type="warning" dense text data-cy="edit_quote_prolongs_degenerate">{{ $t("bookings.prolongs_base_degenerate_hint") }}</v-alert>
                </v-col>
              </v-row>
              <v-row v-if="!manualEditing && quoteStatus === 'prolongs_lock_dates'">
                <v-col cols="12">
                  <v-alert type="warning" dense text data-cy="edit_quote_prolongs_lock">{{ $t("bookings.prolongs_lock_dates_hint") }}</v-alert>
                </v-col>
              </v-row>
              <!-- FT-130: repricing на бронировании с замороженными продлениями
                   ценами — Save заблокирован (pricingReady). -->
              <v-row v-if="!manualEditing && quoteStatus === 'prolongs_frozen_pricing'">
                <v-col cols="12">
                  <v-alert type="warning" dense text data-cy="edit_quote_prolongs_frozen">{{ $t("bookings.prolongs_frozen_pricing_hint") }}</v-alert>
                </v-col>
              </v-row>
              <!-- 2026-07-22 (разворот контракта 2026-07-21): внешняя бронь
                   редактируема, но только вручную — информационный баннер
                   вместо блокирующего, ключуется на самой броне (квота для
                   внешних больше не запрашивается, quoteStatus = ready). -->
              <v-row v-if="isExternalCalculationBooking">
                <v-col cols="12">
                  <!-- warning, не info (USER 2026-07-22): оператор должен
                       насторожиться — бронь чужая по происхождению, и его
                       правки может перезаписать очередной апдейт интеграции -->
                  <v-alert type="warning" dense text data-cy="edit_quote_external_calculation">{{ $t("bookings.external_manual_only") }}</v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Убрал а потом обратно добавил (set_car = []), -->
          <!-- Опять убрал (set_car = []), но добавил getCar(), -->
          <!-- FT-108 DEC-02: панельные флаги + даты/тариф — в едином
               ft108ResetEditSections() (см. крестик шапки) -->
          <v-btn text @click="
            getBooking(),
            (editDialog = false),
            (manualEditing = false),
            (warningAddOneDay = false),
            (warningLessThenDay = false),
            ft108ResetEditSections()
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="editSave()"
            :loading="isLoadingEditSave || (!manualEditing && quoteStatus === 'loading')" :disabled="!pricingReady"
            data-cy="edit_save_booking">
            {{ $t("custom.save") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Продление -->
    <prolong-dialog v-model="prolongDialog" :booking="booking" :is-mobile="isMobile" :currency="currency"
      :client="client" :set_car="set_car" :add_drivers="selected_add_drivers" :company="company"
      :company_cashboxes="company_cashboxes" :worker_accounts="worker_accounts"
      :booking_tariff="findTariffObject(booking.tariff_id)"
      :show-select-worker-cashbox="showSelectWorkerCashbox" @save="saveProlong" @close="closeProlongDialog"
      @translate-count-group="translateCountGroup" @format-created-at="formatCreatedAt"
      @current-deposit="currentDeposit" :is-loading-save-prolong="isLoadingSaveProlong" />
    <!-- Приём -->
    <arrival-dialog v-model="showArrivalDialog" :booking="booking" :set_car="set_car" :fines="fines"
      :is-mobile="isMobile" :company="company" :company_cashboxes="active_company_cashboxes"
      :worker_accounts="worker_accounts" :is-loading="isLoadingInHome"
      :is-tracker-report-loading="isTrackerReportLoading" :tracker_report="tracker_report"
      :show-select-worker-cashbox="showSelectWorkerCashbox" @close="closeArrivalDialog" @in-home="inHomeRefactored" @reset-loading="resetLoadingInHome" />
    <!-- Оплата -->
    <payment-dialog v-model="payment_dialog" :booking="booking" :outcome-unknown="paymentOutcomeUnknown" :departure_payments="departure_payments"
      :rent-to-own-contract="rentToOwnContract" @close="closePaymentDialog" @savePayment="savePayment"
      @start-new-payment="startNewPayment" :is_loading="isLoadingSavePayment" />
    <!-- FT-193 REQ-09 (CTR-05): ручная фиксация исхода платежа Т-Банка со статусом «исход неизвестен» -->
    <v-dialog v-model="tinkoffResolveDialog" :retain-focus="false" max-width="480px" :persistent="isLoadingTinkoffResolve">
      <v-card v-if="tinkoffResolvePayment" data-testid="tinkoff-resolve-dialog">
        <v-card-title class="text-h6">{{ $t("tinkoff.resolve_title") }}</v-card-title>
        <v-card-text>
          {{ $t("tinkoff.resolve_text", { sum: tinkoffResolvePayment.sum / 100.0, payment_id: tinkoffResolvePayment.payment_id || tinkoffResolvePayment.id }) }}
        </v-card-text>
        <v-card-actions class="flex-wrap">
          <v-btn text :disabled="isLoadingTinkoffResolve" @click="tinkoffResolveDialog = false">{{ $t("custom.cancel") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined :loading="isLoadingTinkoffResolve" @click="resolveTinkoffPayment('failed')"
            data-testid="tinkoff-resolve-failed">{{ $t("tinkoff.resolve_failed") }}</v-btn>
          <v-btn color="success" :loading="isLoadingTinkoffResolve" @click="resolveTinkoffPayment('success')"
            data-testid="tinkoff-resolve-success">{{ $t("tinkoff.resolve_success") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCustomEmailDialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="1000px"
      :loading="isLoadingSendCustomEmail || isLoadingUpdateEmailTemplate || isLoadingSaveCustomEmail">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{
            $t("email_templates.letter_for_client")
            }}</span>
          <!-- <v-icon
            class="ml-2 secondary--text"
            @click=""
            v-tooltip="{
              content: 'Шаблоны ответов',
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500
              }
            }"
          >
            mdi-book-open-variant
          </v-icon> -->
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="
            (showCustomEmailDialog = false),
            (editEmailTemplate = false),
            (customEmailData = {
              id: null,
              body: null,
              name: null,
              subject: null,
            }),
            (selected_email_templates = null),
            (save_email_template = false),
            (showEmailTemplates = false)
            ">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-container :style="isMobile ? 'padding: 5px !important;' : ''">
              <v-layout row wrap>
                <v-flex md12>
                  <v-flex md12 v-if="showEmailTemplates">
                    <h4 v-if="editEmailTemplate">
                      {{ $t("email_templates.edit_template") }}
                    </h4>
                    <h4 v-if="!editEmailTemplate">
                      {{ $t("email_templates.templates") }}
                    </h4>
                    <v-flex md12 class="d-flex">
                      <v-select v-model="selected_email_templates" :items="email_templates" item-text="name"
                        item-value="id" clearable :label="$t('email_templates.select_template')"></v-select>
                      <v-icon v-if="selected_email_templates" class="ml-1 mr-1"
                        @click="editEmailTemplate = !editEmailTemplate">
                        mdi-pencil-outline
                      </v-icon>
                      <v-icon v-if="selected_email_templates" @click="deleteEmailTemplate(selected_email_templates)">
                        mdi-delete-forever
                      </v-icon>
                    </v-flex>
                  </v-flex>
                  <v-flex md12 v-if="editEmailTemplate">
                    <v-text-field v-model="customEmailData.name" value="" :label="$t('email_templates.template_name')"
                      :placeholder="$t('email_templates.placeholder_name')"></v-text-field>
                  </v-flex>
                  <v-flex md12>
                    <v-text-field v-model="customEmailData.subject" :label="$t('email_templates.subject')"
                      :placeholder="$t('email_templates.placeholder_subject')"></v-text-field>
                  </v-flex>
                  <v-flex md12>
                    <v-textarea v-model="customEmailData.body" :label="$t('email_templates.message')" rows="2"
                      auto-grow></v-textarea>
                  </v-flex>
                  <v-flex md12>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <p class="subheader-1">
                            {{ $t("email_templates.variables") }}
                          </p>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <code>{{ "{" + "{" + "name" + "}" + "}" }}</code> -
                          {{ $t("email_templates.client_name") }},<br />
                          <code>{{ "{" + "{" + "lastname" + "}" + "}" }}</code>
                          - {{ $t("email_templates.lastname") }},<br />
                          <code>{{
                            "{" + "{" + "middlename" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.middlename") }},<br />
                          <code>{{
                            "{" + "{" + "booking_id" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.booking_id") }},<br />
                          <code>{{
                            "{" + "{" + "start_date" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.start_date") }},<br />
                          <code>{{ "{" + "{" + "end_date" + "}" + "}" }}</code>
                          - {{ $t("email_templates.end_date") }},<br />
                          <code>{{
                            "{" + "{" + "location_start" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.location_start") }},<br />
                          <code>{{
                            "{" + "{" + "location_end" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.location_end") }},<br />
                          <code>{{ "{" + "{" + "car_name" + "}" + "}" }}</code>
                          - {{ $t("email_templates.car_name") }},<br />
                          <code>{{ "{" + "{" + "days" + "}" + "}" }}</code> -
                          {{ $t("email_templates.days") }},<br />
                          <code>{{ "{" + "{" + "price" + "}" + "}" }}</code> -
                          {{ $t("email_templates.price") }},<br />
                          <code>{{ "{" + "{" + "total" + "}" + "}" }}</code> -
                          {{ $t("email_templates.total") }},<br />
                          <code>{{ "{" + "{" + "deposit" + "}" + "}" }}</code> -
                          {{ $t("email_templates.deposit") }},<br />
                          <code>{{
                            "{" + "{" + "company_name" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.company_name") }},<br />
                          <code>{{
                            "{" + "{" + "company_email" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.company_email") }},<br />
                          <code>{{
                            "{" + "{" + "company_phone" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.company_phone") }},<br />
                          <code>{{
                            "{" + "{" + "company_address" + "}" + "}"
                          }}</code>
                          - {{ $t("email_templates.company_address") }}
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                  <v-flex md12 class="d-flex justify-center">
                    <v-switch :label="$t('email_templates.add_attachment')" v-model="attachment_email_template"
                      class="mr-2"></v-switch>
                    <v-switch :label="$t('email_templates.save_template')" v-model="save_email_template"></v-switch>
                  </v-flex>
                  <v-flex md12 v-if="!editEmailTemplate && save_email_template">
                    <v-text-field v-if="save_email_template" v-model="customEmailData.name"
                      :label="$t('email_templates.template_name')"
                      :placeholder="$t('email_templates.placeholder_name')"></v-text-field>
                  </v-flex>
                  <v-flex md12 class="d-flex justify-center">
                    <v-switch v-model="sendEmail" @change="checkEmail()" class="mt-0 mr-1 mr-1" label="Email" dense
                      hide-details></v-switch>
                    <v-switch v-model="sendMessenger" @change="checkMessenger()" class="mt-0 mr-1 mr-1" :label="$t('custom.messengers')"
                      :disabled="$store.getters.getCompany.company
                        ? !$store.getters.getCompany.company.whatsapp
                        : false
                        " dense hide-details></v-switch>
                  </v-flex>
                  <v-flex md12 v-if="attachment_email_template || customEmailData.attachment_id
                  ">
                    <v-autocomplete v-if="attachment_email_template" v-model="customEmailData.attachment_id"
                      item-text="name" item-value="id" flat hide-no-data hide-details
                      :label="$t('email_templates.select_attachment')" :items="templates" clearable>
                    </v-autocomplete>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="
            (showCustomEmailDialog = false),
            (editEmailTemplate = false),
            (customEmailData = {
              id: null,
              body: null,
              name: null,
              subject: null,
            }),
            (selected_email_templates = null),
            (save_email_template = false),
            (showEmailTemplates = false)
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn v-if="!editEmailTemplate && !save_email_template" color="success" @click="sendCustomEmail()"
            :loading="isLoadingSendCustomEmail">{{
              $t("email_templates.send") }}</v-btn>
          <v-btn v-if="editEmailTemplate && !save_email_template" color="success" @click="updateEmailTemplate()"
            :loading="isLoadingUpdateEmailTemplate">{{
              $t("email_templates.save_template") }}</v-btn>
          <v-btn v-if="save_email_template && !editEmailTemplate" color="success" @click="saveCustomEmail()"
            :loading="isLoadingSaveCustomEmail">{{
              $t("email_templates.save_template") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showQrcodeWhatsapp" :retain-focus="false" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <h2>{{ $t("whatsapp.check") }}</h2>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(whatsappQrcode = null), (showQrcodeWhatsapp = false)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-container>
              <v-layout row wrap>
                <v-flex md12>
                  <h3>{{ $t("whatsapp.auth") }}</h3>
                  <p>
                    {{ $t("whatsapp.scan") }}
                  </p>
                  <v-img v-if="whatsappQrcode" :src="whatsappQrcode" max-width="400px"></v-img>
                  <v-btn v-else @click="retryWhatsapp()">{{
                    $t("whatsapp.load_code")
                    }}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="(whatsappQrcode = null), (showQrcodeWhatsapp = false)">{{
            $t("custom.close") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSignPad" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="600px">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <h2>{{ $t("sign.sign") }}</h2>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(showSignPad = false), undoSign()">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="text-center" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-select v-model="signature_type" class="mb-2" item-text="name" item-value="value" :items="signature_types"
            hide-details :label="$t('sign.select_type')"></v-select>
          <VueSignaturePad :options="{
            onBegin: () => {
              $refs.signaturePad.resizeCanvas();
            },
          }" :customStyle="{ border: 'black 1px dashed', margin: '0 auto' }" :width="isMobile ? '300px' : '500px'"
            height="250px" ref="signaturePad" />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="saveSign()">{{
            $t("custom.save")
            }}</v-btn>
          <v-btn color="secondary" @click="undoSign()">{{
            $t("sign.back")
            }}</v-btn>
          <v-btn color="warning" @click="clearSign()">{{
            $t("sign.clear")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- История брони -->
    <v-dialog v-model="booking_histories_dialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="1000px">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("bookings.history") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="booking_histories_dialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-treeview v-if="booking_histories && booking_histories.length > 0" :items="booking_histories"></v-treeview>
          <v-subheader v-else>{{ $t("bookings.empty_history") }}</v-subheader>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="booking_histories_dialog = false">{{ $t("custom.close") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Подарки -->
    <v-dialog v-model="show_gifts_dialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="1000px">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span v-if="!booking.hourly && !booking.weekly && !booking.monthly" class="headline">{{ $t("gifts.title")
          }}</span>
          <span v-if="booking.hourly" class="headline">{{ $t("gifts.hourly_title") }}</span>
          <span v-if="booking.weekly" class="headline">{{ $t("gifts.weekly_title") }}</span>
          <span v-if="booking.monthly" class="headline">{{ $t("gifts.monthly_title") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="show_gifts_dialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex v-if="!booking.hourly && !booking.weekly && !booking.monthly" :class="!isMobile ? 'd-flex' : ''">
            <v-flex md4>
              <v-select v-model="gift.gift_type" item-text="name" item-value="value" class="mr-2" :items="gift_types"
                hide-details :label="$t('gifts.type')"></v-select>
            </v-flex>
            <v-flex md4>
              <v-text-field v-model.number="gift.count" :label="$t('gifts.count')"
                :placeholder="$t('gifts.count_placeholder')" class="mr-2"></v-text-field>
            </v-flex>
            <v-flex md4>
              <v-text-field v-model.number="gift.price" :label="$t('gifts.price')"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex v-if="booking.hourly" :class="!isMobile ? 'd-flex' : ''">
            <v-flex md6>
              <v-text-field v-model.number="gift.count" :label="$t('gifts.hours_count')"
                :placeholder="$t('gifts.hours_count_placeholder')" class="mr-2"></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field v-model.number="gift.price" :label="$t('gifts.price')"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex v-if="booking.weekly" :class="!isMobile ? 'd-flex' : ''">
            <v-flex md6>
              <v-text-field v-model.number="gift.count" :label="$t('gifts.weeks_count')"
                :placeholder="$t('gifts.weeks_count_placeholder')" class="mr-2"></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field v-model.number="gift.price" :label="$t('gifts.price')"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex v-if="booking.monthly" :class="!isMobile ? 'd-flex' : ''">
            <v-flex md6>
              <v-text-field v-model.number="gift.count" :label="$t('gifts.months_count')"
                :placeholder="$t('gifts.months_count_placeholder')" class="mr-2"></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field v-model.number="gift.price" :label="$t('gifts.price')"></v-text-field>
            </v-flex>
          </v-flex>
          <!-- Расчётная подсказка цены за единицу (решение USER 2026-07-16:
               подарок = «бесплатное продление», считать КАК ПРОДЛЕНИЕ):
               подсказка = ставка ступени РАСШИРЕННОЙ длительности
               (квота на [start, end + count], см. requestGiftPreview);
               для типа «Часы» — booking.price_hour. Сам подарок при
               сохранении — вычет −(цена × кол-во) по свободной цене
               оператора; «Использовать» подставляет ставку в поле. -->
          <v-flex class="mt-2" v-if="giftPreviewStatus !== 'idle'">
            <v-alert :value="true" :type="giftPreviewStatus === 'error' ? 'error' : 'info'" dense outlined
              class="mb-0 text-overline text-center" data-cy="gift_server_preview">
              <template v-if="giftPreviewStatus === 'loading'">
                {{ $t("bookings.quote_loading") }}
              </template>
              <template v-else-if="giftPreviewStatus === 'error'">
                {{ $t("bookings.quote_error") }}
              </template>
              <template v-else-if="giftPreviewStatus === 'ready'">
                <span>{{ $t("gifts.estimated_price") }}:
                  <span data-cy="gift_server_preview_price">{{ giftPreviewUnitPrice }}</span>{{ findCurrencySymbol(base_currency_id) }}
                </span>
                <v-btn class="ml-2" x-small outlined color="secondary" data-cy="gift_use_server_price"
                  @click="applyGiftPreviewPrice()">
                  {{ $t("prolongs.use_server_price") }}
                </v-btn>
              </template>
            </v-alert>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-2" @click="saveGift()">{{
            $t("custom.save")
            }}</v-btn>
          <v-btn color="blue darken-1" text @click="show_gifts_dialog = false">{{ $t("custom.close") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Загрузка фото выдачи -->
    <v-dialog v-model="uploadPhotosDialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="800px" @click:outside="uploadPhotosDialog = false">
      <v-card>
        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex xs12 sm12 md12 class="mb-5 mt-10 mx-5">
            <gallery :new-photos="newCheckinPhotos" :booking_id="booking.id"></gallery>
          </v-flex>
          <v-flex xs12 sm12 md12 class="my-2 d-flex justify-center">
            <!-- FT-153: потолок больше не приходит пропом. Он зависит от типа файла
                 (видео 300 МБ, фотография 50 МБ) и живёт в самом загрузчике: задавать
                 его снаружи значило бы держать половину правила здесь, половину там. -->
            <uppy-checkin @updateCheckinPhotos="updateCheckinPhotos"
              :width="isMobile ? 300 : 750" :height="isMobile ? 250 : 250"
              :theme="$vuetify.theme.dark ? 'dark' : 'light'" :booking_id="booking.id"></uppy-checkin>
          </v-flex>
          <!-- Отображение повреждений автомобиля -->
          <v-row v-if="booking && (booking.checkin_damages?.length > 0 || booking.checkout_damages?.length > 0)" class="mt-4">
            <v-col cols="12" md="6">
              <!-- Повреждения при выдаче (checkin) -->
              <v-row v-if="booking.checkin_damages && booking.checkin_damages.length > 0">
                <v-col cols="12">
                  <v-card outlined class="mb-3">
                    <v-card-title class="subtitle-1">
                      {{ $t('bookings.checkin_damages') }}
                      <v-chip x-small color="info" text-color="white" class="ml-2">
                        {{ booking.checkin_damages.length }}
                      </v-chip>
                    </v-card-title>
                    <v-card-text>
                      <CarDamageMarker
                        :value="booking.checkin_damages"
                        mode="checkin"
                        :booking-id="booking.id"
                        :readonly="true"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <!-- Повреждения при возврате (checkout) -->
              <v-row v-if="booking.checkout_damages && booking.checkout_damages.length > 0">
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title class="subtitle-1">
                      {{ $t('bookings.checkout_damages') }}
                      <v-chip x-small color="warning" text-color="white" class="ml-2">
                        {{ booking.checkout_damages.length }}
                      </v-chip>
                    </v-card-title>
                    <v-card-text>
                      <CarDamageMarker
                        :value="booking.checkout_damages"
                        mode="checkout"
                        :booking-id="booking.id"
                        :readonly="true"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="success" @click="uploadPhotos()">{{
            $t("custom.save")
          }}</v-btn> -->
          <v-btn text @click="uploadPhotosDialog = false">{{ $t("custom.close") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_audited_dialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="1000px">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("bookings.history") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="show_audited_dialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-treeview v-if="booking_audits && booking_audits.length > 0" :items="booking_audits"></v-treeview>
          <v-subheader v-else>{{ $t("bookings.empty_history") }}</v-subheader>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="show_audited_dialog = false">{{ $t("custom.close") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- OkiDoki Contract Dialog -->
    <OkidokiContractDialog 
      v-model="showOkidokiDialog"
      :booking="booking"
      @contract-sent="handleContractSent"
    />

    <!-- DocuSeal Contract Dialog -->
    <DocusealContractDialog 
      v-model="showDocusealDialog"
      :booking="booking"
      @contract-sent="handleDocusealContractSent"
    />

  </span>
</template>
<script>
import { clientFullName } from "@/utils/personName";
import { secretSet } from "@/utils/integrationSecrets"; // FT-195
import { translateCountCategory } from "@/utils/countCategory";
import BookingHeader from './BookingHeader.vue'
import { depositFieldFor } from '@/components/dashboard/bookings/addonsMath'
import { isArrivalEndDateValid } from '@/components/dashboard/bookings/arrivalEndDate'
import { isStaleBookingSnapshot } from '@/components/dashboard/bookings/bookingSnapshot'
import LoadFailedRetry from '@/components/common/LoadFailedRetry.vue'
import { isTransientNetworkError } from '@/utils/networkErrors'
import TaskCardSection from '@/components/dashboard/tasks/TaskCardSection.vue'
import TaskFormDialog from '@/components/dashboard/tasks/TaskFormDialog.vue'
import BookingDebts from './BookingDebts.vue'
import BookingFines from './BookingFines.vue'
import BookingInvoices from './BookingInvoices.vue'
import DepartureDialog from './DepartureDialog.vue'
import PaymentDialog from './PaymentDialog.vue'
import ArrivalDialog from './ArrivalDialog.vue'
import DepositHoldBlock from './DepositHoldBlock.vue'
import { requestReviewAfterSuccess } from "@/services/appReviewService";
import ProlongDialog from './ProlongDialog.vue'
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { extendMoment } from "moment-range";
import { Capacitor } from "@capacitor/core";
import UppyCheckin from "../../../plugins/uppy_checkin";
import CarDamageMarker from './CarDamageMarker.vue';
import BookingActIcon from '@/components/dashboard/damage_control/act/BookingActIcon.vue';
import Gallery from "./Gallary";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { copyTextWhenReady } from '@/utils/clipboard';
import { s3PublicUrl } from '@/utils/s3PublicUrl';
let uuid = require("uuid");
import { nanoid } from 'nanoid'

const moment_range = extendMoment(moment);
// moment.locale("ru");
import Docxtemplater from "docxtemplater";
import axios from "axios";
import PizZip from "pizzip";
import { saveAs } from "file-saver";
import PdfDocuments from "./PdfDocuments.vue";
import OkidokiContractDialog from "./OkidokiContractDialog.vue";
import DocusealContractDialog from "./DocusealContractDialog.vue";
import CableSubscriber from "@/mixins/CableSubscriber";
import { getConsumer } from "@/cable";
import { buildQuoteIdentity, quoteIdentityEquals, buildQuotePayload, buildManualPricePart, formatQuoteDate, seasonModeKey, quoteErrorStatus, BookingQuoteRequester, noPriceCauseKey, hasUsableBasePrices, pricesForRentalType, fetchStoredAndCurrentQuotes } from "./bookingQuote";
import { sumMoney, sumPaymentsByType } from "./moneySum";
import { buildProlongAnnulWarning, isNewestProlong } from "./prolongAnnulWarning";
import { buildManualModeOnWarning, buildAutoCalcOnWarning } from "./manualModeWarning";
import { extraDayReasonKey } from "./extraDayReason";
// FT-108 (REQ-03, CON-01): маппинг «панель ↔ edit-флаги» — в модуле
import {
  EDIT_SECTIONS,
  isSectionOpen,
  openSection,
  closeSection,
  resetAllSections,
  takeSectionSnapshots,
  isSectionDirty,
  formatServicesValue,
} from "./editPanels";
// FT-108 v2: состав суммы в шапке формы редактирования
import { buildBookingSummary } from "./editSummary";
// Реакция на выбор/снятие тарифа в форме — вынесена по тому же прецеденту
import { applyTariffSelection } from "./tariffSelection";
import BookingAddonsPanel from "@/components/dashboard/bookings/BookingAddonsPanel.vue";
// FT-173 STEP-15 (REQ-12): панель договора выкупа взамен блока цены у
// договорного бронирования.
import RentToOwnPanel from "@/components/dashboard/bookings/RentToOwnPanel.vue";
import { readInitialSection } from "@/components/dashboard/cards/initialSection";
// FT-173 STEP-18 (REQ-13 сохранение, CTR-05/CTR-06): разбор кода ошибки
// модуля и белый список полей editSave() договорного бронирования.
import { parseRentToOwnError } from "@/api/rentToOwn";
import { extractValidationDetail } from "@/mixins/setErrorMixin";
// «Отъездила» ⇒ приёмка: выбор статуса проверяется до запроса с объяснением
// причины (refuseRidedState), «Выдать» скрыта у отъездившего (isReturnedBooking).
import { isReturnedBooking, refuseRidedState } from "@/utils/ridedStateGuard";
import { filterToRentToOwnAllowlist } from "@/components/dashboard/bookings/rentToOwnSaveAllowlist";
import {
  PERIODIC_RENEWAL_STATE_LABEL_KEYS,
  PERIODIC_FUNDING_LABEL_KEYS,
  TINKOFF_OUTCOME_LABEL_KEYS,
  periodicRenewalStateColor,
  periodicRenewalStopped,
  periodicBlockReasonKey,
  periodicBlockReasonDetail,
  tinkoffOutcomeColor,
  tinkoffPaymentCompleted,
} from "@/components/dashboard/bookings/periodicRenewal";
// FT-173 STEP-22 (F1, REQ-13): секции формы правки, которые для договорного
// бронирования не открываются в режим правки — деньги/даты/машину/тариф/
// клиента ведёт договор выкупа. "info"/"drivers" сюда не входят: они в белом
// списке rentToOwnSaveAllowlist.js (операционные поля).
const RENT_TO_OWN_LOCKED_SECTION_KEYS = new Set(["client", "car", "dates", "tariff", "services"]);
import { translateFineState as translateFineStateText } from "@/utils/localeInfra";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import restoredCaptureMixin from "@/mixins/restoredCaptureMixin"; // FT-186 REQ-04
import { originOf } from "@/utils/apiOrigin";
import { formatPhone, telHref, waHref, phoneLastDigits } from "@/lib/phone/display";
import { generateIdempotencyKey, isOutcomeUnknown, readPendingCharge, writePendingCharge, clearPendingCharge } from "@/utils/tinkoffCard";
import AgentMarker from "@/components/agents/AgentMarker.vue";
import agentMarkerLoader, { isAgentAuditComment } from "@/components/agents/agentMarkerLoader";
import { formatAdjustmentPercent } from "@/utils/adjustmentPercent"; // FT-216

// FT-173 контроль V3 (REQ-25, REQ-26): статусы возврата, которые api
// (641ded4a9) отклоняет у бронирования действующего договора выкупа, —
// значения `value` тех же пунктов bookings_states ниже (data), по которым
// строится меню статусов карточки.
const RENT_TO_OWN_RETURN_STATES = Object.freeze(["Отъездила", "Вернуть залог"]);

export default {
  mixins: [CableSubscriber, rentalObjectMixin, restoredCaptureMixin],
  pullToRefresh: true,
  data() {
    return {
      checkinDamageImageCallback: null, // Callback для загрузки изображения повреждений при выдаче
      subscribedCompanyId: null, // ID компании для отписки от канала
      subscribedBookingId: null, // ID брони для отписки от канала
      cardSections: null,
      cardSectionsEntityId: null,
      cardLoadSequence: 0,
      periodicLoadSequence: 0,
      partnerAccess: { can_view_booking_card: false, can_view_maintenances: false },
      taskDialog: false,
      booking: { payments: [], counts: [], prolongs: [], generated_documents: [], messages: [], client: {} },
      generated_documents: [], // Отдельное реактивное свойство для документов
      bookings: [],
      carBookingsLoaded: false, // Флаг: загружены ли брони машины (lazy load)
      cars: [],
      clients: [],
      workers: [],
      set_car: {},
      set_client: {},
      client: {},
      auto_calculate: true,
      // remount-ключ тумблеров режима: на отмене confirm переключатель
      // пересоздаётся в прежнем положении (:input-value — controlled).
      modeSwitchKey: 0,
      // раскрывашка «Сезоны» в шапке (FT-111): состояние на сессию диалога
      ft108ShowSeasons: false,
      // текст отказа сервера на активации/деактивации — рядом с контролом
      activeStateError: "",
      // поколение попытки: сброс секций сдвигает его, и ответ, прилетевший
      // после закрытия формы, уже не может воскресить строку ошибки
      activeStateEpoch: 0,
      gas_start: "",
      fuel_price: 50,
      clean_price: 0,
      selected_prices: 0,
      check_mileage: 0,
      selected_period: null,
      selected_season: null,
      selected_seasons: [],
      season_days_diff_first: 0,
      season_days_diff_second: 0,
      season_first: null,
      season_second: null,
      editTariff: false,
      selected_tariff_id: null,
      tariffs: [
        {
          id: null,
          name: this.$t("custom.standart_tariff"),
          fullname: this.$t("custom.standart_tariff"),
        },
      ],
      tariff: null,
      gifts: [],
      gift: { gift_type: 0, price: 0, count: 1 },
      // Расчётная подсказка цены подарка (паттерн serverPreview* ProlongDialog).
      giftPreviewStatus: "idle",
      giftPreviewUnitPrice: null,
      giftPreviewSeq: 0,
      giftPreviewTimer: null,
      gift_types: [
        { name: this.$t("gifts.days"), value: 0 },
        { name: this.$t("gifts.hours"), value: 1 },
      ],
      giftsPanel: 0,
      gift_create: false,
      gift_delete: false,
      show_gifts_dialog: false,
      // Инициализация с валидными датами вместо null (для v-calendar)
      start_date_not_formated: new Date().toISOString(),
      end_date_not_formated: new Date(Date.now() + 3600000).toISOString(), // +1 час
      sendEmail: false,
      sendMessenger: false,
      sendSms: false,
      signature: null,
      booking_histories: [],
      booking_histories_dialog: false,
      new_message: null,
      send_message_loading: false,
      masks: {
        // dayPopover: "DD MMM, YYYY",
      },
      hours: 0,
      payment: {
        cash: 0,
        cashless: 0,
        cash_card: 0,
        entity: 0,
        booking_id: null,
      },
      paymentsPanel: 0,
      tinkoffPaymentsPanel: 0,
      // FT-193 STEP-17: действия над автопродлением, фиксация исхода платежа Т-Банка, источник списания в правке
      isLoadingPeriodicAction: false,
      tinkoffResolveDialog: false,
      tinkoffResolvePayment: null,
      isLoadingTinkoffResolve: false,
      edit_periodic_funding: "balance",
      prolongsPanel: 0,
      showAddPayment: false,
      showArrivalPayments: false,
      showCashCardPayment: false,
      showCashPayment: false,
      showEntityPayment: false,
      showPartRejection: false,
      giveFullDeposit: true,
      partReturnDeposit: false,
      part_payment: false,
      showCleanPaid: false,
      showSignPad: false,
      showOkidokiDialog: false,
      showDocusealDialog: false,
      templates: [],
      docx_templates: [],
      departure_payments: {
        rent: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        deposit: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        delivery: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        delivery_end: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        clean: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        hours_cost: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        insurance: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        equipment: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        addons: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null }, // FT-102
        fine: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        damage: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        add_drivers_cost: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        gas: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        mileage: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        other: { sum: 0, icon: null, currency_id: null, company_cashbox_id: null, company_cashbox: null },
      },
      arrival_payments: {
        rent: { sum: 0, icon: null, currency_id: null },
        clean: { sum: 0, icon: null, currency_id: null },
        delivery: { sum: 0, icon: null, currency_id: null },
        delivery_end: { sum: 0, icon: null, currency_id: null },
        additional_hours: { sum: 0, icon: null, currency_id: null },
        insurance: { sum: 0, icon: null, currency_id: null },
        add_drivers_cost: { sum: 0, icon: null, currency_id: null },
        gas: { sum: 0, icon: null, currency_id: null },
        equipment: { sum: 0, icon: null, currency_id: null },
        addons: { sum: 0, icon: null, currency_id: null }, // FT-102: countsConfig (buildAllCounts) читает p.addons
        mileage: { sum: 0, icon: null, currency_id: null },
        fine: { sum: 0, icon: null, currency_id: null },
        damage: { sum: 0, icon: null, currency_id: null },
        other: { sum: 0, icon: null, currency_id: null },
        deposit: { sum: 0, icon: null, currency_id: null },
      },
      depositData: {
        cash: 0,
        cashless: 0,
        cash_card: 0,
        entity: 0,
      },
      tinkoff_headers: [
        // { text: this.$t("custom.number"), align: "center", value: "id" },
        // {
        //   text: this.$t("custom.created_at"),
        //   value: "created_at",
        //   align: "center",
        // },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("custom.status"), value: "status", align: "center" },
        { text: this.$t("tinkoff.card_number"), value: "card_number", align: "center" },
        { text: this.$t("tinkoff.payment_id"), value: "payment_id", align: "center" },
        { text: this.$t("tinkoff.outcome"), value: "outcome", align: "center" },
      ],
      counts_headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        { text: this.$t("custom.date"), value: "created_at", align: "center" },
        { text: this.$t("custom.sum"), value: "sum", align: "center" },
        { text: this.$t("custom.type"), value: "type", align: "center", sortable: false },
        { text: this.$t("custom.group"), value: "group", align: "center" },
      ],
      tinkoff_payments: [],
      finePaymentData: {
        sum: null,
        icon: null,
        state: null,
        number: null,
      },
      editedFine: [],
      invoices: [],
      search_invoices: null,
      date: null,
      showClientSearch: false,
      dataPanelPaymentsInDialog: false,
      finePaymentDialog: false,
      search_client: null,
      add_services: [
        { text: this.$t("add_services.clean"), value: "Мойка" },
        {
          text: this.$t("add_services.add_hours"),
          value: "Дополнительное время",
        },
        {
          text: this.$t("add_services.extra_mileage"),
          value: "Превышение пробега",
        },
        { text: this.$t("add_services.fuel"), value: "Топливо" },
        { text: this.$t("add_services.delivery"), value: "Доставка" },
        { text: this.$t("add_services.checkout"), value: "Приём" },
        { text: this.$t("add_services.rent"), value: "Аренда" },
        { text: this.$t("add_services.insurance"), value: "Страховка" },
        { text: this.$t("add_services.add_drivers"), value: "Доп водители" },
        { text: this.$t("add_services.equipment"), value: "Оборудование" },
        { text: this.$t("add_services.fines"), value: "Штрафы" },
        { text: this.$t("add_services.damages"), value: "Повреждения" },
        { text: this.$t("add_services.others"), value: "Другое" },
      ],
      periods: [],
      hourly_periods: [],
      weekly_periods: [],
      monthly_periods: [],
      seasons: [],
      fines: [],
      fines_search: null,
      fines_state: [
        { text: this.$t("fines_state.created"), value: "Создан" },
        { text: this.$t("fines_state.notify"), value: "Оповещён" },
        { text: this.$t("fines_state.paid"), value: "Оплачен" },
        { text: this.$t("fines_state.refund"), value: "Возмещён" },
      ],
      fines_headers: [
        { text: this.$t("fines.number"), align: "center", value: "number" },
        { text: this.$t("custom.date"), value: "date", align: "center" },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      fines_headers_small: [
        { text: this.$t("fines.number"), align: "center", value: "number" },
        { text: this.$t("custom.date"), value: "date", align: "center" },
        { text: this.$t("custom.client"), value: "client_id", align: "center" },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      search_fines: null,
      period_max_value: 31,
      hourly_period_max_value: 24,
      weekly_period_max_value: 52,
      monthly_period_max_value: 12,
      selected_add_services: [],
      add_drivers: [],
      search_add_drivers: null,
      customer_category: [
        { text: this.$t("customer_category.new"), value: "Новый" },
        { text: this.$t("customer_category.loyal"), value: "Лояльный" },
        { text: this.$t("customer_category.statement"), value: "Постоянный" },
        { text: this.$t("customer_category.problem"), value: "Серый" },
        { text: this.$t("customer_category.bad"), value: "Чёрный" },
      ],
      bookings_states: [
        { text: this.$t("bookings_states.new"), value: "Новая" },
        { text: this.$t("bookings_states.in_work"), value: "В обработке" },
        { text: this.$t("bookings_states.abandoned"), value: "Недозвон" },
        { text: this.$t("bookings_states.decline"), value: "Отказ клиента" },
        { text: this.$t("bookings_states.no_cars"), value: "Нет машин" },
        {
          text: this.$t("bookings_states.wait_answer"),
          value: "Ожидает ответа клиента",
        },
        { text: this.$t("bookings_states.wait_pay"), value: "Ожидает оплаты" },
        { text: this.$t("bookings_states.active"), value: "Активная" },
        { text: this.$t("bookings_states.cancel"), value: "Отмена" },
        { text: this.$t("bookings_states.rided"), value: "Отъездила" },
        {
          text: this.$t("bookings_states.return_deposit"),
          value: "Вернуть залог",
        },
        { text: this.$t("bookings_states.accepted"), value: "Подтверждена" },
        {
          text: this.$t("bookings_states.not_accepted"),
          value: "Не подтверждена",
        },
        { text: this.$t("bookings_states.other"), value: "Другое" },
      ],
      booking_payments_types: [
        { text: this.$t("bookings.payments_type_full"), value: "full" },
        { text: this.$t("bookings.payments_type_periodic"), value: "periodic" },
      ],
      booking_payments_periods: [
        { text: this.$t("bookings.payments_period_daily"), value: "daily" },
        { text: this.$t("bookings.payments_period_weekly"), value: "weekly" },
        { text: this.$t("bookings.payments_period_monthly"), value: "monthly" },
      ],
      booking_payments_type: "full",
      booking_payments_period: "daily",
      debts: [],
      debt: {
        sum: null,
        state: this.$t("debts_state.created"),
        description: null,
        group: this.$t("add_services.rent"),
        client_id: null,
        booking_id: null,
      },
      debts_groups: [
        { text: this.$t("add_services.rent"), value: "Аренда" },
        { text: this.$t("add_services.fines"), value: "Штрафы" },
        { text: this.$t("add_services.damages"), value: "Повреждения" },
        { text: this.$t("add_services.others"), value: "Другое" },
      ],
      debts_state: [
        { text: this.$t("debts_state.created"), value: "Создан" },
        { text: this.$t("debts_state.notify"), value: "Оповещён" },
        // { text: this.$t("debts_state.paid"), value: "Оплачен" },
        { text: this.$t("debts_state.refund"), value: "Возмещён" },
        { text: this.$t("debts_state.remind"), value: "Напомнить" },
        { text: this.$t("debts_state.don_paid"), value: "Не оплачен" },
      ],
      debts_headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.client"), value: "client_id", align: "center" },
        {
          text: this.$t("custom.number"),
          value: "booking_id",
          align: "center",
        },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("bookings.paid"), value: "paid", align: "center" },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      paymentData: {
        sum: null,
        icon: null,
        state: "Оплачен",
        group: null,
        debt_id: null,
      },
      prolongs: [],
      tracker_report: {},
      isTrackerReportLoading: false,
      customEmailData: {
        id: null,
        name: null,
        body: null,
        subject: null,
        attachment_id: null,
      },
      email_templates: [],
      signature_types: [
        { name: this.$t("sign.start_booking"), value: "booking_start" },
        { name: this.$t("sign.end_booking"), value: "booking_end" },
        { name: this.$t("sign.prolong"), value: "prolong" },
        { name: this.$t("custom.invoices"), value: "invoice" },
        { name: this.$t("custom.act"), value: "act" },
      ],
      signature_type: "booking_start",
      agents: [],
      isLoadingGetAgents: false,
      booking_audits: [],
      show_audited_dialog: false,
      selected_email_templates: null,
      editEmailTemplate: false,
      save_email_template: false,
      attachment_email_template: false,
      showEmailTemplates: false,
      showCustomEmailDialog: false,
      editDebtDialog: false,
      paymentDebtDialog: false,
      editDialog: false,
      departureDialog: false,
      payment_dialog: false,
      // FT-193 CTR-08, W1: ключ идемпотентности ручного списания с карты. Создаётся при первой отправке и живёт до
      // однозначного успеха: сбрасывают его только 2xx на отправку с этим ключом и «Начать новый платёж» с подтверждением
      // (и отказ на первую отправку, если неизвестного исхода до неё не было). Повтор уходит с тем же ключом, и сервер
      // возвращает первый результат.
      paymentIdempotencyKey: null,
      // FT-193 W1: неизменный снимок тела первой отправки списания с карты (суммы, способы, кассы, флаги, ключ). Повтор
      // шлёт его, а не текущие поля диалога: иначе сервер ответит 422 idempotency_key_mismatch на тот же ключ с другим телом.
      // Копия — в sessionStorage по booking.id (переживает перезагрузку страницы).
      paymentChargeSnapshot: null,
      // FT-193 NEG-02: исход последней отправки списания с карты неизвестен (нет ответа, 5xx, 408, 409 locked). Пока он не
      // прояснён, ключ нельзя менять: сервер мог провести платёж, и повтор с тем же ключом вернёт первый результат.
      paymentOutcomeUnknown: false,
      // FT-173 STEP-16 (REQ-08, CTR-04): true while waiting for RentToOwnPanel's
      // @contract-loaded to decide whether ?payment=1 opens PaymentDialog.
      paymentQueryPending: false,
      // FT-173 D2/D3: договор договорного бронирования — от панели
      // (@contract-loaded, после каждой попытки загрузки). Пока загрузки не
      // было — loaded=false; null после загрузки — договора нет или нет доступа.
      rentToOwnContract: null,
      rentToOwnContractLoaded: false,
      showArrivalDialog: false,
      showProblems: false,
      departure_yes: false,
      editPlace: false,
      editSale: false,
      manualEditing: false,
      showDescription: false,
      showAddDrivers: false,
      showCashlessPayment: false,
      showRejectionBooking: false,
      uploadPhotosDialog: false,
      newCheckinPhotos: [],
      editCar: false,
      editExtra: false,
      ft102DepositTouched: false, // FT-102 SC-09
      ft102Lines: [], // FT-102: строки оборудования для сводки
      ft102CatalogCount: 0, // FT-102 SC-08: каталог непустой → легаси-галочки прячем
      // FT-108 REQ-04: снапшот полей секций при открытии editDialog — база
      // для точек-индикаторов; null = точки молчат (isSectionDirty → false)
      ft108SectionSnapshots: null,
      editEquipment: false,
      editInsurance: false,
      prolongDialog: false,
      warningAddOneDay: false,
      warningLessThenDay: false,
      showEditClient: false,
      isLoadingClients: false,
      isLoadingClientsAddDriver: false,
      isLoadingCars: false,
      searchCar: "",
      searchClient: null,
      searchClientAddDriver: null,
      selected_add_drivers: [],
      selected_add_driver: null,
      search_add_driver: "",
      editDate: false,
      doc_template_url: "",
      entity_doc_template_url: "",
      dont_send_review_reminder: false,
      company_cashbox_id: null,
      worker_account_id: null,
      showSelectWorkerCashbox: false,
      whatsappQrcode: null,
      showQrcodeWhatsapp: false,
      show_audited_price_alert: false,
      // FT-084 STEP-12: server-side quote (price_quotes / priced_bookings)
      // state — mirrors NewBooking.vue's STEP-11 pattern 1:1. status: 'idle'
      // (no pricing inputs to quote yet — car/dates not set) | 'loading' |
      // 'ready' (quoteIdentity matches current inputs) | 'error' (request
      // failed) | 'no_price' (422 no_price, FM-01) | 'external_calculation'
      // (booking.only_manual_editing — server refuses recompute, DEC-06).
      // Save (editSave) is gated on quoteIsFresh unless manualEditing.
      quoteStatus: "idle",
      quoteError: null,
      quoteIdentity: null, // identity of the LAST APPLIED (ready) quote
      quoteResponse: null, // raw price_quotes/priced_bookings response body
      // price_source driving the quote/banner (DEC-15): 'stored' = server
      // reconstructs historical prices from audits (default for an existing
      // booking); 'current' = today's prices. Persisted server-side onto
      // booking.apply_current_prices via applyCurrentPrices()/editSave().
      quotePriceSource: "stored",
      selectedDocumentId: null,
      hour_timer: 0,
      connected: false,
      timeout: null,
      isMobile: false,
      isLoading: false,
      loadFailed: false,
      isLoadingSaveState: false,
      isLoadingSavePayment: false,
      isLoadingDepositReturned: false,
      clientPageLinkLoading: false, // FT-200: запрос ссылки клиенту в полёте — второе нажатие не шлёт второй
      isLoadingDownloadSignedDoc: false,
      isLoadingDeleteSignedDoc: false,
      isLoadingSendSignedDoc: false,
      isPdfGenerating: false,
      pdfGeneratingTemplateName: '',
      isLoadingAcceptBooking: false,
      isLoadingDeclineBooking: false,
      isLoadingSendCustomEmail: false,
      isLoadingUpdateEmailTemplate: false,
      isLoadingSaveCustomEmail: false,
      isLoadingArchiveBooking: false,
      isLoadingUnarchiveBooking: false,
      isLoadingEditBooking: false,
      isLoadingCheckinCar: false,
      isLoadingActiveRent: false,
      isLoadingInHome: false,
      isLoadingEditSave: false,
      isLoadingSaveProlong: false,
      isLoadingGetDocxTemplates: false,
      isLoadingGenerateDocxTemplates: false,
    };
  },
  mounted() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (
        this.$tours["registrationTour"] &&
        this.$store.getters.getTourNextStep
      ) {
        this.$tours["registrationTour"].nextStep();
      }
      this.loadCardData();
      // Удаляю из селекта перепробег
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.mileage_limit_cost == 0
      ) {
        this.add_services.splice(
          this.add_services.findIndex(
            (service) => service == "Превышение пробега"
          ),
          1
        );
      }
      // FT-066: health-check via native consumer (replaced the old wrapper-registry probe).
      // getConsumer().connection.isOpen() is the public @rails/actioncable API. Dead commented
      // reconnect dropped — native consumer auto-reopens on drop.
      // check every 30 seconds if action cable wss server is online
      function check_server() {
        self.check_server = setInterval(function () {
          const consumer = getConsumer();
          self.connected = !!(consumer && consumer.connection && consumer.connection.isOpen());
        }.bind(self), 30000);
      }
      check_server();
    } else {
      this.$store.commit("unsetCurrentUser");
      this.$router.push({ path: `/signin` }).catch((err) => { });
    }
  },
  created() {
    // FT-084 STEP-12: non-reactive (plain instance field, not in data()) —
    // debounce + stale-response guard over POST /api/v1/price_quotes, same
    // module/pattern as NewBooking.vue (STEP-11).
    this._quoteRequester = new BookingQuoteRequester({
      post: (payload) =>
        this.axios.post("/api/v1/price_quotes", payload, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        }),
      debounceMs: 350,
    });
    // FT-173 STEP-16 (REQ-08, CTR-07): savePayment's ONLY change is
    // self.$emit("payment-saved") in its success branch — the reaction lives
    // here instead, so that change stays a one-liner. Self-registered
    // listener (vm.$on on its own instance is valid Vue 2 usage) forwards to
    // the mounted RentToOwnPanel; an ordinary booking never renders the panel,
    // so handleRentToOwnPaymentSaved is a no-op for it.
    this.$on("payment-saved", this.handleRentToOwnPaymentSaved);
  },
  beforeDestroy() {
    this._cardLoadDestroyed = true;
    // Страница уходит — заявка на объяснение сетевого отказа больше не наша.
    this.$store.commit("network/RELEASE_LOAD", `booking-card-${this._uid}`);
    this._quoteRequester && this._quoteRequester.cancel();
    // FT-066: CableSubscriber mixin auto-unsubscribes the held refs. Explicit drop for clarity.
    this.$cableUnsubscribe(this.tinkoffSub);
    this.tinkoffSub = null;
    this.$cableUnsubscribe(this.bookingSub);
    this.bookingSub = null;
    // Reset the same-booking guard so a remounted instance re-subscribes.
    this.subscribedBookingId = null;
  },
  destroyed() {
    clearInterval(this.check_server);
  },
  watch: {
    "$route.params.id"(id, previousId) {
      if (id && String(id) !== String(previousId)) this.loadCardData();
    },
    // FT-223: initial store lines arrive with the card; explicit lines-changed still reloads.
    "booking.id": {
      immediate: true,
      handler(id) {
        // FT-193 W1: незавершённое списание с карты этого бронирования (после перезагрузки страницы) — из sessionStorage
        if (id) this.restorePendingCharge(id);
      },
    },
    // Подсказка цены подарка: запрос при открытии диалога, смене типа
    // (сутки/часы — разные ставки) и смене количества (ставка ступени
    // ОПЛАЧИВАЕМОЙ длительности зависит от count — USER 2026-07-16).
    show_gifts_dialog(value) {
      if (value) {
        this.requestGiftPreview();
      } else {
        this.giftPreviewSeq += 1; // инвалидируем in-flight ответ
        if (this.giftPreviewTimer) clearTimeout(this.giftPreviewTimer);
        this.giftPreviewStatus = "idle";
        this.giftPreviewUnitPrice = null;
      }
    },
    "gift.gift_type"() {
      if (this.show_gifts_dialog) this.requestGiftPreview();
    },
    "gift.count"() {
      if (this.show_gifts_dialog) this.requestGiftPreview();
    },
    // FT-084 STEP-12 (DEC-06): the two manual-mode toggles in the edit
    // dialog (`manualEditing` — shows the manual price/units fields;
    // `auto_calculate` — legacy label "Рассчитывать автоматически") are kept
    // in sync so either one flips the other, matching the pre-STEP-12
    // behavior where both ultimately drove the same manual_editing flag on
    // save. Re-runs requestQuote() so the Save gate and shown numbers
    // reflect the new mode immediately (mirrors NewBooking.vue's
    // manual_editing() watcher, STEP-11).
    manualEditing(value) {
      // DEC-19: выключение «вручную» у брони, сохранённой в ручном режиме,
      // НЕ включает авторасчёт и НЕ пересчитывает — суммы заморожены
      // (frozenManualMode), пока оператор явно не включит
      // «Рассчитывать автоматически». Для остальных броней — прежняя
      // симметрия тумблеров.
      // ...и то же для брони, которой авторасчёт запрещён вовсе (Localrent,
      // внешняя, архив): выход из ручной правки обязан вести во frozen, а не
      // включать движок, которому эту бронь считать нельзя (ревью 2026-08-11).
      if (!value && (this.booking.manual_editing || this.calcModeDisabled)) {
        return; // auto_calculate остаётся false → frozen
      }
      if (this.auto_calculate === value) {
        this.auto_calculate = !value;
      }
      this.calculateCost();
    },
    auto_calculate(value) {
      if (this.manualEditing === value) {
        this.manualEditing = !value;
        // MANUAL → AUTO одним кликом (USER 2026-07-21): для брони,
        // СОХРАНЁННОЙ в ручном режиме, manualEditing-вотчер выходит рано
        // (frozen-семантика) и пересчёт не дёргает — квота оставалась
        // несвежей и pricingReady держал Save заблокированным, пока
        // оператор не менял что-то ещё. Дёргаем пересчёт явно.
        if (value && this.booking.manual_editing) {
          this.calculateCost();
        }
      } else if (value) {
        // DEC-19: выход из frozen (manualEditing уже false) — flip выше не
        // сработает, пересчёт дергаем явно, чтобы предпросмотр обновился
        // до сохранения.
        this.calculateCost();
      }
    },
    // FT-084 STEP-12 fix round 1 (C1): quotePriceSource must always mirror
    // the persisted flag, not just be set by applyCurrentPrices(). Without
    // this, a booking loaded with apply_current_prices=true would show
    // quotePriceSource="stored" (data() default) until the manager clicked
    // the banner toggle — so editSave() would silently flip the persisted
    // flag back to "stored" on ANY unrelated save. `immediate: true` covers
    // both getBooking() (initial load) and any later reassignment of
    // this.booking (mounted()/getBooking() re-fetch). applyCurrentPrices()
    // itself also sets quotePriceSource explicitly (same value this watcher
    // would derive) — the watcher re-running afterward is a no-op, not a
    // fight: same source flag, same derived value, so no cyclical churn.
    "booking.apply_current_prices": {
      handler(val) {
        this.quotePriceSource = val ? "current" : "stored";
      },
      immediate: true,
    },
    start_date_not_formated() {
      if (this.start_date_not_formated) {
        this.start_date = moment
          .utc(this.start_date_not_formated)
          .format("DD-MM-YYYY H:mm");
        if (this.end_date) {
          this.setDates();
          this.warnIfCarDatesOverlap(this.set_car, this.booking);
        }
      }
    },
    end_date_not_formated() {
      if (this.end_date_not_formated) {
        this.end_date = moment
          .utc(this.end_date_not_formated)
          .format("DD-MM-YYYY H:mm");
        if (this.start_date) {
          this.setDates();
          this.warnIfCarDatesOverlap(this.set_car, this.booking);
        }
      }
    },
    set_car() {
      // Applying the aggregate is not a user car change, even with the editor open.
      if (this.set_car === this._cardHydratedCar) return;
      if (this.editCar) {
        if (!this.set_car) {
          return;
        }
        this.isLoading = true;
        if (this.set_car.car_name) {
          this.booking.car_name = this.set_car.car_name;
        } else {
          this.isLoading = false;
          this.$notify(this.$t("errors.no_car_name_title"), this.$t("errors.no_car_name_text"), "warning", 5000);
        }
        if (this.set_car.state == 3) {
          this.$notify(this.$t("states.car_critical"), "", "warning", 10000);
        } else if (this.set_car.state == 4) {
          this.$notify(this.$t("states.car_long_rent"), "", "warning", 10000);
        } else if (this.set_car.state == 5) {
          this.$notify(this.$t("states.car_no_rent"), "", "warning", 10000);
        }
        this.booking.car_code = this.set_car.code;
        this.booking.car_id = this.set_car.id;
        this.booking.start_mileage = this.set_car.mileage;
        this.booking.price_hour = this.set_car.price_hour;
        this.booking.deposit = this.set_car.deposit;
        this.booking.hourly_deposit = this.set_car.hourly_deposit;
        this.booking.weekly_deposit = this.set_car.weekly_deposit;
        this.booking.monthly_deposit = this.set_car.monthly_deposit;

        // FT-084 STEP-12: was a GET /api/v1/cars/:id fetch of price+audits
        // rows purely to feed the removed findAudited*PricesForBooking
        // client-side reconstruction, PLUS a "does this car have any price
        // configured for the current rental type" presence check. The
        // presence check has no server-quote equivalent worth a round trip
        // here — an absent price now simply surfaces as quoteStatus
        // 'no_price' (FM-01) once requestQuote() runs below, via the same
        // quote_no_price banner used everywhere else in the pricing UI.
        if (!this.showArrivalDialog) {
          // Set_car включается и при приеме и идет ошибка расчета цены
          this.checkAuditedPriceDivergence();
          this.calculateCost();
        }
        this.isLoading = false;
      }
    },
    searchCar(val) {
      // Items have already been loaded
      if (this.cars.length > 0) return;

      // Items have already been requested
      if (this.isLoadingCars) return;

      this.isLoadingCars = true;

      // Lazily load input items
      this.axios
        .get("/api/v1/active_cars", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.cars.push(element.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cars_load"));
        })
        .finally(() => (this.isLoadingCars = false));
    },
    searchClient(val) {
      // if (this.client && this.client.id) {
      //   return;
      // }
      if (this.searchClient == "" || this.searchClient == " ") {
        this.searchClient = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClients();
          }, 200); // delay
        }
        debounce();
      }
    },
    searchClientAddDriver(val) {
      // if (this.client && this.client.id) {
      //   return;
      // }
      if (this.searchClientAddDriver == "" || this.searchClientAddDriver == " ") {
        this.searchClientAddDriver = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClientsForAddDrivers();
          }, 200); // delay
        }
        debounce();
      }
    },
    client() {
      if (this.showEditClient && this.client) {
        this.booking.client_id = this.client.id;
        this.booking.first_name = this.client.name;
        this.booking.middle_name = this.client.middlename;
        this.booking.last_name = this.client.lastname;
        this.booking.fio = this.client.fio;
        // Скидка не грузилась в редактировании брони
        this.booking.sale = this.booking.sale
          ? this.booking.sale
          : this.client.sale;
        this.booking.sale_cash = this.booking.sale_cash
          ? this.booking.sale_cash
          : this.client.sale_cash;
        this.booking.entity = this.client.entity;
        this.booking.entity_name = this.client.entity_name
          ? this.client.entity_name + ", " + this.client.reg_form
          : "";

        if (!this.showArrivalDialog) {
          // Set_car включается и при приеме и идет ошибка расчета цены
          this.calculateCost();
        }
      }
    },
    selected_email_templates() {
      if (this.selected_email_templates) {
        let template = this.email_templates.find(
          (template) => template.id == this.selected_email_templates
        );
        this.customEmailData.name = template.name;
        this.customEmailData.subject = template.subject;
        this.customEmailData.body = template.body;
      }
    },
    // Тело вынесено в tariffSelection.js — там же разобран гард по editDialog,
    // без которого сохранённый тариф пропадал из карточки до перезагрузки.
    selected_tariff_id() {
      applyTariffSelection(this);
    },
  },
  computed: {
    // FT-193 REQ-06 (CTR-02): подпись и цвет состояния автопродления; незнакомое состояние — как есть.
    periodicRenewalStateLabel() {
      const state = this.booking && this.booking.periodic_renewal_state;
      const key = PERIODIC_RENEWAL_STATE_LABEL_KEYS[state];
      return key ? this.$t(key) : state || "";
    },
    periodicRenewalStateColor() {
      return periodicRenewalStateColor(this.booking && this.booking.periodic_renewal_state);
    },
    // FT-193: остановленное автопродление периодического бронирования — условие показа блока-предупреждения в шапке.
    periodicRenewalIsStopped() {
      const booking = this.booking;
      return !!(booking && booking.payments_type === "periodic" && periodicRenewalStopped(booking.periodic_renewal_state));
    },
    // Причина остановки. Booking#periodic_block_reason ведёт сервер только для blocked_credit_limit: пусто или код,
    // которого клиент не знает, — текст credit_limit. У прочих остановок причина — сама подпись состояния
    // («Остановлено: машина занята…»), чтобы не приписывать им лимит долга. Текст банка (bank_declined) — после двоеточия.
    periodicBlockReasonText() {
      const booking = this.booking || {};
      if (booking.periodic_renewal_state !== "blocked_credit_limit") return this.periodicRenewalStateLabel;
      const reason = booking.periodic_block_reason;
      const detail = periodicBlockReasonDetail(reason);
      const text = this.$t(periodicBlockReasonKey(reason));
      return detail ? `${text}: ${detail}` : text;
    },
    periodicFundingLabel() {
      const funding = this.booking && this.booking.periodic_funding;
      const key = PERIODIC_FUNDING_LABEL_KEYS[funding];
      return key ? this.$t(key) : "";
    },
    // FT-193 CTR-05: «Возобновить» — только из stopped_errors, manager+ (сервер отвечает 403 иначе).
    canResumePeriodicRenewal() {
      return !!(this.isManagerPlus && this.booking && this.booking.periodic_renewal_state === "stopped_errors");
    },
    // «Повторить списание» — из blocked_credit_limit, когда источник пополнения — карта.
    canRetryPeriodicTopup() {
      return !!(
        this.isManagerPlus &&
        this.booking &&
        this.booking.periodic_renewal_state === "blocked_credit_limit" &&
        this.booking.periodic_funding === "balance_and_card"
      );
    },
    // FT-193 REQ-07: источник списания в правке — у периодического бронирования и только при рабочем терминале
    // (иначе сервер ответил бы 422 tinkoff_unavailable).
    // Если у бронирования уже стоит «с карты», а терминал выключили, селект остаётся — чтобы вернуть «с баланса».
    showPeriodicFundingEdit() {
      if (!this.booking || this.booking.payments_type !== "periodic") return false;
      return !!(this.company && this.company.tinkoff_operable) || this.booking.periodic_funding === "balance_and_card";
    },
    // Вариант с картой недоступен без рабочего терминала (сервер ответил бы 422 tinkoff_unavailable).
    periodic_fundings() {
      return [
        { text: this.$t("bookings.periodic_funding_balance"), value: "balance" },
        {
          text: this.$t("bookings.periodic_funding_balance_and_card"),
          value: "balance_and_card",
          disabled: !(this.company && this.company.tinkoff_operable),
        },
      ];
    },
    periodicFundingEditChanged() {
      return !!(
        this.showPeriodicFundingEdit &&
        this.edit_periodic_funding &&
        this.edit_periodic_funding !== (this.booking.periodic_funding || "balance")
      );
    },
    // FT-200 REQ-07: ссылка клиенту не предлагается, если в фамилии бронирования нет буквы — вход по ней невозможен.
    // Правило api (Bookings::ClientLookup.enterable_last_name?: /\p{L}/ по фамилии бронирования, не карточки клиента).
    clientPageLinkBlocked() {
      const lastName = this.booking && this.booking.last_name;
      return !/\p{L}/u.test(lastName == null ? "" : String(lastName));
    },
    // FT-198 REQ-04: закрыть удержание залога может только сотрудник и только при стоящем удержании.
    canReturnDeposit() {
      return Boolean(this.isStaff && this.booking && this.booking.part_return_deposit && !this.booking.deposit_hold);
    },
    // FT-166: зеркало NewBooking.vue — причина отказа no_price выводится из
    // rental_type, который карточка и так отправила в запросе квоты.
    noPriceMessageKey() {
      return noPriceCauseKey(this.currentRentalType());
    },
    noPriceCanTryDaily() {
      if (this.currentRentalType() !== "hourly") return false;
      return hasUsableBasePrices(pricesForRentalType(this.set_car, "daily"));
    },
    carPricesHref() {
      const id = (this.set_car && this.set_car.id) || this.booking.car_id;
      if (!id) return null;
      return this.$router.resolve({ name: "CarCard", params: { id: String(id) } }).href;
    },
    // Генерация документа брони — только в браузере (PdfDocuments). Филиал со старым
    // флагом new_templates раньше получал отдельное меню на серверный
    // POST get_signed_document_v2 (Grover в треде запроса, legacy); теперь он идёт тем
    // же путём, что и pdf_templates: шаблоны, переменные и подпись у путей общие.
    showPdfDocuments() {
      const company = this.$store.getters.getCompany && this.$store.getters.getCompany.company;
      if (!company || !this.isStaff) return false;
      return Boolean(company.new_templates || company.pdf_templates);
    },
    // FT-173 STEP-15 (REQ-12): гейт панели договора выкупа — заменяет блок
    // цены и статуса оплаты (:386-401 в шаблоне) только у договорного
    // бронирования. Вынесен в computed, а не инлайн в v-if, чтобы тест мог
    // вызвать гейт без монтирования компонента (BookingCard нигде в тестах
    // проекта не монтируется — v-tooltip/v-resize/размер бандла).
    showRentToOwnPanel() {
      return !!(this.booking && this.booking.rent_to_own);
    },
    // FT-173 контроль V3 (REQ-26, REQ-25): у бронирования действующего
    // договора ручные статусы возврата («Отъездила», «Вернуть залог»)
    // сказали бы «вернули», пока машина занята договором (сервер отвечает
    // 422 managed_by_contract на оба) — пунктов в меню нет. Пока договор не
    // загружен или не получен, состояние неизвестно — тоже нет (как у
    // «Принять авто», canCheckoutCar). Обычное бронирование и закрытый
    // договор — полный список.
    bookingStatesForCard() {
      const states = this.bookings_states || [];
      if (!(this.booking && this.booking.rent_to_own)) return states;
      const contract = this.rentToOwnContractLoaded ? this.rentToOwnContract : null;
      if (contract && contract.lifecycle !== "active") return states;
      return states.filter((item) => !RENT_TO_OWN_RETURN_STATES.includes(item.value));
    },
    // FT-173 решение USER D3 (REQ-12): штатный ряд оплаты бронирования —
    // у обычного бронирования всегда, у договорного — только когда договор
    // закрыт (terminated / completed). У действующего платёж идёт через
    // «Принять платёж» панели; пока договор не загружен — ряда нет.
    showBookingPaymentRow() {
      if (!this.showRentToOwnPanel) return true;
      const contract = this.rentToOwnContractLoaded ? this.rentToOwnContract : null;
      return !!contract && (contract.lifecycle === "terminated" || contract.lifecycle === "completed");
    },
    // FT-173 решение USER D2 (REQ-13, REQ-25): «Принять авто» (in_home) у
    // бронирования действующего договора закрыла бы бронирование при живом
    // договоре — кнопка скрыта (сервер тоже отвечает 422 managed_by_contract).
    // Пока договор не загружен или не получен (нет доступа), его состояние
    // неизвестно — тоже скрыта. Обычное бронирование — как раньше (in_rent).
    // «Выдать» — у активной невыданной, кроме уже отъездившей: сервер такую не
    // выдаёт (409 booking_already_returned, Operations::Bookings::Issue).
    canCheckinCar() {
      const booking = this.booking || {};
      return !!booking.active && !booking.in_rent && !isReturnedBooking(booking);
    },
    canCheckoutCar() {
      const booking = this.booking || {};
      if (!booking.in_rent) return false;
      if (!booking.rent_to_own) return true;
      const contract = this.rentToOwnContractLoaded ? this.rentToOwnContract : null;
      return !!contract && contract.lifecycle !== "active";
    },
    // FT-108 (REQ-03, CON-01): ЕДИНСТВЕННОЕ состояние раскрытия
    // панелей — прокси над существующими edit-флагами, без data-полей
    // открытости. get: индексы открытых секций (OR-агрегация isSectionOpen);
    // set: diff с текущим состоянием — открывшимся openSection (все флаги
    // секции true + side-effects open-only, ASM-01), закрывшимся closeSection
    // (все флаги false, side-effects не зовутся).
    ft108OpenPanels: {
      get() {
        const open = [];
        EDIT_SECTIONS.forEach((section, index) => {
          if (isSectionOpen(section, this)) {
            open.push(index);
          }
        });
        return open;
      },
      set(next) {
        const nextSet = new Set(next || []);
        // FT-173 STEP-22 (F1, REQ-13): у договорного бронирования деньги/даты/
        // машину/тариф/клиента ведёт договор выкупа — эти 5 секций не входят
        // в режим правки (openSection не зовётся), панель остаётся закрытой.
        // "info"/"drivers" — операционные (белый список), их это не касается.
        const locked = this.rentToOwnLocked;
        EDIT_SECTIONS.forEach((section, index) => {
          const isOpen = isSectionOpen(section, this);
          if (locked && RENT_TO_OWN_LOCKED_SECTION_KEYS.has(section.key)) {
            return;
          }
          if (nextSet.has(index) && !isOpen) {
            openSection(section, this);
          } else if (!nextSet.has(index) && isOpen) {
            closeSection(section, this);
          }
        });
      },
    },
    // FT-102: единица тарификации для панели допов
    ft102Units() {
      return this.ft102UnitsValue();
    },

    // FT-102 (SC-08): у брони уже проставлено что-то из легаси-оборудования —
    // блок галочек остаётся видимым даже при активном каталоге, иначе снять
    // их будет негде (брони, созданные до перехода на каталог).
    ft102HasLegacyEquipment() {
      const b = this.booking || {};
      return Boolean(
        b.chair || b.chair_less_1_year || b.booster || b.navigator ||
        b.wifi_router || b.mp3 || b.charger ||
        Number(b.chairs_quantity) > 0 || Number(b.boosters_quantity) > 0
      );
    },

    // Прод-класс брони 664209 (2026-07-21): очищенное поле услуги = "" —
    // сырой `+` в шаблоне превращал сумму «Итого» в конкатенацию строк
    // (32000 + "" -> "32000", каждый следующий + 0 дописывал символ ноля ->
    // 3.2e+22 на экране). Каждый терм коэрцится в moneySum.js.
    bookingTotalPreview() {
      return sumMoney([
        this.booking.rental_cost,
        this.booking.delivery,
        this.booking.delivery_end,
        this.booking.equipment,
        this.booking.addons_cost, // FT-102 REQ-07: каталожное оборудование

        this.booking.insurance,
        this.booking.clean_payment,
        this.booking.add_drivers_cost,
        this.booking.hours_cost,
        this.booking.mileage_cost,
        this.booking.damage,
        this.booking.gas,
        this.booking.fine,
        this.booking.other,
        this.booking.other_end,
        this.booking.hours_cost_end,
        this.currentDeposit(),
      ]);
    },
    // FT-084 STEP-12 fix round 1 (I1): booking.only_manual_editing is
    // already on the loaded booking (BookingSerializer/edit_booking_data) —
    // no need to wait for a 422 from the server to know editSave()/
    // requestQuote() will be rejected (priced_bookings_controller.rb#update:
    // ANY pricing-input key present + only_manual_editing? => 422
    // "external_calculation", unconditionally, PRICING_INPUT_KEYS always
    // sent by editSave()). Detected locally so the warning banner shows the
    // moment the edit dialog opens, not only after a failed save attempt.
    isExternalCalculationBooking() {
      return !!this.booking.only_manual_editing;
    },
    // FT-084 STEP-12 (FM-07), mirrors NewBooking.vue (STEP-11): true only
    // when the shown numbers were computed for EXACTLY the current pricing
    // inputs (quoteIdentity matches). Any pricing-input change immediately
    // invalidates this even before the new debounced request lands
    // (buildCurrentQuoteIdentity is cheap/sync).
    quoteIsFresh() {
      if (this.booking.technical) return true; // technical bookings skip pricing entirely
      if (this.quoteStatus !== "ready") return false;
      return quoteIdentityEquals(this.quoteIdentity, this.buildCurrentQuoteIdentity());
    },
    // Gates the edit-dialog Save action (FM-07: "пока для текущих входов нет
    // актуальной квоты — сохранение заблокировано"; FM-05: request error
    // blocks save; FM-01: no_price blocks save; DEC-06:
    // external_calculation — only_manual_editing bookings block save too,
    // since the server itself refuses to recompute them; I1 fix round 1:
    // blocked immediately/locally, not only after a 422 round-trip).
    pricingReady() {
      if (!this.editDialog) return true; // no pricing gate outside the edit flow
      // 2026-07-22 (разворот контракта 2026-07-21 «Save заблокирован
      // целиком», решение USER): внешняя бронь редактируема в ручном/frozen
      // режиме — Save не блокируем; заблокирован только авторасчёт
      // (тумблер disabled + сервер 422 на manual_price: null).
      if (this.isExternalCalculationBooking) return true;
      if (this.booking.technical) return true;
      // FT-084 STEP-15 (I-1 fix): mirrors NewBooking.vue — manual-mode
      // fields (selected_price, deposit, service costs) have no requote
      // trigger, so editing them advances buildCurrentQuoteIdentity()
      // without ever refreshing quoteIdentity/quoteStatus, stranding
      // quoteIsFresh=false (and Save) forever. DEC-06: manual mode's
      // applied price is whatever was typed — the server accepts
      // manual_price on save (CTR-03) — so freshness doesn't gate Save here.
      // DEC-19: frozen-режим (ручной выключен, авто НЕ включён) — квота так
      // же не нужна, Save шлёт absent manual_price (сервер суммы не трогает).
      if (this.manualEditing || this.frozenManualMode) return true;
      return this.quoteIsFresh;
    },
    // DEC-19 (USER 2026-07-14): «залез в ручное редактирование — сняли с
    // системы ответственность за расчёты». Выключение тумблера «вручную» у
    // брони, СОХРАНЁННОЙ в ручном режиме (booking.manual_editing на сервере),
    // НЕ возвращает авторасчёт: суммы заморожены, пока оператор явно не
    // включит «Рассчитывать автоматически» (тогда полный пересчёт). Для
    // броней, которые manual-режим ещё не сохраняли, состояние недостижимо —
    // выключение тумблера просто возвращает к авто, как раньше.
    frozenManualMode() {
      return (
        !!this.booking.manual_editing &&
        !this.manualEditing &&
        !this.auto_calculate
      );
    },
    // FT-108 v2: режим расчёта одним значением для сегмента «Авто | Вручную».
    // Состояний внутри «Вручную» два — оператор правит суммы (manualEditing)
    // и суммы заморожены (frozenManualMode); для выбора режима это один и тот
    // же ответ «считает не движок», разницу показывает строка frozen-подсказки.
    calculationMode() {
      return this.auto_calculate ? "auto" : "manual";
    },
    // Тот же предикат, что был на тумблере «Рассчитывать автоматически»:
    // архив и брони интеграций режим расчёта не меняют. Вынесен в computed,
    // потому что вешать его надо на обе кнопки сегмента (см. разметку).
    // Запрет АВТОрасчёта: движок не должен переоценивать завершённую бронь и
    // бронь интеграции (её цену согласовали не у нас, а обратного пути нет).
    calcModeDisabled() {
      const booking = this.booking || {};
      return Boolean(
        booking.archive ||
          booking.source == "Localrent" ||
          booking.localrent_id ||
          this.isExternalCalculationBooking
      );
    },
    // Запрет РУЧНОЙ правки — только архив (решение USER 2026-08-11): бронь
    // завершена, её суммы в форме неизменны вовсе. У Localrent и внешних
    // ручная правка остаётся: это единственный способ поправить цену, раз
    // движку их считать нельзя.
    calcManualDisabled() {
      return Boolean((this.booking || {}).archive);
    },
    // Предлагается ли вход в ручную правку. Один предикат на два потребителя —
    // кнопку в строке-подсказке (v-if) и гард в onManualSwitchToggle, — потому
    // что до ревью 2026-08-17 они разъехались: запрет стоял на кнопке сегмента,
    // а подсказка пускала архив в правку сумм в два клика. Разъехаться снова
    // им теперь нечем: источник решения один и он проверяется таблицей тестов
    // без mount 13k-строчного компонента (тот же приём, что у activeControlMode).
    // FT-173 STEP-17 (REQ-13): плюс запрет для договорного бронирования —
    // деньгами такой брони управляет договор выкупа, вход в ручную правку
    // цены ей не предлагается вовсе.
    manualEntryAvailable() {
      return !this.calcManualDisabled && !(this.booking || {}).rent_to_own;
    },
    // «Заморозить» (ft108-manual-hint) — обратное направление того же
    // переключателя ручного режима: возврат из ручной правки в frozen.
    // Прежняя логика была inline-условием v-else-if (manualEditing &&
    // (booking.manual_editing || calcModeDisabled)); вынесена в computed по
    // тому же поводу, что manualEntryAvailable, — плюс запрет для
    // договорного бронирования (FT-173 STEP-17, REQ-13).
    manualFreezeAvailable() {
      const booking = this.booking || {};
      return Boolean(this.manualEditing && (booking.manual_editing || this.calcModeDisabled)) && !booking.rent_to_own;
    },
    // Кому движок цены пересчитывать не должен: сохранённая вручную бронь
    // (frozen) плюс все, у кого запрещён авторасчёт — архив, Localrent,
    // only_manual_editing. Ровно те, у кого в шапке заблокирована кнопка
    // «Авто расчёт»: контракт сохранения и контракт интерфейса совпадают.
    enginePricingForbidden() {
      return Boolean(this.frozenManualMode || this.calcModeDisabled);
    },
    // Группа статус-чипов в шапке: если ни одного чипа нет (техническая
    // бронь с переключаемой активностью), пустой контейнер съедал бы на
    // мобильном целую строку — там он width: 100%.
    ft108HasStatusChips() {
      const booking = this.booking || {};
      return Boolean(
        booking.in_rent ||
          booking.archive ||
          !booking.technical ||
          this.activeControlMode === "chip"
      );
    },
    ft108HasSeasons() {
      return Boolean(
        !this.booking.technical && this.selected_seasons && this.selected_seasons.length > 0
      );
    },
    // Абсолютные запреты активности: архив и брони интеграций не переключаются
    // из формы НИКОМУ, включая админа. in_rent/ride сюда не входят — у брони
    // «на выезде» своя ветка, где админ право снять активность имеет.
    activeHardLocked() {
      const booking = this.booking || {};
      return Boolean(
        booking.archive ||
          booking.source == "Localrent" ||
          booking.localrent_id ||
          booking.vseprokaty_id
      );
    },
    // Предикат прежнего тумблера «Активная» (обычный вариант): выданную,
    // архивную и интеграционные брони со стороны формы не активируют.
    activeModeDisabled() {
      const booking = this.booking || {};
      return Boolean(this.activeHardLocked || booking.in_rent || booking.ride);
    },
    // Решение «чип или сегмент» вынесено из шаблона (ревью 2026-08-11): в
    // цепочке v-if/v-else за один день дважды терялся путь — сначала админ на
    // выезде, потом абсолютные запреты в той же ветке. Как computed решение
    // проверяется таблицей тестов без mount 13k-строчного компонента.
    activeControlMode() {
      const booking = this.booking || {};
      const onRide = Boolean((booking.active || booking.in_rent) && booking.ride);
      if (onRide) {
        // выезд: снимает активность только админ и только если бронь не
        // заблокирована абсолютно (архив, интеграция)
        return this.activeHardLocked || !this.checkAdmin() ? "chip" : "toggle_ride";
      }
      return this.activeModeDisabled ? "chip" : "toggle";
    },
    // Суммы считает не движок, а оператор их сейчас не правит: сохранённая
    // вручную бронь (frozen) ИЛИ бронь интеграции, которой авторасчёт запрещён
    // (only_manual_editing/Localrent — при загрузке им гасят auto_calculate).
    // Строка-подсказка обязана давать вход в ручную правку: сегмент его не
    // даёт, обе кнопки расчёта у таких броней заблокированы, а без этого входа
    // цены внешней брони стали бы нередактируемыми вовсе.
    amountsLockedFromEngine() {
      return !this.auto_calculate && !this.manualEditing;
    },
    // FT-173 STEP-17 (REQ-13): бронирование управляется договором выкупа —
    // деньги, даты и машину эта форма для него не меняет. Общий предикат
    // подсказки-замка (ft108-rent-to-own-hint), которая занимает место
    // строки режима расчёта вместо frozen/manual-подсказок.
    rentToOwnLocked() {
      return Boolean(this.booking && this.booking.rent_to_own);
    },
    // «Продлить» (mdi-history, шапка управления): прежняя логика
    // (booking.active && booking.in_rent) плюс запрет для договорного
    // бронирования — продление ведёт договор выкупа, не карточка (FT-173
    // STEP-17, REQ-13).
    canProlongBooking() {
      const booking = this.booking || {};
      return Boolean(booking.active && booking.in_rent && !booking.rent_to_own);
    },
    // «Подарки» (mdi-gift-outline) и удаление подарка из таблицы: у
    // договорного бронирования подарки —
    // только чтение (FT-173 H9, REQ-13): saveGift создал бы запись, которую
    // editSave по белому списку CTR-06 не применяет, — подарок висел бы в
    // карточке, не влияя на деньги. У обычного бронирования кнопка как была.
    canEditGifts() {
      return !(this.booking && this.booking.rent_to_own);
    },
    // «Удалить» (mdi-delete-forever): прежняя логика (checkAdmin() &&
    // !booking.active) плюс запрет для договорного бронирования (FT-173
    // STEP-17, REQ-13).
    canDeleteBooking() {
      const booking = this.booking || {};
      return Boolean(this.checkAdmin() && !booking.active && !booking.rent_to_own);
    },
    // Верхний v-alert «Ручное редактирование»: прежняя логика (booking &&
    // booking.manual_editing) плюс запрет для договорного бронирования —
    // объяснение сумм такой брони даёт панель договора, не этот алерт
    // (FT-173 STEP-17, REQ-13).
    showManualEditingAlert() {
      const booking = this.booking;
      return Boolean(booking && booking.manual_editing && !booking.rent_to_own);
    },
    // Подписи единицы аренды — те же ключи, что печатала прежняя проза, поэтому
    // новых переводов не требуется и формулировка операторам знакома.
    ft108RentUnitLabels() {
      const unit = (this.ft108Summary.parts[0] || {}).unit || "daily";
      const map = {
        daily: { count: "bookings.bookings_days", price: "bookings.price_bookings_days" },
        hourly: { count: "bookings.bookings_hours", price: "bookings.price_bookings_hours" },
        weekly: { count: "bookings.bookings_weeks", price: "bookings.price_bookings_weeks" },
        monthly: { count: "bookings.bookings_months", price: "bookings.price_bookings_months" },
      };
      return map[unit] || map.daily;
    },
    // FT-108 v2: слагаемые суммы для шапки. Метки берутся из тех же ключей,
    // что и раньше в прозе, — меняется подача, не словарь.
    ft108Summary() {
      return buildBookingSummary(this.booking, {
        deposit: this.currentDeposit(),
        labels: {
          rent: this.$t("bookings.rent"),
          add_hours: this.$t("bookings.add_hours"),
          insurance: this.$t("bookings.insurance"),
          add_drivers: this.$t("bookings.add_drivers_2"),
          // легаси-поле и каталожные допы FT-102 стоят в строке рядом —
          // берём разведённые лейблы (см. фикс UAT 2026-08-10), иначе два
          // слагаемых подряд назывались бы одинаково
          equipment: this.$t("bookings.other_equipment"),
          addons: this.$t("booking_addons.title"),
          delivery: this.$t("bookings.delivery"),
          checkout: this.$t("bookings.checkout"),
          clean: this.$t("bookings.clean"),
          damages: this.$t("bookings.damages"),
          fines: this.$t("bookings.fines"),
          other: this.$t("bookings.other"),
          hours_cost_end: this.$t("bookings.hours_cost_end"),
          other_end: this.$t("bookings.for_other_end"),
          mileage_cost: this.$t("bookings.mileage_cost"),
          gas: this.$t("bookings.gas"),
          deposit: this.$t("bookings.deposit"),
        },
      });
    },
    // Пояснение «почему добавлены сутки» из ответа движка (FT-084 units.extra_day_reason).
    // Пользователь видит настройку «сутки после N доп. часов» и не понимает, почему сутки
    // появились на меньшем остатке: ценовое правило «допчасы дороже суток» действует
    // независимо от неё (staging 2026-07-31). Пустая строка = сутки за остаток не добавляли.
    // Подсказка относится к ДВИЖКОВОМУ расчёту, поэтому показываем её только в авто-режиме:
    // в ручном/замороженном блок units в ответе — справка «как посчитал бы движок», она
    // расходится с сохранёнными значениями брони (ревью 2026-07-31: оператор с 1 сутками
    // видел «Сутки добавлены…» от последней авто-квоты).
    extraDayReasonText() {
      if (this.manualEditing || this.frozenManualMode) return "";
      const key = extraDayReasonKey(this.quoteResponse);
      return key ? this.$t(key) : "";
    },
    // Есть ли свежая движковая квота: только тогда её вывод авторитетен, и только при её
    // отсутствии уместен старый эвристический фоллбек.
    hasEngineQuote() {
      return !!(this.quoteResponse && this.quoteResponse.units) && !this.manualEditing && !this.frozenManualMode;
    },
    checkHoursLimit() {
      return (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.hours_limit &&
        this.$store.getters.getCompany.company.hours_limit > 0 &&
        this.booking.additional_hours >
        this.$store.getters.getCompany.company.hours_limit
      );
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    user_full_name() {
      if (this.$store.getters.getCurrentUser) {
        return `${this.$store.getters.getCurrentUser.last_name} ${this.$store.getters.getCurrentUser.first_name} ${this.$store.getters.getCurrentUser.middle_name}`;
      } else {
        return "";
      }
    },
    user_fio() {
      if (this.$store.getters.getCurrentUser) {
        return `${this.$store.getters.getCurrentUser.last_name} ${this.$store.getters.getCurrentUser.first_name ? this.$store.getters.getCurrentUser.first_name[0] : ''} ${this.$store.getters.getCurrentUser.middle_name ? this.$store.getters.getCurrentUser.middle_name[0] : ''}`;
      } else {
        return "";
      }
    },
    worker_accounts() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.currency_accounts;
      } else {
        return [];
      }
    },
    progressPercent() {
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidDays) /
            this.paidDays) *
          100
        );
      } else if (this.booking.hourly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidHours) /
            this.paidHours) *
          100
        );
      } else if (this.booking.weekly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidWeeks) /
            this.paidWeeks) *
          100
        );
      } else {
        // Оставшийся случай — только monthly: первая ветка забрала «ни один из
        // трёх». Раньше здесь стояло `else if (this.booking.monthly)`, и computed
        // формально мог вернуть undefined.
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidMonths) /
            this.paidMonths) *
          100
        );
      }
    },
    paidDays() {
      let days =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.days)
        ) || this.booking.days;
      if (this.gifts && this.gifts.length > 0) {
        let gift_days = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_days += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_days = days - gift_days;
        days =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / days)) *
            100
          ) / 100;
      }
      return days;
    },
    paidHours() {
      let hours =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.hourly_hours)
        ) || this.booking.hourly_hours;
      if (this.gifts && this.gifts.length > 0) {
        let gift_hours = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_hours += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = hours - gift_hours;
        hours =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / hours)) *
            100
          ) / 100;
      }
      return hours;
    },
    paidWeeks() {
      let weeks =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.weekly_weeks)
        ) || this.booking.weekly_weeks;
      if (this.gifts && this.gifts.length > 0) {
        let gift_weeks = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_weeks += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = weeks - gift_weeks;
        weeks =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / weeks)) *
            100
          ) / 100;
      }
      return weeks;
    },
    paidMonths() {
      let months =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.monthly_months)
        ) || this.booking.monthly_months;
      if (this.gifts && this.gifts.length > 0) {
        let gift_months = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_months += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = months - gift_months;
        months =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / months)) *
            100
          ) / 100;
      }
      return months;
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    messages() {
      // Messages for booking
      if (this.booking && this.booking.messages) {
        return this.booking.messages;
      } else {
        return [];
      }
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    // Панель «Сезоны»: режим определения сезона (manual QA 2026-07-13).
    // Первоисточник — meta.season_mode ответа квоты (режим компании МАШИНЫ,
    // по нему считал движок; при брони машины другого филиала он отличается
    // от компании юзера); fallback — флаги компании юзера из Vuex.
    seasonModeKeyValue() {
      const fromQuote = this.quoteResponse && this.quoteResponse.meta && this.quoteResponse.meta.season_mode;
      return fromQuote || seasonModeKey(this.company);
    },
    seasonModeText() {
      const key = this.seasonModeKeyValue;
      return key ? this.$t("bookings.season_mode_" + key) : "";
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    hasDepositHold() {
      const hold = this.booking && this.booking.deposit_hold;
      return !!(hold && ["pending", "held"].includes(hold.state));
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    isTaxiMode() {
      return this.company && this.company.taxi_park_type && this.company.taxi_park_type !== 'not_taxi';
    },
    computedProlongsHeaders() {
      let headers = [
        { text: this.$t("bookings.date_prolong"), align: "center", value: "last_date" },
        { text: this.$t("custom.type"), align: "center", value: "automatic", sortable: false },
      ];
      if (this.booking.hourly) {
        headers.push({ text: this.$t("custom.hours"), align: "center", value: "prolong_hours" });
      } else if (this.booking.weekly) {
        headers.push({ text: this.$t("custom.weeks"), align: "center", value: "prolong_weeks" });
      } else if (this.booking.monthly) {
        headers.push({ text: this.$t("custom.months"), align: "center", value: "prolong_months" });
      } else {
        headers.push({ text: this.$t("custom.days"), align: "center", value: "prolong_days" });
      }
      headers.push({ text: this.$t("bookings.price"), align: "center", value: "new_price", sortable: false });
      headers.push({ text: this.$t("custom.total"), align: "center", value: "total", sortable: false });
      headers.push({ text: "", align: "center", value: "actions", sortable: false });
      return headers;
    },
    computedGiftsHeaders() {
      let headers = [
        { text: this.$t("gifts.created"), align: "center", value: "created_at" },
      ];
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        headers.push({ text: this.$t("gifts.type"), align: "center", value: "gift_type", sortable: false });
      }
      headers.push({ text: this.$t("gifts.count_short"), align: "center", value: "count" });
      headers.push({ text: this.$t("bookings.price"), align: "center", value: "price" });
      headers.push({ text: "", align: "center", value: "actions", sortable: false });
      return headers;
    },
  },
  methods: {
    formatPhone,
    telHref,
    clientFullName,
    // FT-195: интеграция подключена — по признаку «задан», не по значению ключа (его в ответе нет).
    companySecretSet(name) {
      const store = this.$store.getters.getCompany;
      return secretSet(store && store.company, name);
    },
    onTaskSaved() {}, // задача добавлена в стор (UPSERT) → секция задач покажется автоматически
    // FT-066: BookingChannel handlers (moved 1:1 from the old declarative channel).
    onBookingConnected() {
      this.connected = true;
      console.log("connected cable")
    },
    onBookingDisconnected() {
      this.connected = false;
    },
    onBookingRejected() {
      console.log("rejected");
      this.connected = false;
    },
    onBookingReceived(data) {
      const id = this.$route.params.id;
      if (!data || !this.booking || String(this.booking.id) !== String(id)
        || (data.booking && String(data.booking.id) !== String(id))
        || (data.booking_id != null && String(data.booking_id) !== String(id))) return;
      console.log("🔔 BookingChannel received:", data)

      // Обработка обновления статуса документа OkiDoki
      if (data.type === "document_status_updated" && data.document && data.document.okidoki_contract_id) {
        console.log("📄 OkiDoki document status updated:", data.document)
        console.log("📋 Current generated_documents:", this.generated_documents)

        // Находим индекс документа
        const docIndex = this.generated_documents.findIndex(
          doc => doc.id === data.document.id
        )

        console.log("🔍 Document index:", docIndex)

        if (docIndex !== -1) {
          // Обновляем существующий документ напрямую в реактивном массиве
          console.log("✏️ Updating existing document at index", docIndex)
          this.$set(this.generated_documents, docIndex, data.document)
        } else {
          // Добавляем новый документ
          console.log("➕ Adding new document to list")
          this.generated_documents.unshift(data.document)
        }

        console.log("✅ Updated generated_documents:", this.generated_documents)

        // Показываем уведомление при изменении статуса
        const status = data.document.okidoki_status

        if (status === 'Подписан' || status === 'signed') {
          this.$notify(
            this.$t('okidoki.status_signed'),
            this.$t('okidoki.notification_signed'),
            'success',
            3000
          )
        } else if (status === 'Отклонен' || status === 'rejected') {
          this.$notify(
            this.$t('okidoki.status_rejected'),
            this.$t('okidoki.notification_rejected'),
            'warning',
            5000
          )
        } else {
          this.$notify(
            this.$t('okidoki.status'),
            this.$t('okidoki.notification_status_updated'),
            'info',
            3000
          )
        }

        return
      }

      // Обработка обновления статуса документа DocuSeal
      if (data.type === "document_status_updated" && data.document && data.document.docuseal_submission_id) {
        console.log("📄 DocuSeal document status updated:", data.document)
        console.log("📋 Current generated_documents:", this.generated_documents)

        // Находим индекс документа
        const docIndex = this.generated_documents.findIndex(
          doc => doc.id === data.document.id
        )

        console.log("🔍 Document index:", docIndex)

        if (docIndex !== -1) {
          // Обновляем существующий документ
          console.log("✏️ Updating existing document at index", docIndex)
          this.$set(this.generated_documents, docIndex, data.document)
        } else {
          // Добавляем новый документ
          console.log("➕ Adding new document to list")
          this.generated_documents.unshift(data.document)
        }

        console.log("✅ Updated generated_documents:", this.generated_documents)

        // Показываем уведомление при изменении статуса
        const status = data.document.docuseal_status

        if (status === 'completed') {
          this.$notify(
            this.$t('docuseal.status_completed'),
            this.$t('docuseal.notification_completed'),
            'success',
            3000
          )
        } else if (status === 'declined') {
          this.$notify(
            this.$t('docuseal.status_declined'),
            this.$t('docuseal.notification_declined'),
            'warning',
            5000
          )
        } else {
          this.$notify(
            this.$t('docuseal.status'),
            this.$t('docuseal.notification_status_updated'),
            'info',
            3000
          )
        }

        return
      }

      // Снимок старее загруженной карточки (пришёл после перезагрузки страницы) — целиком устаревший, не применяем.
      if (isStaleBookingSnapshot(data.booking, this.booking)) return;

      // Стандартная обработка других обновлений
      // затирает данные в форме
      if (!(this.editDialog || this.showArrivalDialog || this.departureDialog)) {
        this.booking = data.booking;
      }
      this.booking.counts = data.counts;
      this.booking.client = data.client;
      this.booking.prolongs = data.prolongs;
      this.prolongs = data.prolongs;
      // Синхронизируем generated_documents с отдельным реактивным свойством
      if (data.generated_documents) {
        this.booking.generated_documents = data.generated_documents;
        this.generated_documents = data.generated_documents;
      } else {
        if (!this.booking.generated_documents) {
          this.booking.generated_documents = [];
        }
        if (!this.generated_documents) {
          this.generated_documents = [];
        }
      }
      // Непонятно для чего???
      this.booking.selected_price = this.booking.price;
    },
    // FT-066: TinkoffPaymentChannel handlers (moved 1:1 from the old declarative channel).
    onTinkoffConnected() {
      this.connected = true;
    },
    onTinkoffDisconnected() {
      this.connected = false;
    },
    onTinkoffRejected() {
      console.log("rejected");
      this.connected = false;
    },
    onTinkoffReceived(data) {
      if (data && data.action === "deposit_hold" && data.deposit_hold) {
        this.onDepositHoldUpdated(data.deposit_hold);
        return;
      }
      const payment = data && data.tinkoff_payment;
      if (!payment || payment.company_id != this.company.id) return;
      // FT-193: платёж другого бронирования этой компании в панели карточки не нужен; платежи до фичи приходят
      // без booking_id — для них прежнее поведение.
      if (payment.booking_id != null && this.booking && payment.booking_id != this.booking.id) return;
      // Прежний исход строки — до applyTinkoffPayment: платёж бродкастится на каждый after_commit (4-5 раз за цикл),
      // а состояние автопродления двигает только смена исхода.
      const previous = this.tinkoff_payments.find((item) => item.id == payment.id);
      const previousOutcome = previous ? previous.outcome : undefined;
      this.applyTinkoffPayment(payment);
      // Исход пополнения баланса двигает состояние автопродления на сервере (awaiting_payment -> active и т. д.)
      if (
        payment.purpose === "balance_topup" &&
        this.booking &&
        this.booking.payments_type === "periodic" &&
        payment.outcome !== previousOutcome &&
        ["success", "failed", "stale"].includes(payment.outcome)
      ) {
        this.refreshPeriodicRenewalState();
      }
    },
    onDepositHoldUpdated(hold) {
      if (!this.booking || !hold) return;
      this.$set(this.booking, "deposit_hold", hold);
    },
    // Платёж в панель «Оплата картой» и признак проведения в строки бронирования. Исход учитывается: отказ и полный
    // возврат строку проведённой не оставляют, поздний успех после отказа возвращает её (REQ-09, D11).
    applyTinkoffPayment(payment) {
      if (this.tinkoff_payments.find((item) => item.id == payment.id)) {
        this.tinkoff_payments = this.tinkoff_payments.map((item) => (item.id == payment.id ? payment : item));
      } else {
        this.tinkoff_payments.push(payment);
      }
      // ищем в брони платеж с tinkoff_payment_id
      const completed = tinkoffPaymentCompleted(payment);
      const finded_counts = (this.booking.counts || []).filter((item) => item.tinkoff_payment_id == payment.id);
      finded_counts.forEach((finded_count) => {
        finded_count.completed = completed;
        // заменяем в массиве
        this.booking.counts = this.booking.counts.map((item) => (item.id == finded_count.id ? finded_count : item));
      });
    },
    // FT-193 REQ-09: подпись исхода; незнакомый — как есть
    tinkoffOutcomeLabel(outcome) {
      const key = TINKOFF_OUTCOME_LABEL_KEYS[outcome];
      return key ? this.$t(key) : outcome;
    },
    // Чистые функции periodicRenewal.js — методами, чтобы звать их из шаблона.
    tinkoffOutcomeColor,
    tinkoffPaymentCompleted,
    tinkoffStaleTitle(payment) {
      return payment && payment.outcome === "stale" && payment.stale_since
        ? this.$t("tinkoff.stale_since", { date: this.formatCreatedAt(payment.stale_since) })
        : "";
    },
    // CTR-05: фиксировать исход можно только у платежа в stale и только manager+
    canResolveTinkoffPayment(payment) {
      return !!(this.isManagerPlus && payment && payment.outcome === "stale");
    },
    openTinkoffResolve(payment) {
      if (!this.canResolveTinkoffPayment(payment)) return;
      this.tinkoffResolvePayment = payment;
      this.tinkoffResolveDialog = true;
    },
    // POST /api/v1/tinkoff_payments/:id/resolve { outcome: "success" | "failed" } (api STEP-10/14).
    resolveTinkoffPayment(outcome) {
      const payment = this.tinkoffResolvePayment;
      if (!this.isManagerPlus || !payment || this.isLoadingTinkoffResolve) return;
      if (outcome !== "success" && outcome !== "failed") return;
      this.isLoadingTinkoffResolve = true;
      return this.axios
        .post(
          `/api/v1/tinkoff_payments/${payment.id}/resolve`,
          { outcome },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          const body = response && response.data;
          const returned = body && (body.tinkoff_payment || (body.id == payment.id ? body : null));
          // Сервер ответил платежом — берём его; иначе применяем решение локально, а бродкаст канала дотянет остальное.
          this.applyTinkoffPayment({
            ...payment,
            ...(returned || { outcome, paid: outcome === "success", stale_since: null }),
          });
          this.tinkoffResolveDialog = false;
          this.$notify(this.$t("tinkoff.resolved"), "", "success", 4000);
          if (this.booking && this.booking.payments_type === "periodic") this.refreshPeriodicRenewalState();
        })
        .catch((error) => {
          // FT-193 W3: 409 tinkoff_payment_busy — платёж сейчас обрабатывает банк или другой сотрудник; это ожидаемое
          // состояние, а не сбой: понятный текст, без отчёта об ошибке, диалог остаётся для повтора.
          const status = error && error.response && error.response.status;
          if (status === 409 && extractValidationDetail(error).code === "tinkoff_payment_busy") {
            this.$notify(this.$t("tinkoff.resolve_error"), this.$t("errors.codes.tinkoff_payment_busy"), "warning", 6000);
            return;
          }
          this.setError(error, this.$t("tinkoff.resolve_error"));
        })
        .finally(() => {
          this.isLoadingTinkoffResolve = false;
        });
    },
    // POST /api/v1/bookings/:id/resume_periodic_renewal — manager+, только из stopped_errors (api STEP-07)
    resumePeriodicRenewal() {
      if (!this.canResumePeriodicRenewal || this.isLoadingPeriodicAction) return;
      this.isLoadingPeriodicAction = true;
      return this.axios
        .post(
          `/api/v1/bookings/${this.booking.id}/resume_periodic_renewal`,
          {},
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          const data = (response && response.data) || {};
          this.$set(this.booking, "periodic_renewal_state", data.periodic_renewal_state || "active");
          // выход из блока сбрасывает причину (контракт FT-193)
          this.$set(this.booking, "periodic_block_reason", null);
          if (data.payment_job_count !== undefined) this.$set(this.booking, "payment_job_count", data.payment_job_count);
          this.$notify(this.$t("bookings.periodic_renewal.resumed"), "", "success", 4000);
        })
        .catch((error) => {
          this.setError(error, this.$t("bookings.periodic_renewal.action_failed"));
          // 422 renewal_not_stopped: состояние уже сменил другой сотрудник или тик — показываем актуальное
          if (error && error.response && error.response.status === 422) this.refreshPeriodicRenewalState();
        })
        .finally(() => {
          this.isLoadingPeriodicAction = false;
        });
    },
    // POST /api/v1/bookings/:id/retry_periodic_topup — manager+, из blocked_credit_limit при balance_and_card
    // (api STEP-10/14).
    retryPeriodicTopup() {
      if (!this.canRetryPeriodicTopup || this.isLoadingPeriodicAction) return;
      this.isLoadingPeriodicAction = true;
      return this.axios
        .post(
          `/api/v1/bookings/${this.booking.id}/retry_periodic_topup`,
          {},
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then(() => {
          this.$notify(this.$t("bookings.periodic_renewal.retry_started"), "", "success", 4000);
          return this.refreshPeriodicRenewalState();
        })
        .catch((error) => {
          this.setError(error, this.$t("bookings.periodic_renewal.action_failed"));
          if (error && error.response && error.response.status === 422) this.refreshPeriodicRenewalState();
        })
        .finally(() => {
          this.isLoadingPeriodicAction = false;
        });
    },
    // Состояние автопродления считает сервер (тики, вебхуки): после действия и по бродкасту пополнения берём свежее,
    // не перезагружая карточку целиком. Сбой не страшен — на экране остаётся прежнее состояние.
    refreshPeriodicRenewalState() {
      if (!this.booking || !this.booking.id) return Promise.resolve();
      const booking = this.booking;
      const id = booking.id;
      const cardSequence = this.cardLoadSequence;
      const sequence = this.periodicLoadSequence = (Number(this.periodicLoadSequence) || 0) + 1;
      return this.axios
        .get(`/api/v1/booking_cards/${id}`, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          if (this._cardLoadDestroyed === true || sequence !== this.periodicLoadSequence
            || cardSequence !== this.cardLoadSequence || this.booking !== booking
            || String(id) !== String(this.$route.params.id)) return;
          const fresh = response && response.data && response.data.card && response.data.card.booking;
          if (!fresh) return;
          ["periodic_renewal_state", "periodic_block_reason", "periodic_funding", "payment_job_count", "last_balanced_at"].forEach((key) => {
            this.$set(this.booking, key, fresh[key]);
          });
        })
        .catch((error) => console.log(error));
    },
    editBooking() {
      // FT-193 REQ-07: селект источника списания открывается с текущим значением; уходит в PATCH, только если его сменили
      this.edit_periodic_funding = (this.booking && this.booking.periodic_funding) || "balance";
      // Было «не агент ИЛИ агент с правом» — guest и partner проходили как
      // «не агенты». Право на правку брони даёт компания через agent_setting.
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        if (this.booking.car_id && this.booking.car_id > 0) {
          this.isLoadingEditBooking = true;
          let self = this;
          this.axios
            .get(`/api/v1/edit_booking_data/${this.booking.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.set_car = response.data.car;
              // FT-084 STEP-12: was 4x findAudited*PricesForBooking fed by
              // this response's price.audits — server-side stored-vs-current
              // quote comparison now drives show_audited_price_alert.
              this.checkAuditedPriceDivergence();

              this.seasons = response.data.seasons;
              // При смене авто сохранялся старый пробег
              // this.booking.start_mileage =
              //   this.booking.start_mileage > 0
              //     ? this.booking.start_mileage
              //     : this.set_car.mileage;
              // Поменял на старый вариант, при смене авто пробег записывается новый
              this.booking.start_mileage =
                this.booking.start_mileage > 0
                  ? this.booking.start_mileage
                  : this.set_car.mileage;
              this.start_date = this.booking.start_date;
              this.end_date = this.booking.end_date;
              // FT-084 STEP-12: editDialog must be true BEFORE setDates()/
              // selected_tariff_id below — both funnel into requestQuote(),
              // which no-ops while the edit dialog is closed (guards against
              // firing quote requests from stray pricing-input watchers
              // outside the edit flow).
              this.editDialog = true;
              // Ставится ДО setDates(): дальше по цепочке setDates() →
              // calculateCost() → requestQuote() читает manualEditing
              // СИНХРОННО, и режим обязан быть уже поднят. (Движок при
              // обратном порядке тоже не дёрнулся бы — requestQuote выходит
              // рано и по frozenManualMode, — но держать это на совпадении
              // двух ранних выходов незачем: ревью 2026-08-17 поймало ровно
              // такое ложное обоснование в прежнем комментарии.)
              this.hydrateManualEditingMode();
              this.selected_tariff_id = this.booking.tariff_id
                ? this.booking.tariff_id
                : null;
              this.setDates();
              // FT-108 DEC-02: авто-сет showAddDrivers = true при непустых
              // add_drivers снят — диалог всегда открывается со свёрнутыми
              // панелями, количество водителей видно в заголовке панели.

              let tariffs_data = response.data.tariffs;
              tariffs_data.forEach((item) => {
                let result;
                if (item.sum > 0 || item.sum < 0) {
                  result = `${item.sum}${self.currency}`;
                } else {
                  result = `${item.percent}%`;
                }
                return (item["fullname"] = `${item.name} | ${result}`);
              });
              this.tariffs = this.tariffs.concat(tariffs_data);
              // Ищем тариф если есть
              if (this.booking.tariff_id) {
                let result = this.tariffs.find(
                  (tariff) => tariff.id == this.booking.tariff_id
                );
                if (result) {
                  this.tariff = result;
                  this.selected_tariff_id = this.tariff.id;
                }
              }
              if (this.company && this.company.can_select_agents) {
                this.getAgents();
              }
              // FT-108 REQ-04: снапшот секций — база точек-индикаторов.
              // После editDialog = true, но в КОНЦЕ синхронной инициализации:
              // выше выставляются selected_tariff_id (из booking.tariff_id) и
              // нормализованный формат дат (setDates → HH-паддинг) — снапшот
              // «сразу после editDialog = true» зафиксировал бы старые
              // значения и тариф/даты светились бы dirty с порога. Guard по
              // booking.id — deferred STEP-01 (б): снапшот без загруженной
              // брони = сплошные undefined → всё dirty после догрузки.
              if (this.booking && this.booking.id) {
                this.ft108SectionSnapshots = takeSectionSnapshots(this);
              }
            })
            .catch((error) => {
              // 404 = машины брони нет в скоупе (удалена; до деплоя api-фикса — другой
              // филиал): человеческое сообщение без Rollbar и сырого AxiosError
              if (error.response?.status == 404) {
                this.$notify(this.$t("errors.car_load"), this.$t("errors.booking_car_not_found"), "error", 5000);
                return;
              }
              this.setError(error, this.$t("errors.car_load"));
            })
            .finally(() => (this.isLoadingEditBooking = false));
        } else {
          this.editDialog = true;
          this.hydrateManualEditingMode();
          // FT-108 DEC-02: авто-сет showAddDrivers снят (см. первую ветку).
          // FT-108 REQ-04: снапшот секций (guard — deferred STEP-01 (б),
          // см. первую ветку)
          if (this.booking && this.booking.id) {
            this.ft108SectionSnapshots = takeSectionSnapshots(this);
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Ручной режим — свойство БРОНИ, а не сессии формы: при повторном входе в
    // редактирование он обязан восстановиться из booking.manual_editing.
    // Без этого manualEditing (локальный флаг, гасится после каждого сейва,
    // см. editSave) всегда был false, а auto_calculate у ручной брони гасится
    // при загрузке — форма открывалась во FROZEN (DEC-19), поля сумм были
    // скрыты, и оператор каждый раз тыкал «Изменить данные вручную» в
    // строке-подсказке, чтобы вернуть их (сообщение USER 2026-08-17).
    // FROZEN никуда не делся: в него ведёт явная кнопка «Зафиксировать суммы»
    // — как и задумано FT-108, где MANUAL → FROZEN сделан отдельным действием.
    // Условие узкое, ровно booking.manual_editing: бронь интеграции, которую
    // вручную ещё не сохраняли (only_manual_editing, Localrent), сюда не
    // попадает — её вход в правку остаётся через строку-подсказку, состав её
    // сейва не меняется. Если такую бронь однажды сохранили вручную, сервер
    // поставит manual_editing = true, и режим поднимется здесь на общих
    // основаниях — это и правильно: движок ей всё равно не считает.
    // Архив исключён отдельно (ревью 2026-08-17, Codex P1): у завершённой
    // брони суммы в форме неизменны вовсе (решение USER 2026-08-11 — тот же
    // предикат гасит кнопку «Ручной» в сегменте режима), а MANUAL-ветка
    // buildManualPricePart отправила бы manual_price и всю денежную панель
    // там, где по контракту не должно уйти ничего.
    // Второе слагаемое — брони, которым запрещён АВТОрасчёт (Localrent,
    // only_manual_editing). Им ручной режим поднимает не сервер, а загрузка
    // карточки: она гасит auto_calculate, и вотчер ставит manualEditing = true.
    // Гидратация по одному booking.manual_editing этот режим ОПУСКАЛА — форма
    // открывалась во FROZEN, и класс броней, которому ручная правка является
    // единственным входом в цены, получал ровно тот лишний клик, который фикс
    // снимает у обычных (P2 ревью 2026-08-17). Здесь не «расширение на
    // интеграции», а запрет гасить уже поднятый режим: это восстановление
    // поведения до фикса. Решение 2026-08-11 про ABSENT не задето — оно про
    // manual_price: null у брони, которую оператор НЕ правит вручную
    // (manualEditing = false), и живёт в enginePricingForbidden.
    hydrateManualEditingMode() {
      const booking = this.booking || {};
      if (this.calcManualDisabled) {
        this.manualEditing = false;
        return;
      }
      this.manualEditing = Boolean(booking.manual_editing) || Boolean(this.calcModeDisabled);
    },
    safeParseFloat(value) {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parseFloat(parsed.toFixed(2));
    },
    setDates() {
      if (this.set_car != null) {
        // FT-084 STEP-12: `HH` (zero-padded), not `H` — booking.start_date/
        // end_date now feed straight into requestQuote()/editSave(), and the
        // server's DATE_FORMAT_REGEX (price_quotes_controller.rb/
        // priced_bookings_controller.rb) requires exactly 2 digits for the
        // hour; moment's `H` token renders single-digit hours unpadded
        // ("9:00"), which would 422 as invalid_input for any edit landing
        // on hour 0-9.
        this.booking.start_date = moment
          .utc(this.start_date, "DD-MM-YYYY H:mm")
          .format("DD-MM-YYYY HH:mm");
        this.booking.end_date = moment
          .utc(this.end_date, "DD-MM-YYYY H:mm")
          .format("DD-MM-YYYY HH:mm");
        // проверка на дата конца раньше начала
        if (
          this.booking.start_date &&
          this.booking.end_date &&
          moment
            .utc(this.booking.start_date, "DD-MM-YYYY H:mm")
            .isAfter(
              moment.utc(this.booking.end_date, "DD-MM-YYYY H:mm"),
              "hour"
            )
        ) {
          this.$notify(this.$t("errors.incorrect_date_title"), this.$t("errors.incorrect_date_text"), "warning", 5000)
          return;
        }

        // FT-084 STEP-12: was calculateDays() + calculateCost() (client-side
        // seasonal math) — a single server quote request now covers both.
        this.calculateCost();
      } else {
        this.$notify(this.$t("errors.car_not_select_title"), this.$t("errors.car_not_select_text"), "warning", 5000)
      }
    },
    minDate() {
      if (this.start_date) {
        console.log(moment(this.start_date, "DD-MM-YYYY H:mm").toDate());
        return moment(this.start_date, "DD-MM-YYYY H:mm").toDate();
      } else {
        return undefined;
      }
    },
    setDataToEditDate() {
      // Безопасная установка дат с проверкой на undefined/null
      if (this.booking && this.booking.start_date) {
        this.start_date = this.booking.start_date;
        this.start_date_not_formated = moment
          .utc(this.booking.start_date, "DD-MM-YYYY H:mm")
          .toISOString();
      } else {
        // Fallback: текущая дата + 1 час
        this.start_date_not_formated = moment().add(1, 'hour').toISOString();
      }
      
      if (this.booking && this.booking.end_date) {
        this.end_date = this.booking.end_date;
        this.end_date_not_formated = moment
          .utc(this.booking.end_date, "DD-MM-YYYY H:mm")
          .toISOString();
      } else {
        // Fallback: текущая дата + 2 часа
        this.end_date_not_formated = moment().add(2, 'hours').toISOString();
      }
    },
    getTariffs() {
      let self = this;
      this.axios
        .get(`api/v1/tariffs`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          let tariff = response.data;
          tariff.forEach((item) => {
            let result;
            if (item.sum > 0 || item.sum < 0) {
              result = `${item.sum}${self.currency}`;
            } else {
              result = `${item.percent}%`;
            }
            return (item["fullname"] = `${item.name} | ${result}`);
          });
          this.tariffs = this.tariffs.concat(tariff);
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.tariffs_load"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
    getTemplates() {
      this.isLoading = true;
      let self = this;
      this.axios
        .get(`/api/v1/small_templates?car_id=${this.booking.car_id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.templates = response.data;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.templates"));
          this.isLoading = false;
        })
        .finally((this.isLoading = false));
    },
    // Объект тарифа для превью продления (ProlongDialog считает по нему квоту).
    // findTariff рядом отдаёт fullname для витрин и здесь не подходит.
    findTariffObject(id) {
      if (!id || !this.tariffs || this.tariffs.length === 0) return null;
      return this.tariffs.find((tariff) => tariff.id == id) || null;
    },
    findTariff(id) {
      let result;
      if (this.tariffs && this.tariffs.length > 0) {
        result = this.tariffs.find((tariff) => tariff.id == id);
        if (result) {
          return result.fullname;
        }
      }
    },
    // FT-108 DEC-02/REQ-07: ЕДИНЫЙ reset секций для всех трёх точек закрытия
    // диалога (крестик шапки, кнопка Close, success-ветка editSave). Заменяет
    // прежние inline-цепочки: панельные флаги (расширенный список DEC-02 —
    // resetAllSections) + сегодняшние сбросы дат/тарифа. НЕ входят и остаются
    // на местах вызова: getBooking()/getCar(), editDialog=false,
    // manualEditing=false, warning*-сбросы — они не про панели/даты/тариф.
    ft108ResetEditSections() {
      resetAllSections(this);
      // DEC-02 распространяется и на раскрывашку сезонов: диалог всегда
      // открывается свёрнутым целиком
      this.ft108ShowSeasons = false;
      // ...и на строку ошибки активности: она относится к попытке, а не к
      // брони, и без сброса переживала закрытие диалога — оператор открывал
      // форму заново и видел отказ, которого в этой сессии не было.
      // Сдвиг поколения обязателен вместе с очисткой: запрос мог ещё лететь,
      // и его catch-ветка вернула бы строку уже после закрытия формы
      this.activeStateEpoch++;
      this.activeStateError = "";
      // ВНИМАНИЕ: success-ветка editSave читает selected_tariff_id ДО вызова
      // (booking.tariff_id = selected_tariff_id) — порядок там обязателен
      this.selected_tariff_id = null;
      this.tariff = null;
      this.start_date = null;
      this.end_date = null;
      // REQ-04: без снапшота точки-индикаторы молчат до следующего editBooking()
      this.ft108SectionSnapshots = null;
    },
    // FT-108 REQ-04: точка-индикатор секции — текущие значения отличаются от
    // снапшота, снятого при открытии диалога
    ft108IsDirty(sectionKey) {
      return isSectionDirty(sectionKey, this.ft108SectionSnapshots, this);
    },
    // FT-108 REQ-04: значения секций в заголовках свёрнутых панелей.
    // Роль-видимость ФИО клиента — в шаблоне (тот же style-паттерн
    // guest/partner, что у ссылки в сводке).
    ft108ClientValue() {
      const b = this.booking || {};
      if (b.entity) return b.entity_name || "";
      return [b.last_name, b.first_name, b.middle_name].filter(Boolean).join(" ");
    },
    ft108DatesValue() {
      const b = this.booking || {};
      const dates = [b.start_date, b.end_date].filter(Boolean).join(" → ");
      const places = [b.location_start, b.location_end].filter(Boolean).join(" → ");
      return [dates, places].filter(Boolean).join(" · ");
    },
    ft108TariffValue() {
      const b = this.booking || {};
      const parts = [];
      const tariffName = b.tariff_id ? this.findTariff(b.tariff_id) : null;
      if (tariffName) parts.push(tariffName);
      // «100₽» без подписи читалось как цена тарифа (критика 2026-08-11)
      if (Number(b.sale)) parts.push(`${this.$t("bookings.sale")} ${b.sale}%`);
      if (Number(b.sale_cash)) parts.push(`${this.$t("bookings.sale")} ${b.sale_cash}${this.currency}`);
      return parts.join(" · ");
    },
    ft108ServicesValue() {
      return formatServicesValue(this.booking, {
        equipment: this.$t("bookings.equipment"),
        insurance: this.$t("bookings.insurance"),
        services: this.$t("bookings.add_services_short"),
      });
    },
    ft108InfoValue() {
      // Витрина синхронна с dirty-снапшотом секции: description ИЛИ первая
      // непустая кастомка — иначе бронь с заполненным только custom_field_*
      // показывала бы «—», хотя точка-индикатор эти поля отслеживает.
      const b = this.booking || {};
      const text = b.description || b.custom_field_1 || b.custom_field_2 || b.custom_field_3;
      if (!text) return "—";
      return text.length > 40 ? `${text.slice(0, 40)}…` : text;
    },
    ft108DriversValue() {
      const count = (this.selected_add_drivers || []).length;
      return count > 0 ? String(count) : this.$t("custom.no");
    },
    loadCardData() {
      const id = this.$route.params.id;
      const sequence = this.cardLoadSequence = (Number(this.cardLoadSequence) || 0) + 1;
      const isCurrent = () => this._cardLoadDestroyed !== true
        && sequence === this.cardLoadSequence && String(id) === String(this.$route.params.id);
      // Drop A before requesting B: B can fail, and queued A broadcasts can still arrive.
      if (String(this.subscribedBookingId) !== String(id)) this.unsubscribe();
      if (this.booking && String(this.booking.id) !== String(id)) {
        this.cardSections = null;
        this.cardSectionsEntityId = null;
        this.booking = { payments: [], counts: [], prolongs: [], generated_documents: [], messages: [], client: {} };
        this.ft102Lines = [];
        this.show_audited_price_alert = false;
      }
      this.isLoading = true;
      this.loadFailed = false;
      this.carBookingsLoaded = false; // Сбрасываем флаг при загрузке
      // Пока карточка грузится, сетевой отказ объясняет она сама (котик с
      // «Повторить» в шапке) — глобальный индикатор молчит. Заявка держится всю
      // попытку, включая ретрай; канон — store/modules/network.js.
      this.$store.commit("network/CLAIM_LOAD", `booking-card-${this._uid}`);
      return this.axios
        .get(`/api/v1/booking_cards/${id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          if (!isCurrent()) return;
          this.$store.commit("network/RELEASE_LOAD", `booking-card-${this._uid}`);
          const card = response.data && response.data.card;
          if (!card || !card.booking) {
            console.error('Bad booking data:', response.data);
            this.$notify(this.$t("errors.booking_not_found"), "", "error");
            this.$router.push({ path: `/bookings/list` });
            return;
          }
          // Missing envelopes are failed sections, never an invitation for children to fetch.
          const sections = {};
          const suppliedSections = response.data.sections || {};
          ["partner_access", "store_lines", "price_divergence", "tasks", "task_users", "leads", "rent_to_own_contracts", "damage_control_act"].forEach((name) => {
            sections[name] = suppliedSections[name] === undefined ? { status: "error" } : suppliedSections[name];
          });
          const access = readInitialSection(sections.partner_access);
          this.partnerAccess = access.data || { can_view_booking_card: false, can_view_maintenances: false };
          if (this.user_role === "partner" && access.status === "ok" && !this.partnerAccess.can_view_booking_card) {
            this.$router.push({ path: "/bookings/list" });
            this.$notify(this.$t("errors.no_access"), "", "warning");
            return;
          }
          
          // FT-184: метки «через агента» брони и её платежей едут в этом же ответе (agent_marks).
          agentMarkerLoader.prime(card.agent_marks);
          this.booking = card.booking;
          // FT-173 STEP-16 (REQ-08, CTR-04): booking.rent_to_own is known now —
          // decide ?payment=1 as soon as possible. rent_to_own bookings wait
          // for RentToOwnPanel's @contract-loaded (onRentToOwnContractLoaded);
          // everything else strips the param immediately.
          this.applyPaymentQueryParam();
          this.booking.payments = card.payments || []
          this.booking.counts = card.counts || []
          this.booking.client = card.client || {}
          this.booking.prolongs = card.prolongs || []
          this.prolongs = card.prolongs || []
          this.booking.generated_documents = card.generated_documents || []
          this.generated_documents = card.generated_documents || []
          this.booking.messages = card.messages || []
          this.tinkoff_payments = card.tinkoff_payments || []
          this.company_cashbox_id = this.active_company_cashboxes && this.active_company_cashboxes[0] && this.active_company_cashboxes[0].id ? this.active_company_cashboxes[0].id : null
          // set car
          if (this.booking.car_id && this.booking.car_id > 0) {
            this._cardHydratedCar = card.car;
            this.set_car = this._cardHydratedCar;
            // Выставляем пробег
            this.booking.start_mileage =
              this.booking.start_mileage > 0
                ? this.booking.start_mileage
                : this.set_car.mileage;
          }

          // Проверка что если пользователь партнер, то можно просматривать только свои брони
          if (this.isPartner && this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.partner_id) {
            let current_user_partner_id = this.$store.getters.getCurrentUser.partner_id;
            if (this.set_car.investor_id != current_user_partner_id) {
              this.$router.push({ path: `/bookings/list` });
              this.$notify(this.$t("errors.no_access"), "", "warning");
            }
          }

          if (card.add_drivers && card.add_drivers.length > 0) {
            let add_drivers = card.add_drivers
            this.add_drivers = [];
            add_drivers.forEach((client) => {
              if (!client) return;
              if (!client.entity) {
                client["fullname"] =
                  (client.lastname || '') +
                  " " +
                  (client.name || '') +
                  " " +
                  (client.middlename || '') +
                  " " +
                  (client.phone
                    ? phoneLastDigits(client.phone)
                    : "");
              } else {
                client["fullname"] =
                  (client.entity_name || '') +
                  ", " +
                  (client.reg_form || '') +
                  " " +
                  " - " +
                  (client.entity_phone
                    ? phoneLastDigits(client.entity_phone)
                    : "");
              }
              this.add_drivers.push(client);
            });
          }
          // only_manual_editing добавлен по ревью 2026-07-22 (P1 Codex):
          // легаси-строка внешней брони с manual_editing=false иначе
          // открывалась с auto_calculate=true и editSave слал
          // manual_price:null — новый сервер честно 422-ит такой сброс.
          if (this.booking.manual_editing || this.booking.only_manual_editing || this.booking.source == 'Localrent' || this.booking.localrent_id) {
            this.auto_calculate = false;
          }

          // Same-entity reloads retain both subscriptions. Capture their identity:
          // unsubscribe cannot cancel callbacks already queued by ActionCable.
          if (!(this.subscribedBookingId === this.booking.id && this.subscribedCompanyId === this.company.id
            && this.bookingSub && this.tinkoffSub)) {
            this.unsubscribe();
            const bookingId = this.subscribedBookingId = this.booking.id;
            const companyId = this.subscribedCompanyId = this.company.id;
            const isCurrentSubscription = () => this._cardLoadDestroyed !== true
              && this.subscribedBookingId === bookingId && this.subscribedCompanyId === companyId
              && String(this.$route.params.id) === String(bookingId)
              && this.booking && String(this.booking.id) === String(bookingId)
              && this.company && String(this.company.id) === String(companyId);

            this.bookingSub = this.$cableSubscribe(
              { channel: "BookingChannel", room: bookingId, booking_id: bookingId },
              {
                connected: () => this.onBookingConnected(),
                disconnected: () => this.onBookingDisconnected(),
                rejected: () => this.onBookingRejected(),
                received: (data) => { if (isCurrentSubscription()) this.onBookingReceived(data); },
              }
            );
            this.tinkoffSub = this.$cableSubscribe(
              { channel: "TinkoffPaymentChannel", room: companyId },
              {
                connected: () => this.onTinkoffConnected(),
                disconnected: () => this.onTinkoffDisconnected(),
                rejected: () => this.onTinkoffRejected(),
                received: (data) => { if (isCurrentSubscription()) this.onTinkoffReceived(data); },
              }
            );
          }
          // Непонятно для чего???
          this.booking.selected_price = this.booking.price;

          // Timer
          if (this.booking.created_at) {
            this.hour_timer = moment.duration(moment().diff(moment(this.booking.created_at).add(1, 'hours'))).asMilliseconds() * -1
          } else {
            this.hour_timer = 0;
          }
          // periods
          this.periods = card.company.periods;
          this.hourly_periods = card.company.hourly_periods;
          this.weekly_periods = card.company.weekly_periods;
          this.monthly_periods = card.company.monthly_periods;
          // seasons
          this.seasons = card.seasons;
          // gifts
          this.gifts = card.gifts;
          // client
          this.set_client = card.client;
          this.client = card.client;
          // Проверяем подключение оповещений через мессенджеры
          let company = this.$store.getters.getCompany.company;
          if (
            this.client.phone &&
            (company.whatsapp || company.telegram_green_api_enabled || company.max_enabled)
          ) {
            this.sendMessenger = true;
            this.checkMessenger();
          }
          if (this.client.email) {
            this.sendEmail = true;
            this.checkEmail();
          }
          // Доп водители
          if (this.booking.add_drivers && this.booking.add_drivers.length > 0) {
            this.add_drivers = card.add_drivers;
            this.selected_add_drivers = card.add_drivers;
          }
          // tariffs
          let tariffs = card.tariffs;
          tariffs.forEach((item) => {
            let result;
            if (item.sum > 0 || item.sum < 0) {
              result = `${item.sum}`;
            } else {
              result = `${item.percent}%`;
            }
            return (item["fullname"] = `${item.name} | ${result}`);
          });

          this.tariffs = this.tariffs.concat(tariffs);
          // fines
          this.fines = card.fines;
          // debts
          this.debts = card.debts;
          // invoices
          this.invoices = card.invoices;
          // workers
          let workers = [];
          card.users.forEach((item) =>
            workers.push({
              id: item.id,
              name: item.name ? item.name : item.email,
            })
          );
          this.workers = workers;
          // bookings (для обратной совместимости — старые версии API отправляют bookings)
          this.bookings = [];
          // берем из сериалазера
          if (card.bookings && card.bookings.data) {
            card.bookings.data.forEach((booking) => {
              this.bookings.push(booking.attributes);
            });
            this.carBookingsLoaded = true; // Брони уже загружены из booking_cards
          }
          this.ft223ApplyStoreLines(sections.store_lines);
          const divergence = readInitialSection(sections.price_divergence);
          this.show_audited_price_alert = divergence.status === "ok" && divergence.data.diverged === true;
          // Vue batches these synchronous writes: children see the complete card + envelopes.
          this.cardSectionsEntityId = this.booking.id;
          this.cardSections = sections;
        })
        .catch((error) => {
          if (!isCurrent()) return;
          // 404 = брони нет (удалена / чужой филиал / битый id). Это НЕ сбой
          // сети: fallback-котик «Проверьте соединение… Повторить» тут врёт, а
          // ретрай будет 404-ить вечно. Ведём себя как then()-ветка «плохих
          // данных» — уводим на список. Заодно не поднимаем loadFailed, чтобы
          // setError не тащил голый 404 в Rollbar красным.
          if (error.response?.status === 404) {
            this.$store.commit("network/RELEASE_LOAD", `booking-card-${this._uid}`);
            this.$notify(this.$t("errors.booking_not_found"), "", "error");
            this.$router.push({ path: `/bookings/list` });
            return;
          }
          // Котик с «Повторить» — только когда ретрай реально может помочь
          // (транзиентный обрыв сети). Прочие ошибки идут через setError.
          this.loadFailed = isTransientNetworkError(error);
          if (!this.loadFailed) {
            this.$store.commit("network/RELEASE_LOAD", `booking-card-${this._uid}`);
          }
          // Блок на экране уже объяснил отказ — тост был бы вторым сообщением.
          this.setError(error, this.$t("errors.booking_load"), { silent: this.loadFailed });
        })
        .finally(() => {
          if (isCurrent()) this.isLoading = false;
        });
    },
    getBooking() {
      const id = this.$route.params.id;
      // A route change may still be bootstrapping when an old action finishes.
      if (String(this.cardSectionsEntityId) !== String(id)) return this.loadCardData();
      const sequence = this.cardLoadSequence = (Number(this.cardLoadSequence) || 0) + 1;
      const isCurrent = () => this._cardLoadDestroyed !== true
        && sequence === this.cardLoadSequence && String(id) === String(this.$route.params.id);
      this.isLoading = true;
      this.loadFailed = false;
      this.carBookingsLoaded = false; // Сбрасываем флаг при перезагрузке
      return this.axios
        .get(`/api/v1/booking_cards/${id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          if (!isCurrent()) return;
          const card = response.data && response.data.card;
          if (!card || !card.booking) {
            console.error('Bad booking data:', response.data);
            this.$notify(this.$t("errors.booking_not_found"), "", "error");
            this.$router.push({ path: `/bookings/list` });
            return;
          }
          
          // FT-184: метки «через агента» брони и её платежей едут в этом же ответе (agent_marks).
          agentMarkerLoader.prime(card.agent_marks);
          this.booking = card.booking;
          this.booking.selected_price = this.booking.price;
          this.booking.payments = card.payments || []
          this.booking.counts = card.counts || []
          this.booking.client = card.client || {}
          this.booking.prolongs = card.prolongs || []
          this.prolongs = card.prolongs || []
          // Инициализируем отдельное реактивное свойство
          this.booking.generated_documents = card.generated_documents || []
          this.generated_documents = card.generated_documents || []
          this.booking.messages = card.messages || []
          // FT-084 STEP-12 fix round 1 (C2): mounted() already refreshes
          // this.gifts from this same booking_cards payload — getBooking()
          // (re-fetch path, e.g. after websocket-driven refresh) didn't,
          // leaving this.gifts stale and currentGiftsPayload() wrong for any
          // editSave() that followed a getBooking()-only refresh.
          this.gifts = card.gifts || [];

          if (card.add_drivers && card.add_drivers.length > 0) {
            let add_drivers = card.add_drivers
            this.add_drivers = [];
            add_drivers.forEach((client) => {
              if (!client) return;
              if (!client.entity) {
                client["fullname"] =
                  (client.lastname || '') +
                  " " +
                  (client.name || '') +
                  " " +
                  (client.middlename || '') +
                  " " +
                  (client.phone
                    ? phoneLastDigits(client.phone)
                    : "");
              } else {
                client["fullname"] =
                  (client.entity_name || '') +
                  ", " +
                  (client.reg_form || '') +
                  " " +
                  " - " +
                  (client.entity_phone
                    ? phoneLastDigits(client.entity_phone)
                    : "");
              }
              this.add_drivers.push(client);
            });
          }
          // Единый вид с loadCardData-инициализацией (P3 ревью 2026-07-22):
          // only_manual_editing/Localrent тоже не должны поднимать авто.
          if (this.booking.manual_editing || this.booking.only_manual_editing || this.booking.source == 'Localrent' || this.booking.localrent_id) {
            this.auto_calculate = false;
          }
          this._cardHydratedCar = card.car || {};
          this.set_car = this._cardHydratedCar;
          const sections = response.data.sections || {};
          this.ft223ApplyStoreLines(sections.store_lines);
          const divergence = readInitialSection(sections.price_divergence);
          this.show_audited_price_alert = divergence.status === "ok" && divergence.data.diverged === true;
          // Keep the original child envelopes and live subscriptions for this booking.
        })
        .catch((error) => {
          if (!isCurrent()) return;
          // Ре-фетч уже открытой карточки: 404 = бронь удалили под нами.
          // Уводим на список вместо генерик-тоста поверх устаревших данных.
          if (error.response?.status === 404) {
            this.$notify(this.$t("errors.booking_not_found"), "", "error");
            this.$router.push({ path: `/bookings/list` });
            return;
          }
          this.setError(error, this.$t("errors.booking_load"));
        })
        .finally(() => {
          if (!isCurrent()) return;
          // Also release a bootstrap/retry claim superseded by this reload.
          this.$store.commit("network/RELEASE_LOAD", `booking-card-${this._uid}`);
          this.isLoading = false;
        });
    },
    getCar() {
      if (this.set_car && this.set_car.id) {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/cars/${this.set_car.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            // FT-084 STEP-12: was 4x findAudited*PricesForBooking fed by
            // this response's price.audits, plus a per-rental-type "no
            // prices configured" presence check (see the set_car watcher
            // above for why the presence check has no replacement here —
            // an absent price surfaces via quoteStatus 'no_price' instead).
            if (!this.showArrivalDialog) {
              // Set_car включается и при приеме и идет ошибка расчета цены
              this.checkAuditedPriceDivergence();
              this.calculateCost();
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.set_car"));
          })
          .finally(() => (this.isLoading = false));
      }
    },
    // ------------------------------------------------------------------
    // FT-084 STEP-12: server-side quote (POST /api/v1/price_quotes) replaces
    // the client-side seasonal/tariff/gift math that used to live in
    // calculateDays/calculateCost/calculateCostWithTariff + the audits-based
    // reconstruction in findAuditedPricesForBooking/findAuditedHourlyPricesForBooking/
    // findAuditedWeeklyPricesForBooking/findAuditedMonthlyPricesForBooking
    // (task-12-report.md has the full removed-method/branch list). Pattern
    // mirrors NewBooking.vue (STEP-11) 1:1: identity + debounce + stale-guard
    // via bookingQuote.js, quoteStatus gates Save, applyQuoteResponse maps
    // CTR-02 onto booking.*.
    // ------------------------------------------------------------------

    // Current rental_type string per CTR-01 (daily|hourly|weekly|monthly),
    // derived from the same three booleans the legacy code branched on.
    currentRentalType() {
      if (this.booking.hourly) return "hourly";
      if (this.booking.weekly) return "weekly";
      if (this.booking.monthly) return "monthly";
      return "daily";
    },

    // FT-166: вкладка «Цены» передаётся через персистентный Vuex, поэтому
    // доезжает и до новой вкладки браузера. На вебе открываем новую вкладку —
    // иначе несохранённые правки брони теряются; под Capacitor вкладок нет.
    onOpenCarPrices(event) {
      this.$store.commit("setCarTab", "prices");
      // Зовётся и на auxclick (средняя кнопка): браузер открывает вкладку сам,
      // минуя @click, и без коммита она открылась бы на «Бронях». Перехват
      // нужен только нативу, где вкладок нет.
      if (!Capacitor.isNativePlatform()) return;
      if (event && event.preventDefault) event.preventDefault();
      const id = (this.set_car && this.set_car.id) || this.booking.car_id;
      this.$router.push({ name: "CarCard", params: { id: String(id) } });
    },

    // FT-084 STEP-12 fix round 1 (C2): maps this.gifts (booking's persisted
    // Gift records — loaded in mounted()/pushed-spliced by saveGift()/
    // deleteGift()) onto the { gift_type, price, count } shape the pricing
    // Engine reads (Pricing::Engine#build_gift_items — see
    // price_quotes_controller.rb/priced_bookings_controller.rb#gifts_param,
    // raw passthrough, no strong-params permit). Without this, every quote/
    // save silently drops the gift discount (rental_cost/hours_cost
    // recomputed as if no gift existed).
    currentGiftsPayload() {
      if (!this.gifts || !this.gifts.length) return [];
      return this.gifts.map((gift) => ({
        gift_type: gift.gift_type,
        price: gift.price,
        count: gift.count,
      }));
    },

    // Builds the CTR-01 pricing-input identity from current booking/form
    // state. Used both to send the request and to compare "is the shown
    // quote still valid for the current inputs" (quoteIsFresh computed).
    buildCurrentQuoteIdentity() {
      return buildQuoteIdentity({
        carId: this.booking.car_id,
        startAt: this.booking.start_date,
        endAt: this.booking.end_date,
        rentalType: this.currentRentalType(),
        bookingId: this.booking.id,
        sale: this.booking.sale,
        saleCash: this.booking.sale_cash,
        rentalCostSale: this.booking.rental_cost_sale,
        rentalCostSaleCash: this.booking.rental_cost_sale_cash,
        tariff: this.tariff,
        gifts: this.currentGiftsPayload(),
        services: {
          delivery: this.booking.delivery,
          delivery_end: this.booking.delivery_end,
          equipment: this.booking.equipment,
          insurance: this.booking.insurance,
          clean_payment: this.booking.clean_payment,
          add_drivers_cost: this.booking.add_drivers_cost,
          other: this.booking.other,
          deposit: this.currentDeposit(),
        },
        priceHour: this.booking.price_hour,
        manualPrice: this.manualEditing ? this.booking.selected_price : null,
        // FT-216 REQ-04: тип платежей брони — тот же, что уходит при сохранении (editSave шлёт booking.payments_type).
        paymentsType: this.booking.payments_type,
      });
    },

    // Debounced quote request (FM-07): call on every pricing-input change
    // while the edit dialog is open. While in flight (or before the first
    // quote for the current inputs arrives) the previously shown numbers are
    // marked stale and Save is blocked (quoteIsFresh/pricingReady computed) —
    // CTR-03 makes this safe even if the user manages to save on stale
    // numbers, since the server always recomputes authoritatively.
    requestQuote() {
      if (!this.editDialog || !this.set_car || !this.booking.car_id || !this.booking.start_date || !this.booking.end_date) {
        // FT-084 dual-review V-1/V-2: bump _seq (cancel()) even on this
        // early exit — a previously in-flight request's .then()/.catch()
        // (attached by an earlier requestQuote() call) would otherwise still
        // see mySeq === _seq when it resolves and clobber booking.* via
        // applyQuoteResponse() after the inputs went missing/dialog closed.
        this._quoteRequester.cancel();
        return;
      }
      // Равные/инвертированные даты — промежуточное состояние правки, а НЕ
      // ошибка: квоту не запрашиваем (сервер честно 422-ил бы нулевой
      // интервал), панель цены нейтральна. Решение USER 2026-07-22, как в
      // NewBooking.requestQuote.
      if (!moment(this.booking.end_date, "DD-MM-YYYY HH:mm").isAfter(moment(this.booking.start_date, "DD-MM-YYYY HH:mm"))) {
        this._quoteRequester.cancel();
        this.quoteStatus = "idle";
        return;
      }
      // FT-084 STEP-12 fix round 1 (I1): booking.only_manual_editing is
      // known locally (isExternalCalculationBooking) — /api/v1/price_quotes
      // never actually returns "external_calculation" (only no_price/
      // invalid_input; that code only comes from priced_bookings#update),
      // so waiting on the request to discover this was dead code — the quote
      // came back normally (pricingReady=true) and the manager only found
      // out the booking couldn't be saved from a 422 on Save. Short-circuit
      // here: no round-trip, banner shown immediately (template), Save
      // blocked immediately (pricingReady computed).
      if (this.isExternalCalculationBooking) {
        // FT-084 dual-review V-1/V-2: cancel() the in-flight auto-quote
        // request (bumps _seq) before short-circuiting — otherwise a stale
        // response landing after the booking is recognized as
        // external-calculation would still pass the mySeq===_seq guard and
        // applyQuoteResponse() would overwrite booking.* with a server
        // recompute that should never have happened for this booking.
        this._quoteRequester.cancel();
        // 2026-07-22 (разворот контракта): внешняя бронь ведёт себя как
        // manual/frozen — серверную квоту не запрашиваем (движок не должен
        // считать её цены), Save не блокируем. Баннер в шаблоне держится
        // на isExternalCalculationBooking, не на quoteStatus.
        this.quoteStatus = "ready";
        this.quoteError = null;
        this.quoteIdentity = this.buildCurrentQuoteIdentity();
        return;
      }
      // Manual editing (DEC-06): no server round-trip needed for the numbers
      // (the applied price is whatever the user typed), but we still mark
      // the quote "ready" so Save isn't blocked. total/rental_cost stay
      // exactly as the user edited them in the manual fields.
      // DEC-19: frozen-режим ведёт себя как manual — квота не нужна и не
      // должна перерисовывать сохранённые вручную суммы в предпросмотре.
      if (this.manualEditing || this.frozenManualMode) {
        // FT-084 dual-review V-1/V-2: cancel() any in-flight auto-quote
        // request (bumps _seq) BEFORE returning — otherwise a stale response
        // that lands after manual mode is enabled would still pass the
        // mySeq===_seq guard and applyQuoteResponse() would overwrite the
        // manually-typed booking.selected_price.
        this._quoteRequester.cancel();
        this.quoteStatus = "ready";
        this.quoteError = null;
        this.quoteIdentity = this.buildCurrentQuoteIdentity();
        return;
      }

      const identity = this.buildCurrentQuoteIdentity();
      this.quoteStatus = "loading";
      this.quoteError = null;

      this._quoteRequester
        .request(identity, this.quoteExtraPayload())
        .then((response) => {
          this.applyQuoteResponse(response.data, identity);
        })
        .catch((error) => {
          // FM-01: 422 no_price — machine-readable code, explicit state
          // distinct from a generic request error (FM-05). DEC-06:
          // external_calculation — booking.only_manual_editing refuses
          // server recompute entirely (external pricing source of truth).
          // Плавающая база (2026-07-16): prolongs_base_degenerate — новый
          // конец срезает продлённый период; prolongs_lock_dates — смена
          // типа аренды у брони с продлениями. Оба блокируют Save
          // (pricingReady требует quoteStatus === 'ready').
          // FT-130: маппинг вынесен в bookingQuote.js (юнит-тестируем);
          // prolongs_frozen_pricing — новый код: repricing на бронировании
          // с замороженными продлениями ценами.
          this.quoteStatus = quoteErrorStatus(error);
          this.quoteError = error;
        });
    },

    // Extra top-level поля payload квоты (не входят в identity). Плавающая
    // база: у брони с продлениями превью обязано зеркалить persist — сервер
    // сегментирует от нового конца ТОЛЬКО при явном prolong_segments=true
    // (без флага контракт диалога продления: полная квота интервала).
    quoteExtraPayload() {
      const extra = { price_source: this.quotePriceSource };
      if (this.prolongs && this.prolongs.length > 0) {
        extra.prolong_segments = true;
      }
      return extra;
    },

    // Applies a price_quotes response (CTR-02) onto booking.* — the exact
    // set of fields the edit-dialog template reads, plus the season
    // breakdown table (selected_seasons).
    applyQuoteResponse(quote, identity) {
      this.quoteStatus = "ready";
      this.quoteIdentity = identity;
      this.quoteResponse = quote;

      const rentalType = this.currentRentalType();

      this.booking.days = quote.units.days;
      this.booking.additional_hours = quote.units.hours_less_day > 0 && Number(quote.totals.hours_cost) > 0 ? quote.units.hours_less_day : 0;
      this.booking.price_no_sale = Number(quote.totals.price_no_sale);
      this.booking.selected_price = Number(quote.totals.selected_price);
      this.booking.rental_cost = Number(quote.totals.rental_cost);
      this.booking.hours_cost = Number(quote.totals.hours_cost);
      // FT-102 REQ-07 (ревью PR-B, Codex+fresh): квота считает БЕЗ каталожного
      // оборудования (addons_cost вне SERVICE_KEYS — им владеет сервер), а
      // total брони обязан его содержать. Без слагаемого каждый quote-ответ
      // затирал корректный booking_total, выставленный CRUD-ом строк допов.
      this.booking.total = Number(quote.totals.total) + (Number(this.booking.addons_cost) || 0);
      this.booking.price = Number(quote.totals.selected_price);

      if (rentalType === "hourly") {
        this.booking.hourly_hours = quote.units.days;
      } else if (rentalType === "weekly") {
        this.booking.weekly_weeks = quote.units.days;
      } else if (rentalType === "monthly") {
        this.booking.monthly_months = quote.units.days;
      }

      // Season breakdown table (template `selected_seasons`, v-for over
      // {season: {start_date, end_date, id}, days, price, isBase}) — mapped
      // from ALL rental_unit line items: base-price groups (season_id=null)
      // тоже показываем в панели «Сезоны» (manual QA 2026-07-13).
      this.selected_seasons = quote.line_items
        .filter((item) => item.kind === "rental_unit" || item.kind === "prolong_segment")
        .map((item, index) =>
          // Сегмент продления (решение USER 2026-07-15): свободная цена
          // оператора, отдельная строка «Продление: N × цена» — база и
          // сегменты видны оператору как два слоя.
          item.kind === "prolong_segment"
            ? {
              index,
              isBase: false,
              isProlong: true,
              season: { id: null, start_date: null, end_date: null },
              days: item.qty,
              price: item.unit_price,
            }
            : {
              index,
              isBase: item.season_id == null,
              season: {
                id: item.season_id,
                // CTR-02 отдаёт ISO "YYYY-MM-DD"; в таблице сезонов показываем
                // "DD-MM-YYYY" (manual QA 2026-07-13).
                start_date: formatQuoteDate(item.starts_on),
                end_date: formatQuoteDate(item.ends_on),
              },
              days: item.qty,
              price: item.unit_price,
              // FT-216 CTR-05: у старого api поля нет — пустая строка, суффикс не рисуется
              adjustmentPercent: formatAdjustmentPercent(item.adjustment_percent),
            });

      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        this.checkDaysMinLimit(this.booking.days);
      }
    },

    // FT-084 STEP-12: setDates()/editCar/editExtra/editSale/manualEditing all
    // funnel through this single entry point (was calculateDays()+calculateCost()).
    // FT-102 (DEC-01): единица тарификации брони для per_unit-допов
    ft102UnitsValue() {
      const b = this.booking;
      if (b.hourly) return Number(b.hourly_hours) || 1;
      if (b.weekly) return Number(b.weekly_weeks) || 1;
      if (b.monthly) return Number(b.monthly_months) || 1;
      return Number(b.days) || 1;
    },
    // FT-223: hydrate the summary without a startup fetch.
    ft223ApplyStoreLines(section) {
      const initial = readInitialSection(section);
      if (!initial.provided) return false;
      this.ft102Lines = Array.isArray(initial.data) ? initial.data : [];
      return true;
    },
    // FT-102: сводка не зависит от панели редактора; lines-changed перечитывает строки.
    ft102FetchLines() {
      if (!this.booking || !this.booking.id) return;
      this.axios
        .get(`/api/v1/bookings/${this.booking.id}/booking_store_products`, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.ft102Lines = Array.isArray(response.data) ? response.data : [];
        })
        .catch(() => {});
    },
    // FT-102 (UAT-реверс G3/F7): total ведёт СЕРВЕР (дельта в Recalculate) —
    // карточка принимает значения из ответа, ничего не прибавляя сама.
    ft102OnServerAddonsCost(payload) {
      const value = payload && typeof payload === "object" ? payload.addons_cost : payload;
      const serverTotal = payload && typeof payload === "object" ? payload.booking_total : undefined;
      const changed = value !== this.booking.addons_cost;
      this.booking.addons_cost = value;
      if (serverTotal !== undefined) this.booking.total = serverTotal;
      if (changed) {
        // Программное изменение сумм без пересчёта замораживало Save
        // (pricingReady/quoteIsFresh) — прецедент MANUAL→AUTO 2026-07-21
        this.calculateCost();
      }
    },
    // FT-102 (REQ-08): подсказка залога — только пока менеджер не правил депозит.
    // Поле выбирается по типу аренды (ревью PR-B: у hourly/weekly/monthly залог
    // живёт в своих полях — дельта в booking.deposit для них мёртвая)
    ft102OnAddonsDepositChanged({ delta }) {
      if (this.ft102DepositTouched || !delta) return;
      const field = depositFieldFor(this.booking);
      this.booking[field] = Math.round(((Number(this.booking[field]) || 0) + delta) * 100) / 100;
      this.calculateCost(); // депозит входит в идентичность квоты — освежаем gate
    },
    calculateCost() {
      this.requestQuote();
    },
    onStartChange(selectedDates, dateStr, instance) {
      this.$set(this.configEnd, "minDate", dateStr);
    },
    // DEC-15/CTR-02 banner (was findAuditedPricesForBooking + 3 unit-specific
    // twins, purely client-side audits reconstruction): server tells us
    // directly via the `stored` vs `current` quote totals whether stored
    // prices differ from current ones. Called once the edit dialog opens
    // (editBooking) and whenever the car changes; drives show_audited_price_alert
    // (same UX/banner as before — "текущие цены отличаются от цен на момент
    // создания") without any client math over price audits.
    //
    // Intentionally bypasses `this._quoteRequester` (plain axios calls
    // instead): the shared requester's monotonic _seq guard is owned by
    // requestQuote() — routing this side-channel comparison through it would
    // bump _seq and starve/orphan a concurrently in-flight debounced quote.
    checkAuditedPriceDivergence() {
      this.show_audited_price_alert = false;
      if (this.booking.apply_current_prices || !this.booking.car_id || !this.booking.start_date || !this.booking.end_date) {
        return;
      }

      const identity = this.buildCurrentQuoteIdentity();
      const headers = { Authorization: this.$store.getters.getAuthToken };
      // Плавающая база: у брони с продлениями сравнение stored/current тоже
      // должно быть сегментным (иначе полная квота интервала — другие числа).
      // Обе квоты — одним запросом (прод 29.09.2026: пара запросов на каждое
      // открытие карточки упиралась в лимит на IP у офисов за одним NAT).
      return fetchStoredAndCurrentQuotes(
        (payload) => this.axios.post("/api/v1/price_quotes", payload, { headers }),
        buildQuotePayload(identity, this.quoteExtraPayload()),
        originOf(this.$store.getters.getApiUrl) || ""
      )
        .then(({ stored, current }) => {
          // Сегментная бронь: selected_price в ОБЕИХ квотах запинен ценой
          // последнего продления (равны всегда) — сравниваем totals.total
          // (сегменты одинаковы, разница = честная разница базы). Обычная
          // бронь — прежнее сравнение по ставке (dual-line review, fresh M3).
          const field = this.prolongs && this.prolongs.length > 0 ? "total" : "selected_price";
          const storedTotal = stored.totals[field];
          const currentTotal = current.totals[field];
          if (storedTotal != null && currentTotal != null && storedTotal !== currentTotal) {
            this.show_audited_price_alert = true;
          }
        })
        .catch(() => {
          // Best-effort banner — a failed divergence check must not block
          // opening/using the edit dialog (requestQuote() runs its own
          // request separately and surfaces real errors via quoteStatus).
        });
    },
    // DEC-15: manager's explicit current/stored toggle — persists onto
    // booking.apply_current_prices via priced_bookings#update (same
    // persistence semantics as legacy: true = "текущие", false = "из
    // истории"/stored). Re-quotes immediately so the shown numbers reflect
    // the new source without waiting for a separate pricing-input change.
    applyCurrentPrices() {
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        this.isLoading = true;
        const nextApplyCurrent = !this.booking.apply_current_prices;
        // FT-084 STEP-12 fix round 1 (C1 verification): was `{ price_source }`
        // alone — priced_bookings_controller.rb#update only calls
        // resolve_update_price_source! (the method that actually persists
        // booking.apply_current_prices) when `recompute` is true, i.e. when
        // at least one PRICING_INPUT_KEYS param is present. A price_source-only
        // payload left `recompute` false, so the flag was NEVER actually
        // persisted server-side — the client's optimistic
        // `this.booking.apply_current_prices = nextApplyCurrent` (below) was
        // immediately overwritten back to the (unchanged) server value by
        // applyPricedBookingResponse(), silently. Sending the same pricing
        // inputs editSave() always sends makes the server actually recompute
        // + persist (booking.car_id/start_date/end_date are always available
        // here — this banner button renders outside the edit dialog too).
        this.axios
          .patch(
            `/api/v1/priced_bookings/${this.booking.id}`,
            {
              price_source: nextApplyCurrent ? "current" : "stored",
              car_id: this.booking.car_id,
              start_at: this.booking.start_date,
              end_at: this.booking.end_date,
              rental_type: this.currentRentalType(),
              sale: this.booking.sale ? this.booking.sale : 0,
              sale_cash: this.booking.sale_cash ? this.booking.sale_cash : 0,
              rental_cost_sale: this.booking.rental_cost_sale ? this.booking.rental_cost_sale : 0,
              rental_cost_sale_cash: this.booking.rental_cost_sale_cash ? this.booking.rental_cost_sale_cash : 0,
              tariff: this.tariff ? { sum: this.tariff.sum, percent: this.tariff.percent, id: this.tariff.id } : null,
              gifts: this.currentGiftsPayload(),
              price_hour: this.booking.price_hour,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.booking.apply_current_prices = nextApplyCurrent;
            this.quotePriceSource = nextApplyCurrent ? "current" : "stored";
            this.show_audited_price_alert = !nextApplyCurrent && this.show_audited_price_alert;
            this.applyPricedBookingResponse(response.data);
            this.$notify(this.$t("bookings.success_update_title"), this.$t("bookings.success_update_text"), "success", 3000)
          })
          .catch((error) => {
            // Сегментный persist-путь достижим и отсюда (кнопка «текущие/
            // сохранённые цены» на броне с продлениями) — разбираем те же
            // коды, что editSave (final review M2).
            const code = extractValidationDetail(error).code;
            if (error.response && error.response?.status === 409 && code === "prolongs_stale") {
              this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_stale_hint"), "warning", 6000);
              this.getBooking();
              return;
            }
            if (error.response && error.response?.status === 422 && code === "prolongs_base_degenerate") {
              this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_base_degenerate_hint"), "warning", 6000);
              return;
            }
            // FT-130: смена источника цен = repricing — на вырожденном
            // бронировании цены заморожены продлениями.
            if (error.response && error.response?.status === 422 && code === "prolongs_frozen_pricing") {
              this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_frozen_pricing_hint"), "warning", 6000);
              return;
            }
            this.setError(error, this.$t("errors.update_booking"));
            this.isLoading = false;
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Applies the `booking` sub-object of a priced_bookings response
    // (CTR-02 + booking, priced_bookings_controller.rb#serialize_booking)
    // onto the local booking — used after applyCurrentPrices()/editSave()/
    // prolongServerPreview() so the displayed numbers always reflect the
    // server's authoritative recompute.
    applyPricedBookingResponse(data) {
      if (!data || !data.booking) return;
      const b = data.booking;
      this.booking.price = Number(b.price);
      this.booking.selected_price = Number(b.price);
      this.booking.price_no_sale = Number(b.price_no_sale);
      this.booking.rental_cost = Number(b.rental_cost);
      this.booking.hours_cost = Number(b.hours_cost);
      this.booking.total = Number(b.total);
      this.booking.days = b.days;
      // Плавающая база: юнит-колонки типов освежаем с сервера — saveProlong
      // шлёт АБСОЛЮТНЫЕ full_hours/start_hours из локального стейта, после
      // смены дат сервером stale-значения дали бы кривое продление
      // (dual-line review, Codex C2). undefined-guard — совместимость со
      // старым api без этих полей в serialize_booking.
      if (b.hourly_hours !== undefined) this.booking.hourly_hours = b.hourly_hours;
      if (b.weekly_weeks !== undefined) this.booking.weekly_weeks = b.weekly_weeks;
      if (b.monthly_months !== undefined) this.booking.monthly_months = b.monthly_months;
      this.booking.additional_hours = b.additional_hours;
      this.booking.start_price = Number(b.start_price);
      this.booking.start_date = b.start_date;
      this.booking.end_date = b.end_date;
      this.booking.manual_editing = b.manual_editing;
      this.booking.only_manual_editing = b.only_manual_editing;
      this.booking.apply_current_prices = b.apply_current_prices;
    },
    // FT-084 STEP-12: was PATCH /api/v1/bookings/:id (client sent every
    // money field it had just computed). Now PATCH /api/v1/priced_bookings/:id
    // (priced_bookings_controller.rb) — the pricing-input fields below
    // (car_id/start_at/end_at/rental_type/sale*/tariff/price_hour/
    // manual_price/price_source) trigger a server recompute (CTR-03,
    // PRICING_INPUT_KEYS); NON_PRICING_PERMITTED_FIELDS passthrough (dates
    // display, equipment, insurance, client, description, ...) is applied
    // as-is without affecting price. Money fields (days/rental_cost/price/
    // hours_cost/total/deposit/etc.) are NOT sent — the server computes them
    // and echoes them back in `booking` (applyPricedBookingResponse).
    editSave() {
      // Условие 1-в-1 как у точки входа editBooking: иначе диалог правки
      // открывался бы агенту с can_edit_booking, а сохранение отбивалось.
      // Прежний денилист через == был слабее своей точки входа — пускал
      // ЛЮБОГО агента, в том числе без права.
      if (!this.isStaff && !this.agentCan("can_edit_booking")) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      if (!this.pricingReady) return; // FM-07 — gated by the Save button/icon already, defense in depth

      let booking = this.booking;
      let self = this;
      this.isLoadingEditSave = true;
      let add_drivers = this.selected_add_drivers.map((driver) => driver.id);

      // DEC-19, три состояния manual_price (серверный контракт CTR-03):
      //   MANUAL (тумблер «вручную» вкл)  → число (применить ручную цену);
      //   FROZEN (оба тумблера выкл, бронь сохранена manual) → ключ НЕ
      //     отправляется (absent = сервер не меняет режим и не трогает суммы);
      //   AUTO   (включён авторасчёт)     → null (явный сброс + пересчёт).
      // В MANUAL вместе с ценой уходит ВСЯ панель ручного редактирования
      // (полный легаси-паритет, USER 2026-07-21): юниты (days/hourly_hours/
      // weekly_weeks/monthly_months — сервер применит релевантное типу),
      // доп. часы (additional_hours/hours_cost), аренда напрямую
      // (rental_cost) и итог напрямую (total — может осознанно не сходиться
      // с компонентами: «округлить некрасивую сумму»). Сервер применяет всё
      // это только в ручном режиме; в AUTO цифры считает движок, в FROZEN
      // absent = не менять.
      // Решение из трёх исходов вынесено в buildManualPricePart (bookingQuote.js):
      // внутри axios-вызова оно было непроверяемо, а ревью 2026-08-11 показало,
      // что ветка absent теряла целый класс броней (Localrent без manual_editing).
      const manualPricePart = buildManualPricePart({
        manualEditing: this.manualEditing,
        enginePricingForbidden: this.enginePricingForbidden,
        booking,
      });

      const editSavePayload = {
        // Pricing inputs (CTR-01/PRICING_INPUT_KEYS) — always sent so the
        // server recomputes on every save, matching the legacy behavior
        // where the client always resubmitted its calculated numbers.
        car_id: booking.car_id,
        start_at: booking.start_date,
        end_at: booking.end_date,
        rental_type: this.currentRentalType(),
        sale: booking.sale ? booking.sale : 0,
        sale_cash: booking.sale_cash ? booking.sale_cash : 0,
        rental_cost_sale: booking.rental_cost_sale ? booking.rental_cost_sale : 0,
        rental_cost_sale_cash: booking.rental_cost_sale_cash ? booking.rental_cost_sale_cash : 0,
        tariff: this.tariff ? { sum: this.tariff.sum, percent: this.tariff.percent, id: this.tariff.id } : null,
        // FT-084 STEP-12 fix round 1 (C2): was hardcoded [] — the server
        // recomputes rental_cost/hours_cost from EXACTLY the gifts array
        // in this payload (Pricing::Engine#build_gift_items), so an
        // empty array silently dropped any applied gift discount on
        // every save, including the editSave() call saveGift()/
        // deleteGift() make right after POST/DELETE .../gifts.
        gifts: this.currentGiftsPayload(),
        price_hour: booking.price_hour,
        // DEC-06/DEC-19: см. manualPricePart выше (число / absent / null).
        ...manualPricePart,
        price_source: this.quotePriceSource,
        services: {
          delivery: booking.delivery,
          delivery_end: booking.delivery_end,
          equipment: booking.equipment,
          insurance: booking.insurance,
          clean_payment: booking.clean_payment,
          add_drivers_cost: booking.add_drivers_cost,
          other: booking.other,
          fine: booking.fine,
          damage: booking.damage,
          gas: booking.gas,
          mileage_cost: booking.mileage_cost,
          other_end: booking.other_end,
          hours_cost_end: booking.hours_cost_end,
        },
        deposit: booking.deposit,
        // Non-pricing passthrough (NON_PRICING_PERMITTED_FIELDS parity).
        // car_name/car_code — денормализованные снапшоты машины (поиск,
        // telegram, iCal). FT-084 STEP-12 их потерял в этом payload, из-за
        // чего при смене машины они протухали. Клиент держит их свежими в
        // set_car watcher — шлём вместе с car_id, как делал легаси editSave.
        car_name: booking.car_name,
        car_code: booking.car_code,
        client_id: booking.client_id,
        first_name: booking.first_name,
        middle_name: booking.middle_name,
        last_name: booking.last_name,
        tariff_id: self.selected_tariff_id ? self.selected_tariff_id : null,
        kasko: booking.kasko,
        super_kasko: booking.super_kasko,
        theft: booking.theft,
        no_franchise: booking.no_franchise,
        location_start: booking.location_start,
        location_end: booking.location_end,
        chair: booking.chair,
        chair_less_1_year: booking.chair_less_1_year,
        booster: booking.booster,
        chairs_quantity: booking.chairs_quantity,
        boosters_quantity: booking.boosters_quantity,
        navigator: booking.navigator,
        wifi_router: booking.wifi_router,
        mp3: booking.mp3,
        charger: booking.charger,
        entity: self.client.entity,
        entity_name: self.client.entity_name,
        add_drivers: add_drivers,
        hourly_deposit: booking.hourly_deposit,
        weekly_deposit: booking.weekly_deposit,
        monthly_deposit: booking.monthly_deposit,
        description: booking.description,
        clean_start: booking.clean_start,
        clean_end: booking.clean_end,
        gas_start_full: booking.gas_start_full,
        gas_start: booking.gas_start,
        gas_end: booking.gas_end,
        gas_end_full: booking.gas_end_full,
        start_mileage: booking.start_mileage,
        end_mileage: booking.end_mileage,
        booking_mileage: booking.booking_mileage,
        fio: booking.fio,
        custom_field_1: booking.custom_field_1,
        custom_field_2: booking.custom_field_2,
        custom_field_3: booking.custom_field_3,
        payments_type: booking.payments_type,
        payments_period: booking.payments_period,
        agent_id: booking.agent_id,
        // FT-193 REQ-07: источник списания — только если его сменили (иначе обычное сохранение не получит 422)
        ...(this.periodicFundingEditChanged ? { periodic_funding: this.edit_periodic_funding } : {}),
      };
      // REQ-13, CTR-06: договорное бронирование — сервер защищает деньги,
      // тариф и коммерческие условия такси (Booking::RENT_TO_OWN_MANAGED_FIELDS)
      // от записи модульным писателем не-договора; клиент отфильтровывает
      // payload заранее тем же белым списком (rentToOwnSaveAllowlist.js), а
      // не полагается только на серверный 422 — иначе КАЖДОЕ сохранение
      // такой брони било бы в ошибку вместо сохранения операционных полей.
      const requestPayload = booking.rent_to_own
        ? filterToRentToOwnAllowlist(editSavePayload)
        : editSavePayload;

      this.axios
        .patch(
          `/api/v1/priced_bookings/${booking.id}`,
          requestPayload,
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          const data = response.data;
          this.applyPricedBookingResponse(data);
          // FT-193 REQ-07: ответ priced_bookings источник не эхом возвращает — фиксируем то, что ушло и принято
          if (requestPayload.periodic_funding) this.$set(this.booking, "periodic_funding", requestPayload.periodic_funding);
          this.quoteStatus = "ready";
          this.quoteResponse = data;
          // this.set_car = [];
          this.getCar();
          this.manualEditing = false;
          this.warningAddOneDay = false;
          this.warningLessThenDay = false;
          // Читает selected_tariff_id — обязан стоять ДО ft108ResetEditSections(),
          // который его обнуляет (порядок легаси-цепочки сохранён)
          this.booking.tariff_id = this.selected_tariff_id
            ? this.selected_tariff_id
            : null;
          // FT-108 DEC-02: панельные флаги + даты/тариф — единым reset'ом
          this.ft108ResetEditSections();

          if (add_drivers && add_drivers.length > 0) {
            add_drivers.forEach((driver) => {
              this.axios
                .get(`/api/v1/clients/${driver}`, {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                })
                .then((response) => {
                  if (
                    self.add_drivers.filter(
                      (d) => d.id == Number(response.data.client.id)
                    ).length == 0
                  ) {
                    self.add_drivers.push(response.data.client);
                  }
                  if (
                    self.selected_add_drivers.filter(
                      (d) => d.id == Number(response.data.client.id)
                    ).length == 0
                  ) {
                    self.selected_add_drivers.push(response.data.client);
                  }
                })
                .catch((error) => {
                  this.setError(error, this.$t("errors.car_load"));
                  console.log(error);
                });
            });
          } else {
            self.add_drivers = [];
            self.selected_add_drivers = [];
          }
          this.editDialog = false;
          // FT-108 REQ-04: сохранённое состояние = новая база снапшота —
          // точки гаснут (диалог закрыт, но editSave умеют звать и
          // saveGift/deleteGift; повторное открытие всё равно переснимет)
          if (this.booking && this.booking.id) {
            this.ft108SectionSnapshots = takeSectionSnapshots(this);
          }
          this.$notify(this.$t("bookings.success_update_title"), this.$t("bookings.success_update_text"), "success");
        })
        .catch((error) => {
          // REQ-13, CTR-05/CTR-06: договорное бронирование — сервер отбивает
          // 422 managed_by_contract, если белый список клиента разошёлся с
          // серверным (гонка, устаревший фронт). parseRentToOwnError — тот
          // же разбор кодов модуля, что RentToOwnPanel.vue; форма ошибки
          // модуля (`error.response.data.error` — голая строка-код) общий
          // разбор extractValidationDetail намеренно не угадывает, поэтому
          // она разбирается отдельно, до общего `code`. Текст без
          // перезаписи локальных полей формы — только перечитывание
          // карточки с сервера (getBooking(), тот же метод загрузки, что и
          // 409 prolongs_stale ниже).
          const rentToOwnError = parseRentToOwnError(error);
          if (rentToOwnError && rentToOwnError.code === "managed_by_contract") {
            this.$notify(this.$t("errors.update_booking"), this.$t(rentToOwnError.i18nKey), "warning", 6000);
            this.getBooking();
            return;
          }
          const code = extractValidationDetail(error).code;
          if (error.response && error.response?.status === 422 && code === "external_calculation") {
            // Понятный отказ вместо мёртвого quoteStatus (баннер больше не
            // ключуется на статусе): достижимо в окне деплоя «новый FE +
            // старый api» (тот 422-ит любой ценовой вход внешней брони —
            // поэтому порядок деплоя api ПЕРВЫМ) и на будущие серверные
            // отказы авто-сброса.
            this.$notify(this.$t("errors.update_booking"), this.$t("bookings.external_manual_only"), "warning", 6000);
            return;
          }
          // Плавающая база (2026-07-16): смена дат разрешена; 422 остались
          // на смену типа аренды (prolongs_lock_dates) и на конец, срезающий
          // продлённый период (prolongs_base_degenerate). Превью показывает
          // те же баннеры до Save — сюда попадаем при гонке.
          if (error.response && error.response?.status === 422 && code === "prolongs_lock_dates") {
            this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_lock_dates_hint"), "warning", 6000);
            return;
          }
          if (error.response && error.response?.status === 422 && code === "prolongs_base_degenerate") {
            this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_base_degenerate_hint"), "warning", 6000);
            return;
          }
          // FT-130: repricing на вырожденном бронировании (гонка с превью).
          if (error.response && error.response?.status === 422 && code === "prolongs_frozen_pricing") {
            this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_frozen_pricing_hint"), "warning", 6000);
            return;
          }
          // 409: бронь продлили параллельно между расчётом и сохранением —
          // с разблокированными датами кейс достижим из UI. editDate
          // сбрасываем: пикеры держали правку оператора, а getBooking()
          // подтянул свежие даты — иначе Save молча сохранил бы серверные
          // даты под видом правки (dual-line review, fresh M1).
          if (error.response && error.response?.status === 409 && code === "prolongs_stale") {
            this.$notify(this.$t("errors.update_booking"), this.$t("bookings.prolongs_stale_hint"), "warning", 6000);
            // Секцию дат сворачиваем целиком: сброс одного editDate оставлял
            // панель раскрытой по OR через editPlace, а пикеры (v-if="editDate")
            // исчезали без пути вернуть их на месте. Свёрнутая панель честна:
            // повторное раскрытие перезовёт setDataToEditDate со свежими датами.
            closeSection("dates", this);
            this.start_date = null;
            this.end_date = null;
            this.getBooking();
            return;
          }
          this.setError(error, this.$t("errors.update_booking"));
        })
        .finally(() => (this.isLoadingEditSave = false));
    },
    async deleteBooking(booking) {
      if (this.isStaff) {
        // Проверяем откуда бронь, если из агрегатора, то не удаляем
        if (booking.vseprokaty_id || booking.localrent_id) {
          this.$notify(this.$t("agregator.no_delete_aggregator"), this.$t("agregator.no_delete_aggregator_text"), "warning", 5000)
          return;
        }
        
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("bookings.remove_booking_warn"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          try {
            await this.axios.delete(`/api/v1/bookings/${booking.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            });
            this.$router.push({ name: "BookingsList" });
            this.$notify(this.$t("custom.deleted"), this.$t("custom.deleted_ok"), "success");
          } catch (error) {
            this.setError(error, this.$t("errors.remove_booking"));
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Lazy load броней машины для проверки пересечения дат
    // Использует новый endpoint для ускорения загрузки
    async loadCarBookings(carId) {
      if (!carId) return;
      // Если брони уже загружены (из booking_cards или предыдущего вызова), не загружаем повторно
      if (this.carBookingsLoaded && this.bookings.length > 0) return;
      
      try {
        const response = await this.axios.get(`/api/v1/car_bookings_for_card/${carId}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        this.bookings = [];
        if (response.data.bookings && response.data.bookings.data) {
          response.data.bookings.data.forEach((booking) => {
            this.bookings.push(booking.attributes);
          });
        }
        this.carBookingsLoaded = true;
      } catch (error) {
        console.error("Error loading car bookings:", error);
        // В случае ошибки (старая версия API) используем уже загруженные данные
      }
    },
    async checkFreeCar(car, checked_booking) {
      let result = true;
      if (car && checked_booking) {
        // Lazy load броней если они еще не загружены
        if (!this.carBookingsLoaded && this.bookings.length === 0) {
          await this.loadCarBookings(car.id);
        }
        let start_date = checked_booking.start_date;
        let end_date = checked_booking.end_date;
        let cars_bookings = this.bookings.filter((booking) => {
          return booking.car_id === car.id && booking.id != checked_booking.id;
        });
        cars_bookings.forEach((booking) => {
          let checked_start_date = moment(start_date, "DD-MM-YYYY H:mm");
          let checked_end_date = moment(end_date, "DD-MM-YYYY H:mm");
          let booking_start_date = moment(
            booking.start_date,
            "DD-MM-YYYY H:mm"
          ).subtract(
            this.$store.getters.getCompany.company.interval_bookings,
            "hours"
          );
          let booking_end_date = moment(
            booking.end_date,
            "DD-MM-YYYY H:mm"
          ).add(
            this.$store.getters.getCompany.company.interval_bookings,
            "hours"
          );
          if (
            checked_start_date.isBetween(
              booking_start_date,
              booking_end_date,
              "hour"
            ) ||
            checked_end_date.isBetween(
              booking_start_date,
              booking_end_date,
              "hour"
            ) ||
            booking_start_date.isBetween(
              checked_start_date,
              checked_end_date,
              "hour"
            ) ||
            booking_end_date.isBetween(
              checked_start_date,
              checked_end_date,
              "hour"
            )
          ) {
            result = false;
          }
        });
        return result;
      } else {
        this.$notify(this.$t("errors.check_car"), "", "warning", 3000)
      }
    },
    async activateBooking(booking) {
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        let self = this;
        function activateBooking() {
          self.isLoading = true;
          self.axios
            .patch(
              `/api/v1/bookings/${booking.id}`,
              {
                bookings: {
                  active: true,
                  state: "Активная",
                },
              },
              {
                headers: {
                  Authorization: self.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              self.booking.active = true;
              self.booking.state = "Активная";
              self.$notify(self.$t("bookings.activated_booking"), "", "success")
            })
            .catch((error) => {
              self.setError(error, self.$t("errors.activate_booking"));
            })
            .finally(() => (self.isLoading = false));
        }
        if (booking && booking.archive == false) {
          if (await this.checkFreeCar(this.set_car, booking)) {
            activateBooking();
          } else {
            const confirmed = await this.$confirm({
              title: this.$t("errors.booked_title"),
              text: this.$t("errors.booked_text"),
              icon: "mdi-alert-outline",
              iconColor: "warning",
              iconSize: 72,
              iconPosition: "top",
              confirmButtonText: this.$t("bookings.activated_booking_warn"),
              confirmButtonColor: "primary",
              cancelButtonText: this.$t("custom.decline"),
              cancelButtonColor: "grey darken-1",
              useFilledButtons: true,
              maxWidth: 450,
            });

            if (confirmed) {
              activateBooking();
            }
          }
        } else {
          this.$notify(this.$t("errors.not_activate_title"), this.$t("errors.not_activate_text"), "warning", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Включение тумблера «Активна» в edit-диалоге: предупреждение о
    // пересечении дат (warnIfCarDatesOverlap, как в исходном тумблере) +
    // персист active:true. Персист нужен по той же причине, что у
    // deactivateBooking: editSave (priced_bookings) поле active не permit'ит,
    // без немедленного PATCH включение молча терялось. state НЕ трогаем
    // (в отличие от activateBooking-иконки) — тумблер меняет только active.
    activateBookingFromToggle(booking) {
      const epoch = this.activeStateEpoch;
      // Паритет с activateBooking: активность брони — правка брони, право на
      // неё даёт компания через agent_setting, а не роль. Прежний денилист
      // через == пускал ЛЮБОГО агента, в том числе без права.
      if (!this.isStaff && !this.agentCan("can_edit_booking")) {
        this.booking.active = false; // откат контрола
        this.modeSwitchKey++; // синхронный откат: prop не изменится, нужен remount
        this.setActiveStateError(epoch, this.$t("errors.no_access"));
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      this.warnIfCarDatesOverlap(this.set_car, booking);
      let self = this;
      self.isLoading = true;
      self.axios
        .patch(
          `/api/v1/bookings/${booking.id}`,
          {
            bookings: {
              active: true,
            },
          },
          {
            headers: {
              Authorization: self.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          // Поколение проверяется и перед ЗНАЧЕНИЕМ, не только перед строкой
          // ошибки: два быстрых клика с ответами не по порядку иначе оставляли
          // контрол в состоянии, противоположном серверному (ревью 2026-08-11).
          if (epoch !== self.activeStateEpoch) return;
          self.booking.active = true;
          self.setActiveStateError(epoch, "");
          self.$notify(self.$t("bookings.activated_booking"), "", "success");
        })
        .catch((error) => {
          if (epoch === self.activeStateEpoch) {
            self.booking.active = false; // сервер не активировал — вернуть контрол
            self.modeSwitchKey++;
          }
          self.setActiveStateError(epoch, self.$t("errors.activate_booking"));
          self.setError(error, self.$t("errors.activate_booking"));
        })
        .finally(() => (self.isLoading = false));
    },
    // Деактивация брони тумблером «Активна». Симметрична activateBooking.
    // FT-084 STEP-12 перевёл editSave() на /api/v1/priced_bookings/:id, где
    // поля `active` нет ни в PRICING_INPUT_KEYS, ни в NON_PRICING_PERMITTED_FIELDS —
    // раньше editSave слал `active: booking.active` в легаси bookings#update и
    // тумблер сохранялся, теперь Save молча терял выключение. Персистим active
    // отдельным легаси-PATCH. state НЕ трогаем: по модели active и state —
    // независимые оси (active = формальный lifecycle, state = workflow-тег
    // менеджера), а легаси editSave тоже менял только active.
    deactivateBooking(booking) {
      const epoch = this.activeStateEpoch;
      // Паритет с activateBooking: активность брони — правка брони, право на
      // неё даёт компания через agent_setting, а не роль. Прежний денилист
      // через == пускал ЛЮБОГО агента, в том числе без права.
      if (!this.isStaff && !this.agentCan("can_edit_booking")) {
        this.booking.active = true; // откат контрола
        this.modeSwitchKey++; // синхронный откат: prop не изменится, нужен remount
        this.setActiveStateError(epoch, this.$t("errors.no_access"));
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      let self = this;
      self.isLoading = true;
      self.axios
        .patch(
          `/api/v1/bookings/${booking.id}`,
          {
            bookings: {
              active: false,
            },
          },
          {
            headers: {
              Authorization: self.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          if (epoch !== self.activeStateEpoch) return;
          self.booking.active = false;
          self.setActiveStateError(epoch, "");
          self.$notify(self.$t("bookings.deactivated_booking"), "", "success");
        })
        .catch((error) => {
          if (epoch === self.activeStateEpoch) {
            self.booking.active = true; // сервер не деактивировал — вернуть контрол
            self.modeSwitchKey++;
          }
          self.setActiveStateError(epoch, self.$t("errors.deactivate_booking"));
          self.setError(error, self.$t("errors.deactivate_booking"));
        })
        .finally(() => (self.isLoading = false));
    },
    async activeRent() {
      if (this.isStaff) {
        let self = this;
        let booking = this.booking;

        async function departure() {
          self.isLoadingActiveRent = true;
          
          // Вызываем callback для загрузки изображения повреждений (если есть)
          let checkinImageUrl = null;
          if (self.checkinDamageImageCallback) {
            console.log('Calling checkinDamageImageCallback before sending data to server');
            try {
              checkinImageUrl = await self.checkinDamageImageCallback();
              console.log('Checkin image uploaded, URL:', checkinImageUrl);
            } catch (error) {
              console.error('Error calling checkinDamageImageCallback:', error);
            }
          }
          
          // Подготавливаем данные для отправки
          const bookingData = {
                  in_rent: true,
                  navigator: booking.navigator,
                  chair: booking.chair,
                  clean_start: booking.clean_start,
                  clean_end: booking.clean_start,
                  other_equipment: booking.other_equipment,
                  gas_start: booking.gas_start,
                  gas_end: booking.gas_start,
                  gas_start_full: booking.gas_start_full,
                  gas_end_full: booking.gas_start_full,
                  start_worker_id: self.$store.getters.getCurrentUser.id,
                  departure: true,
                  start_mileage: booking.start_mileage,
                  responsible: null,
                  serial_number: nanoid(10),
                  technical_check_start: booking.technical_check_start,
                  technical_check_start_comment: booking.technical_check_start_comment,
          };
          
          // Добавляем URL изображения из callback (загруженное в последний момент)
          if (checkinImageUrl) {
            bookingData.checkin_damage_image_url = checkinImageUrl;
          }
          // Или из booking если callback не вернул результат
          else if (booking.checkin_damage_image_url) {
            bookingData.checkin_damage_image_url = booking.checkin_damage_image_url;
          }
          
          // Добавляем повреждения, если они есть
          if (booking.checkin_damages && booking.checkin_damages.length > 0) {
            bookingData.checkin_damages = booking.checkin_damages;
          }
          
          self.axios
            .patch(
              `/api/v1/bookings/${booking.id}`,
              {
                bookings: bookingData,
                checkin_damages: booking.checkin_damages || []
              },
              {
                headers: {
                  Authorization: self.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              // КРИТИЧНО: Обновляем booking.checkin_damages с сервера, включая фото
              if (response.data && response.data.checkin_damages) {
                console.log('Updating booking.checkin_damages from server response:', response.data.checkin_damages);
                self.$set(self.booking, 'checkin_damages', response.data.checkin_damages);
              }
              // Обновляем также URL изображения диаграммы если он есть
              if (response.data && response.data.checkin_damage_image_url) {
                self.$set(self.booking, 'checkin_damage_image_url', response.data.checkin_damage_image_url);
              }
              // Только при успехе: раньше это стояло в finally, и отказ сервера
              // (409, 422, сеть) помечал машину выданной и затирал своё
              // предупреждение зелёным «выдано» — снекбар один.
              self.booking.in_rent = true;
              self.booking.gas_start = self.gas_start;
              self.booking.gas_end = self.gas_start;
              self.booking.clean_end = self.booking.clean_start;
              self.$notify(self.$t("bookings.success_checkin"), "", "success", 3000);
            })
            .catch((error) => {
              if (self.handleIssueRefusal(error)) return;
              self.setError(error, self.$t("errors.checkout"));
            })
            .finally(() => {
              self.isLoadingActiveRent = false;
              self.departureDialog = false;
              // Очищаем callback после использования
              self.checkinDamageImageCallback = null;
            });
        }
        if (this.departure_yes) {
          // FT-183: у вело-компании поля пробега нет — и окна о нём нет.
          if (self.showMileage && (booking.start_mileage == 0 || booking.start_mileage < self.set_car.mileage)) {
            const confirmed = await this.$confirm({
              title: this.$t("bookings.mileage_warn_title"),
              text: this.$t("bookings.mileage_warn_text"),
              icon: "mdi-alert-outline",
              iconColor: "warning",
              iconSize: 72,
              iconPosition: "top",
              confirmButtonText: this.$t("custom.yes"),
              confirmButtonColor: "primary",
              cancelButtonText: this.$t("custom.no_big"),
              cancelButtonColor: "grey darken-1",
              useFilledButtons: true,
              maxWidth: 450,
            });
            
            if (confirmed) {
              await departure();
            } else {
              // Если пользователь отказался, сбрасываем флаг загрузки
              self.isLoadingActiveRent = false;
            }
          } else {
            await departure();
          }
        }
        this.departure = false;
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Предупреждения при переключении режимов расчёта (USER 2026-07-21):
    // блокирующий confirm в момент клика — пользователи включают ручной
    // режим «просто вписать цифру», не понимая последствий. Перехват через
    // :input-value/@change: программные синхронизации вотчеров confirm НЕ
    // дёргают, только живой клик; отмена = remount тумблера (modeSwitchKey).
    confirmManualModeOn() {
      return this.$confirm({
        title: this.$t("bookings.manual_on_title"),
        html: buildManualModeOnWarning({
          context: "edit",
          prolongsCount: (this.prolongs || []).length,
          t: (key, params) => this.$t(key, params),
        }),
        icon: "mdi-alert-outline",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: this.$t("bookings.manual_on_confirm"),
        confirmButtonColor: "primary",
        cancelButtonText: this.$t("custom.cancel"),
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 520,
      });
    },
    confirmAutoCalcOn() {
      return this.$confirm({
        title: this.$t("bookings.auto_on_title"),
        html: buildAutoCalcOnWarning({
          prolongsCount: (this.prolongs || []).length,
          t: (key, params) => this.$t(key, params),
        }),
        icon: "mdi-alert-outline",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: this.$t("bookings.auto_on_confirm"),
        confirmButtonColor: "primary",
        cancelButtonText: this.$t("custom.cancel"),
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 520,
      });
    },
    async onManualSwitchToggle(value) {
      const next = !!value;
      if (next === this.manualEditing) return;
      // Запрет ручной правки (архив) — на самой ручке, а не только на кнопке
      // сегмента и на v-if строки-подсказки: раз это единственная точка входа
      // в режим, здесь ему и место. Молча, без всплывашки: интерфейс такого
      // действия архиву не предлагает, сюда попадают только программные пути.
      if (next && !this.manualEntryAvailable) return;
      if (next && !(await this.confirmManualModeOn())) {
        this.modeSwitchKey++;
        return;
      }
      this.manualEditing = next;
    },
    // FT-108 v2: сегмент режима расчёта поверх прежних обработчиков — те же
    // confirm'ы и та же семантика, что у двух прежних тумблеров.
    // «Вручную» при включённом авто = выключение авторасчёта (вотчер
    // auto_calculate поднимет manualEditing); при уже выключенном авто это
    // frozen-режим, и его размораживает кнопка в подсказке, а не сегмент —
    // mandatory-сегмент повторный клик по активному варианту не шлёт.
    // Единственная точка записи строки ошибки активности. Поздний ответ
    // сервера писать не имеет права: пока запрос летел, оператор мог закрыть
    // форму, а сброс сдвигает поколение попытки.
    setActiveStateError(epoch, message) {
      if (epoch !== this.activeStateEpoch) return;
      this.activeStateError = message;
    },
    // Сегмент активности поверх прежних activate/deactivate. booking.active
    // присваивается ДО вызова — прежний тумблер работал через v-model, и обе
    // ручки на этом стоят: у guest/partner и на ошибке сервера они «возвращают
    // тумблер», переприсваивая значение обратно.
    selectBookingActive(value) {
      const next = value === "on";
      if (next === Boolean(this.booking.active)) return;
      // новая попытка тоже сдвигает поколение: ответ предыдущей, если он ещё
      // в пути, относится к состоянию, которое оператор уже переиграл
      this.activeStateEpoch++;
      this.activeStateError = "";
      this.booking.active = next;
      return next ? this.activateBookingFromToggle(this.booking) : this.deactivateBooking(this.booking);
    },
    async selectCalculationMode(mode) {
      if (mode === "auto") return this.onAutoCalcToggle(true);
      if (mode === "manual" && this.auto_calculate) return this.onAutoCalcToggle(false);
    },
    async onAutoCalcToggle(value) {
      const next = !!value;
      if (next === this.auto_calculate) return;
      // Внешняя бронь (only_manual_editing): авторасчёт запрещён — движок
      // не должен переписывать цены интеграции (тумблер и так disabled,
      // это страховка от программных путей).
      if (next && this.isExternalCalculationBooking) {
        this.$notify(this.$t("errors.error"), this.$t("bookings.external_manual_only"), "warning", 4000);
        this.modeSwitchKey++;
        return;
      }
      if (next) {
        // Включение авторасчёта поверх ручных цифр — движок их заменит.
        if ((this.manualEditing || this.booking.manual_editing) && !(await this.confirmAutoCalcOn())) {
          this.modeSwitchKey++;
          return;
        }
      } else if (!(await this.confirmManualModeOn())) {
        // Выключение авторасчёта = включение ручного режима (вотчер
        // auto_calculate поднимет manualEditing) — то же предупреждение.
        this.modeSwitchKey++;
        return;
      }
      this.auto_calculate = next;
    },
    // Аннулировать можно только новейшее ручное продление: сервер отказывает
    // 422 prolong_not_last на любом другом (см. isNewestProlong).
    canAnnulProlong(prolong) {
      return this.isStaff && !prolong.automatic && isNewestProlong(prolong, this.prolongs);
    },
    async deleteProlong(prolong) {
      if (this.isStaff) {
        if (!isNewestProlong(prolong, this.prolongs)) return;
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          // Расширенное предупреждение (USER 2026-07-21): точные последствия
          // аннулирования до клика — сумма вычета, новый итог, откат цены,
          // адаптивные предупреждения (ручная бронь / отрицательный итог).
          html: buildProlongAnnulWarning({
            prolong,
            prolongs: this.prolongs,
            booking: this.booking,
            t: (key, params) => this.$t(key, params),
            currency: this.currency,
          }),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          try {
            const response = await this.axios.delete(`/api/v1/prolongs/${prolong.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            });
            
            this.prolongs = this.prolongs.filter((p) => p.id !== prolong.id);
            this.booking.prolongs = this.prolongs;

            this.booking.price = response.data.price;
            this.booking.selected_price = response.data.price;
            this.booking.days = response.data.days;
            this.booking.hourly_hours = response.data.hourly_hours;
            this.booking.weekly_weeks = response.data.weekly_weeks;
            this.booking.monthly_months = response.data.monthly_months;
            this.booking.rental_cost = response.data.rental_cost;
            this.booking.total = response.data.total;
            this.booking.end_date = response.data.end_date;

            this.$notify(this.$t("custom.deleted"), this.$t("prolongs.delete_prolong_success"), "success", 3000);
          } catch (error) {
            this.setError(error, this.$t("errors.remove_prolong"));
          } finally {
            this.isLoading = false;
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async saveProlong(prolong_data) {
      // Продление с суммой — это ПЛАТЁЖ: ниже уходят type и касса в
      // /save_prolong и пересчитываются счета брони. Право на правку брони
      // не должно давать приём денег, поэтому платное продление требует
      // can_take_money отдельно (найдено ревью Codex).
      const isPaidProlong = Number(prolong_data && prolong_data.sum) > 0;
      if (isPaidProlong && !this.isStaff && !this.agentCan("can_take_money")) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        let self = this;
        if (prolong_data.sum > 0 && prolong_data.type == null) {
          this.$notify(this.$t("errors.money_type_title"), this.$t("errors.money_type_text"), "warning", 4000);
        } else {
          if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
            // Проверяем если в prolong_data.type что платеж наличными
            if (prolong_data && prolong_data.type == 'Наличные') {
              // проверяем что у пользователя есть выбранный счёт
              let worker_accounts_cashboxes_ids = this.worker_accounts.map(
                (account) => account.company_cashbox_id
              );
              // получаем все company_cashbox_id из наличного платежа
              let cash_payments_cashbox_ids = [prolong_data.company_cashbox_id];
              // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
              let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
                worker_accounts_cashboxes_ids.includes(cashbox_id)
              );
              // проверяем есть ли в кассах пользователя касса с такой валютой
              let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
              let cash_payments_currency_ids = [prolong_data.currency_id];
              let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
                worker_cashboxes_currency_ids.includes(cashbox_id)
              );
              if (has_matching_worker_cashbox_currency) {
                console.log("exists worker_cashbox_currency, select first on server")
              } else {
                console.log("not exists worker_cashbox_currency")
                this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "warning", 4000);
                return;
              }
            }
          }
          // Lazy load броней если они еще не загружены
          if (!self.carBookingsLoaded && self.bookings.length === 0) {
            await self.loadCarBookings(self.set_car.id);
          }
          function checkProlongBookingsDates(car_id, checked_booking, prolong_data) {
            let result = false;
            if (car_id && checked_booking) {
              let start_date = checked_booking.start_date;
              let end_date = checked_booking.end_date;
              let cars_bookings = self.bookings.filter((booking) => {
                return (
                  booking.car_id === car_id && booking.id != checked_booking.id
                );
              });

              cars_bookings.forEach((booking) => {
                let checked_start_date = moment(start_date, "DD-MM-YYYY H:mm");
                let checked_end_date = moment(end_date, "DD-MM-YYYY H:mm").add(
                  prolong_data.days,
                  "days"
                );
                let booking_start_date = moment(
                  booking.start_date,
                  "DD-MM-YYYY H:mm"
                ).subtract(
                  self.$store.getters.getCompany.company.interval_bookings,
                  "hours"
                );
                let booking_end_date = moment(
                  booking.end_date,
                  "DD-MM-YYYY H:mm"
                ).add(
                  self.$store.getters.getCompany.company.interval_bookings,
                  "hours"
                );
                if (
                  checked_start_date.isBetween(
                    booking_start_date,
                    booking_end_date,
                    "hours"
                  ) ||
                  checked_end_date.isBetween(
                    booking_start_date,
                    booking_end_date,
                    "hours"
                  ) ||
                  booking_start_date.isBetween(
                    checked_start_date,
                    checked_end_date,
                    "hours"
                  ) ||
                  booking_end_date.isBetween(
                    checked_start_date,
                    checked_end_date,
                    "hours"
                  )
                ) {
                  result = true;
                }
              });
              return result;
            }
          }

          // Для создания продления
          let old_price = this.booking.price;
          let last_date = this.booking.end_date;
          if (
            prolong_data.sum > 0 &&
            prolong_data.price >= 0 && prolong_data.price >= 0 && prolong_data.price != null && prolong_data.price != "" &&
            (prolong_data.days > 0 || prolong_data.hourly_hours > 0 || prolong_data.weekly_weeks > 0 || prolong_data.monthly_months > 0)
          ) {
            if (checkProlongBookingsDates(this.set_car.id, this.booking, prolong_data)) {
              const confirmed = await this.$confirm({
                title: self.$t("bookings.check_bookings_days"),
                text: self.$t("bookings.check_bookings_days_text"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: self.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: self.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmed) {
                    this.isLoadingSaveProlong = true;
                    let booking = this.booking;
                    console.log("save prolong 1")
                    let data = {};
                    if (!self.booking.hourly && !self.booking.weekly && !self.booking.monthly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        days: self.booking.days + prolong_data.days,
                        start_days: self.booking.days,
                        rental_cost:
                          prolong_data.days * prolong_data.price,
                        total: prolong_data.days * prolong_data.price,
                        end_date: moment(self.booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.days, "days")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                        company_cashbox_id: prolong_data.company_cashbox_id,
                        currency_id: prolong_data.currency_id,
                        company_cashbox: prolong_data.company_cashbox
                      }
                    } else if (self.booking.hourly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        full_hours: booking.hourly_hours + prolong_data.hourly_hours,
                        start_hours: booking.hourly_hours,
                        rental_cost: prolong_data.hourly_hours * prolong_data.price,
                        total: prolong_data.hourly_hours * prolong_data.price,
                        end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.hourly_hours, "hours")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                        company_cashbox_id: prolong_data.company_cashbox_id,
                        currency_id: prolong_data.currency_id,
                        company_cashbox: prolong_data.company_cashbox
                      }
                    } else if (self.booking.weekly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        full_weeks: booking.weekly_weeks + prolong_data.weekly_weeks,
                        start_weeks: booking.weekly_weeks,
                        rental_cost: prolong_data.weekly_weeks * prolong_data.price,
                        total: prolong_data.weekly_weeks * prolong_data.price,
                        end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.weekly_weeks, "weeks")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                        company_cashbox_id: prolong_data.company_cashbox_id,
                        currency_id: prolong_data.currency_id,
                        company_cashbox: prolong_data.company_cashbox
                      }
                    } else if (self.booking.monthly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        full_months: booking.monthly_months + prolong_data.monthly_months,
                        start_months: booking.monthly_months,
                        rental_cost: prolong_data.monthly_months * prolong_data.price,
                        total: prolong_data.monthly_months * prolong_data.price,
                        end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.monthly_months, "months")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                        company_cashbox_id: prolong_data.company_cashbox_id,
                        currency_id: prolong_data.currency_id,
                        company_cashbox: prolong_data.company_cashbox
                      }
                    }
                    this.axios
                      .post(
                        `/api/v1/save_prolong`,
                        data,
                        {
                          headers: {
                            Authorization: self.$store.getters.getAuthToken,
                          },
                        }
                      )
                      .then((response) => {
                        this.booking.price = response.data.price;
                        this.booking.selected_price = response.data.price;
                        this.booking.days = response.data.days;
                        this.booking.hourly_hours = response.data.hourly_hours;
                        this.booking.weekly_weeks = response.data.weekly_weeks;
                        this.booking.monthly_months = response.data.monthly_months;
                        this.booking.rental_cost = response.data.rental_cost;
                        this.booking.total = response.data.total;
                        this.booking.end_date = response.data.end_date;
                        this.booking.counts = response.data.counts;
                        this.booking.prolongs = response.data.prolongs;
                        this.prolongs = response.data.prolongs;

                        this.prolongDialog = false;
                        this.$notify(this.$t("bookings.prolong_title"), this.$t("bookings.prolong_text"), "success", 3000);
                      })
                      .catch((error) => {
                        self.setError(error, self.$t("errors.prolong_title"));
                      })
                      .finally(() => (self.isLoadingSaveProlong = false));
              }
            } else {
              this.isLoadingSaveProlong = true;
              let booking = this.booking;
              console.log("save prolong 2")
              let data = {};
              if (!self.booking.hourly && !self.booking.weekly && !self.booking.monthly) {
                data = {
                  booking_id: booking.id,
                  car_id: booking.car_id,
                  price: prolong_data.price,
                  days: self.booking.days + prolong_data.days,
                  hourly_hours: self.booking.hourly_hours + prolong_data.hourly_hours,
                  weekly_weeks: self.booking.weekly_weeks + prolong_data.weekly_weeks,
                  monthly_months: self.booking.monthly_months + prolong_data.monthly_months,
                  start_days: self.booking.days,
                  rental_cost: prolong_data.days * prolong_data.price,
                  total: prolong_data.days * prolong_data.price,
                  end_date: moment(self.booking.end_date, "DD-MM-YYYY H:mm")
                    .add(prolong_data.days, "days")
                    .format("DD-MM-YYYY H:mm"),
                  last_date: last_date,
                  old_price: old_price,
                  prolong_data: prolong_data,
                }
              } else if (self.booking.hourly) {
                data = {
                  booking_id: booking.id,
                  car_id: booking.car_id,
                  price: prolong_data.price,
                  full_hours: booking.hourly_hours + prolong_data.hourly_hours,
                  start_hours: booking.hourly_hours,
                  rental_cost: prolong_data.hourly_hours * prolong_data.price,
                  total: prolong_data.hourly_hours * prolong_data.price,
                  end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                    .add(prolong_data.hourly_hours, "hours")
                    .format("DD-MM-YYYY H:mm"),
                  last_date: last_date,
                  old_price: old_price,
                  prolong_data: prolong_data,
                }
              } else if (self.booking.weekly) {
                data = {
                  booking_id: booking.id,
                  car_id: booking.car_id,
                  price: prolong_data.price,
                  full_weeks: booking.weekly_weeks + prolong_data.weekly_weeks,
                  start_weeks: booking.weekly_weeks,
                  rental_cost: prolong_data.weekly_weeks * prolong_data.price,
                  total: prolong_data.weekly_weeks * prolong_data.price,
                  end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                    .add(prolong_data.weekly_weeks, "weeks")
                    .format("DD-MM-YYYY H:mm"),
                  last_date: last_date,
                  old_price: old_price,
                  prolong_data: prolong_data,
                }
              } else if (self.booking.monthly) {
                data = {
                  booking_id: booking.id,
                  car_id: booking.car_id,
                  price: prolong_data.price,
                  full_months: booking.monthly_months + prolong_data.monthly_months,
                  start_months: booking.monthly_months,
                  rental_cost: prolong_data.monthly_months * prolong_data.price,
                  total: prolong_data.monthly_months * prolong_data.price,
                  end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                    .add(prolong_data.monthly_months, "months")
                    .format("DD-MM-YYYY H:mm"),
                  last_date: last_date,
                  old_price: old_price,
                  prolong_data: prolong_data,
                }
              }
              this.axios
                .post(
                  `/api/v1/save_prolong`,
                  data,
                  {
                    headers: {
                      Authorization: self.$store.getters.getAuthToken,
                    },
                  }
                )
                .then((response) => {
                  this.booking.price = response.data.price;
                  this.booking.selected_price = response.data.price;
                  this.booking.days = response.data.days;
                  this.booking.hourly_hours = response.data.hourly_hours;
                  this.booking.weekly_weeks = response.data.weekly_weeks;
                  this.booking.monthly_months = response.data.monthly_months;
                  this.booking.rental_cost = response.data.rental_cost;
                  this.booking.total = response.data.total;
                  this.booking.end_date = response.data.end_date;
                  this.booking.counts = response.data.counts;
                  this.booking.prolongs = response.data.prolongs;
                  this.prolongs = response.data.prolongs;

                  this.prolongDialog = false;
                  self.$notify(self.$t("bookings.prolong_title"), self.$t("bookings.prolong_text"), "success", 3000);
                })
                .catch((error) => {
                  self.setError(error, self.$t("errors.prolong_title"));
                })
                .finally(() => (self.isLoadingSaveProlong = false));
            }
          } else {
            if (prolong_data.price >= 0 && prolong_data.price >= 0 && prolong_data.price != null && prolong_data.price != "" && (prolong_data.days > 0 || prolong_data.hourly_hours > 0 || prolong_data.weekly_weeks > 0 || prolong_data.monthly_months > 0)) {
              const confirmed = await this.$confirm({
                title: this.$t("bookings.prolong_zero_title"),
                text: this.$t("bookings.prolong_zero_text"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: self.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmed) {
                if (checkProlongBookingsDates(self.set_car.id, self.booking, prolong_data)) {
                  const confirmedReserved = await self.$confirm({
                    title: self.$t("bookings.prolong_reserved_title"),
                    text: self.$t("bookings.prolong_reserved_text"),
                    icon: "mdi-alert-outline",
                    iconColor: "warning",
                    iconSize: 72,
                    iconPosition: "top",
                    confirmButtonText: self.$t("custom.yes"),
                    confirmButtonColor: "primary",
                    cancelButtonText: self.$t("custom.no"),
                    cancelButtonColor: "grey darken-1",
                    useFilledButtons: true,
                    maxWidth: 450,
                  });
                  
                  if (confirmedReserved) {
                          let booking = self.booking;
                          console.log("save prolong 3")
                          let data = {};
                          if (!self.booking.hourly && !self.booking.weekly && !self.booking.monthly) {
                            data = {
                              booking_id: booking.id,
                              car_id: booking.car_id,
                              price: prolong_data.price,
                              days: self.booking.days + prolong_data.days,
                              hourly_hours: self.booking.hourly_hours + prolong_data.hourly_hours,
                              weekly_weeks: self.booking.weekly_weeks + prolong_data.weekly_weeks,
                              monthly_months: self.booking.monthly_months + prolong_data.monthly_months,
                              start_days: self.booking.days,
                              rental_cost: prolong_data.days * prolong_data.price,
                              total: prolong_data.days * prolong_data.price,
                              end_date: moment(self.booking.end_date, "DD-MM-YYYY H:mm")
                                .add(prolong_data.days, "days")
                                .format("DD-MM-YYYY H:mm"),
                              last_date: last_date,
                              old_price: old_price,
                              prolong_data: prolong_data,
                            }
                          } else if (self.booking.hourly) {
                            data = {
                              booking_id: booking.id,
                              car_id: booking.car_id,
                              price: prolong_data.price,
                              full_hours: booking.hourly_hours + prolong_data.hourly_hours,
                              start_hours: booking.hourly_hours,
                              rental_cost: prolong_data.hourly_hours * prolong_data.price,
                              total: prolong_data.hourly_hours * prolong_data.price,
                              end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                                .add(prolong_data.hourly_hours, "hours")
                                .format("DD-MM-YYYY H:mm"),
                              last_date: last_date,
                              old_price: old_price,
                              prolong_data: prolong_data,
                            }
                          } else if (self.booking.weekly) {
                            data = {
                              booking_id: booking.id,
                              car_id: booking.car_id,
                              price: prolong_data.price,
                              full_weeks: booking.weekly_weeks + prolong_data.weekly_weeks,
                              start_weeks: booking.weekly_weeks,
                              rental_cost: prolong_data.weekly_weeks * prolong_data.price,
                              total: prolong_data.weekly_weeks * prolong_data.price,
                              end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                                .add(prolong_data.weekly_weeks, "weeks")
                                .format("DD-MM-YYYY H:mm"),
                              last_date: last_date,
                              old_price: old_price,
                              prolong_data: prolong_data,
                            }
                          } else if (self.booking.monthly) {
                            data = {
                              booking_id: booking.id,
                              car_id: booking.car_id,
                              price: prolong_data.price,
                              full_months: booking.monthly_months + prolong_data.monthly_months,
                              start_months: booking.monthly_months,
                              rental_cost: prolong_data.monthly_months * prolong_data.price,
                              total: prolong_data.monthly_months * prolong_data.price,
                              end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                                .add(prolong_data.monthly_months, "months")
                                .format("DD-MM-YYYY H:mm"),
                              last_date: last_date,
                              old_price: old_price,
                              prolong_data: prolong_data,
                            }
                          }
                          this.isLoadingSaveProlong = true;
                          this.axios
                            .post(
                              `/api/v1/save_prolong`,
                              data,
                              {
                                headers: {
                                  Authorization:
                                    self.$store.getters.getAuthToken,
                                },
                              }
                            )
                            .then((response) => {
                              this.booking.price = response.data.price;
                              this.booking.selected_price = response.data.price;
                              this.booking.days = response.data.days;
                              this.booking.hourly_hours = response.data.hourly_hours;
                              this.booking.weekly_weeks = response.data.weekly_weeks;
                              this.booking.monthly_months = response.data.monthly_months;
                              this.booking.rental_cost = response.data.rental_cost;
                              this.booking.total = response.data.total;
                              this.booking.end_date = response.data.end_date;
                              this.booking.counts = response.data.counts;
                              this.booking.prolongs = response.data.prolongs;
                              this.prolongs = response.data.prolongs;

                              self.prolongDialog = false;
                              self.$notify(self.$t("bookings.prolong_title"), self.$t("bookings.prolong_text_short"), "success", 3000);
                            })
                            .catch((error) => {
                              self.setError(error, self.$t("errors.prolong_title"));
                            })
                            .finally(() => (self.isLoadingSaveProlong = false));
                  }
                } else {
                    let booking = self.booking;
                    console.log("save prolong 4")
                    let data = {};
                    if (!self.booking.hourly && !self.booking.weekly && !self.booking.monthly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        days: self.booking.days + prolong_data.days,
                        hourly_hours: self.booking.hourly_hours + prolong_data.hourly_hours,
                        weekly_weeks: self.booking.weekly_weeks + prolong_data.weekly_weeks,
                        monthly_months: self.booking.monthly_months + prolong_data.monthly_months,
                        start_days: self.booking.days,
                        rental_cost: prolong_data.days * prolong_data.price,
                        total: prolong_data.days * prolong_data.price,
                        end_date: moment(self.booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.days, "days")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                      }
                    } else if (self.booking.hourly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        full_hours: booking.hourly_hours + prolong_data.hourly_hours,
                        start_hours: booking.hourly_hours,
                        rental_cost: prolong_data.hourly_hours * prolong_data.price,
                        total: prolong_data.hourly_hours * prolong_data.price,
                        end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.hourly_hours, "hours")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                      }
                    } else if (self.booking.weekly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        full_weeks: booking.weekly_weeks + prolong_data.weekly_weeks,
                        start_weeks: booking.weekly_weeks,
                        rental_cost: prolong_data.weekly_weeks * prolong_data.price,
                        total: prolong_data.weekly_weeks * prolong_data.price,
                        end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.weekly_weeks, "weeks")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                      }
                    } else if (self.booking.monthly) {
                      data = {
                        booking_id: booking.id,
                        car_id: booking.car_id,
                        price: prolong_data.price,
                        full_months: booking.monthly_months + prolong_data.monthly_months,
                        start_months: booking.monthly_months,
                        rental_cost: prolong_data.monthly_months * prolong_data.price,
                        total: prolong_data.monthly_months * prolong_data.price,
                        end_date: moment(booking.end_date, "DD-MM-YYYY H:mm")
                          .add(prolong_data.monthly_months, "months")
                          .format("DD-MM-YYYY H:mm"),
                        last_date: last_date,
                        old_price: old_price,
                        prolong_data: prolong_data,
                      }
                    }
                    self.isLoadingSaveProlong = true;
                    self.axios
                      .post(
                        `/api/v1/save_prolong`,
                        data,
                        {
                          headers: {
                            Authorization: self.$store.getters.getAuthToken,
                          },
                        }
                      )
                      .then((response) => {
                        this.booking.price = response.data.price;
                        this.booking.selected_price = response.data.price;
                        this.booking.days = response.data.days;
                        this.booking.hourly_hours = response.data.hourly_hours;
                        this.booking.weekly_weeks = response.data.weekly_weeks;
                        this.booking.monthly_months = response.data.monthly_months;
                        this.booking.rental_cost = response.data.rental_cost;
                        this.booking.total = response.data.total;
                        this.booking.end_date = response.data.end_date;
                        this.booking.counts = response.data.counts;
                        this.booking.prolongs = response.data.prolongs;
                        this.prolongs = response.data.prolongs;

                        self.prolongDialog = false;
                        self.$notify(self.$t("bookings.prolong_title"), self.$t("bookings.prolong_no_money_text"), "success", 3000);
                      })
                      .catch((error) => {
                        self.setError(error, self.$t("errors.prolong_title"));
                      })
                      .finally(() => (self.isLoadingSaveProlong = false));
                }
              }
            } else {
              this.$notify(this.$t("custom.no_data"), this.$t("bookings.prolong_no_data_text"), "warning", 4000);
              this.isLoadingSaveProlong = false;
            }
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    closeProlongDialog() {
      this.prolongDialog = false;
    },
    checkDaysMinLimit(days) {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        !this.booking.technical &&
        this.$store.getters.getCompany.company.min_days &&
        days < this.$store.getters.getCompany.company.min_days
      ) {
        this.$notify(this.$t("bookings.booking_very_short_title"), this.$t("bookings.booking_very_short_text", { days: days }), "warning", 4000)
      }
    },
    checkMileage() {
      return this.set_car ? this.set_car.mileage : 0;
    },
    loadClients() {
      this.isLoadingClients = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.searchClient,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          console.log(response.data)
          this.clients = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients.forEach((client) => {
            if (!client) return;
            if (!client.entity) {
              client["fullname"] =
                (client.lastname || '') +
                " " +
                (client.name || '') +
                " " +
                (client.middlename || '') +
                " " +
                (client.phone
                  ? phoneLastDigits(client.phone)
                  : "");
            } else {
              client["fullname"] =
                (client.entity_name || '') +
                ", " +
                (client.reg_form || '') +
                " " +
                " - " +
                (client.entity_phone
                  ? phoneLastDigits(client.entity_phone)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.isLoadingClients = false;
          this.setError(error, this.$t("errors.clients_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingClients = false));
    },
    loadClientsForAddDrivers() {
      this.isLoadingClientsAddDriver = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.searchClientAddDriver,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          let add_drivers = response.data.query ? response.data.query : (response.data ? response.data : []);
          add_drivers.forEach((client) => {
            if (!client) return;
            if (!client.entity) {
              client["fullname"] =
                (client.lastname || '') +
                " " +
                (client.name || '') +
                " " +
                (client.middlename || '') +
                " " +
                (client.phone
                  ? phoneLastDigits(client.phone)
                  : "");
            } else {
              client["fullname"] =
                (client.entity_name || '') +
                ", " +
                (client.reg_form || '') +
                " " +
                " - " +
                (client.entity_phone
                  ? phoneLastDigits(client.entity_phone)
                  : "");
            }
          });

          this.search_add_drivers = add_drivers

          // let result = existing + add_drivers
          // // make unique
          // let unique = result.filter((item, index) => {
          //   return result.indexOf(item) === index;
          // });
          // this.add_drivers = unique
        })
        .catch((error) => {
          this.isLoadingClientsAddDriver = false;
          this.setError(error, this.$t("errors.clients_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingClientsAddDriver = false));
    },
    addDriver(driver) {
      if (driver && driver.id) {
        this.selected_add_drivers.push(driver)
        this.searchClientAddDriver = ""
        this.search_add_drivers = []
      }
    },
    removeAddDriver(driver) {
      let index = this.selected_add_drivers.indexOf(driver);
      this.selected_add_drivers.splice(index, 1);
    },
    async inHome(data) {
      // Защита от двойного вызова (race condition)
      if (this.isLoadingInHome) {
        console.warn("inHome: already running, skipping the repeat call");
        return;
      }
      
      if (this.isStaff) {
        let self = this;
        // Если есть платежи по терминалу за залог, то ставим в положение не возвращать залог
        if (this.hasDepositHold) {
          data.giveNullDeposit = true;
        }
        // this.arrival_payments.deposit.sum = this.returnDeposit()
        // Поменял залог на ноль, если не возвращать
        if (!data.giveNullDeposit) {
          // Если частичный возврат залога, то берем проставленную сумму, если нет, то из брони
          if (!data.partReturnDeposit) {
            // Убрал проставление суммы залога, т.к. она проставляется в ArrivalDialog.vue
            // data.arrival_payments.deposit.sum = this.currentDeposit();
          }
        } else {
          data.arrival_payments.deposit.sum = 0;
        }
        // Валидации прошли, устанавливаем флаг загрузки ДО всех диалогов
        self.isLoadingInHome = true;
        
        async function processArrival(giveNullDeposit, data) {
          // ЗАГРУЗКА ФОТО ПОВРЕЖДЕНИЙ - только после всех диалогов, перед отправкой на сервер
          if (data.uploadDamageImageCallback) {
            console.log('Uploading damage image before sending to server...');
            const imageUrl = await data.uploadDamageImageCallback();
            if (imageUrl) {
              data.booking.checkout_damage_image_url = imageUrl;
              console.log('Damage image uploaded, URL:', imageUrl);
            }
          }
          
          let booking_data = {
            end_date: data.booking.end_date,
            clean_end: data.booking.clean_end,
            gas_end_full: data.booking.gas_end_full,
            gas_end: data.booking.gas_end,
            in_rent: false,
            active: false,
            ride: true,
            accepted: true,
            delivery: data.booking.delivery > 0 ? data.booking.delivery + data.arrival_payments.delivery.sum : data.arrival_payments.delivery.sum,
            delivery_end:
              data.booking.delivery_end > 0
                ? data.booking.delivery_end +
                data.arrival_payments.delivery_end.sum
                : data.arrival_payments.delivery_end.sum,
            hours_cost_end: data.arrival_payments.additional_hours.sum,
            mileage_cost:
              data.booking.mileage > 0
                ? data.booking.mileage + data.arrival_payments.mileage.sum
                : data.arrival_payments.mileage.sum,
            clean_payment:
              data.booking.clean_payment > 0
                ? data.booking.clean_payment + data.arrival_payments.clean.sum
                : data.arrival_payments.clean.sum,
            gas:
              data.booking.gas > 0
                ? data.booking.gas + data.arrival_payments.gas.sum
                : data.arrival_payments.gas.sum,
            fine:
              data.booking.fine > 0
                ? data.booking.fine + data.arrival_payments.fine.sum
                : data.arrival_payments.fine.sum,
            damage:
              data.booking.damage > 0
                ? data.booking.damage + data.arrival_payments.damage.sum
                : data.arrival_payments.damage.sum,
            insurance:
              data.booking.insurance > 0
                ? data.booking.insurance + data.arrival_payments.insurance.sum
                : data.arrival_payments.insurance.sum,
            add_drivers_cost:
              data.booking.add_drivers_cost > 0
                ? data.booking.add_drivers_cost +
                data.arrival_payments.add_drivers_cost.sum
                : data.arrival_payments.add_drivers_cost.sum,
            other_end: data.arrival_payments.other.sum,
            end_worker_id: self.$store.getters.getCurrentUser.id,
            end_mileage: data.booking.end_mileage,
            booking_mileage:
              data.booking.start_mileage > 0 && data.booking.end_mileage > 0
                ? data.booking.end_mileage - data.booking.start_mileage
                : 0,
            responsible: null,
            part_return_deposit: data.partReturnDeposit,
          };
          
          // Добавляем URL изображения диаграммы повреждений при возврате, если он есть
          if (data.booking.checkout_damage_image_url) {
            booking_data.checkout_damage_image_url = data.booking.checkout_damage_image_url;
          }
          
          // Добавляем повреждения checkout, если они есть
          if (data.booking.checkout_damages && data.booking.checkout_damages.length > 0) {
            booking_data.checkout_damages = data.booking.checkout_damages;
          }

          // Проверка клиента
          let client_data = null;
          if (data.showProblems) {
            client_data = {
              category: data.client.category,
              problems: true,
              problems_description: data.client.problems_description,
              send_review_reminder: false,
            };
          } else {
            client_data = {
              category: "Постоянный",
              problems: false,
              problems_description: null,
              send_review_reminder: true,
            };

            // send reminder review email and whatsapp
            if (data.dont_send_review_reminder ||
              data.client.category == "Серый" ||
              data.client.category == "Чёрный"
            ) {
              client_data.send_review_reminder = false;
            } else {
              client_data.send_review_reminder = true;
            }
          }

          // Состояние машины
          let car_data = {};
          if (data.booking.end_mileage > 0) {
            // check state
            let finded_car = self.set_car;
            let check_state = false;
            if (
              (finded_car &&
                data.booking.end_mileage - finded_car.oil_engine >
                finded_car.oil_engine_km - 1000) ||
              data.booking.end_mileage - finded_car.grm > finded_car.grm_km - 5000
            ) {
              check_state = true;
            }

            car_data = {
              mileage: data.booking.end_mileage,
              // state: check_state ? 6 : finded_car.state,
              store_place: finded_car.store_place,
            };
          }

          // Мойка и бак в автомобиле
          car_data["tank_state"] = data.booking.gas_end_full;
          car_data["clean_state"] = data.booking.clean_end;

          // Технический осмотр
          car_data["technical_check"] = {
            technical_check_end: data.booking.technical_check_end,
            technical_check_end_comment: data.booking.technical_check_end_comment,
          }

          let all_counts = [];

          // Мойка
          let clean_count = null;
          if (data.arrival_payments.clean.sum != 0) {
            clean_count = {
              group: "Доплата за мойку",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_clean_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.clean.sum,
              cash: data.arrival_payments.clean.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.clean.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.clean.type == "На карту" ? true : false,
              entity: data.arrival_payments.clean.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.clean.company_cashbox_id,
              currency_id: data.arrival_payments.clean.currency_id,
            };
            all_counts.push(clean_count);
          }
          // Доставка
          let delivery_count = null;
          if (data.arrival_payments.delivery.sum != 0) {
            delivery_count = {
              group: "Доплата за доставку",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_delivery_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.delivery.sum,
              cash: data.arrival_payments.delivery.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.delivery.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.delivery.type == "На карту" ? true : false,
              entity: data.arrival_payments.delivery.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.delivery.company_cashbox_id,
              currency_id: data.arrival_payments.delivery.currency_id,
            };
            all_counts.push(delivery_count);
          }
          // Приём
          let delivery_end_count = null;
          if (data.arrival_payments.delivery_end.sum != 0) {
            delivery_end_count = {
              group: "Доплата за приём",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.delivery_end.sum,
              cash: data.arrival_payments.delivery_end.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.delivery_end.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.delivery_end.type == "На карту" ? true : false,
              entity: data.arrival_payments.delivery_end.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.delivery_end.company_cashbox_id,
              currency_id: data.arrival_payments.delivery_end.currency_id,
            };
            all_counts.push(delivery_end_count);
          }
          // Дополнительное время
          let additional_hours_count = null;
          if (data.arrival_payments.additional_hours.sum != 0) {
            additional_hours_count = {
              group: "Доплата за дополнительное время",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_addhours_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.additional_hours.sum,
              cash: data.arrival_payments.additional_hours.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.additional_hours.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.additional_hours.type == "На карту" ? true : false,
              entity: data.arrival_payments.additional_hours.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.additional_hours.company_cashbox_id,
              currency_id: data.arrival_payments.additional_hours.currency_id,
            };
            all_counts.push(additional_hours_count);
          }
          // Превышение пробега
          let mileage_count = null;
          if (data.arrival_payments.mileage.sum != 0) {
            mileage_count = {
              group: "Доплата за превышение пробега",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_mileage_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.mileage.sum,
              cash: data.arrival_payments.mileage.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.mileage.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.mileage.type == "На карту" ? true : false,
              entity: data.arrival_payments.mileage.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.mileage.company_cashbox_id,
              currency_id: data.arrival_payments.mileage.currency_id,
            };
            all_counts.push(mileage_count);
          }
          // Аренда
          let rent_count = null;
          if (data.arrival_payments.rent.sum != 0) {
            rent_count = {
              group: "Оплата аренды",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_rent_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.rent.sum,
              cash: data.arrival_payments.rent.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.rent.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.rent.type == "На карту" ? true : false,
              entity: data.arrival_payments.rent.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.rent.company_cashbox_id,
              currency_id: data.arrival_payments.rent.currency_id,
            };
            all_counts.push(rent_count);
          }
          // Топливо
          let gas_count = null;
          if (data.arrival_payments.gas.sum != 0) {
            gas_count = {
              group: "Доплата за топливо",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_gas_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.gas.sum,
              cash: data.arrival_payments.gas.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.gas.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.gas.type == "На карту" ? true : false,
              entity: data.arrival_payments.gas.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.gas.company_cashbox_id,
              currency_id: data.arrival_payments.gas.currency_id,
            };
            all_counts.push(gas_count);
          }
          // Оборудование
          let equipment_count = null;
          if (data.arrival_payments.equipment.sum != 0) {
            equipment_count = {
              group: "Доплата за оборудование",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_equipment_checkout_payment",
                { id: data.booking.id }
              ),
              sum: data.arrival_payments.equipment.sum,
              cash: data.arrival_payments.equipment.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.equipment.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.equipment.type == "На карту" ? true : false,
              entity: data.arrival_payments.equipment.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.equipment.company_cashbox_id,
              currency_id: data.arrival_payments.equipment.currency_id,
            };
            all_counts.push(equipment_count);
          }
          // Страховка
          let insurance_count = null;
          if (data.arrival_payments.insurance.sum != 0) {
            insurance_count = {
              group: "Доплата за страховку",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_insuranse_checkout_payment",
                { id: self.booking.id }
              ),
              sum: data.arrival_payments.insurance.sum,
              cash: data.arrival_payments.insurance.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.insurance.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.insurance.type == "На карту" ? true : false,
              entity: data.arrival_payments.insurance.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.insurance.company_cashbox_id,
              currency_id: data.arrival_payments.insurance.currency_id,
            };
            all_counts.push(insurance_count);
          }
          // Доп водители
          let add_drivers_cost_count = null;
          if (data.arrival_payments.add_drivers_cost.sum != 0) {
            add_drivers_cost_count = {
              group: "Доплата за доп водителей",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_drivers_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.add_drivers_cost.sum,
              cash: data.arrival_payments.add_drivers_cost.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.add_drivers_cost.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.add_drivers_cost.type == "На карту" ? true : false,
              entity: data.arrival_payments.add_drivers_cost.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.add_drivers_cost.company_cashbox_id,
              currency_id: data.arrival_payments.add_drivers_cost.currency_id,
            };
            all_counts.push(add_drivers_cost_count);
          }
          // Штрафы
          let fine_count = null;
          if (data.arrival_payments.fine.sum != 0) {
            fine_count = {
              group: "Доплата за штрафы",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_fines_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.fine.sum,
              cash: data.arrival_payments.fine.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.fine.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.fine.type == "На карту" ? true : false,
              entity: data.arrival_payments.fine.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.fine.company_cashbox_id,
              currency_id: data.arrival_payments.fine.currency_id,
            };
            all_counts.push(fine_count);
          }
          // Повреждения
          let damage_count = null;
          if (data.arrival_payments.damage.sum != 0) {
            damage_count = {
              group: "Доплата за повреждения",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_damages_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.damage.sum,
              cash: data.arrival_payments.damage.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.damage.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.damage.type == "На карту" ? true : false,
              entity: data.arrival_payments.damage.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.damage.company_cashbox_id,
              currency_id: data.arrival_payments.damage.currency_id,
            };
            all_counts.push(damage_count);
          }
          // Другое
          let other_count = null;
          if (data.arrival_payments.other.sum != 0) {
            other_count = {
              group: "Доплата за другое",
              car_id: data.booking.car_id,
              operation: true,
              description: self.$t("bookings.desc_other_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.other.sum,
              cash: data.arrival_payments.other.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.other.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.other.type == "На карту" ? true : false,
              entity: data.arrival_payments.other.type == "Р/с" ? true : false,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.other.company_cashbox_id,
              currency_id: data.arrival_payments.other.currency_id,
            };
            all_counts.push(other_count);
          }

          // Возврат залога
          let deposit_count = null;
          let deposit_payment = null;
          if (!data.giveNullDeposit && data.arrival_payments.deposit.sum != 0) {
            deposit_count = {
              group: "Залог",
              operation: false,
              description: self.$t("bookings.desc_other_checkout_payment", {
                id: data.booking.id,
              }),
              sum: data.arrival_payments.deposit.sum,
              cash: data.arrival_payments.deposit.type == "Наличные" ? true : false,
              cashless: data.arrival_payments.deposit.type == "Терминал" ? true : false,
              cash_card: data.arrival_payments.deposit.type == "На карту" ? true : false,
              entity: data.arrival_payments.deposit.type == "Р/с" ? true : false,
              car_id: data.booking.car_id,
              booking_id: data.booking.id,
              company_cashbox_id: data.arrival_payments.deposit.company_cashbox_id,
              currency_id: data.arrival_payments.deposit.currency_id,
            };
            all_counts.push(deposit_count);
          }

          // Считаем на сколько изменять кассы
          function calcKassChanges(data) {
            let cash = 0;
            let cashless = 0;
            let cash_card = 0;
            let entity = 0;

            if (data.giveNullDeposit) {
              data.arrival_payments.deposit.sum = 0;
            }
            // Наличные
            if (data.arrival_payments.rent.type == "Наличные") {
              cash += data.arrival_payments.rent.sum;
            }
            if (data.arrival_payments.clean.type == "Наличные") {
              cash += data.arrival_payments.clean.sum;
            }
            if (data.arrival_payments.delivery.type == "Наличные") {
              cash += data.arrival_payments.delivery.sum;
            }
            if (data.arrival_payments.delivery_end.type == "Наличные") {
              cash += data.arrival_payments.delivery_end.sum;
            }
            if (data.arrival_payments.additional_hours.type == "Наличные") {
              cash += data.arrival_payments.additional_hours.sum;
            }
            if (data.arrival_payments.mileage.type == "Наличные") {
              cash += data.arrival_payments.mileage.sum;
            }
            if (data.arrival_payments.insurance.type == "Наличные") {
              cash += data.arrival_payments.insurance.sum;
            }
            if (data.arrival_payments.add_drivers_cost.type == "Наличные") {
              cash += data.arrival_payments.add_drivers_cost.sum;
            }
            if (data.arrival_payments.gas.type == "Наличные") {
              cash += data.arrival_payments.gas.sum;
            }
            if (data.arrival_payments.equipment.type == "Наличные") {
              cash += data.arrival_payments.equipment.sum;
            }
            if (data.arrival_payments.fine.type == "Наличные") {
              cash += data.arrival_payments.fine.sum;
            }
            if (data.arrival_payments.damage.type == "Наличные") {
              cash += data.arrival_payments.damage.sum;
            }
            if (data.arrival_payments.other.type == "Наличные") {
              cash += data.arrival_payments.other.sum;
            }
            // залог с минусом
            if (data.arrival_payments.deposit.type == "Наличные") {
              cash -= data.arrival_payments.deposit.sum;
            }
            // 'Терминал'
            if (data.arrival_payments.rent.type == "Терминал") {
              cashless += data.arrival_payments.rent.sum;
            }
            if (data.arrival_payments.clean.type == "Терминал") {
              cashless += data.arrival_payments.clean.sum;
            }
            if (data.arrival_payments.delivery.type == "Терминал") {
              cashless += data.arrival_payments.delivery.sum;
            }
            if (data.arrival_payments.delivery_end.type == "Терминал") {
              cashless += data.arrival_payments.delivery_end.sum;
            }
            if (data.arrival_payments.additional_hours.type == "Терминал") {
              cashless += data.arrival_payments.additional_hours.sum;
            }
            if (data.arrival_payments.mileage.type == "Терминал") {
              cashless += data.arrival_payments.mileage.sum;
            }
            if (data.arrival_payments.insurance.type == "Терминал") {
              cashless += data.arrival_payments.insurance.sum;
            }
            if (data.arrival_payments.add_drivers_cost.type == "Терминал") {
              cashless += data.arrival_payments.add_drivers_cost.sum;
            }
            if (data.arrival_payments.gas.type == "Терминал") {
              cashless += data.arrival_payments.gas.sum;
            }
            if (data.arrival_payments.equipment.type == "Терминал") {
              cashless += data.arrival_payments.equipment.sum;
            }
            if (data.arrival_payments.fine.type == "Терминал") {
              cashless += data.arrival_payments.fine.sum;
            }
            if (data.arrival_payments.damage.type == "Терминал") {
              cashless += data.arrival_payments.damage.sum;
            }
            if (data.arrival_payments.other.type == "Терминал") {
              cashless += data.arrival_payments.other.sum;
            }
            // залог с минусом
            if (data.arrival_payments.deposit.type == "Терминал") {
              cashless -= data.arrival_payments.deposit.sum;
            }
            // На карту
            if (data.arrival_payments.rent.type == "На карту") {
              cash_card += data.arrival_payments.rent.sum;
            }
            if (data.arrival_payments.clean.type == "На карту") {
              cash_card += data.arrival_payments.clean.sum;
            }
            if (data.arrival_payments.delivery.type == "На карту") {
              cash_card += data.arrival_payments.delivery.sum;
            }
            if (data.arrival_payments.delivery_end.type == "На карту") {
              cash_card += data.arrival_payments.delivery_end.sum;
            }
            if (data.arrival_payments.additional_hours.type == "На карту") {
              cash_card += data.arrival_payments.additional_hours.sum;
            }
            if (data.arrival_payments.mileage.type == "На карту") {
              cash_card += data.arrival_payments.mileage.sum;
            }
            if (data.arrival_payments.insurance.type == "На карту") {
              cash_card += data.arrival_payments.insurance.sum;
            }
            if (data.arrival_payments.add_drivers_cost.type == "На карту") {
              cash_card += data.arrival_payments.add_drivers_cost.sum;
            }
            if (data.arrival_payments.gas.type == "На карту") {
              cash_card += data.arrival_payments.gas.sum;
            }
            if (data.arrival_payments.equipment.type == "На карту") {
              cash_card += data.arrival_payments.equipment.sum;
            }
            if (data.arrival_payments.fine.type == "На карту") {
              cash_card += data.arrival_payments.fine.sum;
            }
            if (data.arrival_payments.damage.type == "На карту") {
              cash_card += data.arrival_payments.damage.sum;
            }
            if (data.arrival_payments.other.type == "На карту") {
              cash_card += data.arrival_payments.other.sum;
            }
            // залог с минусом
            if (data.arrival_payments.deposit.type == "На карту") {
              cash_card -= data.arrival_payments.deposit.sum;
            }
            // 'Р/с'
            if (data.arrival_payments.rent.type == "Р/с") {
              entity += data.arrival_payments.rent.sum;
            }
            if (data.arrival_payments.clean.type == "Р/с") {
              entity += data.arrival_payments.clean.sum;
            }
            if (data.arrival_payments.delivery.type == "Р/с") {
              entity += data.arrival_payments.delivery.sum;
            }
            if (data.arrival_payments.delivery_end.type == "Р/с") {
              entity += data.arrival_payments.delivery_end.sum;
            }
            if (data.arrival_payments.additional_hours.type == "Р/с") {
              entity += data.arrival_payments.additional_hours.sum;
            }
            if (data.arrival_payments.mileage.type == "Р/с") {
              entity += data.arrival_payments.mileage.sum;
            }
            if (data.arrival_payments.insurance.type == "Р/с") {
              entity += data.arrival_payments.insurance.sum;
            }
            if (data.arrival_payments.add_drivers_cost.type == "Р/с") {
              entity += data.arrival_payments.add_drivers_cost.sum;
            }
            if (data.arrival_payments.gas.type == "Р/с") {
              entity += data.arrival_payments.gas.sum;
            }
            if (data.arrival_payments.equipment.type == "Р/с") {
              entity += data.arrival_payments.equipment.sum;
            }
            if (data.arrival_payments.fine.type == "Р/с") {
              entity += data.arrival_payments.fine.sum;
            }
            if (data.arrival_payments.damage.type == "Р/с") {
              entity += data.arrival_payments.damage.sum;
            }
            if (data.arrival_payments.other.type == "Р/с") {
              entity += data.arrival_payments.other.sum;
            }
            // залог с минусом
            if (data.arrival_payments.deposit.type == "Р/с") {
              entity -= data.arrival_payments.deposit.sum;
            }

            return {
              cash: cash,
              cashless: cashless,
              cash_card: cash_card,
              entity: entity,
            };
          }
          let company_cashless = null;
          let company_cash = null;
          // изменяем кассу компании
          // Безнал
          if (
            calcKassChanges(data).cashless != 0 ||
            calcKassChanges(data).entity != 0
          ) {
            company_cashless =
              calcKassChanges(data).cashless + calcKassChanges(data).entity;
          }
          // С карты на карту
          if (calcKassChanges(data).cash_card != 0) {
            company_cash = calcKassChanges(data).cash_card;
          }

          // Изменяем кассу сотрудника
          let workers_cashbox = null;
          if (calcKassChanges(data).cash != 0) {
            workers_cashbox = {
              workers_id: self.$store.getters.currentUserId,
              cash: calcKassChanges(data).cash,
            };
          }

          // Отправляем на сервер
          self.axios
            .post(
              "/api/v1/in_home",
              {
                client_id: data.booking.client_id,
                booking_id: data.booking.id,
                car_id: data.booking.car_id,
                booking_data: booking_data,
                client_data: client_data,
                car_data: car_data,
                clean_count: clean_count,
                delivery_count: delivery_count,
                delivery_end_count: delivery_end_count,
                additional_hours_count: additional_hours_count,
                mileage_count: mileage_count,
                rent_count: rent_count,
                gas_count: gas_count,
                equipment_count: equipment_count,
                insurance_count: insurance_count,
                add_drivers_cost_count: add_drivers_cost_count,
                fine_count: fine_count,
                damage_count: damage_count,
                other_count: other_count,
                deposit_count: deposit_count,
                deposit_payment: deposit_payment,
                company_cashless: company_cashless,
                company_cash: company_cash,
                workers_cashbox: workers_cashbox,
                company_cashbox_id: data.company_cashbox_id,
                worker_account_id: data.worker_account_id,
                checkout_damages: data.booking.checkout_damages || [],
              },
              {
                headers: {
                  Authorization: self.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              // Обновляем фронт
              (self.booking.end_date = data.booking.end_date),
                (self.booking.clean_end = data.booking.clean_end),
                (self.booking.gas_start = data.booking.gas_start),
                (self.booking.gas_end_full = data.booking.gas_end_full),
                (self.booking.gas_end = data.booking.gas_end),
                (self.booking.in_rent = false),
                (self.booking.active = false),
                (self.booking.ride = true),
                (self.booking.accepted = true),
                (self.booking.delivery += data.arrival_payments.delivery.sum),
                (self.booking.delivery_end += data.arrival_payments.delivery_end.sum),
                (self.booking.hours_cost_end += data.arrival_payments.additional_hours.sum),
                (self.booking.mileage_cost += data.arrival_payments.mileage.sum),
                (self.booking.clean_payment += data.arrival_payments.clean.sum),
                (self.booking.gas = data.arrival_payments.gas.sum),
                (self.booking.fine += data.arrival_payments.fine.sum),
                (self.booking.damage = data.arrival_payments.damage.sum),
                (self.booking.insurance += data.arrival_payments.insurance.sum),
                (self.booking.add_drivers_cost += data.arrival_payments.add_drivers_cost.sum),
                (self.booking.other_end = data.arrival_payments.other.sum),
                (self.booking.end_worker_id = self.$store.getters.getCurrentUser.id),
                (self.booking.end_mileage = data.booking.end_mileage),
                (self.booking.booking_mileage = data.booking.start_mileage > 0 && data.booking.end_mileage > 0 ? data.booking.end_mileage - data.booking.start_mileage : 0);
              self.booking.responsible = null;
              self.booking.state = "Отъездила";
              self.showArrivalPayments = false;
              self.showProblems = false;
              self.dont_send_review_reminder = false;
              self.showPartRejection = false;
              self.showCleanPaid = false;
              self.giveFullDeposit = true;
              self.showArrivalDialog = false;
              self.selected_add_services = [];
              // Вставляем счета в существующую бронь
              self.booking.counts = self.booking.counts.concat(all_counts);
            })
            .catch((error) => {
              if (error.response?.status == 406) {
                self.$notify(self.$t("errors.return_car"), self.$t("errors.booking_was_accepted"), "warning", 5000);
              } else if (error.response?.status == 422) {
                // Отказ с причиной — напр. exchange_rate_missing (курс к валюте кассы не задан):
                // setError переводит его по коду. Передавать надо саму ошибку axios, а не
                // data.error — структурный { code, message } иначе стал бы «[object Object]».
                self.setError(error, self.$t("errors.return_car"));
              } else if (error.response?.status == 404) {
                self.setError(error.response?.data && error.response?.data.error ? error.response?.data.error : self.$t("errors.error"), '');
              } else {
                self.setError(error.response?.data && error.response?.data.error ? error.response?.data.error : self.$t("errors.error"), '');
              }
            })
            .finally(() => (self.isLoadingInHome = false));
        }

        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
          // Проверяем если в self.arrival_payments есть платеж наличными
          let arrival_payments_keys = Object.keys(data.arrival_payments);
          let cash_payments = arrival_payments_keys.filter((key) => data.arrival_payments[key].type == "Наличные");
          if (cash_payments && cash_payments.length > 0) {
            // проверяем что у пользователя есть выбранный счёт
            let worker_accounts_cashboxes_ids = this.worker_accounts.map(
              (account) => account.company_cashbox_id
            );
            // получаем все company_cashbox_id из наличных платежей
            let cash_payments_cashbox_ids = cash_payments.map((key) => data.arrival_payments[key].company_cashbox_id);
            // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
            let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
              worker_accounts_cashboxes_ids.includes(cashbox_id)
            );
            // проверяем что у пользователя есть выбранный счёт
            if (worker_accounts_cashboxes_ids.length > 0 && has_matching_cashbox) {
              console.log("exists currency_account")
            } else if (worker_accounts_cashboxes_ids.length > 0 && !has_matching_cashbox) {
              console.log("not exists company_cashbox, check currency in worker_cashboxes")
              // проверяем есть ли в кассах пользователя касса с такой валютой
              let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
              let cash_payments_currency_ids = cash_payments.map((key) => data.arrival_payments[key].currency_id);
              let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
                worker_cashboxes_currency_ids.includes(cashbox_id)
              );
              if (has_matching_worker_cashbox_currency) {
                console.log("exists worker_cashbox_currency, select first on server")
              } else {
                console.log("not exists worker_cashbox_currency")
                this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "warning", 5000);
                return;
              }
            } else {
              console.log("currency_account selected")
            }
          }
        }

        let giveNullDepositCustom = false;
        if ((data.giveNullDeposit || data.arrival_payments.deposit.sum == 0) && !this.hasDepositHold) {
          const confirmedDeposit = await this.$confirm({
            title: this.$t("bookings.return_deposit_title"),
            text: this.$t("bookings.return_deposit_zero"),
            icon: "mdi-alert-outline",
            iconColor: "warning",
            iconSize: 72,
            iconPosition: "top",
            confirmButtonText: this.$t("custom.yes"),
            confirmButtonColor: "primary",
            cancelButtonText: this.$t("custom.no"),
            cancelButtonColor: "grey darken-1",
            useFilledButtons: true,
            maxWidth: 450,
          });
          
          if (confirmedDeposit) {
            giveNullDepositCustom = true;
            if (data.booking.end_mileage == 0) {
              const confirmedMileageZero = await this.$confirm({
                title: this.$t("bookings.return_mileage_title"),
                text: this.$t("bookings.return_mileage_no"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmedMileageZero) {
                processArrival(giveNullDepositCustom, data);
              } else {
                self.isLoadingInHome = false;
              }
            } else if (data.booking.start_mileage > data.booking.end_mileage) {
              const confirmedMileageBad = await this.$confirm({
                title: this.$t("bookings.mileage_bad_title"),
                text: this.$t("bookings.mileage_bad_text"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmedMileageBad) {
                processArrival(giveNullDepositCustom, data);
              } else {
                self.isLoadingInHome = false;
              }
            } else if (
              (data.booking.end_mileage - data.booking.start_mileage) /
              (data.booking.days > 0 ? data.booking.days : 1) >
              300
            ) {
              const confirmedMileageBig = await this.$confirm({
                title: this.$t("bookings.mileage_bad_big"),
                text: this.$t("bookings.mileage_bad_text"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmedMileageBig) {
                processArrival(giveNullDepositCustom, data);
              } else {
                self.isLoadingInHome = false;
              }
            } else {
              processArrival(giveNullDepositCustom, data);
            }
          } else {
            // Пользователь отказался от возврата залога
            self.isLoadingInHome = false;
          }
        } else {
          if (
            (data.arrival_payments.clean.sum != 0 &&
              data.arrival_payments.clean.type) ||
            (data.arrival_payments.delivery.sum != 0 &&
              data.arrival_payments.delivery.type) ||
            (data.arrival_payments.delivery_end.sum != 0 &&
              data.arrival_payments.delivery_end.type) ||
            (data.arrival_payments.additional_hours.sum != 0 &&
              data.arrival_payments.additional_hours.type) ||
            (data.arrival_payments.rent.sum != 0 &&
              data.arrival_payments.rent.type) ||
            (data.arrival_payments.gas.sum != 0 &&
              data.arrival_payments.gas.type) ||
            (data.arrival_payments.equipment.sum != 0 &&
              data.arrival_payments.equipment.type) ||
            (data.arrival_payments.insurance.sum != 0 &&
              data.arrival_payments.insurance.type) ||
            (data.arrival_payments.fine.sum != 0 &&
              data.arrival_payments.fine.type) ||
            (data.arrival_payments.damage.sum != 0 &&
              data.arrival_payments.damage.type) ||
            (data.arrival_payments.other.sum != 0 &&
              data.arrival_payments.other.type) ||
            (!data.giveNullDeposit && data.arrival_payments.deposit.sum != 0 &&
              data.arrival_payments.deposit.type)
          ) {
            if (data.booking.end_mileage == 0) {
              const confirmedZero = await this.$confirm({
                title: this.$t("bookings.return_mileage_title"),
                text: this.$t("bookings.mileage_bad_zero"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmedZero) {
                processArrival(giveNullDepositCustom, data);
              } else {
                self.isLoadingInHome = false;
              }
            } else if (data.booking.start_mileage > data.booking.end_mileage) {
              const confirmedBad = await this.$confirm({
                title: this.$t("bookings.return_mileage_title"),
                text: this.$t("bookings.mileage_bad_text"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmedBad) {
                processArrival(giveNullDepositCustom, data);
              } else {
                self.isLoadingInHome = false;
              }
            } else if (
              (data.booking.end_mileage - data.booking.start_mileage) /
              (data.booking.days > 0 ? data.booking.days : 1) >
              300
            ) {
              const confirmedBig = await this.$confirm({
                title: this.$t("bookings.mileage_bad_big"),
                text: this.$t("bookings.mileage_bad_text"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmedBig) {
                processArrival(giveNullDepositCustom, data);
              } else {
                self.isLoadingInHome = false;
              }
            } else {
              processArrival(giveNullDepositCustom, data);
            }
          } else {
            // Не выбран тип платежа - сбрасываем флаг загрузки
            self.isLoadingInHome = false;
            this.$notify(this.$t("errors.money_type_title"), "", "warning", 4000)
          }
        }
        
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    resetLoadingInHome() {
      // Метод для сброса флага загрузки из дочернего компонента
      this.isLoadingInHome = false;
      console.log("isLoadingInHome reset to false");
    },
    
    // ============================================
    // ХЕЛПЕР-МЕТОДЫ ДЛЯ inHome (рефакторинг)
    // Документация: docs/inHome-refactoring-plan.md
    // ============================================
    
    /**
     * Этап 1: Создание объекта платежа (count) для отправки на сервер
     * Заменяет повторяющийся код создания 14 типов counts
     * 
     * @param {Object} payment - объект платежа из arrival_payments (например data.arrival_payments.clean)
     * @param {String} group - название группы платежа (например "Доплата за мойку")
     * @param {String} descriptionKey - ключ перевода для описания (например "bookings.desc_clean_payment")
     * @param {Number} bookingId - ID брони
     * @param {Number} carId - ID автомобиля
     * @param {Boolean} isDeposit - флаг залога (operation: false для залога)
     * @returns {Object|null} - объект count или null если сумма = 0
     */
    buildPaymentCount(payment, group, descriptionKey, bookingId, carId, isDeposit = false) {
      if (payment.sum == 0) return null;
      
      return {
        group: group,
        car_id: carId,
        operation: !isDeposit, // false для залога, true для остальных
        description: this.$t(descriptionKey, { id: bookingId }),
        sum: payment.sum,
        cash: payment.type == "Наличные",
        cashless: payment.type == "Терминал",
        cash_card: payment.type == "На карту",
        entity: payment.type == "Р/с",
        // Пятый тип обязателен. Диалог приёмки предлагает «Баланс клиента» для каждой
        // услуги, а сервер требует хотя бы один из ПЯТИ флагов: с четырьмя false он
        // уходит в ветку отказа и возвращает 422 с ПУСТЫМ телом, откатывая всю приёмку.
        // Оператор видел отказ без причины и без единого созданного платежа
        // (найдено ревью 28.08.2026, воспроизведено прогоном).
        client_balance: payment.type == "Баланс клиента",
        booking_id: bookingId,
        company_cashbox_id: payment.company_cashbox_id,
        currency_id: payment.currency_id,
      };
    },
    
    /**
     * Этап 2: Создание всех counts для платежей при возврате
     * Заменяет ~300 строк повторяющегося кода
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Object} - объект с отдельными counts и массивом all
     */
    buildAllCounts(data) {
      const bookingId = data.booking.id;
      const carId = data.booking.car_id;
      const p = data.arrival_payments;
      
      // Конфигурация всех типов платежей
      const countsConfig = [
        { key: 'clean', payment: p.clean, group: "Доплата за мойку", desc: "bookings.desc_clean_payment" },
        { key: 'delivery', payment: p.delivery, group: "Доплата за доставку", desc: "bookings.desc_delivery_payment" },
        { key: 'delivery_end', payment: p.delivery_end, group: "Доплата за приём", desc: "bookings.desc_checkout_payment" },
        { key: 'additional_hours', payment: p.additional_hours, group: "Доплата за дополнительное время", desc: "bookings.desc_addhours_payment" },
        { key: 'mileage', payment: p.mileage, group: "Доплата за превышение пробега", desc: "bookings.desc_mileage_payment" },
        { key: 'rent', payment: p.rent, group: "Оплата аренды", desc: "bookings.desc_rent_checkout_payment" },
        { key: 'gas', payment: p.gas, group: "Доплата за топливо", desc: "bookings.desc_gas_checkout_payment" },
        { key: 'equipment', payment: p.equipment, group: "Доплата за оборудование", desc: "bookings.desc_equipment_checkout_payment" },
        { key: 'addons', payment: p.addons, group: "Доплата за оборудование", desc: "bookings.desc_equipment_checkout_payment" }, // FT-102: каталожное оборудование — та же статья учёта
        { key: 'insurance', payment: p.insurance, group: "Доплата за страховку", desc: "bookings.desc_insuranse_checkout_payment" },
        { key: 'add_drivers_cost', payment: p.add_drivers_cost, group: "Доплата за доп водителей", desc: "bookings.desc_drivers_checkout_payment" },
        { key: 'fine', payment: p.fine, group: "Доплата за штрафы", desc: "bookings.desc_fines_checkout_payment" },
        { key: 'damage', payment: p.damage, group: "Доплата за повреждения", desc: "bookings.desc_damages_checkout_payment" },
        { key: 'other', payment: p.other, group: "Доплата за другое", desc: "bookings.desc_other_checkout_payment" },
      ];
      
      // Создаём объект с отдельными counts (для совместимости с API)
      const counts = {};
      countsConfig.forEach(c => {
        counts[c.key] = this.buildPaymentCount(c.payment, c.group, c.desc, bookingId, carId, false);
      });
      
      // Залог - особый случай (operation: false, только если не giveNullDeposit)
      counts.deposit = null;
      if (!data.giveNullDeposit && p.deposit.sum != 0) {
        counts.deposit = this.buildPaymentCount(p.deposit, "Залог", "bookings.desc_other_checkout_payment", bookingId, carId, true);
      }
      
      // Собираем массив всех ненулевых counts для добавления в бронь
      counts.all = Object.keys(counts)
        .filter(key => key !== 'all' && counts[key] !== null)
        .map(key => counts[key]);
      
      return counts;
    },
    
    /**
     * Этап 3: Подсчёт изменений в кассах по типам платежей
     * Заменяет ~200 строк повторяющегося кода
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Object} - { cash, cashless, cash_card, entity }
     */
    calcKassChanges(data) {
      const payments = data.arrival_payments;
      const paymentTypes = [
        'rent', 'clean', 'delivery', 'delivery_end', 'additional_hours',
        'mileage', 'insurance', 'add_drivers_cost', 'gas', 'equipment',
        'addons', 'fine', 'damage', 'other'
      ];
      
      let cash = 0;
      let cashless = 0;
      let cash_card = 0;
      let entity = 0;
      
      // Обнуляем залог если нужно
      if (data.giveNullDeposit) {
        payments.deposit.sum = 0;
      }
      
      // Суммируем по типам платежей
      paymentTypes.forEach(type => {
        const payment = payments[type];
        if (payment.type == "Наличные") cash += payment.sum;
        if (payment.type == "Терминал") cashless += payment.sum;
        if (payment.type == "На карту") cash_card += payment.sum;
        if (payment.type == "Р/с") entity += payment.sum;
      });
      
      // Залог вычитается (возврат денег клиенту)
      const deposit = payments.deposit;
      if (deposit.type == "Наличные") cash -= deposit.sum;
      if (deposit.type == "Терминал") cashless -= deposit.sum;
      if (deposit.type == "На карту") cash_card -= deposit.sum;
      if (deposit.type == "Р/с") entity -= deposit.sum;
      
      return { cash, cashless, cash_card, entity };
    },
    
    /**
     * Этап 4.1: Формирование booking_data для отправки на сервер
     * Заменяет ~65 строк inline кода
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Object} - booking_data для API
     */
    buildBookingData(data) {
      const booking = data.booking;
      const payments = data.arrival_payments;
      
      const bookingData = {
        end_date: booking.end_date,
        clean_end: booking.clean_end,
        gas_end_full: booking.gas_end_full,
        gas_end: booking.gas_end,
        in_rent: false,
        active: false,
        ride: true,
        accepted: true,
        delivery: (booking.delivery > 0 ? booking.delivery : 0) + payments.delivery.sum,
        delivery_end: (booking.delivery_end > 0 ? booking.delivery_end : 0) + payments.delivery_end.sum,
        hours_cost_end: payments.additional_hours.sum,
        mileage_cost: (booking.mileage > 0 ? booking.mileage : 0) + payments.mileage.sum,
        clean_payment: (booking.clean_payment > 0 ? booking.clean_payment : 0) + payments.clean.sum,
        gas: (booking.gas > 0 ? booking.gas : 0) + payments.gas.sum,
        fine: (booking.fine > 0 ? booking.fine : 0) + payments.fine.sum,
        damage: (booking.damage > 0 ? booking.damage : 0) + payments.damage.sum,
        insurance: (booking.insurance > 0 ? booking.insurance : 0) + payments.insurance.sum,
        add_drivers_cost: (booking.add_drivers_cost > 0 ? booking.add_drivers_cost : 0) + payments.add_drivers_cost.sum,
        other_end: payments.other.sum,
        end_worker_id: this.$store.getters.getCurrentUser.id,
        end_mileage: booking.end_mileage,
        booking_mileage: (booking.start_mileage > 0 && booking.end_mileage > 0)
          ? booking.end_mileage - booking.start_mileage
          : 0,
        responsible: null,
        part_return_deposit: data.partReturnDeposit,
      };
      
      // Добавляем URL изображения повреждений
      if (booking.checkout_damage_image_url) {
        bookingData.checkout_damage_image_url = booking.checkout_damage_image_url;
      }
      
      // Добавляем повреждения
      if (booking.checkout_damages && booking.checkout_damages.length > 0) {
        bookingData.checkout_damages = booking.checkout_damages;
      }
      
      return bookingData;
    },
    
    /**
     * Этап 4.2: Формирование client_data для отправки на сервер
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Object} - client_data для API
     */
    buildClientData(data) {
      if (data.showProblems) {
        return {
          category: data.client.category,
          problems: true,
          problems_description: data.client.problems_description,
          send_review_reminder: false,
        };
      }
      
      const shouldSendReminder = !data.dont_send_review_reminder
        && data.client.category != "Серый"
        && data.client.category != "Чёрный";
      
      return {
        category: "Постоянный",
        problems: false,
        problems_description: null,
        send_review_reminder: shouldSendReminder,
      };
    },
    
    /**
     * Этап 4.3: Формирование car_data для отправки на сервер
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Object} - car_data для API
     */
    buildCarData(data) {
      const booking = data.booking;
      const car = this.set_car;
      
      let carData = {};
      
      if (booking.end_mileage > 0 && car) {
        carData = {
          mileage: booking.end_mileage,
          store_place: car.store_place,
        };
      }
      
      carData.tank_state = booking.gas_end_full;
      carData.clean_state = booking.clean_end;
      carData.technical_check = {
        technical_check_end: booking.technical_check_end,
        technical_check_end_comment: booking.technical_check_end_comment,
      };
      
      return carData;
    },
    
    /**
     * Этап 5: Проверка пробега с показом диалогов
     * Заменяет вложенные callback'и на async/await
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Promise<Boolean>} - true если можно продолжить
     */
    async checkMileageWarnings(data) {
      // FT-183: у вело-компании поля пробега нет — окна о нём не показываются.
      if (!this.showMileage) return true;
      const booking = data.booking;
      const mileagePerDay = booking.days > 0
        ? (booking.end_mileage - booking.start_mileage) / booking.days
        : 0;
      
      // Пробег = 0
      if (booking.end_mileage == 0) {
        return await this.$confirm({
          title: this.$t("bookings.return_mileage_title"),
          text: this.$t("bookings.mileage_bad_zero"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
      }
      
      // Пробег конца < пробега начала
      if (booking.start_mileage > booking.end_mileage) {
        return await this.$confirm({
          title: this.$t("bookings.mileage_bad_title"),
          text: this.$t("bookings.mileage_bad_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
      }
      
      // Пробег > 300 км/день
      if (mileagePerDay > 300) {
        return await this.$confirm({
          title: this.$t("bookings.mileage_bad_big"),
          text: this.$t("bookings.mileage_bad_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
      }
      
      // Всё ОК, диалог не нужен
      return true;
    },
    
    /**
     * Этап 6.1: Проверка мультивалютных платежей
     * Проверяет наличие кассы для наличных платежей
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Boolean} - true если проверка пройдена
     */
    validateMulticurrencyPayments(data) {
      if (!this.company.multicurrency_cashboxes) return true;
      
      const paymentKeys = Object.keys(data.arrival_payments);
      const cashPayments = paymentKeys.filter(key => data.arrival_payments[key].type == "Наличные");
      
      if (cashPayments.length === 0) return true;
      
      const workerCashboxIds = this.worker_accounts.map(a => a.company_cashbox_id);
      const cashPaymentCashboxIds = cashPayments.map(key => data.arrival_payments[key].company_cashbox_id);
      
      // Проверяем совпадение касс
      const hasMatchingCashbox = cashPaymentCashboxIds.some(id => workerCashboxIds.includes(id));
      
      if (workerCashboxIds.length > 0 && hasMatchingCashbox) {
        console.log("exists currency_account");
        return true;
      }
      
      if (workerCashboxIds.length > 0 && !hasMatchingCashbox) {
        // Проверяем валюты
        const workerCurrencyIds = this.worker_accounts.map(a => a.currency_id);
        const cashPaymentCurrencyIds = cashPayments.map(key => data.arrival_payments[key].currency_id);
        const hasMatchingCurrency = cashPaymentCurrencyIds.some(id => workerCurrencyIds.includes(id));
        
        if (hasMatchingCurrency) {
          console.log("exists worker_cashbox_currency");
          return true;
        }
        
        console.log("not exists worker_cashbox_currency");
        this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "warning", 5000);
        return false;
      }
      
      return true;
    },
    
    /**
     * Валидация: Проверка пустых значений сумм платежей
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Boolean} - true если все значения заполнены
     */
    validateEmptyPaymentValues(data) {
      const payments = data.arrival_payments;
      const fields = [
        'mileage', 'damage', 'fine', 'insurance', 'add_drivers_cost',
        'gas', 'clean', 'rent', 'deposit', 'delivery', 'delivery_end',
        'additional_hours', 'equipment', 'other'
      ];
      
      const hasEmpty = fields.some(field => {
        // Если giveNullDeposit, то не проверяем deposit
        if (field === 'deposit' && data.giveNullDeposit) {
          return false;
        }
        return payments[field].sum === "";
      });
      
      if (hasEmpty) {
        this.$notify(this.$t("errors.empty_value_title"), this.$t("errors.empty_value_text"), "warning", 4000);
        return false;
      }
      return true;
    },
    
    /**
     * Валидация: Проверка типов платежей для ненулевых сумм
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Boolean} - true если для всех ненулевых сумм выбран тип
     */
    validatePaymentTypes(data) {
      const payments = data.arrival_payments;
      const fields = [
        'mileage', 'damage', 'fine', 'insurance', 'add_drivers_cost',
        'gas', 'clean', 'rent', 'deposit', 'delivery', 'delivery_end',
        'additional_hours', 'equipment', 'other'
      ];
      
      const hasMissingType = fields.some(field => {
        // Если giveNullDeposit, то не проверяем deposit
        if (field === 'deposit' && data.giveNullDeposit) {
          return false;
        }
        return payments[field].sum != 0 && payments[field].type == null;
      });
      
      if (hasMissingType) {
        this.$notify(this.$t("errors.empty_value_title"), this.$t("errors.empty_value_text"), "warning", 4000);
        return false;
      }
      return true;
    },
    
    /**
     * Этап 6.2: Проверка наличия платежей с выбранным типом
     * Используется для определения нужно ли показывать диалог
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Boolean} - true если есть хотя бы один платёж с типом
     */
    hasPaymentsWithType(data) {
      const payments = data.arrival_payments;
      const types = [
        'clean', 'delivery', 'delivery_end', 'additional_hours', 'rent',
        'gas', 'equipment', 'insurance', 'fine', 'damage', 'other', 'deposit'
      ];
      
      return types.some(type => {
        // Если giveNullDeposit, то не учитываем deposit
        if (type === 'deposit' && data.giveNullDeposit) {
          return false;
        }
        return payments[type].sum != 0 && payments[type].type;
      });
    },
    
    /**
     * Этап 7.1: Отправка данных на сервер
     * Использует новые хелпер-методы для построения данных
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @param {Object} counts - объект counts из buildAllCounts
     * @returns {Promise} - промис запроса
     */
    async sendArrivalToServer(data, counts) {
      const kassChanges = this.calcKassChanges(data);
      
      let companyCashless = null;
      let companyCash = null;
      let workersCashbox = null;
      
      if (kassChanges.cashless != 0 || kassChanges.entity != 0) {
        companyCashless = kassChanges.cashless + kassChanges.entity;
      }
      
      if (kassChanges.cash_card != 0) {
        companyCash = kassChanges.cash_card;
      }
      
      if (kassChanges.cash != 0) {
        workersCashbox = {
          workers_id: this.$store.getters.currentUserId,
          cash: kassChanges.cash,
        };
      }
      
      return this.axios.post(
        "/api/v1/in_home",
        {
          client_id: data.booking.client_id,
          booking_id: data.booking.id,
          car_id: data.booking.car_id,
          booking_data: this.buildBookingData(data),
          client_data: this.buildClientData(data),
          car_data: this.buildCarData(data),
          clean_count: counts.clean,
          delivery_count: counts.delivery,
          delivery_end_count: counts.delivery_end,
          additional_hours_count: counts.additional_hours,
          mileage_count: counts.mileage,
          rent_count: counts.rent,
          gas_count: counts.gas,
          equipment_count: counts.equipment,
          insurance_count: counts.insurance,
          add_drivers_cost_count: counts.add_drivers_cost,
          fine_count: counts.fine,
          damage_count: counts.damage,
          other_count: counts.other,
          deposit_count: data.depositHold ? null : counts.deposit,
          deposit_hold: data.depositHold || undefined,
          deposit_payment: null,
          company_cashless: companyCashless,
          company_cash: companyCash,
          workers_cashbox: workersCashbox,
          company_cashbox_id: data.company_cashbox_id,
          worker_account_id: data.worker_account_id,
          checkout_damages: data.booking.checkout_damages || [],
        },
        {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        }
      );
    },
    
    /**
     * Этап 7.2: Обновление booking на фронтенде после успешного возврата
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @param {Object} counts - объект counts с массивом all
     */
    updateBookingAfterArrival(data, counts) {
      const payments = data.arrival_payments;
      
      this.booking.end_date = data.booking.end_date;
      this.booking.clean_end = data.booking.clean_end;
      this.booking.gas_start = data.booking.gas_start;
      this.booking.gas_end_full = data.booking.gas_end_full;
      this.booking.gas_end = data.booking.gas_end;
      this.booking.in_rent = false;
      this.booking.active = false;
      this.booking.ride = true;
      this.booking.accepted = true;
      this.booking.delivery += payments.delivery.sum;
      this.booking.delivery_end += payments.delivery_end.sum;
      this.booking.hours_cost_end += payments.additional_hours.sum;
      this.booking.mileage_cost += payments.mileage.sum;
      this.booking.clean_payment += payments.clean.sum;
      this.booking.gas = payments.gas.sum;
      this.booking.fine += payments.fine.sum;
      this.booking.damage = payments.damage.sum;
      this.booking.insurance += payments.insurance.sum;
      this.booking.add_drivers_cost += payments.add_drivers_cost.sum;
      this.booking.other_end = payments.other.sum;
      this.booking.end_worker_id = this.$store.getters.getCurrentUser.id;
      this.booking.end_mileage = data.booking.end_mileage;
      this.booking.booking_mileage = data.booking.start_mileage > 0 && data.booking.end_mileage > 0
        ? data.booking.end_mileage - data.booking.start_mileage
        : 0;
      this.booking.responsible = null;
      this.booking.state = "Отъездила";
      
      // Сбрасываем UI состояния
      this.showArrivalPayments = false;
      this.showProblems = false;
      this.dont_send_review_reminder = false;
      this.showPartRejection = false;
      this.showCleanPaid = false;
      this.giveFullDeposit = true;
      this.showArrivalDialog = false;
      this.selected_add_services = [];
      
      // Добавляем counts в бронь
      this.booking.counts = this.booking.counts.concat(counts.all);
    },
    
    /**
     * Этап 8: Основной метод обработки возврата автомобиля
     * Использует все хелпер-методы для чистой структуры
     * 
     * @param {Boolean} giveNullDeposit - не возвращать залог
     * @param {Object} data - данные из ArrivalDialog
     */
    async processArrivalRefactored(giveNullDeposit, data) {
      console.log('processArrivalRefactored: started, giveNullDeposit:', giveNullDeposit);
      
      try {
        // 1. Загрузка фото повреждений (callback из ArrivalDialog)
        if (data.uploadDamageImageCallback) {
          console.log('Uploading damage image...');
          const imageUrl = await data.uploadDamageImageCallback();
          if (imageUrl) {
            data.booking.checkout_damage_image_url = imageUrl;
            console.log('Damage image uploaded:', imageUrl);
          }
        }
        
        // 2. Обновляем флаг залога в data
        data.giveNullDeposit = giveNullDeposit;
        
        // 3. Формируем все counts
        const counts = this.buildAllCounts(data);
        console.log('Counts built:', counts.all.length, 'items');
        
        // 4. Отправляем на сервер
        await this.sendArrivalToServer(data, counts);
        console.log('Server request successful');
        
        // 5. Обновляем UI
        this.updateBookingAfterArrival(data, counts);
        console.log('UI updated');

        // 6. Машина принята, диалог закрыт — «победный» момент для нативного
        // запроса оценки в сторе. Сервис сам проверяет платформу/роль/возраст
        // компании/частоту, ждёт 1.5 с и никогда не бросает.
        requestReviewAfterSuccess(this.$store);

      } catch (error) {
        console.error('Error in processArrivalRefactored:', error);

        // FT-173 D2 (REQ-25, NEG-13): приёмка бронирования действующего
        // договора — сервер отвечает 422 managed_by_contract. Текст модуля и
        // перечитывание карточки, как у editSave (REQ-13), а не сырой код.
        const rentToOwnError = parseRentToOwnError(error);
        if (rentToOwnError && rentToOwnError.code === "managed_by_contract") {
          this.$notify(this.$t("errors.return_car"), this.$t(rentToOwnError.i18nKey), "warning", 6000);
          this.getBooking();
        } else if (error.response?.status == 406) {
          this.$notify(
            this.$t("errors.return_car"),
            this.$t("errors.booking_was_accepted"),
            "warning",
            5000
          );
        } else if (error.response?.status == 422) {
          // Отказ с причиной — напр. exchange_rate_missing: setError переводит его по коду.
          // Сама ошибка axios, а не data.error: объект { code, message } стал бы «[object Object]».
          this.setError(error, this.$t("errors.return_car"));
        } else {
          this.setError(
            error.response?.data?.error || this.$t("errors.error"),
            ''
          );
        }
        throw error;
      } finally {
        this.isLoadingInHome = false;
      }
    },
    
    /**
     * Вспомогательные методы для сценариев возврата
     */
    async handleZeroDepositFlow(data) {
      const confirmed = await this.$confirm({
        title: this.$t("bookings.return_deposit_title"),
        text: this.$t("bookings.return_deposit_zero"),
        icon: "mdi-cash-refund",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: this.$t("custom.yes"),
        confirmButtonColor: "primary",
        cancelButtonText: this.$t("custom.no"),
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 450,
      });
      
      if (!confirmed) {
        this.isLoadingInHome = false;
        return;
      }
      
      const canProceed = await this.checkMileageWarnings(data);
      if (canProceed) {
        await this.processArrivalRefactored(true, data);
      } else {
        this.isLoadingInHome = false;
      }
    },
    
    async handlePaymentsFlow(data) {
      const canProceed = await this.checkMileageWarnings(data);
      if (canProceed) {
        await this.processArrivalRefactored(false, data);
      } else {
        this.isLoadingInHome = false;
      }
    },
    
    /**
     * Проверка даты окончания бронирования
     * Показывает предупреждение если дата раньше или позже текущей
     * 
     * @param {Object} data - данные из ArrivalDialog
     * @returns {Promise<Boolean>} - true если можно продолжить
     */
    async checkEndDateEarly(data) {
      const endDate = this.booking.end_date_formatted;
      
      // Проверяем если дата раньше сегодня ИЛИ позже чем завтра
      if (endDate && (
        moment(endDate).isBefore(moment(), 'days') || 
        moment(endDate).isAfter(moment().add(1, 'days'), 'days')
      )) {
        return await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.end_date_early"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
      }
      
      // Дата в норме - продолжаем
      return true;
    },
    
    /**
     * Этап 9: НОВЫЙ РЕФАКТОРЁННЫЙ МЕТОД inHome
     * Использует все хелперы для чистой и понятной структуры
     * 
     * ВАЖНО: Старый метод inHome() остаётся без изменений как fallback
     * Чтобы использовать новый метод:
     * 1. В ArrivalDialog.vue измените @in-home="inHome" на @in-home="inHomeRefactored"
     * 2. Протестируйте полный flow возврата
     * 3. После успешного тестирования можно удалить старый inHome
     * 
     * @param {Object} data - данные из ArrivalDialog
     */
    async inHomeRefactored(data) {
      console.log('inHomeRefactored: started');
      
      // 1. Защита от двойного вызова (race condition)
      if (this.isLoadingInHome) {
        console.warn("inHomeRefactored: already running, skipping");
        return;
      }
      
      // 2. Проверка доступа
      // Выровнено с activeRent (выдача): выдать и принять машину — операции
      // сотрудника. Прежний денилист через == пускал агента, и роль могла
      // завершить аренду, которую не может начать.
      if (!this.isStaff) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      
      // 3. Устанавливаем флаг загрузки СРАЗУ после проверки доступа
      // Это важно для сброса isProcessingLocal в ArrivalDialog через watch
      this.isLoadingInHome = true;
      console.log('inHomeRefactored: isLoadingInHome set to true');
      
      try {
        // 4. Валидация пустых значений платежей
        if (!this.validateEmptyPaymentValues(data)) {
          console.log('inHomeRefactored: empty payment values');
          this.isLoadingInHome = false;
          return;
        }
        
        // 5. Валидация типов платежей (для ненулевых сумм должен быть выбран тип)
        if (!this.validatePaymentTypes(data)) {
          console.log('inHomeRefactored: missing payment types');
          this.isLoadingInHome = false;
          return;
        }
        
        // 6. Подготовка данных залога
        if (this.hasDepositHold) {
          data.giveNullDeposit = true;
        }
        if (data.giveNullDeposit) {
          data.arrival_payments.deposit.sum = 0;
        }
        
        // 7. Проверка даты окончания бронирования
        // 7.0. Пустая/битая дата возврата (v-calendar deselect пишет "" в
        // booking.end_date) — сервер отверг бы её валидацией end_date без
        // внятного сообщения (HB-поток «End date не может быть пустым»)
        if (!isArrivalEndDateValid(data.booking.end_date)) {
          this.$notify(this.$t("errors.incorrect_date_title"), this.$t("errors.select_dates"), "warning", 5000);
          this.isLoadingInHome = false;
          return;
        }
        const dateConfirmed = await this.checkEndDateEarly(data);
        if (!dateConfirmed) {
          console.log('inHomeRefactored: end date check cancelled');
          this.isLoadingInHome = false;
          return;
        }
        
        // 8. Проверка мультивалютных платежей
        if (!this.validateMulticurrencyPayments(data)) {
          console.log('inHomeRefactored: multicurrency validation failed');
          this.isLoadingInHome = false;
          return;
        }
        
        // 9. Определяем сценарий: залог = 0 или есть платежи
        const isZeroDeposit = (data.giveNullDeposit || data.arrival_payments.deposit.sum == 0)
          && !this.hasDepositHold;
        
        console.log('inHomeRefactored: isZeroDeposit:', isZeroDeposit);
        
        if (isZeroDeposit) {
          // Показываем диалог подтверждения нулевого залога
          await this.handleZeroDepositFlow(data);
        } else {
          // Есть платежи - проверяем пробег и выполняем
          await this.handlePaymentsFlow(data);
        }
        
      } catch (error) {
        console.error('Error in inHomeRefactored:', error);
        this.isLoadingInHome = false;
      }
    },
    
    // ============================================
    // КОНЕЦ ХЕЛПЕР-МЕТОДОВ ДЛЯ inHome
    // ============================================
    
    getBookingHistory() {
      let self = this;
      this.axios
        .get(`/api/v1/booking_audits/${this.booking.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.booking_audits = [];
          response.data.forEach((item, index) => {
            this.booking_audits.push({
              id: item.id,
              // FT-184 REQ-12: правка агента — комментарий аудита "mcp:<operation_id>".
              name: `${moment(item.created_at).format(
                "DD-MM-YYYY H:mm:ss"
              )} ${self.findWorker(item.user_id)}${isAgentAuditComment(item.comment) ? ` · ${self.$t("agent_marker.label")}` : ""}`,
              children: Object.keys(item.audited_changes).map(
                (item2, index) => {
                  return {
                    id: index,
                    name: `${self.$t("bookings.param")}: ${item2}, ${self.$t(
                      "bookings.was"
                    )}: ${item.audited_changes[item2][0]}, ${self.$t(
                      "bookings.became"
                    )}: ${item.audited_changes[item2][1]}`,
                  };
                }
              ),
            });
          });
          this.show_audited_dialog = true;
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.error"));
          console.log(error.response?.data);
        })
        .finally(() => (this.isLoading = false));
    },
    // Расчётная подсказка цены за единицу подарка (решение USER 2026-07-16:
    // подарок — «бесплатное продление», считать КАК ПРОДЛЕНИЕ): подсказка =
    // selected_price квоты на РАСШИРЕННОМ интервале [start, end + count] —
    // ставка ступени новой длительности, тот же паттерн и payload, что
    // ProlongDialog#requestServerPreview (полная квота, без сегментного
    // флага — как у продления). Пересчёт при смене количества (debounce
    // 350мс, seq-guard). Тип «Часы» на суточной броне (gift_type == 1):
    // ставка = booking.price_hour, локально без запроса (час фиксирован).
    requestGiftPreview() {
      if (!this.booking || !this.booking.id) return;

      const mySeq = ++this.giftPreviewSeq;
      if (this.giftPreviewTimer) clearTimeout(this.giftPreviewTimer);

      const isHourGift = !this.booking.hourly && !this.booking.weekly && !this.booking.monthly &&
        Number(this.gift.gift_type) === 1;
      if (isHourGift) {
        const unitPrice = Number(this.booking.price_hour);
        if (!Number.isFinite(unitPrice)) {
          this.giftPreviewStatus = "error";
          return;
        }
        this.giftPreviewStatus = "ready";
        this.giftPreviewUnitPrice = unitPrice.toFixed(2);
        return;
      }

      const count = Number(this.gift.count);
      if (!Number.isFinite(count) || count <= 0) {
        this.giftPreviewStatus = "idle";
        return;
      }
      const unitName = this.booking.hourly ? "hours" : this.booking.weekly ? "weeks" : this.booking.monthly ? "months" : "days";
      const extendedEnd = moment(this.booking.end_date, "DD-MM-YYYY H:mm").add(count, unitName);

      this.giftPreviewStatus = "loading";
      this.giftPreviewTimer = setTimeout(() => {
        const headers = { Authorization: this.$store.getters.getAuthToken };
        this.axios.post("/api/v1/price_quotes", {
          car_id: this.booking.car_id,
          booking_id: this.booking.id,
          rental_type: this.currentRentalType(),
          price_source: this.booking.apply_current_prices ? "current" : "stored",
          sale: this.booking.sale || 0,
          sale_cash: this.booking.sale_cash || 0,
          rental_cost_sale: this.booking.rental_cost_sale || 0,
          rental_cost_sale_cash: this.booking.rental_cost_sale_cash || 0,
          price_hour: this.booking.price_hour,
          start_at: this.booking.start_date,
          end_at: extendedEnd.format("DD-MM-YYYY HH:mm"),
          // FT-216 REQ-04: поправки на даты — по типу платежей брони, как в основной квоте
          ...(this.booking.payments_type ? { payments_type: this.booking.payments_type } : {}),
        }, { headers })
          .then((response) => {
            if (mySeq !== this.giftPreviewSeq) return; // stale — молча игнорируем
            const unitPrice = Number(response.data.totals.selected_price);
            if (!Number.isFinite(unitPrice)) {
              this.giftPreviewStatus = "error";
              return;
            }
            this.giftPreviewStatus = "ready";
            this.giftPreviewUnitPrice = unitPrice.toFixed(2);
          })
          .catch(() => {
            if (mySeq !== this.giftPreviewSeq) return;
            this.giftPreviewStatus = "error";
          });
      }, 350);
    },
    applyGiftPreviewPrice() {
      if (this.giftPreviewUnitPrice != null) {
        this.gift.price = Number(this.giftPreviewUnitPrice);
      }
    },
    saveGift() {
      if (this.isStaff) {
        this.axios
          .post(
            `/api/v1/bookings/${this.booking.id}/gifts`,
            {
              gifts: {
                gift_type: this.gift.gift_type,
                price: this.gift.price,
                count: this.gift.count,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            if (this.gift.gift_type == 0) {
              this.booking.rental_cost = parseFloat((
                this.booking.rental_cost - this.gift.price * this.gift.count
              ).toFixed(2));
            }
            if (this.gift.gift_type == 1) {
              this.booking.hours_cost = parseFloat((
                this.booking.hours_cost - this.gift.price * this.gift.count
              ).toFixed(2));
            }
            // FT-084 STEP-12 fix round 1 (C2): this.gifts must be updated
            // BEFORE editSave() — editSave()'s payload is built from
            // currentGiftsPayload() (which reads this.gifts). Calling
            // editSave() first sent the PATCH without the just-created gift,
            // so the server recomputed as if it didn't exist yet.
            this.gifts.unshift(response.data);
            this.editSave();
            this.show_gifts_dialog = false;
            this.gift = { gift_type: 0, price: 0, count: 1 };
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.gifts_load"));
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async deleteGift(gift) {
      if (this.isStaff) {
        let self = this;
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("gifts.delete_warn"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          this.axios
            .delete(`/api/v1/bookings/${self.booking.id}/gifts/${gift.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              // FT-084 STEP-12 fix round 1 (C2): was
              // `self.gifts.indexOf((item) => item.id == gift.id)` —
              // Array#indexOf does NOT take a predicate (that's findIndex),
              // so this always evaluated to -1 and `.splice(-1, 1)` silently
              // removed the LAST gift in the array instead of the deleted
              // one. Also moved before editSave() (same reasoning as
              // saveGift(), C2): editSave()'s payload reads this.gifts.
              let index = self.gifts.findIndex((item) => item.id == gift.id);
              if (index !== -1) this.gifts.splice(index, 1);
              // непонятно почему, но не работает
              // if (
              //   !(this.booking.sale || this.booking.sale_cash) &&
              //   gift.gift_type == 0
              // ) {
              //   this.booking.rental_cost = Math.trunc(
              //     this.booking.rental_cost + gift.price * gift.count
              //   );
              // }
              if (gift.gift_type == 0) {
                this.booking.rental_cost = parseFloat((
                  this.booking.rental_cost + gift.price * gift.count
                ).toFixed(2));
              }
              if (gift.gift_type == 1) {
                this.booking.hours_cost = parseFloat((
                  this.booking.hours_cost + gift.price * gift.count
                ).toFixed(2));
              }
              this.editSave();

              this.$notify(this.$t("custom.deleted"), "", "success", 3000)
            })
            .catch((error) => this.setError(error, this.$t("errors.error")))
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    clearSign() {
      this.$refs.signaturePad.clearSignature();
    },
    undoSign() {
      this.$refs.signaturePad.undoSignature();
    },
    saveSign() {
      if (this.isStaff) {
        let self = this;
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

        if (!isEmpty) {
          this.axios
            .post(
              `/api/v1/signature`,
              {
                signature: {
                  sign: data,
                  booking_id: this.booking.id,
                  signature_type: this.signature_type,
                  client_id: null,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.booking.sign_id = response.data;
            })
            .catch((error) => {
              self.setError(error, self.$t("errors.sign"));
            })
            .finally(() => {
              this.clearSign();
              this.showSignPad = false;
              this.isLoading = false;
              this.$notify(this.$t("bookings.success_sign"), "", "success", 3000)
            });
        } else {
          this.$notify(this.$t("errors.sign"), this.$t("errors.sign_empty"), "error", 3000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    handleDocumentCreated(document) {
      if (!this.booking.generated_documents) {
        this.booking.generated_documents = [];
      }
      this.booking.generated_documents.unshift(document);
    },

    handleDocumentDeleted(documentId) {
      if (!this.booking.generated_documents) {
        this.booking.generated_documents = [];
        return;
      }
      let index = this.booking.generated_documents.findIndex(doc => doc.id == documentId);
      if (index !== -1) {
        this.booking.generated_documents.splice(index, 1);
      }
    },

    handleContractSent(data) {
      // Добавляем новый документ OkiDoki в отдельное реактивное свойство
      if (data.document) {
        if (!this.booking.generated_documents) {
          this.booking.generated_documents = [];
        }
        if (!this.generated_documents) {
          this.generated_documents = [];
        }
        this.booking.generated_documents.unshift(data.document);
        this.generated_documents.unshift(data.document);
      }
      // Показываем уведомление
      this.$notify(this.$t('okidoki.send_success'), this.$t('okidoki.send_info'), 'success', 5000)
      // Обновляем список документов
      this.getBooking();
    },

    // Методы для отображения статусов OkiDoki
    getOkidokiStatusColor(status) {
      const statusMap = {
        'draft': 'grey',
        'Черновик': 'grey',
        'awaiting': 'orange',
        'Выставлен': 'orange',
        'signed': 'green',
        'Подписан': 'green',
        'rejected': 'red',
        'Отклонен': 'red',
        'cancelled': 'grey darken-2',
        'Аннулирован': 'grey darken-2'
      };
      const color = statusMap[status] || 'blue'
      return color
    },

    getOkidokiStatusIcon(status) {
      const iconMap = {
        'draft': 'mdi-file-edit',
        'Черновик': 'mdi-file-edit',
        'awaiting': 'mdi-clock-outline',
        'Выставлен': 'mdi-clock-outline',
        'signed': 'mdi-check-circle',
        'Подписан': 'mdi-check-circle',
        'rejected': 'mdi-close-circle',
        'Отклонен': 'mdi-close-circle',
        'cancelled': 'mdi-cancel',
        'Аннулирован': 'mdi-cancel'
      };
      return iconMap[status] || 'mdi-file-document';
    },

    getOkidokiStatusText(status) {
      const textMap = {
        'draft': this.$t('okidoki.status_draft'),
        'Черновик': this.$t('okidoki.status_draft'),
        'awaiting': this.$t('okidoki.status_awaiting'),
        'Выставлен': this.$t('okidoki.status_awaiting'),
        'signed': this.$t('okidoki.status_signed'),
        'Подписан': this.$t('okidoki.status_signed'),
        'rejected': this.$t('okidoki.status_rejected'),
        'Отклонен': this.$t('okidoki.status_rejected'),
        'cancelled': this.$t('okidoki.status_cancelled'),
        'Аннулирован': this.$t('okidoki.status_cancelled')
      };
      return textMap[status] || status;
    },

    // Методы для DocuSeal
    handleDocusealContractSent(data) {
      if (data.document) {
        if (!this.booking.generated_documents) {
          this.booking.generated_documents = [];
        }
        if (!this.generated_documents) {
          this.generated_documents = [];
        }
        this.booking.generated_documents.unshift(data.document);
        this.generated_documents.unshift(data.document);
      }
      this.$notify(this.$t('docuseal.send_success'), this.$t('docuseal.send_info'), 'success', 5000)
      this.getBooking();
    },

    getDocusealStatusColor(status) {
      const statusMap = {
        'pending': 'orange',
        'awaiting': 'orange',
        'completed': 'green',
        'declined': 'red',
        'expired': 'grey darken-2'
      };
      return statusMap[status] || 'blue';
    },

    getDocusealStatusIcon(status) {
      const iconMap = {
        'pending': 'mdi-clock-outline',
        'awaiting': 'mdi-clock-outline',
        'completed': 'mdi-check-circle',
        'declined': 'mdi-close-circle',
        'expired': 'mdi-timer-off'
      };
      return iconMap[status] || 'mdi-file-document';
    },

    getDocusealStatusText(status) {
      const textMap = {
        'pending': this.$t('docuseal.status_pending'),
        'awaiting': this.$t('docuseal.status_awaiting'),
        'completed': this.$t('docuseal.status_completed'),
        'declined': this.$t('docuseal.status_declined'),
        'expired': this.$t('docuseal.status_expired')
      };
      return textMap[status] || status;
    },
    
    getDocusealDetailedStatusText(document) {
      // Если завершён
      if (document.docuseal_status === 'completed') {
        return this.$t('docuseal.status_completed');
      }
      
      // Если отклонён
      if (document.docuseal_status === 'declined') {
        return this.$t('docuseal.status_declined');
      }
      
      // Если истёк
      if (document.docuseal_status === 'expired') {
        return this.$t('docuseal.status_expired');
      }
      
      // Для pending и awaiting показываем общий статус
      return this.$t('docuseal.status_awaiting');
    },

    downloadSignedDocBottom(urlOrLink) {
      // Accepts either a full https URL (preferred, from document.download_url)
      // or a legacy raw S3 key (document.link) for back-compat with stale cached
      // bundles. Prefer passing document.download_url at call sites.
      if (!urlOrLink) {
        return;
      }
      const url = s3PublicUrl(urlOrLink);
      if (this.isNative) {
        if (Filesystem.checkPermissions()) {
          const getBase64FromUrl = async (fileUrl) => {
            const data = await fetch(fileUrl);
            const blob = await data.blob();
            return new Promise((resolve) => {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
              }
            });
          }
          getBase64FromUrl(url).then(
            (base64) => {
              // save file
              async function writeFile() {
                return await Filesystem.writeFile({
                  path: `${uuid.v1()}.pdf`,
                  data: base64,
                  directory: Directory.Documents,
                });
              }
              let file_uri = null
              let writedFile = writeFile().then((getUriResult) => {
                // share file opened file
                let shareFile = async () => {
                  await Share.share({
                    title: 'Download document',
                    files: [getUriResult.uri],
                  }).catch((error) => {
                    console.log("shareFile", error)
                  });
                };
                let sharedFile = shareFile();
              }).catch((error) => {
                console.log("shareFile", error)
              });
            }
          );
        } else {
          Filesystem.requestPermissions();
        }
      } else {
        saveAs(url, `${uuid.v1()}.pdf`);
      }
    },
    async deleteSignedDoc(id) {
      if (this.isAdminPlus) {
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          let self = this;
          this.isLoadingDeleteSignedDoc = true;
          this.axios
            .delete(`/api/v1/generated_documents/${id}`, {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            })
            .then(() => {
              let index = this.booking.generated_documents.indexOf(
                (template) => template.id == id
              );
              this.booking.generated_documents.splice(index, 1);
              this.$notify(this.$t("bookings.deleted_title"), this.$t("bookings.deleted_text"), "success", 3000)
            })
            .catch((error) => this.setError(error, this.$t("errors.deleted")))
            .finally(() => (this.isLoadingDeleteSignedDoc = false, this.selectedDocumentId = null));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sendSignedDocument(signed_document_id) {
      if (this.isStaff) {
        if (this.client && this.client.email) {
          this.isLoadingSendSignedDoc = true;
          this.axios
            .post(
              `/api/v1/send_signed_document`,
              {
                booking_id: this.booking.id,
                signed_document_id: signed_document_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.$notify(this.$t("bookings.letter_send_title"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.bad_email"));
              console.log(error);
            })
            .finally(() => (this.isLoadingSendSignedDoc = false, this.selectedDocumentId = null));
        } else {
          this.$notify(this.$t("errors.bad_email"), "", "error", 3000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async cancelInAgregator() {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("agregator.cancel_title"),
          text: this.$t("agregator.cancel_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          this.axios
            .post(
              `/api/v1/cancel_in_vseprokaty`,
              {
                booking_id: this.booking.id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.failure = true;
              this.booking.state = "Нет машин";
              this.$notify(this.$t("agregator.cancel_success"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("agregator.cancel_text_error"));
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async acceptInAgregator() {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("agregator.accept_title"),
          text: this.$t("agregator.accept_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          this.axios
            .post(
              `/api/v1/accept_in_vseprokaty`,
              {
                booking_id: this.booking.id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.active = true;
              this.booking.state = "Подтверждена";
              this.booking.accepted = true;
              this.booking.failure = false;
              this.$notify(this.$t("agregator.accept_success"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("agregator.accept_text_error"));
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    isValidEmail(email) {
      let reg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      if (reg.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    isValidPhone(phone) {
      let reg = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g;
      if (reg.test(phone)) {
        return true;
      } else {
        return false;
      }
    },
    async checkDepartureMileage(mileage, updatedBooking = null, uploadDamageImageCallback = null) {
      console.log('checkDepartureMileage', mileage, updatedBooking, 'has callback:', !!uploadDamageImageCallback);
      
      // Сохраняем callback для использования в activeRent
      this.checkinDamageImageCallback = uploadDamageImageCallback;
      
      // Если передан обновленный объект booking, обновляем его
      // Сделано чтобы информация обновлялась при изменении в диалоге
      if (updatedBooking) {
        Object.assign(this.booking, updatedBooking);
      }
      
      // FT-183: окно о пробеге только там, где поле пробега есть (не у вело-компании).
      if (this.showMileage && (mileage < this.check_mileage || mileage > this.check_mileage + 300)) {
        const confirmed = await this.$confirm({
          title: this.$t("bookings.bad_mileage_text"),
          text: this.$t("bookings.mileage_bad_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.departure_yes = true;
          await this.activeRent();
        } else {
          // Если пользователь отказался, сбрасываем флаг загрузки
          this.isLoadingActiveRent = false;
        }
      } else {
        this.departure_yes = true;
        await this.activeRent();
      }
    },
    archiveBooking(booking) {
      if (this.isStaff) {
        // Проверяем если бронь из агрегатора то не даем архивировать если не принято решение
        if (booking.vseprokaty_id) {
          if (!booking.active && !booking.failure && !booking.ride && !booking.decision_date) {
            this.$notify(this.$t("agregator.have_not_decision"), this.$t("agregator.have_not_decision_text"), "error", 5000)
            
            return;
          }
        }
        let self = this;
        if (booking) {
          this.isLoadingArchiveBooking = true;
          this.axios
            .patch(
              `/api/v1/bookings/${booking.id}`,
              {
                bookings: {
                  archive: true,
                  archived_date: new Date(),
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.archive = true;
              this.$notify(this.$t("bookings.archivate"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.bad_archivate"));
            })
            .finally(() => (this.isLoadingArchiveBooking = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    unarchiveBooking(booking) {
      if (this.isStaff) {
        let self = this;
        if (booking) {
          this.isLoadingUnarchiveBooking = true;
          this.axios
            .patch(
              `/api/v1/bookings/${booking.id}`,
              {
                bookings: {
                  archive: false,
                  archived_date: null,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.archive = false;
              this.$notify(this.$t("bookings.archivate_return"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.bad_unarchivate_text"));
            })
            .finally(() => (this.isLoadingUnarchiveBooking = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkEmail() {
      if (!this.client.email) {
        this.sendEmail = false;
        this.$notify(this.$t("errors.bad_email_title"), this.$t("errors.bad_email_text"), "warning", 5000)
      }
    },
    checkMessenger() {
      let company = this.$store.getters.getCompany.company;
      if (
        !(this.client.phone &&
        (company.whatsapp || company.telegram_green_api_enabled || company.max_enabled))
      ) {
        this.sendMessenger = false;
        this.$notify(this.$t("errors.bad_whatsapp_title"), this.$t("errors.bad_whatsapp_text"), "warning", 5000)
      }
    },
    checkSms() {
      if (!this.client.phone) {
        this.sendSms = false;
        this.$notify(this.$t("errors.bad_sms_title"), this.$t("errors.bad_sms_text"), "warning", 5000)
      }
    },
    updateCheckinPhotos(photos) {
      console.log("updateCheckinPhotos BookingCard", photos)
      this.newCheckinPhotos = photos
    },
    acceptBooking() {
      // Агенту оставлено: подтверждение брони клиенту — завершение того же
      // оформления, которое агент и делает. Договор и подпись — только
      // сотруднику (решение USER 12.08.2026), они закрыты отдельно.
      if (this.isStaff || this.isAgent) {
        if (this.client && (this.client.email || this.client.phone)) {
          this.isLoadingAcceptBooking = true;
          let self = this;
          this.axios
            .get(
              `/api/v1/accept_booking/${this.booking.id}?email=${this.sendEmail}&whatsapp=${this.sendMessenger}&sms=${this.sendSms}`,
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.send_accept_email = true;
              this.$notify(this.$t("bookings.send_success"), "", "success", 3000)
            })
            .catch((error) => {
              this.isLoading = false;
              if (error.response?.status == 409) {
                if (error.response?.data.qrCode) {
                  this.whatsappQrcode = error.response?.data.qrCode;
                }

                this.showQrcodeWhatsapp = true;
              } else {
                this.setError(error, this.$t("errors.bad_message_title"));
              }
              console.log(error.response?.data);
            })
            .finally(() => (this.isLoadingAcceptBooking = false));
        } else {
          this.$notify(this.$t("errors.bad_message_text"), "", "error", 5000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    cancelBookingFewDaysEmail() {
      if (this.isStaff) {
        if (this.client && (this.client.email || this.client.phone)) {
          this.isLoading = true;
          let self = this;
          this.axios
            .get(
              `/api/v1/cancel_booking_few_days/${this.booking.id}?email=${this.sendEmail}&whatsapp=${this.sendMessenger}&sms=${this.sendSms}`,
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.send_cancel_email = true;
              this.$notify(this.$t("bookings.send_decline_success"), "", "success", 5000)
            })
            .catch((error) => {
              this.setError(
                error,
                "Something went wrong in cancelBookingFewDaysEmail"
              );
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.bad_decline_text"), "", "error", 5000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    cancelBookingNotCarsEmail() {
      if (this.isStaff) {
        if (this.client && (this.client.email || this.client.phone)) {
          this.isLoadingDeclineBooking = true;
          let self = this;
          this.axios
            .get(
              `/api/v1/cancel_booking_not_cars/${this.booking.id}?email=${this.sendEmail}&whatsapp=${this.sendMessenger}&sms=${this.sendSms}`,
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.booking.send_cancel_email = true;
              this.$notify(this.$t("bookings.send_decline_success"), "", "success", 5000)
            })
            .catch((error) => {
              this.setError(error, "Something went wrong in cancelBookingNotCarsEmail");
            })
            .finally(() => (this.isLoadingDeclineBooking = false));
        } else {
          this.$notify(this.$t("errors.bad_decline_text"), "", "error", 5000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    retryWhatsapp() {
      this.isLoading = true;
      let self = this;
      this.axios
        .get(`/api/v1/retry_whatsapp`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.whatsappQrcode = response.data.qrCode;
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.bad_qr_text"));
          console.log(error.response?.data);
        })
        .finally(() => (this.isLoading = false));
    },
    getEmailTemplates() {
      this.isLoading = true;
      let self = this;
      this.axios
        .get(`/api/v1/email_templates`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.email_templates = response.data;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.email_template_text"));
        })
        .finally(() => (this.isLoading = false));
    },
    sendCustomEmail() {
      if (this.isStaff) {
        if (
          this.client &&
          (this.client.email || this.client.phone) &&
          this.customEmailData.body
        ) {
          let self = this;
          this.isLoadingSendCustomEmail = true;
          this.axios
            .post(
              `/api/v1/send_custom_email?email=${this.sendEmail}&whatsapp=${this.sendMessenger}&sms=${this.sendSms}`,
              {
                id: this.$route.params.id,
                name: this.customEmailData.name,
                subject: this.customEmailData.subject,
                body: this.customEmailData.body,
                save_new: this.save_email_template,
                attachment_id: this.customEmailData.attachment_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.booking.send_custom_email = true;
              this.selected_email_templates = null;
              // this.customEmailData = {
              //   id: this.$route.params.id,
              //   name: this.customEmailData.name,
              //   body: this.customEmailData.subject,
              //   subject: this.save_email_template,
              //   attachment_id: this.customEmailData.attachment_id,
              // };
              this.showCustomEmailDialog = false;
              this.$notify(this.$t("bookings.send_email_success"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.email_bad_send"));
            })
            .finally(() => (this.isLoadingSendCustomEmail = false));
        } else {
          this.$notify(this.$t("errors.email_bad_send_2"), "", "error", 3000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCustomEmail() {
      if (this.isStaff) {
        if (
          this.customEmailData.name &&
          this.customEmailData.subject &&
          this.customEmailData.body
        ) {
          let self = this;
          this.isLoadingSaveCustomEmail = true;
          this.axios
            .post(
              `/api/v1/save_custom_email_template`,
              {
                name: this.customEmailData.name,
                subject: this.customEmailData.subject,
                body: this.customEmailData.body,
                save_new: this.save_email_template,
                attachment_id: this.customEmailData.attachment_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.email_templates.push(response.data);
              this.selected_email_templates = response.data.id;
              this.$notify(this.$t("custom.saved"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.email_bad_send"));
            })
            .finally(() => (this.isLoadingSaveCustomEmail = false));
        } else {
          this.$notify(this.$t("errors.email_bad_send_2"), "", "error", 3000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateEmailTemplate() {
      if (this.isStaff) {
        if (
          this.selected_email_templates &&
          this.customEmailData.name &&
          this.customEmailData.body
        ) {
          let self = this;
          this.isLoadingUpdateEmailTemplate = true;
          this.axios
            .patch(
              `/api/v1/email_templates/${this.selected_email_templates}`,
              {
                email_templates: {
                  name: this.customEmailData.name,
                  subject: this.customEmailData.subject,
                  body: this.customEmailData.body,
                  attachment_id: this.customEmailData.attachment_id,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let template = this.email_templates.find(
                (template) => template.id == this.selected_email_templates
              );
              template.subject = this.customEmailData.subject;
              template.body = this.customEmailData.body;
              let foundIndex = this.email_templates.findIndex(
                (element) => element.id === this.selected_email_templates
              );
              this.email_templates.splice(foundIndex, 1, response.data);

              this.editEmailTemplate = false;
              this.$notify(this.$t("bookings.update_templates_success"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.email_bad_template"));
            })
            .finally(() => (this.isLoadingUpdateEmailTemplate = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async deleteEmailTemplate(id) {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          let self = this;
          this.isLoading = true;
          this.axios
            .delete(`/api/v1/email_templates/${id}`, {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.email_templates.splice(
                this.email_templates.indexOf((template) => template.id == id),
                1
              );
              this.$notify(this.$t("custom.deleted"), this.$t("bookings.deletes_template"), "success", 3000)
            })
            .catch((error) =>
              this.setError(error, this.$t("errors.remove_bad_template"))
            )
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    getDocxTemplates() {
      if (this.isStaff) {
        this.isLoadingGetDocxTemplates = true;
        this.axios
          .get(`api/v1/docx_templates?car_id=${this.set_car.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.docx_templates = [];
            this.docx_templates.unshift({
              id: null,
              name: this.$t("bookings.entity_template"),
              url: this.$store.getters.getEntityDocUrl,
            });
            this.docx_templates.unshift({
              id: null,
              name: this.$t("bookings.base_template"),
              url: response.data.car_special_template.url,
            });
            response.data.docx_templates.forEach((template) => {
              this.docx_templates.push(template);
            });
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.get_docx_templates"));
          })
          .finally(() => (this.isLoadingGetDocxTemplates = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Подписант со стороны клиента для договоров (docx) — зеркалит серверную
    // логику client_signer: юрлицо → директор/название фирмы; физлицо → fio с
    // фолбэком на склейку частей имени (fio часто пуст в проде).
    docxSignerName(client) {
      if (!client) return "      ";
      if (client.entity) return client.ceo || client.entity_name || "      ";
      const parts = `${client.lastname || ""} ${client.name || ""} ${client.middlename || ""}`
        .replace(/\s+/g, " ")
        .trim();
      return client.fio || parts || "      ";
    },
    generateDocxTemplates(docx_template, booking) {
      if (this.isStaff) {
        this.isLoadingGenerateDocxTemplates = true;
        let self = this;
        let content, error, url;

        url = docx_template.url;

        // Используем стандартный fetch вместо axios
        fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8',
          },
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.arrayBuffer();
          })
          .then(async (arrayBuffer) => {
            content = arrayBuffer;
            var zip = new PizZip(content);
            let client = self.client;
            let car = self.set_car;
            let add_drivers_info = "";
            if (this.add_drivers && this.add_drivers.length > 0) {
              this.add_drivers.forEach((driver) => {
                add_drivers_info += `${driver.lastname ? driver.lastname : ""
                  } ${driver.name ? driver.name : ""} ${driver.middlename ? driver.middlename : ""
                  }, ${this.$t("custom.passport")}: ${driver.passport_series ? driver.passport_series : ""
                  } ${driver.passport_number ? driver.passport_number : ""
                  }, ${this.$t("custom.driver_license")}: ${driver.driver_series ? driver.driver_series : ""
                  } ${driver.driver_number ? driver.driver_number : ""}${this.add_drivers.length > 1 ? ", " : ""
                  }`;
              });
            }
            // Больше информации о доп клиенте в документе
            let add_drivers_info_full = "";
            if (this.add_drivers && this.add_drivers.length > 0) {
              this.add_drivers.forEach((driver) => {
                add_drivers_info_full += `${driver.lastname ? driver.lastname : ""
                  } ${driver.name ? driver.name : ""} ${driver.middlename ? driver.middlename : ""
                  }, ${this.$t("bookings.birthdate_small")}: ${driver.birthday
                    ? moment(driver.birthday, "YYYY-MM-DD").format("L")
                    : ""
                  }, ${this.$t("custom.phone")}: ${driver.phone ? driver.phone : ""
                  }, ${this.$t("custom.passport")}: ${driver.passport_series ? driver.passport_series : ""
                  } ${driver.passport_number ? driver.passport_number : ""
                  }, ${this.$t("custom.issued")}: ${driver.passport_issued ? driver.passport_issued : ""
                  }, ${this.$t("custom.address").toLowerCase()}: ${driver.country ? driver.country : ""
                  }, ${driver.city ? driver.city : ""}, ${driver.address ? driver.address : ""
                  }, ${this.$t("custom.driver_license")}: ${driver.driver_series ? driver.driver_series : ""
                  } ${driver.driver_number ? driver.driver_number : ""
                  }, ${this.$t("custom.issued")}: ${driver.driver_issued ? driver.driver_issued : ""
                  } ${this.add_drivers.length > 1 ? ", " : ""}`;
              });
            }

            // Комплексные доп водители в масссиве
            let add_drivers_array = {};
            add_drivers_array['has_add_drivers'] = this.add_drivers && this.add_drivers.length > 0 ? true : false;
            add_drivers_array['drivers'] = [];
            this.add_drivers.forEach((driver) => {
              add_drivers_array['drivers'].push(
                {
                  driver_name: driver.name ? driver.name : "       ",
                  driver_lastname: driver.lastname ? driver.lastname : "       ",
                  driver_middlename: driver.middlename ? driver.middlename : "       ",
                  driver_phone: driver.phone ? driver.phone : "       ",
                  driver_birthday: driver.birthday ? moment(driver.birthday, "YYYY-MM-DD").format("L") : "       ",
                  driver_passport_series: driver.passport_series ? driver.passport_series : "       ",
                  driver_passport_number: driver.passport_number ? driver.passport_number : "       ",
                  driver_passport_issued: driver.passport_issued ? driver.passport_issued : "       ",
                  driver_passport_issued_date: driver.passport_issued_date ? moment(driver.passport_issued_date, "YYYY-MM-DD").format("L") : "       ",
                  driver_passport_expired_date: driver.passport_expired_date ? moment(driver.passport_expired_date, "YYYY-MM-DD").format("L") : "       ",
                  driver_country: driver.country ? driver.country : "       ",
                  driver_city: driver.city ? driver.city : "       ",
                  driver_address: driver.address ? driver.address : "       ",
                  driver_driver_series: driver.driver_series ? driver.driver_series : "       ",
                  driver_driver_number: driver.driver_number ? driver.driver_number : "       ",
                  driver_driver_issued: driver.driver_issued ? driver.driver_issued : "       ",
                },
              )
            })
            // Считаю предоплату
            let prepaid = 0;
            if (booking.counts && booking.counts.length > 0) {
              booking.counts.forEach((count) => {
                if (count.completed) {
                  if (count.operation) {
                    if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                      let ratedSum = Number(count.rated_sum);
                      prepaid += ratedSum;
                    } else {
                      let sum = Number(count.sum);
                      prepaid += sum;
                    }
                  } else {
                    if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                      let ratedSum = Number(count.rated_sum);
                      prepaid -= ratedSum;
                    } else {
                      let sum = Number(count.sum);
                      prepaid -= sum;
                    }
                  }
                }
              });
            }
            // Округляем сумму до 2 знаков после запятой
            prepaid = parseFloat(prepaid.toFixed(2));

            // Считаю доп сервисы
            let additional_services =
              (booking.hours_cost > 0
                ? booking.additional_hours * booking.price_hour
                : 0) +
              booking.hours_cost_end +
              booking.delivery +
              booking.delivery_end +
              booking.equipment +
              (booking.addons_cost || 0) + // FT-102 REQ-07
              booking.clean_payment +
              booking.damage +
              booking.gas +
              booking.add_drivers_cost +
              booking.insurance +
              booking.fine +
              booking.other +
              booking.other_end;

            // Считаю комиссию в сутки
            let commission = booking.aggr_commission;
            let commission_day = 0;

            if (booking.days > 0) {
              commission_day = commission / (booking.days > 0 ? booking.days : 1);
            } else if (booking.hourly_hours > 0) {
              commission_day = commission / (booking.hourly_hours > 0 ? booking.hourly_hours : 1);
            } else if (booking.weekly_weeks > 0) {
              commission_day = commission / (booking.weekly_weeks > 0 ? booking.weekly_weeks : 1);
            } else if (booking.monthly_months > 0) {
              commission_day = commission / (booking.monthly_months > 0 ? booking.monthly_months : 1);
            }

            var doc = new Docxtemplater().loadZip(zip);
            doc.setOptions({ paragraphLoop: true, nullGetter: () => "" });

            // Добавляем данные в шаблон
            doc.setData({
              date: moment().format("DD/MM/YY"),
              date_short: moment().format("DD/MM"),
              serial_number: booking.serial_number ? booking.serial_number : "      ",
              employee_full_name: this.user_full_name,
              employee_short_name: this.user_fio,
              company_signer: this.user_full_name,
              client_signer: this.docxSignerName(client),
              first_name: client.name ? client.name : "      ",
              middle_name: client.middlename ? client.middlename : "      ",
              last_name: client.lastname ? client.lastname : "      ",
              short_name: client.fio ? client.fio : "      ",
              client_id: client.id ? client.id : "      ",
              booking_id: booking.id ? booking.id : "      ",
              car_id: car.id ? car.id : "      ",
              date_birth: client.birthday
                ? moment(client.birthday, "YYYY-MM-DD").format("DD-MM-YYYY")
                : "      ",
              passport_series: client.passport_series
                ? client.passport_series
                : "      ",
              passport_number: client.passport_number
                ? client.passport_number
                : "      ",
              passport_issued: client.passport_issued
                ? client.passport_issued
                : "      ",
              passport_issued_date: client.passport_issued_date
                ? moment(client.passport_issued_date, "YYYY-MM-DD").format("L")
                : "      ",
              passport_expired_date: client.passport_expired_date
                ? moment(client.passport_expired_date, "YYYY-MM-DD").format("L")
                : "      ",
              driver_series: client.driver_series
                ? client.driver_series
                : "      ",
              driver_number: client.driver_number
                ? client.driver_number
                : "      ",
              driver_issued: client.driver_issued
                ? client.driver_issued
                : "      ",
              driver_issued_date: client.driver_issued_date
                ? moment(client.driver_issued_date, "YYYY-MM-DD").format("L")
                : "      ",
              driver_expired_date: client.driver_expired_date
                ? moment(client.driver_expired_date, "YYYY-MM-DD").format("L")
                : "      ",
              addons_cost: booking.addons_cost || 0,
              addons_list: (self.ft102Lines || [])
                .map(
                  (l) =>
                    `${l.name} × ${l.quantity} — ${l.price}${self.$t(
                      "booking_addons.per_unit_short"
                    )}, ${l.total}`
                )
                .join("; "),
              taxi_license: client.taxi_license
                ? client.taxi_license
                : "      ",
              phone: client.phone ? client.phone : "      ",
              email: client.email ? client.email : "      ",
              start_date: booking.start_date
                ? booking.start_date
                : "      ",
              end_date: booking.end_date ? booking.end_date : "      ",
              start_date_short: booking.start_date
                ? moment(booking.start_date, "DD-MM-YYYY H:mm").format(
                  "DD.MM.YYYY"
                )
                : "     ",
              end_date_short: booking.end_date
                ? moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                  "DD.MM.YYYY"
                )
                : "     ",
              day_cost: car.prices && car.prices.find((price) => price.season_id === null)
                ? car.prices.find((price) => price.season_id === null)
                  .values[0]
                : booking.start_price,
              hour_cost: car.hourly_prices && car.hourly_prices.find((price) => price.season_id === null)
                ? car.hourly_prices.find((price) => price.season_id === null)
                  .values[0]
                : 0,
              week_cost: car.weekly_prices && car.weekly_prices.find((price) => price.season_id === null)
                ? car.weekly_prices.find((price) => price.season_id === null)
                  .values[0]
                : 0,
              month_cost: car.monthly_prices && car.monthly_prices.find((price) => price.season_id === null)
                ? car.monthly_prices.find((price) => price.season_id === null)
                  .values[0]
                : 0,
              price: booking.price ? booking.price : "      ",
              day_cost_without_commission: car.prices && car.prices.find((price) => price.season_id === null)
                ? (car.prices.find((price) => price.season_id === null)
                  .values[0] - commission_day).toFixed(2)
                : booking.start_price,
              price_without_commission: booking.price
                ? (booking.price - commission_day).toFixed(2)
                : "      ",
              cost_without_commission: booking.rental_cost
                ? (booking.rental_cost - commission).toFixed(2)
                : "      ",
              selected_price: booking.selected_price
                ? booking.selected_price
                : "      ",
              cost: booking.rental_cost ? booking.rental_cost : "      ",
              days: booking.days ? booking.days : "      ",
              location_start: booking.location_start
                ? booking.location_start
                : "      ",
              location_end: booking.location_end
                ? booking.location_end
                : "      ",
              delivery_start: booking.delivery || booking.delivery === 0
                ? booking.delivery
                : "      ",
              delivery_end: booking.delivery_end || booking.delivery_end === 0
                ? booking.delivery_end
                : "      ",
              equipment: booking.equipment || booking.equipment === 0 ? booking.equipment : "      ",
              hours_cost: booking.hours_cost || booking.hours_cost === 0
                ? booking.hours_cost
                : "      ",
              additional_hours: booking.additional_hours || booking.additional_hours === 0
                ? booking.additional_hours
                : "      ",
              add_drivers_cost: booking.add_drivers_cost || booking.add_drivers_cost === 0
                ? booking.add_drivers_cost
                : "      ",
              insurance: booking.insurance || booking.insurance === 0 ? booking.insurance : "      ",
              clean: booking.clean_payment || booking.clean_payment === 0
                ? booking.clean_payment
                : "      ",
              other: booking.other || booking.other === 0 ? booking.other : "      ",
              mileage_limit: car.extra_mileage_km ? car.extra_mileage_km : this.company.mileage_limit || 0,
              extra_mileage_km: car.extra_mileage_price ? car.extra_mileage_price : this.company.mileage_limit_cost || 0,
              has_delivery_start: booking.delivery ? true : false,
              has_delivery_end: booking.delivery_end ? true : false,
              has_equipment: booking.equipment ? true : false,
              has_additional_hours: booking.additional_hours ? true : false,
              has_hours_cost: booking.hours_cost ? true : false,
              has_add_drivers_cost: booking.add_drivers_cost ? true : false,
              has_insurance: booking.insurance ? true : false,
              has_clean: booking.clean_payment ? true : false,
              has_other: booking.other ? true : false,
              has_sale: booking.sale ? true : false,
              has_sale_cash: booking.sale_cash ? true : false,
              has_rental_cost_sale: booking.rental_cost_sale ? true : false,
              has_rental_cost_sale_cash: booking.rental_cost_sale_cash ? true : false,
              sale: booking.sale ? booking.sale : "",
              sale_cash: booking.sale_cash ? booking.sale_cash : "",
              rental_cost_sale: booking.rental_cost_sale ? booking.rental_cost_sale : "",
              rental_cost_sale_cash: booking.rental_cost_sale_cash ? booking.rental_cost_sale_cash : "",
              start_mileage: booking.start_mileage
                ? booking.start_mileage
                : "      ",
              end_mileage: booking.end_mileage
                ? booking.end_mileage
                : "      ",
              car_name: booking.car_name ? booking.car_name : "      ",
              car_code: booking.car_code ? booking.car_code : "      ",
              car_number: car.number ? car.number : "      ",
              car_vin: car.vin ? car.vin : "      ",
              car_body: car.body_number ? car.body_number : "      ",
              car_pts: car.pts ? car.pts : "      ",
              car_purchase_price: car.purchase_price ? car.purchase_price : "      ",
              car_reg: car.registration_certificate
                ? car.registration_certificate
                : "      ",
              car_color: car.color ? car.color : "      ",
              car_year: car.year ? car.year : "      ",
              car_fuel: car.fuel ? car.fuel : "      ",
              engine_capacity: car.engine_capacity ? car.engine_capacity : "      ",
              engine_power: car.engine_power ? car.engine_power : "      ",
              tire_size: car.tire_size ? car.tire_size : "      ",
              car_type: car.car_type ? this.translateType(car.car_type) : "      ",
              price_hour: car.price_hour ? car.price_hour : "      ",
              additional_services:
                additional_services > 0 ? additional_services : "      ",
              has_additional_services:
                additional_services > 0 ? true : false,
              deposit: this.currentDeposit() || this.currentDeposit() === 0 ? this.currentDeposit() : "      ",
              total: booking.total ? booking.total : "      ",
              total_without_commission:
                booking.total
                  ? booking.total - commission
                  : "      ",
              total_with_deposit:
                booking.total && this.currentDeposit()
                  ? booking.total + this.currentDeposit()
                  : "      ",
              total_with_deposit_without_commission:
                booking.total && this.currentDeposit()
                  ? booking.total + this.currentDeposit() - commission
                  : "      ",
              prepaid: prepaid,
              entity_name: client.entity_name
                ? client.entity_name
                : "     ",
              ceo: client.ceo ? client.ceo : "     ",
              reg_form: client.reg_form ? client.reg_form : "     ",
              entity_phone: client.entity_phone
                ? client.entity_phone
                : "     ",
              country: client.country ? client.country : "      ",
              city: client.city ? client.city : "      ",
              entity_adress: client.entity_adress
                ? client.entity_adress
                : "     ",
              // Каноническое написание: эталонный entity_doc_example_en.docx
              // использует {entity_address}. Отдаём оба имени.
              entity_address: client.entity_adress
                ? client.entity_adress
                : "     ",
              address: client.address ? client.address : "     ",
              inn: client.inn ? client.inn : "     ",
              ogrn: client.ogrn ? client.ogrn : "     ",
              acc_number: client.acc_number
                ? client.acc_number
                : "     ",
              bank: client.bank ? client.bank : "     ",
              korr: client.korr ? client.korr : "     ",
              bik: client.bik ? client.bik : "     ",
              add_drivers_info: add_drivers_info,
              add_drivers_info_full: add_drivers_info_full,
              has_add_drivers: self.add_drivers > 0 ? true : false,
              add_drivers_array: add_drivers_array,
              repair_cost: car.repair_cost || booking.repair_cost === 0 ? car.repair_cost : "      ",
              franchise: car.franchise || booking.franchise === 0 ? car.franchise : "      ",
              max_fine: car.max_fine || booking.max_fine === 0 ? car.max_fine : "      ",
              has_tariff: booking.tariff_id ? true : false,
              tariff: booking.tariff_id ? self.findTariff(booking.tariff_id) : "      ",
              custom_field_1: booking.custom_field_1
                ? booking.custom_field_1
                : "      ",
              custom_field_2: booking.custom_field_2
                ? booking.custom_field_2
                : "      ",
              custom_field_3: booking.custom_field_3
                ? booking.custom_field_3
                : "      ",
              cars_custom_field_1: car.custom_field_1
                ? car.custom_field_1
                : "      ",
              cars_custom_field_2: car.custom_field_2
                ? car.custom_field_2
                : "      ",
              cars_custom_field_3: car.custom_field_3
                ? car.custom_field_3
                : "      ",
            });

            try {
              doc.render();
            } catch (error) {
              console.error('Error template docx:', error);
              self.$notify(self.$t("errors.template_error"), "", "error");
              return;
            }

            var out = doc.getZip().generate({
              type: "blob",
              mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              compression: "DEFLATE",
            });

            let date = moment().format("Y_MM_DD");

            if (!self.isNative) {
              saveAs(out, `${docx_template.name}_${date}_${booking.id}.docx`);
            } else {
              // Обработка для мобильных устройств
              if (Filesystem.checkPermissions()) {
                const getBase64FromBlob = async (blob) => {
                  return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                      const base64data = reader.result;
                      resolve(base64data);
                    }
                  });
                }
                getBase64FromBlob(out).then((base64) => {
                  async function writeFile() {
                    return await Filesystem.writeFile({
                      path: `${docx_template.name}_${date}_${booking.id}.docx`,
                      data: base64,
                      directory: Directory.Documents,
                    });
                  }
                  writeFile().then((getUriResult) => {
                    Share.share({
                      title: 'Download document',
                      files: [getUriResult.uri],
                    }).catch((error) => {
                      console.log("shareFile", error)
                    });
                  }).catch((error) => {
                    console.log("writeFile", error);
                  });
                });
              } else {
                Filesystem.requestPermissions();
              }
            }
          })
          .catch(error => {
            console.error('Error template docx:', error);
            this.$notify(this.$t("errors.template_load_error"), "", "error");
          })
          .finally(() => {
            this.isLoadingGenerateDocxTemplates = false;
          });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    generateDoc(booking) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        let content, error, url;

        // console.log(booking, this.client, this.set_car, this.set_car.prices);
        this.axios
          .get(`api/v1/doc_templates/${booking.car_id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((doc_templates_response) => {
            if (
              doc_templates_response.data &&
              doc_templates_response.data.url
            ) {
              url = doc_templates_response.data.url;
            } else {
              if (self.$i18n.locale == "ru") {
                url = "https://web.rentprog.ru/doc_example.docx";
              } else {
                url = "https://web.rentprog.com/doc_example_en.docx";
              }
            }
          })
          .then(() => {
            axios
              .get(url, {
                responseType: "arraybuffer",
                timeout: 120000, // выгрузка шаблона может не влезть в глобальные 30с на медленной сети
                headers: {
                  "Content-Type": "text/plain;charset=utf-8",
                },
              })
              .then((response) => {
                content = response.data;
                var zip = new PizZip(content);
                let client = self.client;
                let car = self.set_car;
                let add_drivers_info = "";
                if (self.add_drivers && self.add_drivers.length > 0) {
                  self.add_drivers.forEach((driver) => {
                    add_drivers_info += `${driver.lastname ? driver.lastname : ""
                      } ${driver.name ? driver.name : ""} ${driver.middlename ? driver.middlename : ""
                      }, ${self.$t("custom.passport")}: ${driver.passport_series ? driver.passport_series : ""
                      } ${driver.passport_number ? driver.passport_number : ""
                      }, ${self.$t("custom.driver_license")}: ${driver.driver_series ? driver.driver_series : ""
                      } ${driver.driver_number ? driver.driver_number : ""}${self.add_drivers.length > 1 ? ", " : ""
                      }`;
                  });
                }
                // Больше информации о доп клиенте в документе
                let add_drivers_info_full = "";
                if (self.add_drivers && self.add_drivers.length > 0) {
                  self.add_drivers.forEach((driver) => {
                    add_drivers_info_full += `${driver.lastname ? driver.lastname : ""
                      } ${driver.name ? driver.name : ""} ${driver.middlename ? driver.middlename : ""
                      }, ${self.$t("bookings.birthdate_small")}: ${driver.birthday
                        ? moment(driver.birthday, "YYYY-MM-DD").format("L")
                        : ""
                      }, ${self.$t("custom.passport")}: ${driver.passport_series ? driver.passport_series : ""
                      } ${driver.passport_number ? driver.passport_number : ""
                      }, ${self.$t("custom.issued")}: ${driver.passport_issued ? driver.passport_issued : ""
                      }, ${self.$t("custom.address").toLowerCase()}: ${driver.country ? driver.country : ""
                      }, ${driver.city ? driver.city : ""}, ${driver.address ? driver.address : ""
                      }, ${self.$t("custom.driver_license")}: ${driver.driver_series ? driver.driver_series : ""
                      } ${driver.driver_number ? driver.driver_number : ""
                      }, ${self.$t("custom.issued")}: ${driver.driver_issued ? driver.driver_issued : ""
                      } ${self.add_drivers.length > 1 ? ", " : ""}`;
                  });
                }

                // Комплексные доп водители в масссиве
                let add_drivers_array = {};
                add_drivers_array['has_add_drivers'] = self.add_drivers && self.add_drivers.length > 0 ? true : false;
                add_drivers_array['drivers'] = [];
                self.add_drivers.forEach((driver) => {
                  add_drivers_array['drivers'].push(
                    {
                      driver_name: driver.name ? driver.name : "       ",
                      driver_lastname: driver.lastname ? driver.lastname : "       ",
                      driver_middlename: driver.middlename ? driver.middlename : "       ",
                      driver_phone: driver.phone ? driver.phone : "       ",
                      driver_birthday: driver.birthday ? moment(driver.birthday, "YYYY-MM-DD").format("L") : "       ",
                      driver_passport_series: driver.passport_series ? driver.passport_series : "       ",
                      driver_passport_number: driver.passport_number ? driver.passport_number : "       ",
                      driver_passport_issued: driver.passport_issued ? driver.passport_issued : "       ",
                      driver_passport_issued_date: driver.passport_issued_date ? moment(driver.passport_issued_date, "YYYY-MM-DD").format("L") : "       ",
                      driver_passport_expired_date: driver.passport_expired_date ? moment(driver.passport_expired_date, "YYYY-MM-DD").format("L") : "       ",
                      driver_country: driver.country ? driver.country : "       ",
                      driver_city: driver.city ? driver.city : "       ",
                      driver_address: driver.address ? driver.address : "       ",
                      driver_driver_series: driver.driver_series ? driver.driver_series : "       ",
                      driver_driver_number: driver.driver_number ? driver.driver_number : "       ",
                      driver_driver_issued: driver.driver_issued ? driver.driver_issued : "       ",
                    },
                  )
                })
                // Считаю предоплату
                let prepaid = 0;
                if (booking.counts && booking.counts.length > 0) {
                  booking.counts.forEach((count) => {
                    if (count.completed) {
                      if (count.operation) {
                        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                          let ratedSum = Number(count.rated_sum);
                          prepaid += ratedSum;
                        } else {
                          let sum = Number(count.sum);
                          prepaid += sum;
                        }
                      } else {
                        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                          let ratedSum = Number(count.rated_sum);
                          prepaid -= ratedSum;
                        } else {
                          let sum = Number(count.sum);
                          prepaid -= sum;
                        }
                      }
                    }
                  });
                }
                // Округляем сумму до 2 знаков после запятой
                prepaid = parseFloat(prepaid.toFixed(2));

                // Считаю доп сервисы
                let additional_services =
                  (booking.hours_cost > 0
                    ? booking.additional_hours * booking.price_hour
                    : 0) +
                  booking.hours_cost_end +
                  booking.delivery +
                  booking.delivery_end +
                  booking.equipment +
                  (booking.addons_cost || 0) + // FT-102 REQ-07
                  booking.clean_payment +
                  booking.damage +
                  booking.gas +
                  booking.add_drivers_cost +
                  booking.insurance +
                  booking.fine +
                  booking.other +
                  booking.other_end;

                // Считаю комиссию в сутки
                let commission = booking.aggr_commission;
                let commission_day = commission / (booking.days > 0 ? booking.days : 1);

                var doc = new Docxtemplater().loadZip(zip);
                doc.setOptions({ paragraphLoop: true, nullGetter: () => "" });
                doc.setData({
                  date: moment().format("DD/MM/YY"),
                  date_short: moment().format("DD/MM"),
                  serial_number: booking.serial_number ? booking.serial_number : "      ",
                  employee_full_name: self.user_full_name,
                  employee_short_name: self.user_fio,
                  company_signer: self.user_full_name,
                  client_signer: self.docxSignerName(client),
                  first_name: client.name ? client.name : "      ",
                  middle_name: client.middlename ? client.middlename : "      ",
                  last_name: client.lastname ? client.lastname : "      ",
                  short_name: client.fio ? client.fio : "      ",
                  client_id: client.id ? client.id : "      ",
                  booking_id: booking.id ? booking.id : "      ",
                  car_id: car.id ? car.id : "      ",
                  date_birth: client.birthday
                    ? moment(client.birthday, "YYYY-MM-DD").format("DD-MM-YYYY")
                    : "      ",
                  passport_series: client.passport_series
                    ? client.passport_series
                    : "      ",
                  passport_number: client.passport_number
                    ? client.passport_number
                    : "      ",
                  passport_issued: client.passport_issued
                    ? client.passport_issued
                    : "      ",
                  passport_issued_date: client.passport_issued_date
                    ? moment(client.passport_issued_date, "YYYY-MM-DD").format("L")
                    : "      ",
                  passport_expired_date: client.passport_expired_date
                    ? moment(client.passport_expired_date, "YYYY-MM-DD").format("L")
                    : "      ",
                  driver_series: client.driver_series
                    ? client.driver_series
                    : "      ",
                  driver_number: client.driver_number
                    ? client.driver_number
                    : "      ",
                  driver_issued: client.driver_issued
                    ? client.driver_issued
                    : "      ",
                  driver_issued_date: client.driver_issued_date
                    ? moment(client.driver_issued_date, "YYYY-MM-DD").format("L")
                    : "      ",
                  driver_expired_date: client.driver_expired_date
                    ? moment(client.driver_expired_date, "YYYY-MM-DD").format("L")
                    : "      ",
                  addons_cost: booking.addons_cost || 0,
                  addons_list: (self.ft102Lines || [])
                    .map(
                      (l) =>
                        `${l.name} × ${l.quantity} — ${l.price}${self.$t(
                          "booking_addons.per_unit_short"
                        )}, ${l.total}`
                    )
                    .join("; "),
                  taxi_license: client.taxi_license
                    ? client.taxi_license
                    : "      ",
                  inn: client.inn ? client.inn : "      ",
                  country: client.country ? client.country : "      ",
                  city: client.city ? client.city : "      ",
                  address: client.address ? client.address : "      ",
                  phone: client.phone ? client.phone : "      ",
                  email: client.email ? client.email : "      ",
                  start_date: booking.start_date
                    ? booking.start_date
                    : "      ",
                  end_date: booking.end_date ? booking.end_date : "      ",
                  start_date_short: booking.start_date
                    ? moment(booking.start_date, "DD-MM-YYYY H:mm").format(
                      "DD.MM.YYYY"
                    )
                    : "     ",
                  end_date_short: booking.end_date
                    ? moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                      "DD.MM.YYYY"
                    )
                    : "     ",
                  day_cost: car.prices && car.prices.find((price) => price.season_id === null)
                    ? car.prices.find((price) => price.season_id === null)
                      .values[0]
                    : booking.start_price,
                  hour_cost: car.hourly_prices && car.hourly_prices.find((price) => price.season_id === null)
                    ? car.hourly_prices.find((price) => price.season_id === null)
                      .values[0]
                    : 0,
                  week_cost: car.weekly_prices && car.weekly_prices.find((price) => price.season_id === null)
                    ? car.weekly_prices.find((price) => price.season_id === null)
                      .values[0]
                    : 0,
                  month_cost: car.monthly_prices && car.monthly_prices.find((price) => price.season_id === null)
                    ? car.monthly_prices.find((price) => price.season_id === null)
                      .values[0]
                    : 0,
                  price: booking.price ? booking.price : "      ",
                  day_cost_without_commission: car.prices && car.prices.find((price) => price.season_id === null)
                    ? (car.prices.find((price) => price.season_id === null)
                      .values[0] - commission_day).toFixed(2)
                    : booking.start_price,
                  price_without_commission: booking.price
                    ? (booking.price - commission_day).toFixed(2)
                    : "      ",
                  cost_without_commission: booking.rental_cost
                    ? (booking.rental_cost - commission).toFixed(2)
                    : "      ",
                  selected_price: booking.selected_price
                    ? booking.selected_price
                    : "      ",
                  cost: booking.rental_cost ? booking.rental_cost : "      ",
                  days: booking.days ? booking.days : "      ",
                  location_start: booking.location_start
                    ? booking.location_start
                    : "      ",
                  location_end: booking.location_end
                    ? booking.location_end
                    : "      ",
                  delivery_start: booking.delivery || booking.delivery === 0
                    ? booking.delivery
                    : "      ",
                  delivery_end: booking.delivery_end || booking.delivery_end === 0
                    ? booking.delivery_end
                    : "      ",
                  equipment: booking.equipment || booking.equipment === 0 ? booking.equipment : "      ",
                  hours_cost: booking.hours_cost || booking.hours_cost === 0
                    ? booking.hours_cost
                    : "      ",
                  additional_hours: booking.additional_hours || booking.additional_hours === 0
                    ? booking.additional_hours
                    : "      ",
                  add_drivers_cost: booking.add_drivers_cost || booking.add_drivers_cost === 0
                    ? booking.add_drivers_cost
                    : "      ",
                  insurance: booking.insurance || booking.insurance === 0 ? booking.insurance : "      ",
                  clean: booking.clean_payment || booking.clean_payment === 0
                    ? booking.clean_payment
                    : "      ",
                  other: booking.other || booking.other === 0 ? booking.other : "      ",
                  mileage_limit: car.extra_mileage_km ? car.extra_mileage_km : this.company.mileage_limit || 0,
                  extra_mileage_km: car.extra_mileage_price ? car.extra_mileage_price : this.company.mileage_limit_cost || 0,
                  has_delivery_start: booking.delivery ? true : false,
                  has_delivery_end: booking.delivery_end ? true : false,
                  has_equipment: booking.equipment ? true : false,
                  has_additional_hours: booking.additional_hours ? true : false,
                  has_hours_cost: booking.hours_cost ? true : false,
                  has_add_drivers_cost: booking.add_drivers_cost ? true : false,
                  has_insurance: booking.insurance ? true : false,
                  has_clean: booking.clean_payment ? true : false,
                  has_other: booking.other ? true : false,
                  has_sale: booking.sale ? true : false,
                  has_sale_cash: booking.sale_cash ? true : false,
                  has_rental_cost_sale: booking.rental_cost_sale ? true : false,
                  has_rental_cost_sale_cash: booking.rental_cost_sale_cash ? true : false,
                  sale: booking.sale ? booking.sale : "",
                  sale_cash: booking.sale_cash ? booking.sale_cash : "",
                  rental_cost_sale: booking.rental_cost_sale ? booking.rental_cost_sale : "",
                  rental_cost_sale_cash: booking.rental_cost_sale_cash ? booking.rental_cost_sale_cash : "",
                  start_mileage: booking.start_mileage
                    ? booking.start_mileage
                    : "      ",
                  end_mileage: booking.end_mileage
                    ? booking.end_mileage
                    : "      ",
                  car_name: booking.car_name ? booking.car_name : "      ",
                  car_code: booking.car_code ? booking.car_code : "      ",
                  car_number: car.number ? car.number : "      ",
                  car_vin: car.vin ? car.vin : "      ",
                  car_body: car.body_number ? car.body_number : "      ",
                  car_pts: car.pts ? car.pts : "      ",
                  car_purchase_price: car.purchase_price ? car.purchase_price : "      ",
                  car_reg: car.registration_certificate
                    ? car.registration_certificate
                    : "      ",
                  car_color: car.color ? car.color : "      ",
                  car_year: car.year ? car.year : "      ",
                  car_fuel: car.fuel ? car.fuel : "      ",
                  engine_capacity: car.engine_capacity ? car.engine_capacity : "      ",
                  engine_power: car.engine_power ? car.engine_power : "      ",
                  tire_size: car.tire_size ? car.tire_size : "      ",
                  car_type: car.car_type ? this.translateType(car.car_type) : "      ",
                  price_hour: car.price_hour ? car.price_hour : "      ",
                  additional_services:
                    additional_services > 0 ? additional_services : "      ",
                  has_additional_services:
                    additional_services > 0 ? true : false,
                  deposit: this.currentDeposit() || this.currentDeposit() === 0 ? this.currentDeposit() : "      ",
                  total: booking.total ? booking.total : "      ",
                  total_without_commission:
                    booking.total
                      ? booking.total - commission
                      : "      ",
                  total_with_deposit:
                    booking.total && this.currentDeposit()
                      ? booking.total + this.currentDeposit()
                      : "      ",
                  total_with_deposit_without_commission:
                    booking.total && this.currentDeposit()
                      ? booking.total + this.currentDeposit() - commission
                      : "      ",
                  prepaid: prepaid,
                  add_drivers_info: add_drivers_info,
                  add_drivers_info_full: add_drivers_info_full,
                  has_add_drivers: self.add_drivers > 0 ? true : false,
                  add_drivers_array: add_drivers_array,
                  repair_cost: car.repair_cost || booking.repair_cost === 0 ? car.repair_cost : "      ",
                  franchise: car.franchise || booking.franchise === 0 ? car.franchise : "      ",
                  max_fine: car.max_fine || booking.max_fine === 0 ? car.max_fine : "      ",
                  has_tariff: booking.tariff_id ? true : false,
                  tariff: booking.tariff_id ? self.findTariff(booking.tariff_id) : "      ",
                  custom_field_1: booking.custom_field_1
                    ? booking.custom_field_1
                    : "      ",
                  custom_field_2: booking.custom_field_2
                    ? booking.custom_field_2
                    : "      ",
                  custom_field_3: booking.custom_field_3
                    ? booking.custom_field_3
                    : "      ",
                  cars_custom_field_1: car.custom_field_1
                    ? car.custom_field_1
                    : "      ",
                  cars_custom_field_2: car.custom_field_2
                    ? car.custom_field_2
                    : "      ",
                  cars_custom_field_3: car.custom_field_3
                    ? car.custom_field_3
                    : "      ",
                });

                doc.render();

                var out = doc.getZip().generate({
                  type: "blob",
                  mimeType:
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                }); //Output the document using Data-URI
                let date = moment().format("Y_MM_DD");
                // console.log(client)
                if (!self.isNative) {
                  saveAs(out, date + "_" + client.lastname + ".docx");
                } else {
                  if (Filesystem.checkPermissions()) {
                    const getBase64FromBlob = async (blob) => {
                      return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = () => {
                          const base64data = reader.result;
                          resolve(base64data);
                        }
                      });
                    }
                    getBase64FromBlob(out).then(
                      (base64) => {
                        // save file
                        async function writeFile() {
                          return await Filesystem.writeFile({
                            path: date + "_" + client.lastname + ".docx",
                            data: base64,
                            directory: Directory.Documents,
                          });
                        }
                        let file_uri = null
                        let writedFile = writeFile().then((getUriResult) => {
                          // share file opened file
                          let shareFile = async () => {
                            await Share.share({
                              title: 'Download document',
                              files: [getUriResult.uri],
                            }).catch((error) => {
                              console.log("shareFile", error)
                            });
                          };
                          let sharedFile = shareFile();
                        }).catch((error) => {
                          console.log("shareFile", error);
                        });
                      }
                    );
                  } else {
                    Filesystem.requestPermissions();
                  }
                }
              })
              .catch(function (error) {
                console.log("2", error);
                self.$notify(self.$t("errors.gen_template_title"), self.$t("errors.gen_template_text"), "error", 3000)
              });
          })
          .catch((error) => {
            this.isLoading = false;
            this.setError(error, this.$t("errors.upload_template"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    generateDocEntity(booking) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .get(`api/v1/doc_entity_templates/${booking.car_id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            let content, error, url;
            if (response.data && response.data.url) {
              url = response.data.url;
            } else {
              if (self.$i18n.locale == "ru") {
                url = "https://web.rentprog.ru/entity_doc_example.docx";
              } else {
                url = "https://web.rentprog.com/entity_doc_example_en.docx";
              }
            }
            axios
              .get(url, {
                responseType: "arraybuffer",
                timeout: 120000, // выгрузка шаблона может не влезть в глобальные 30с на медленной сети
                headers: {
                  "Content-Type": "text/plain;charset=utf-8",
                },
              })
              .then((response) => {
                content = response.data;
                var zip = new PizZip(content);
                this.axios
                  .get(`/api/v1/clients/${booking.client_id}`, {
                    headers: {
                      Authorization: self.$store.getters.getAuthToken,
                    },
                  })
                  .then((response) => {
                    let client = response.data.client;
                    // let car = self.cars.find(x => x.id === booking.car_id);
                    let car = self.set_car;
                    let add_drivers_info = "";
                    if (self.add_drivers && self.add_drivers.length > 0) {
                      self.add_drivers.forEach((driver) => {
                        add_drivers_info += `${driver.lastname ? driver.lastname : ""
                          } ${driver.name ? driver.name : ""} ${driver.middlename ? driver.middlename : ""
                          }, ${self.$t("custom.passport")}: ${driver.passport_series ? driver.passport_series : "-"
                          } ${driver.passport_number ? driver.passport_number : ""
                          }, ${self.$t("custom.driver_license")}: ${driver.driver_series ? driver.driver_series : "-"
                          } ${driver.driver_number ? driver.driver_number : ""}${self.add_drivers.length > 1 ? ", " : ""
                          }`;
                      });
                    }
                    // Больше информации о доп клиенте в документе
                    let add_drivers_info_full = "";
                    if (self.add_drivers && self.add_drivers.length > 0) {
                      self.add_drivers.forEach((driver) => {
                        add_drivers_info_full += `${driver.lastname ? driver.lastname : ""
                          } ${driver.name ? driver.name : ""} ${driver.middlename ? driver.middlename : ""
                          }, ${self.$t("bookings.birthdate_small")}: ${driver.birthday
                            ? moment(driver.birthday, "YYYY-MM-DD").format("L")
                            : ""
                          }, ${self.$t("custom.passport")}: ${driver.passport_series ? driver.passport_series : ""
                          } ${driver.passport_number ? driver.passport_number : ""
                          }, ${self.$t("custom.issued")}: ${driver.passport_issued ? driver.passport_issued : ""
                          }, ${self.$t("custom.address").toLowerCase()}: ${driver.country ? driver.country : ""
                          }, ${driver.city ? driver.city : ""}, ${driver.address ? driver.address : ""
                          }, ${self.$t("custom.driver_license")}: ${driver.driver_series ? driver.driver_series : ""
                          } ${driver.driver_number ? driver.driver_number : ""
                          }, ${self.$t("custom.issued")}: ${driver.driver_issued ? driver.driver_issued : ""
                          } ${self.add_drivers.length > 1 ? ", " : ""}`;
                      });
                    }
                    // Комплексные доп водители в масссиве
                    let add_drivers_array = {};
                    add_drivers_array['has_add_drivers'] = self.add_drivers && self.add_drivers.length > 0 ? true : false;
                    add_drivers_array['drivers'] = [];
                    self.add_drivers.forEach((driver) => {
                      add_drivers_array['drivers'].push(
                        {
                          driver_name: driver.name ? driver.name : "       ",
                          driver_lastname: driver.lastname ? driver.lastname : "       ",
                          driver_middlename: driver.middlename ? driver.middlename : "       ",
                          driver_birthday: driver.birthday ? moment(driver.birthday, "YYYY-MM-DD").format("L") : "       ",
                          driver_passport_series: driver.passport_series ? driver.passport_series : "       ",
                          driver_passport_number: driver.passport_number ? driver.passport_number : "       ",
                          driver_passport_issued: driver.passport_issued ? driver.passport_issued : "       ",
                          driver_country: driver.country ? driver.country : "       ",
                          driver_city: driver.city ? driver.city : "       ",
                          driver_address: driver.address ? driver.address : "       ",
                          driver_driver_series: driver.driver_series ? driver.driver_series : "       ",
                          driver_driver_number: driver.driver_number ? driver.driver_number : "       ",
                          driver_driver_issued: driver.driver_issued ? driver.driver_issued : "       ",
                        },
                      )
                    })
                    // Считаю предоплату
                    let prepaid = 0;
                    if (booking.counts && booking.counts.length > 0) {
                      booking.counts.forEach((count) => {
                        if (count.completed) {
                          if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                            let ratedSum = Number(count.rated_sum);
                            prepaid += ratedSum;
                          } else {
                            let sum = Number(count.sum);
                            prepaid += sum;
                          }
                        }
                      });
                    }
                    // Округляем сумму до 2 знаков после запятой
                    prepaid = parseFloat(prepaid.toFixed(2));

                    // Считаю доп сервисы
                    let additional_services =
                      (booking.hours_cost > 0
                        ? booking.additional_hours * booking.price_hour
                        : 0) +
                      booking.hours_cost_end +
                      booking.delivery +
                      booking.delivery_end +
                      booking.equipment +
                      (booking.addons_cost || 0) + // FT-102 REQ-07
                      booking.clean_payment +
                      booking.damage +
                      booking.gas +
                      booking.add_drivers_cost +
                      booking.insurance +
                      booking.fine +
                      booking.other +
                      booking.other_end;

                    // Считаю комиссию в сутки
                    let commission = booking.aggr_commission;
                    let commission_day = commission / (booking.days > 0 ? booking.days : 1);

                    var doc = new Docxtemplater().loadZip(zip);
                    doc.setOptions({ nullGetter: () => "" });
                    doc.setData({
                      date: moment().format("DD/MM/YY"),
                      date_short: moment().format("DD/MM"),
                      serial_number: booking.serial_number ? booking.serial_number : "      ",
                      employee_full_name: self.user_full_name,
                      employee_short_name: self.user_fio,
                      company_signer: self.user_full_name,
                      client_signer: self.docxSignerName(client),
                      client_id: client.id ? client.id : "      ",
                      booking_id: booking.id ? booking.id : "      ",
                      car_id: car.id ? car.id : "      ",
                      start_date: booking.start_date
                        ? booking.start_date
                        : "     ",
                      end_date: booking.end_date ? booking.end_date : "     ",
                      start_date_short: booking.start_date
                        ? moment(booking.start_date, "DD-MM-YYYY H:mm").format(
                          "DD.MM.YYYY"
                        )
                        : "     ",
                      end_date_short: booking.end_date
                        ? moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                          "DD.MM.YYYY"
                        )
                        : "     ",
                      location_start: booking.location_start
                        ? booking.location_start
                        : "      ",
                      location_end: booking.location_end
                        ? booking.location_end
                        : "      ",
                      delivery_start: booking.delivery || booking.delivery === 0
                        ? booking.delivery
                        : "      ",
                      delivery_end: booking.delivery_end || booking.delivery_end === 0
                        ? booking.delivery_end
                        : "      ",
                      equipment: booking.equipment || booking.equipment === 0
                        ? booking.equipment
                        : "      ",
                      hours_cost: booking.hours_cost || booking.hours_cost === 0
                        ? booking.hours_cost
                        : "      ",
                      additional_hours: booking.additional_hours || booking.additional_hours === 0
                        ? booking.additional_hours
                        : "      ",
                      add_drivers_cost: booking.add_drivers_cost || booking.add_drivers_cost === 0
                        ? booking.add_drivers_cost
                        : "      ",
                      insurance: booking.insurance || booking.insurance === 0
                        ? booking.insurance
                        : "      ",
                      clean: booking.clean_payment || booking.clean_payment === 0
                        ? booking.clean_payment
                        : "      ",
                      other: booking.other || booking.other === 0 ? booking.other : "      ",
                      mileage_limit: car.extra_mileage_km ? car.extra_mileage_km : this.company.mileage_limit || 0,
                      extra_mileage_km: car.extra_mileage_price ? car.extra_mileage_price : this.company.mileage_limit_cost || 0,
                      has_delivery_start: booking.delivery ? true : false,
                      has_delivery_end: booking.delivery_end ? true : false,
                      has_equipment: booking.equipment ? true : false,
                      has_additional_hours: booking.additional_hours
                        ? true
                        : false,
                      has_hours_cost: booking.hours_cost ? true : false,
                      has_add_drivers_cost: booking.add_drivers_cost
                        ? true
                        : false,
                      has_insurance: booking.insurance ? true : false,
                      has_clean: booking.clean_payment ? true : false,
                      has_other: booking.other ? true : false,
                      has_sale: booking.sale ? true : false,
                      has_sale_cash: booking.sale_cash ? true : false,
                      has_rental_cost_sale: booking.rental_cost_sale ? true : false,
                      has_rental_cost_sale_cash: booking.rental_cost_sale_cash ? true : false,
                      sale: booking.sale ? booking.sale : "",
                      sale_cash: booking.sale_cash ? booking.sale_cash : "",
                      rental_cost_sale: booking.rental_cost_sale ? booking.rental_cost_sale : "",
                      rental_cost_sale_cash: booking.rental_cost_sale_cash ? booking.rental_cost_sale_cash : "",
                      start_mileage: booking.start_mileage
                        ? booking.start_mileage
                        : "      ",
                      end_mileage: booking.end_mileage
                        ? booking.end_mileage
                        : "      ",
                      day_cost: car.prices.find(
                        (price) => price.season_id === null
                      )
                        ? car.prices.find((price) => price.season_id === null)
                          .values[0]
                        : booking.start_price,
                      hour_cost: car.hourly_prices && car.hourly_prices.find((price) => price.season_id === null)
                        ? car.hourly_prices.find((price) => price.season_id === null)
                          .values[0]
                        : 0,
                      week_cost: car.weekly_prices && car.weekly_prices.find((price) => price.season_id === null)
                        ? car.weekly_prices.find((price) => price.season_id === null)
                          .values[0]
                        : 0,
                      month_cost: car.monthly_prices && car.monthly_prices.find((price) => price.season_id === null)
                        ? car.monthly_prices.find((price) => price.season_id === null)
                          .values[0]
                        : 0,
                      price: booking.price ? booking.price : "      ",
                      day_cost_without_commission: car.prices && car.prices.find((price) => price.season_id === null)
                        ? (car.prices.find((price) => price.season_id === null)
                          .values[0] - commission_day).toFixed(2)
                        : booking.start_price,
                      price_without_commission: booking.price
                        ? (booking.price - commission_day).toFixed(2)
                        : "      ",
                      cost_without_commission: booking.rental_cost
                        ? (booking.rental_cost - commission).toFixed(2)
                        : "      ",
                      selected_price: booking.selected_price
                        ? booking.selected_price
                        : "      ",
                      cost: booking.rental_cost ? booking.rental_cost : "     ",
                      days: booking.days ? booking.days : "     ",
                      car_name: booking.car_name ? booking.car_name : "     ",
                      car_code: booking.car_code ? booking.car_code : "     ",
                      car_number: car.number ? car.number : "     ",
                      car_vin: car.vin ? car.vin : "     ",
                      car_body: car.body_number ? car.body_number : "     ",
                      car_pts: car.pts ? car.pts : "     ",
                      car_purchase_price: car.purchase_price ? car.purchase_price : "      ",
                      car_reg: car.registration_certificate
                        ? car.registration_certificate
                        : "     ",
                      car_color: car.color ? car.color : "     ",
                      car_year: car.year ? car.year : "      ",
                      car_fuel: car.fuel ? car.fuel : "     ",
                      engine_capacity: car.engine_capacity ? car.engine_capacity : "      ",
                      engine_power: car.engine_power ? car.engine_power : "      ",
                      tire_size: car.tire_size ? car.tire_size : "      ",
                      car_type: car.car_type ? this.translateType(car.car_type) : "      ",
                      price_hour: car.price_hour ? car.price_hour : "      ",
                      additional_services:
                        additional_services > 0
                          ? additional_services
                          : "      ",
                      has_additional_services:
                        additional_services > 0 ? true : false,
                      addons_cost: booking.addons_cost || 0,
                      addons_list: (self.ft102Lines || [])
                        .map(
                          (l) =>
                            `${l.name} × ${l.quantity} — ${l.price}${self.$t(
                              "booking_addons.per_unit_short"
                            )}, ${l.total}`
                        )
                        .join("; "),
                      deposit: this.currentDeposit() || this.currentDeposit() === 0 ? this.currentDeposit() : "     ",
                      total: booking.total ? booking.total : "      ",
                      total_without_commission:
                        booking.total
                          ? booking.total - commission
                          : "      ",
                      total_with_deposit:
                        booking.total && this.currentDeposit()
                          ? booking.total + this.currentDeposit()
                          : "      ",
                      total_with_deposit_without_commission:
                        booking.total && this.currentDeposit()
                          ? booking.total + this.currentDeposit() - commission
                          : "      ",
                      prepaid: prepaid,
                      entity_name: client.entity_name
                        ? client.entity_name
                        : "     ",
                      ceo: client.ceo ? client.ceo : "     ",
                      reg_form: client.reg_form ? client.reg_form : "     ",
                      entity_phone: client.entity_phone
                        ? client.entity_phone
                        : "     ",
                      country: client.country ? client.country : "      ",
                      city: client.city ? client.city : "      ",
                      entity_adress: client.entity_adress
                        ? client.entity_adress
                        : "     ",
                      entity_address: client.entity_adress
                        ? client.entity_adress
                        : "     ",
                      address: client.address ? client.address : "     ",
                      inn: client.inn ? client.inn : "     ",
                      ogrn: client.ogrn ? client.ogrn : "     ",
                      acc_number: client.acc_number
                        ? client.acc_number
                        : "     ",
                      bank: client.bank ? client.bank : "     ",
                      korr: client.korr ? client.korr : "     ",
                      bik: client.bik ? client.bik : "     ",
                      email: client.email ? client.email : "     ",
                      doc_number: client.doc_number
                        ? client.doc_number
                        : "     ",
                      add_drivers_info: add_drivers_info,
                      add_drivers_info_full: add_drivers_info_full,
                      has_add_drivers: self.add_drivers > 0 ? true : false,
                      add_drivers_array: add_drivers_array,
                      repair_cost: car.repair_cost || booking.repair_cost === 0 ? car.repair_cost : "      ",
                      franchise: car.franchise || booking.franchise === 0 ? car.franchise : "      ",
                      max_fine: car.max_fine || booking.max_fine === 0 ? car.max_fine : "      ",
                      has_tariff: booking.tariff_id ? true : false,
                      tariff: booking.tariff_id ? self.findTariff(booking.tariff_id) : "      ",
                      custom_field_1: booking.custom_field_1
                        ? booking.custom_field_1
                        : "      ",
                      custom_field_2: booking.custom_field_2
                        ? booking.custom_field_2
                        : "      ",
                      custom_field_3: booking.custom_field_3
                        ? booking.custom_field_3
                        : "      ",
                      cars_custom_field_1: car.custom_field_1
                        ? car.custom_field_1
                        : "      ",
                      cars_custom_field_2: car.custom_field_2
                        ? car.custom_field_2
                        : "      ",
                      cars_custom_field_3: car.custom_field_3
                        ? car.custom_field_3
                        : "      ",
                    });

                    doc.render();

                    var out = doc.getZip().generate({
                      type: "blob",
                      mimeType:
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    }); //Output the document using Data-URI
                    let date = moment().format("Y_MM_DD");
                    // console.log(client)
                    if (!self.isNative) {
                      saveAs(out, date + "_" + client.lastname + ".docx");
                    } else {
                      if (Filesystem.checkPermissions()) {
                        const getBase64FromBlob = async (blob) => {
                          return new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = () => {
                              const base64data = reader.result;
                              resolve(base64data);
                            }
                          });
                        }
                        getBase64FromBlob(out).then(
                          (base64) => {
                            // save file
                            async function writeFile() {
                              return await Filesystem.writeFile({
                                path: date + "_" + client.lastname + ".docx",
                                data: base64,
                                directory: Directory.Documents,
                              });
                            }
                            let file_uri = null
                            let writedFile = writeFile().then((getUriResult) => {
                              // share file opened file
                              let shareFile = async () => {
                                await Share.share({
                                  title: 'Download document',
                                  files: [getUriResult.uri],
                                }).catch((error) => {
                                  console.log("shareFile", error)
                                });
                              };
                              let sharedFile = shareFile();
                            }).catch((error) => {
                              console.log("shareFile", error)
                            });
                          }
                        );
                      } else {
                        Filesystem.requestPermissions();
                      }
                    }
                  })
                  .catch((error) => {
                    self.$notify(self.$t("errors.gen_template_title"), self.$t("errors.gen_template_text"), "error", 3000)
                    console.log(error);
                  });
              })
              .catch(function (error) {
                console.log(error);
              })
              .finally(() => (this.isLoading = false));
          })
          .catch((error) => {
            this.isLoading = false;
            this.setError(error, this.$t("errors.upload_template"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateType(type) {
      let types = [
        { text: this.$t("car_types.micro"), value: "Микро" },
        { text: this.$t("car_types.hatchback"), value: "Хэтчбек" },
        { text: this.$t("car_types.sedan"), value: "Седан" },
        { text: this.$t("car_types.universal"), value: "Универсал" },
        { text: this.$t("car_types.minivan"), value: "Минивен" },
        { text: this.$t("car_types.coupe"), value: "Купе" },
        { text: this.$t("car_types.crossover"), value: "Кроссовер" },
        { text: this.$t("car_types.suv"), value: "Внедорожник" },
        { text: this.$t("car_types.pickup"), value: "Пикап" },
        { text: this.$t("car_types.limousine"), value: "Лимузин" },
        { text: this.$t("car_types.van"), value: "Фургон" },
        { text: this.$t("car_types.cabriolet"), value: "Кабриолет" },
        { text: this.$t("car_types.bus"), value: "Микроавтобус" },
        { text: this.$t("car_types.campervan"), value: "Автодом" },
        { text: this.$t("car_types.light_van"), value: "Легковой фургон" },
        { text: this.$t("car_types.rodster"), value: "Родстер" },
        { text: this.$t("car_types.sportcar"), value: "Спорткар" },
        { text: this.$t("motorcycle_types.sport"), value: "Спортивные (спортбайки)" },
        { text: this.$t("motorcycle_types.cruiser"), value: "Круизеры" },
        { text: this.$t("motorcycle_types.tourist"), value: "Туристические (турэндуро)" },
        { text: this.$t("motorcycle_types.enduro"), value: "Эндуро" },
        { text: this.$t("motorcycle_types.standard"), value: "Стандартные (нейкед)" },
        { text: this.$t("motorcycle_types.scooter"), value: "Скутеры" },
        { text: this.$t("motorcycle_types.chopper"), value: "Чопперы" },
        { text: this.$t("motorcycle_types.cafe_racer"), value: "Кафе рейсеры" },
        { text: this.$t("motorcycle_types.kross"), value: "Кроссовые (мотокросс)" },
        { text: this.$t("motorcycle_types.super"), value: "Супермото" },
        { text: this.$t("motorcycle_types.street"), value: "Стритфайтеры" },
        { text: this.$t("motorcycle_types.sport_tourist"), value: "Спорт-туристические" },
        { text: this.$t("motorcycle_types.moped"), value: "Мопеды" },
        { text: this.$t("motorcycle_types.truck"), value: "Трайки (трехколесные)" },
        { text: this.$t("motorcycle_types.bobber"), value: "Боббер" },
        { text: this.$t("motorcycle_types.buggy"), value: "Багги" },
        { text: this.$t("bike_types.road"), value: "Шоссейные" },
        { text: this.$t("bike_types.mtb"), value: "Горные (MTB)" },
        { text: this.$t("bike_types.city"), value: "Городские" },
        { text: this.$t("bike_types.hybrid"), value: "Гибридные" },
        { text: this.$t("bike_types.track"), value: "Трековые" },
        { text: this.$t("bike_types.gravel"), value: "Гравийные (гревел)" },
        { text: this.$t("bike_types.folding"), value: "Складные" },
        { text: this.$t("bike_types.bmx"), value: "BMX" },
        { text: this.$t("bike_types.tourist"), value: "Туристические" },
        { text: this.$t("bike_types.triathlon"), value: "Для триатлона" },
        { text: this.$t("bike_types.fatbike"), value: "Фэтбайки" },
        { text: this.$t("bike_types.cruiser"), value: "Круизеры" },
        { text: this.$t("bike_types.downhill"), value: "Даунхилл" },
        { text: this.$t("bike_types.children"), value: "Детские" },
        { text: this.$t("bike_types.tandem"), value: "Тандемы" },
        { text: this.$t("bike_types.electric"), value: "Электрические" },
        { text: this.$t("bike_types.trick"), value: "Трюковые" },
        { text: this.$t("bike_types.offroad"), value: "Внедорожные" },
        { text: this.$t("bike_types.sport"), value: "Спортивные" },
        { text: this.$t("bike_types.seat"), value: "Самокаты с сиденьем" },
        { text: this.$t("bike_types.scooter"), value: "Гироскутеры" },
        { text: this.$t("bike_types.kick"), value: "Кикскутеры" },
        { text: this.$t("bike_types.speed"), value: "Быстроходные" },
      ];
      return types.find((type) => type.value === type)?.text || type;
    },
    paymentStart() {
      // Было три ветки вокруг `!= 'agent'`, из-за чего диалог оплаты
      // открывался guest и partner (они «не агенты»). Условие то же, что в
      // savePayment, — иначе диалог открывался бы, а сохранение отбивало.
      if (this.isStaff || this.agentCan("can_take_money")) {
        this.payment_dialog = true;
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // FT-173 STEP-16 (REQ-08, CTR-04): ?payment=1 opens PaymentDialog only for
    // a loaded rent_to_own booking, once RentToOwnPanel confirms it holds the
    // contract (onRentToOwnContractLoaded below). Any other case — ordinary
    // booking, no query param — strips `payment` right away: ordinary
    // bookings never react to ?payment=1 (эталон STEP-14).
    applyPaymentQueryParam() {
      if (!this.$route || !this.$route.query || this.$route.query.payment !== "1") {
        return;
      }
      if (this.booking && this.booking.rent_to_own === true) {
        this.paymentQueryPending = true;
      } else {
        this.clearPaymentQueryParam();
      }
    },
    clearPaymentQueryParam() {
      if (!this.$route || !this.$route.query || this.$route.query.payment === undefined || !this.$router) {
        return;
      }
      const query = Object.assign({}, this.$route.query);
      delete query.payment;
      this.$router
        .replace({ path: `/bookings/${this.$route.params.id}`, query })
        .catch((err) => { });
    },
    // Called by RentToOwnPanel's @contract-loaded, fired after every load()
    // attempt (found / empty / paywall / 403 / network error — REQ-12). Only
    // acts while a ?payment=1 request is pending; a contract-loaded event
    // that fires later (e.g. after «Повторить») is ignored. Same gate as the
    // panel's own «Принять платёж» button: only an active contract takes a
    // payment — draft/closed contracts just lose the param (FT-173 H4).
    onRentToOwnContractLoaded(contract) {
      this.rentToOwnContract = contract || null;
      this.rentToOwnContractLoaded = true;
      if (!this.paymentQueryPending) return;
      this.paymentQueryPending = false;
      if (contract && contract.lifecycle === "active") {
        this.paymentStart();
      }
      this.clearPaymentQueryParam();
    },
    // FT-173 STEP-16 (REQ-08, CTR-07): reaction to the self-emitted
    // "payment-saved" (registered in created()). Ordinary bookings never
    // render RentToOwnPanel — $refs.rentToOwnPanel is empty, no-op.
    handleRentToOwnPaymentSaved() {
      if (this.$refs.rentToOwnPanel && this.$refs.rentToOwnPanel.handlePaymentSaved) {
        this.$refs.rentToOwnPanel.handlePaymentSaved();
      }
    },
    showPayments(booking) {
      if (booking.counts) {
        if (booking.counts.length > 0) {
          return true;
        }
      }
    },
    calculatePayments(booking) {
      if (booking != undefined) {
        let self = this;
        let paid = 0;
        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_hours_cost_end = Number(booking.hours_cost_end) === booking.hours_cost_end;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = check_number_hours_cost_end ? booking.hours_cost_end : 0;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum =
          parseFloat((rental_cost +
            delivery +
            delivery_end +
            equipment +
            addons_cost +
            insurance +
            clean_payment +
            add_drivers_cost +
            hours_cost +
            mileage_cost +
            damage +
            gas +
            fine +
            other +
            other_end +
            hours_cost_end).toFixed(2));
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid += ratedSum;
              } else {
                let sum = Number(count.sum);
                paid += sum;
              }
            } else {
              if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid -= ratedSum;
              } else {
                let sum = Number(count.sum);
                paid -= sum;
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        booking_sum = parseFloat(booking_sum.toFixed(2));
        paid = parseFloat(paid.toFixed(2));
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += this.currentDeposit();
        }
        if (parseInt(paid) == parseInt(booking_sum)) {
          return self.$t("bookings.paid");
        } else {
          return paid - booking_sum >= 0
            ? `+ ${parseFloat((paid - booking_sum).toFixed(2))}`
            : ` ${parseFloat((paid - booking_sum).toFixed(2))}`;
        }
      }
    },
    calculatePaymentsSum(booking) {
      if (booking != undefined) {
        let self = this;
        let paid = 0.0;
        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_hours_cost_end = Number(booking.hours_cost_end) === booking.hours_cost_end;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = check_number_hours_cost_end ? booking.hours_cost_end : 0;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum =
          parseFloat((rental_cost +
            delivery +
            delivery_end +
            equipment +
            addons_cost +
            insurance +
            clean_payment +
            add_drivers_cost +
            hours_cost +
            mileage_cost +
            damage +
            gas +
            fine +
            other +
            other_end +
            hours_cost_end).toFixed(2));
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid += ratedSum;
              } else {
                let sum = Number(count.sum);
                paid += sum;
              }
            } else {
              if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid -= ratedSum;
              } else {
                let sum = Number(count.sum);
                paid -= sum;
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        booking_sum = parseFloat(booking_sum.toFixed(2));
        paid = parseFloat(paid.toFixed(2));
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += this.currentDeposit();
        }
        return parseFloat(paid.toFixed(2));
      }
    },
    calculateRentPaymentsSum(booking) {
      if (booking != undefined) {
        let self = this;
        let paid = 0;
        booking.counts.forEach((count) => {
          if (count.group == "Оплата аренды") {
            // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
            if (count.completed) {
              if (count.operation) {
                if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                  let ratedSum = Number(count.rated_sum);
                  paid += ratedSum;
                } else {
                  let sum = Number(count.sum);
                  paid += sum;
                }
              } else {
                if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                  let ratedSum = Number(count.rated_sum);
                  paid -= ratedSum;
                } else {
                  let sum = Number(count.sum);
                  paid -= sum;
                }
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        paid = parseFloat(paid.toFixed(2));
        return paid;
      }
    },
    selectColorPaid(booking) {
      if (booking != undefined) {
        let paid = 0.0;
        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_hours_cost_end = Number(booking.hours_cost_end) === booking.hours_cost_end;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = check_number_hours_cost_end ? booking.hours_cost_end : 0;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum =
          parseFloat((rental_cost +
            delivery +
            delivery_end +
            equipment +
            addons_cost +
            insurance +
            clean_payment +
            add_drivers_cost +
            hours_cost +
            mileage_cost +
            damage +
            gas +
            fine +
            other +
            other_end +
            hours_cost_end).toFixed(2));
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
              let ratedSum = Number(count.rated_sum);
              if (count.operation) {
                paid += ratedSum;
              } else {
                paid -= ratedSum;
              }
            } else {
              let sum = Number(count.sum);
              if (count.operation) {
                paid += sum;
              } else {
                paid -= sum;
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        booking_sum = parseFloat(booking_sum.toFixed(2));
        paid = parseFloat(paid.toFixed(2));
        // Отнимаем залог у непринятых броней
        if (!booking.ride && this.currentDeposit() && this.currentDeposit() != undefined) {
          booking_sum += parseFloat(this.currentDeposit().toFixed(2));
        }
        // Убираем дробную часть
        if (parseInt(paid) == parseInt(booking_sum)) {
          return "success";
        } else if (paid - booking_sum > 0) {
          return "warning";
        } else if (paid - booking_sum < 0) {
          return "error";
        }
      }
    },
    // FT-198 REQ-04: удержание закрывается тем же эндпоинтом, что кнопка, и только после проведённого платежа.
    // Ошибка закрытия платёж не повторяет: сообщение и перечитывание бронирования.
    returnDeposit({ afterPayment = false } = {}) {
      if (!this.canReturnDeposit) return Promise.resolve(false);
      this.isLoadingDepositReturned = true;
      return this.axios
        .post(`/api/v1/bookings/${this.booking.id}/deposit_returned`, {}, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then(() => {
          this.$notify(this.$t("bookings.deposit_returned_done"), "", "success", 3000);
          return true;
        })
        .catch(() => {
          const key = afterPayment ? "bookings.deposit_returned_after_payment_failed" : "bookings.deposit_returned_failed";
          this.$notify(this.$t("errors.attention"), this.$t(key), "error", 8000);
          return false;
        })
        .finally(() => {
          this.isLoadingDepositReturned = false;
          this.getBooking();
        });
    },
    async confirmReturnDeposit() {
      const confirmed = await this.$confirm({
        title: this.$t("bookings.deposit_returned_confirm_title"),
        text: this.$t("bookings.deposit_returned_confirm_text"),
        confirmButtonText: this.$t("bookings.deposit_returned_action"),
        cancelButtonText: this.$t("custom.cancel"),
      });
      return confirmed ? this.returnDeposit() : false;
    },
    async savePayment(booking, departure_payments, charge_saved_card, closeDepositHold = false) {
      // Двойной клик: вторая отправка пока идёт первая не должна ни повторить запрос, ни дописать строки дважды.
      if (this.isLoadingSavePayment) return;
      // FT-193 NEG-02: прошлая отправка с карты не подтверждена — любая другая отправка записала бы платёж второй раз
      // обычными строками. Повторить можно только списанием с карты (тот же ключ вернёт первый результат).
      if (this.paymentOutcomeUnknown && charge_saved_card !== true) {
        this.$notify(this.$t("errors.add_payment"), this.$t("tinkoff.errors.outcome_unknown_locked"), "warning", 10000);
        return;
      }
      // FT-193 W1: незавершённое списание с карты повторяется неизменным снимком первой отправки, а не текущими полями
      // диалога: проверки ниже и тело запроса — по снимку.
      if (charge_saved_card === true && this.paymentChargeSnapshot) {
        departure_payments = JSON.parse(JSON.stringify(this.paymentChargeSnapshot.departure_payments));
      }
      // Не голый isStaff: paymentStart (ниже) уже открывает диалог оплаты
      // агенту с can_take_money — иначе он вводил бы сумму и получал отказ
      // на сохранении. Право приёма денег даёт компания, а не роль.
      if (this.isStaff || this.agentCan("can_take_money")) {
        let self = this;
        // Класс брони 664209 (2026-07-21): раньше гвард требовал, чтобы ВСЕ
        // суммы были пустыми (&&) — смешанный случай «одна очищена в "",
        // остальные с числами» проходил дальше: "" склеивался конкатенацией
        // в calcTypePayment (портил client.balance на порядки) и уходил
        // сырым в /save_count. Как в приёмке (validateEmptyPaymentValues):
        // ЛЮБАЯ пустая сумма блокирует сохранение.
        const departurePaymentFields = [
          "rent", "deposit", "delivery", "delivery_end", "clean",
          "hours_cost", "equipment", "addons", "insurance", "fine",
          "add_drivers_cost", "gas", "mileage", "other", "damage",
        ];
        if (departurePaymentFields.some((field) => departure_payments[field].sum === "")) {
          this.$notify(this.$t("errors.empty_value_title"), this.$t("errors.empty_value_text"), "error", 4000);
        } else if (
          departure_payments.rent.sum == 0 &&
          departure_payments.deposit.sum == 0 &&
          departure_payments.delivery.sum == 0 &&
          departure_payments.delivery_end.sum == 0 &&
          departure_payments.clean.sum == 0 &&
          departure_payments.hours_cost.sum == 0 &&
          departure_payments.equipment.sum == 0 &&
          departure_payments.addons.sum == 0 &&
          departure_payments.insurance.sum == 0 &&
          departure_payments.fine.sum == 0 &&
          departure_payments.add_drivers_cost.sum == 0 &&
          departure_payments.gas.sum == 0 &&
          departure_payments.mileage.sum == 0 &&
          departure_payments.other.sum == 0 &&
          departure_payments.damage.sum == 0
        ) {
          this.$notify(this.$t("errors.zero_value_title"), this.$t("errors.zero_value_text"), "error", 4000);
        } else {
          if (
            (departure_payments.rent.sum != 0 &&
              departure_payments.rent.type == null) ||
            (departure_payments.deposit.sum != 0 &&
              departure_payments.deposit.type == null) ||
            (departure_payments.delivery.sum != 0 &&
              departure_payments.delivery.type == null) ||
            (departure_payments.delivery_end.sum != 0 &&
              departure_payments.delivery_end.type == null) ||
            (departure_payments.clean.sum != 0 &&
              departure_payments.clean.type == null) ||
            (departure_payments.hours_cost.sum != 0 &&
              departure_payments.hours_cost.type == null) ||
            (departure_payments.equipment.sum != 0 &&
              departure_payments.equipment.type == null) ||
            (departure_payments.addons.sum != 0 &&
              departure_payments.addons.type == null) ||
            (departure_payments.insurance.sum != 0 &&
              departure_payments.insurance.type == null) ||
            (departure_payments.fine.sum != 0 &&
              departure_payments.fine.type == null) ||
            (departure_payments.add_drivers_cost.sum != 0 &&
              departure_payments.add_drivers_cost.type == null) ||
            (departure_payments.gas.sum != 0 &&
              departure_payments.gas.type == null) ||
            (departure_payments.mileage.sum != 0 &&
              departure_payments.mileage.type == null) ||
            (departure_payments.other.sum != 0 &&
              departure_payments.other.type == null) ||
            (departure_payments.damage.sum != 0 &&
              departure_payments.damage.type == null)
          ) {
            this.$notify(this.$t("errors.type_payment_title"), this.$t("errors.type_payment_text"), "warning", 3000);
          } else {
            if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
              // Проверяем если в self.departure_payments есть платеж наличными
              let departure_payments_keys = Object.keys(departure_payments);
              let cash_payments = departure_payments_keys.filter((key) => departure_payments[key].type == "Наличные");
              if (cash_payments && cash_payments.length > 0) {
                // проверяем что у пользователя есть выбранный счёт
                let worker_accounts_cashboxes_ids = this.worker_accounts.map(
                  (account) => account.company_cashbox_id
                );
                // получаем все company_cashbox_id из наличных платежей
                let cash_payments_cashbox_ids = cash_payments.map((key) => departure_payments[key].company_cashbox_id);
                // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
                let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
                  worker_accounts_cashboxes_ids.includes(cashbox_id)
                );
                // проверяем что у пользователя есть выбранный счёт
                if (worker_accounts_cashboxes_ids.length > 0 && has_matching_cashbox) {
                  console.log("exists currency_account")
                } else if (worker_accounts_cashboxes_ids.length > 0 && !has_matching_cashbox) {
                  console.log("not exists company_cashbox, check currency in worker_cashboxes")
                  // проверяем есть ли в кассах пользователя касса с такой валютой
                  let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
                  let cash_payments_currency_ids = cash_payments.map((key) => departure_payments[key].currency_id);
                  let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
                    worker_cashboxes_currency_ids.includes(cashbox_id)
                  );
                  if (has_matching_worker_cashbox_currency) {
                    console.log("exists worker_cashbox_currency, select first on server")
                  } else {
                    console.log("not exists worker_cashbox_currency")
                    this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "warning", 3000);
                    return;
                  }
                } else {
                  console.log("currency_account selected")
                }
              }
              // Проверяем если есть платежи через баланс клиента, то проводим если все платежи в базовой валюте
              let clients_payments_in_non_base_currency = departure_payments_keys.filter((key) => departure_payments[key].type == "Баланс клиента" && departure_payments[key].currency_id != this.base_currency_id);
              if (clients_payments_in_non_base_currency.length > 0) {
                this.$notify(this.$t("errors.client_payments_in_non_base_currency"), "", "error", 4000);
                return;
              }
            }
            // Класс брони 664209 (2026-07-21): sum из v-model.number после
            // очистки поля = "" — сырой `+=` конкатенировал строки и портил
            // client.balance на порядки (склеенные цифры). Свёрнуто из 70
            // одинаковых if-блоков в sumPaymentsByType (moneySum.js) с
            // коэрцией каждого терма; whitelist полей — тот же, что у гварда
            // пустых сумм выше (холистик-ревью: посторонние ключи объекта
            // не должны влиять на баланс клиента).
            const calcTypePayment = (payments) =>
              sumPaymentsByType(payments, departurePaymentFields);
            function saveCount() {
              if (self.isLoadingSavePayment) return;
              self.isLoadingSavePayment = true;
              let body;
              if (charge_saved_card === true && self.paymentChargeSnapshot) {
                // FT-193 W1: повтор незавершённого списания — тот же снимок с тем же ключом
                body = JSON.parse(JSON.stringify(self.paymentChargeSnapshot));
              } else {
                body = {
                  booking_id: booking.id,
                  car_id: booking.car_id,
                  departure_payments: departure_payments,
                };
                // FT-193 REQ-08, CTR-08: списание с привязанной карты — только явным параметром и с ключом
                // идемпотентности. Старый tinkoff_enabled_on_payment не шлём: сервер отвечает на него 422.
                // W1: ключ и неизменный снимок тела создаются при первой отправке (до запроса — и в sessionStorage).
                if (charge_saved_card === true) {
                  body.charge_saved_card = true;
                  body.idempotency_key = generateIdempotencyKey();
                  // FT-198 × FT-193: закрыть удержание залога после 2xx — часть намерения первой отправки. Хранится в
                  // снимке (и в sessionStorage) клиентской пометкой, только когда запрошено; на сервер не уходит.
                  if (closeDepositHold) body.close_deposit_hold = true;
                  self.rememberPendingCharge(body);
                  // в запрос — копия снимка: правка полей, пока запрос ждёт (подтверждение крупной суммы), его не меняет
                  body = JSON.parse(JSON.stringify(self.paymentChargeSnapshot));
                }
              }
              // Списание с карты (первое или повтор) закрывает удержание только по снимку: повтор делает то же, что
              // просила первая отправка, а не текущий переключатель окна. Пометку из тела запроса убираем.
              let closeHoldAfterSave = closeDepositHold;
              if (body.idempotency_key) {
                closeHoldAfterSave = body.close_deposit_hold === true;
                delete body.close_deposit_hold;
              }
              let keepDialogOpen = false;
              let responded = false;
              self.axios
                .post(
                  `/api/v1/save_count`,
                  body,
                  {
                    headers: {
                      Authorization: self.$store.getters.getAuthToken,
                    },
                  }
                )
                .then((response) => {
                  // 2xx: сервер ответил, исход однозначен — следующий платёж начнётся с нового ключа
                  responded = true;
                  if (body.idempotency_key) self.forgetPendingCharge(body.idempotency_key);
                  // добавляем счета в бронь
                  // Повтор с тем же ключом возвращает строки первой отправки, а getBooking() после неизвестного исхода
                  // мог их уже подтянуть — по id не дублируем.
                  response.data.forEach((count) => {
                    if (!self.booking.counts.some((existing) => existing.id != null && existing.id === count.id)) self.booking.counts.push(count);
                  });
                  // обновляем баланс клиента если оплата с баланса=
                  // баланс — по тому, что ушло на сервер (при повторе списания с карты — снимок первой отправки)
                  if (calcTypePayment(body.departure_payments).client_balance > 0 || calcTypePayment(body.departure_payments).client_balance < 0) {
                    self.client.balance -= calcTypePayment(body.departure_payments).client_balance;
                  }
                  let default_company_cashbox = self.company.company_cashboxes.find((cashbox) => cashbox.is_default == true);
                  self.departure_payments = {
                    rent: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    deposit: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    delivery: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    delivery_end: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    clean: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    hours_cost: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    insurance: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    equipment: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    addons: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox }, // FT-102
                    fine: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    add_drivers_cost: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    gas: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    mileage: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    damage: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                    other: { sum: 0, icon: null, currency_id: default_company_cashbox.currency_id, company_cashbox_id: default_company_cashbox.id, company_cashbox: default_company_cashbox },
                  }
                  self.$notify(self.$t("bookings.payment_save"), "", "success", 3000);
                  // FT-173 STEP-16 (REQ-08, CTR-07): единственное изменение
                  // savePayment — self.$emit из успешной ветки. Обработчик —
                  // в created() (handleRentToOwnPaymentSaved), не здесь.
                  self.$emit("payment-saved");
                  if (closeHoldAfterSave) self.returnDeposit({ afterPayment: true });
                })
                .catch((error) => {
                  // FT-193 NEG-02: списание с карты, а ответа нет (сеть, таймаут) или он 5xx/408/409 locked — сервер мог
                  // провести платёж (409: первый запрос с этим ключом ещё выполняется). Диалог остаётся открытым, ключ сохраняется: повтор вернёт первый результат
                  // и не спишет карту второй раз. Строки, которые сервер успел записать, подтягивает перечитывание.
                  if (!responded && body.idempotency_key && isOutcomeUnknown(error)) {
                    keepDialogOpen = true;
                    self.paymentOutcomeUnknown = true;
                    // W1: поля диалога заперты и показывают снимок, а не то, что успели поменять, пока запрос был в полёте
                    if (self.paymentChargeSnapshot) {
                      self.departure_payments = JSON.parse(JSON.stringify(self.paymentChargeSnapshot.departure_payments));
                    }
                    self.setError(error, self.$t("errors.add_payment"), { silent: true });
                    // 409 locked: первый запрос с этим ключом ещё выполняется — «ответ не получен» тут неверно
                    const inProgress = error && error.response && error.response.status === 409;
                    self.$notify(self.$t("errors.add_payment"), self.$t(inProgress ? "tinkoff.errors.payment_in_progress" : "tinkoff.errors.outcome_unknown"), "warning", 10000);
                    self.getBooking();
                    return;
                  }
                  // FT-193 W1: после неизвестного исхода никакой отказ (4xx, отказ moneyConfirmGuard) ключ не сбрасывает:
                  // по прошлой попытке банк мог уже списать, а отказ относится только к этому повтору. Ключ, флаг и снимок
                  // живут до 2xx или «Начать новый платёж»; диалог остаётся открытым с запертыми полями.
                  if (!responded && body.idempotency_key && self.paymentOutcomeUnknown) {
                    keepDialogOpen = true;
                    self.setError(error, self.$t("errors.add_payment"));
                    return;
                  }
                  // Отказ сервера (422, 406, 403, 404) на первую отправку до записи: ключ отработал, платёж не создан.
                  if (body.idempotency_key) self.forgetPendingCharge(body.idempotency_key);
                  self.setError(error, self.$t("errors.add_payment"));
                })
                .finally(() => {
                  // self.closePaymentDialog()
                  if (!keepDialogOpen) {
                    self.showAddPayment = false;
                    self.payment_dialog = false;
                  }
                  self.isLoadingSavePayment = false;
                });
            }
            // проверка если списание с баланса клиента больше чем есть на балансе
            if ((calcTypePayment(departure_payments).client_balance > 0 || calcTypePayment(departure_payments).client_balance < 0) && self.client.balance - calcTypePayment(departure_payments).client_balance < 0) {
              const confirmed = await this.$confirm({
                title: this.$t("custom.you_sure_title"),
                text: this.$t("counts.client_balance_not_enough"),
                icon: "mdi-alert-outline",
                iconColor: "warning",
                iconSize: 72,
                iconPosition: "top",
                confirmButtonText: this.$t("custom.yes"),
                confirmButtonColor: "primary",
                cancelButtonText: this.$t("custom.no"),
                cancelButtonColor: "grey darken-1",
                useFilledButtons: true,
                maxWidth: 450,
              });
              
              if (confirmed) {
                saveCount();
              }
            } else {
              saveCount();
            }
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // FT-193 W1: незавершённое списание с карты — ключ и неизменный снимок тела первой отправки, в памяти и в
    // sessionStorage по booking.id.
    rememberPendingCharge(body) {
      this.paymentChargeSnapshot = JSON.parse(JSON.stringify(body));
      this.paymentIdempotencyKey = body.idempotency_key;
      writePendingCharge(body.booking_id, this.paymentChargeSnapshot);
    },
    // Сброс — только по ключу завершившегося запроса (или подтверждённого «Начать новый платёж»): чужое, более новое
    // состояние не трогается ни в памяти, ни в sessionStorage. Поздний 2xx на K1 в старом экземпляре карточки не сотрёт
    // K2, начатый в новом (ревью Codex после W1).
    forgetPendingCharge(key) {
      if (!key) return;
      const bookingId = (this.paymentChargeSnapshot && this.paymentChargeSnapshot.booking_id) || (this.booking && this.booking.id);
      if (this.paymentIdempotencyKey === key) {
        this.paymentChargeSnapshot = null;
        this.paymentIdempotencyKey = null;
        this.paymentOutcomeUnknown = false;
      }
      clearPendingCharge(bookingId, key);
    },
    // Карточка открыта (или перезагружена) на бронировании: незавершённое списание с его карты подхватывается из
    // sessionStorage, исход считается неизвестным — повтор уйдёт тем же снимком с тем же ключом. Снимок другого
    // бронирования в памяти не остаётся (в хранилище он ждёт своё бронирование).
    restorePendingCharge(bookingId) {
      const pending = readPendingCharge(bookingId);
      if (!pending) {
        if (this.paymentChargeSnapshot && this.paymentChargeSnapshot.booking_id !== bookingId) {
          this.paymentChargeSnapshot = null;
          this.paymentIdempotencyKey = null;
          this.paymentOutcomeUnknown = false;
        }
        return;
      }
      this.paymentChargeSnapshot = pending;
      this.paymentIdempotencyKey = pending.idempotency_key;
      this.paymentOutcomeUnknown = true;
      this.departure_payments = JSON.parse(JSON.stringify(pending.departure_payments));
    },
    // FT-193 W1: явное действие оператора — отказаться от повтора незавершённого списания и начать новый платёж.
    // Единственный, кроме 2xx, путь сбросить ключ после неизвестного исхода; только с подтверждением, что прошлая
    // попытка могла уже списать деньги.
    async startNewPayment() {
      if (this.isLoadingSavePayment) return;
      const confirmed = await this.$confirm({
        title: this.$t("tinkoff.start_new_payment"),
        text: this.$t("tinkoff.start_new_payment_confirm"),
        icon: "mdi-alert-outline",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: this.$t("tinkoff.start_new_payment"),
        confirmButtonColor: "warning",
        cancelButtonText: this.$t("custom.cancel"),
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 450,
      });
      if (!confirmed || this.isLoadingSavePayment) return;
      this.forgetPendingCharge(this.paymentIdempotencyKey);
    },
    // Устаревшая карточка: бронь уже «Отъездила» — выдача отвечает 409
    // booking_already_returned. Понятный текст и перечитывание вместо общей
    // ошибки и записи в Rollbar; true — обработано.
    handleIssueRefusal(error) {
      if (extractValidationDetail(error).code !== "booking_already_returned") return false;
      this.$notify(this.$t("errors.checkout"), this.$t("bookings.issue_already_returned"), "warning", 8000);
      this.getBooking();
      return true;
    },
    startDepartureDialog(booking) {
      this.isLoadingCheckinCar = true;
      this.axios
        .get(`/api/v1/cars/${booking.car_id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.booking.start_mileage = response.data.mileage;
          this.check_mileage = this.booking.start_mileage;
          this.departureDialog = true;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.get_mileage"));
        })
        .finally(() => (this.isLoadingCheckinCar = false));
    },
    async checkPayments() {
      if (!this.booking.counts.length > 0 && !this.booking.technical) {
        const confirmed = await this.$confirm({
          title: this.$t("bookings.checkin_not_pay_title"),
          text: this.$t("bookings.checkin_not_pay_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.startDepartureDialog(this.booking);
        }
      } else {
        this.startDepartureDialog(this.booking);
      }
    },
    // Только УВЕДОМЛЯЕТ (не блокирует, не возвращает результат): если даты
    // checked_booking пересекаются с другой бронью той же машины — показывает
    // warning-нотификацию. Раньше называлась checkBookingsDates, что вводило в
    // заблуждение (никакого check/return).
    async warnIfCarDatesOverlap(car, checked_booking) {
      let self = this;
      if (car && checked_booking) {
        // Lazy load броней если они еще не загружены
        if (!this.carBookingsLoaded && this.bookings.length === 0) {
          await this.loadCarBookings(car.id);
        }
        let start_date = checked_booking.start_date;
        let end_date = checked_booking.end_date;
        let cars_bookings = this.bookings.filter((booking) => {
          return booking.car_id === car.id && booking.id != checked_booking.id;
        });
        cars_bookings.forEach((booking) => {
          let checked_start_date = moment(start_date, "DD-MM-YYYY H:mm");
          let checked_end_date = moment(end_date, "DD-MM-YYYY H:mm");
          let booking_start_date = moment(
            booking.start_date,
            "DD-MM-YYYY H:mm"
          ).subtract(
            this.$store.getters.getCompany.company.interval_bookings,
            "hours"
          );
          let booking_end_date = moment(
            booking.end_date,
            "DD-MM-YYYY H:mm"
          ).add(
            this.$store.getters.getCompany.company.interval_bookings,
            "hours"
          );
          if (
            checked_start_date.isBetween(
              booking_start_date,
              booking_end_date,
              "hour"
            ) ||
            checked_end_date.isBetween(
              booking_start_date,
              booking_end_date,
              "hour"
            ) ||
            booking_start_date.isBetween(
              checked_start_date,
              checked_end_date,
              "hour"
            ) ||
            booking_end_date.isBetween(
              checked_start_date,
              checked_end_date,
              "hour"
            )
          ) {
            this.$notify(this.$t("errors.booked_title"), this.$t("errors.booked_text"), "warning", 3000)
          }
        });
      }
    },
    findWorker(id) {
      let name;
      if (this.workers.find((worker) => worker.id == id)) {
        name = this.workers.find((worker) => worker.id == id).name
          ? this.workers.find((worker) => worker.id == id).name
          : this.workers.find((worker) => worker.id == id).email;
      }
      if (name) {
        return name;
      } else {
        return id;
      }
    },
    translateFinesState(state) {
      return translateFineStateText(this.$t.bind(this), state);
    },
    stateFineColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Оплачен") {
        return "red";
      }
      if (state == "Возмещён") {
        return "success";
      }
    },
    getTrackerReport() {
      if (this.set_car && this.set_car.traccar_id && this.booking.start_date && this.booking.end_date && this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.traccar_password && this.$store.getters.getCurrentUser.traccar_id) {
        this.isTrackerReportLoading = true;
        let from = moment(this.booking.start_date, "DD-MM-YYYY H:mm").format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        let to = moment(this.booking.end_date, "DD-MM-YYYY H:mm").format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        let report_url = `https://vos-rentprog.ru/api/reports/route?deviceId=${this.set_car.traccar_id}&from=${from}&to=${to}`
        this.axios({
          method: "get",
          url: report_url,
          headers: {
            "Authorization": "Basic " + btoa(`${this.$store.getters.getCurrentUser.email}:${this.$store.getters.getCurrentUser.traccar_password}`),
            "Content-Type": "application/x-www-form-urlencoded"
          },
        })
          .then(report_response => {
            // console.log("report_response", report_response)
            let report_data = report_response.data;
            if (report_data && report_data.length > 0) {
              // сумируем пробег
              let distance = 0;
              report_data.forEach((item, index) => {
                if (index > 0) {
                  distance += item.attributes.distance;
                }
              })
              // определяем среднюю скорость
              let speed = 0;
              report_data.forEach((item, index) => {
                if (item.speed > 10) {
                  speed += item.speed;
                }
              })
              speed = speed / report_data.length;
              // определяем максимальную скорость
              let max_speed = 0;
              report_data.forEach((item, index) => {
                if (item.speed > max_speed) {
                  max_speed = item.speed;
                }
              })
              // создаем объект с данными
              this.tracker_report = {
                distance: parseInt(distance / 1852),
                speed: parseInt(speed * 1.852),
                max_speed: parseInt(max_speed * 1.852),
              }
            } else {
              // создаем объект с данными
              this.tracker_report = {
                distance: 0,
                speed: 0,
                max_speed: 0,
              }
            }
          })
          .catch(error => {
            this.setError(error, this.$t('errors.beacon_load'));
            console.log(error);
          })
          .finally(() => (this.isTrackerReportLoading = false));
      }
    },
    saveBookingState(state, id) {
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        let self = this;
        if (state && id) {
          if (refuseRidedState(this, this.booking, state)) return;
          this.isLoadingSaveState = true;
          this.axios
            .patch(
              `/api/v1/bookings/${id}`,
              {
                bookings: {
                  state: state,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.booking.state = state;
            })
            .catch((error) => {
              // FT-173 контроль V3 (REQ-26): статус, который договор выкупа
              // не допускает, — текст модуля и перечитывание карточки.
              const rentToOwnError = parseRentToOwnError(error);
              if (rentToOwnError && rentToOwnError.code === "managed_by_contract") {
                this.$notify(this.$t("errors.update_state"), this.$t(rentToOwnError.i18nKey), "warning", 6000);
                this.getBooking();
                return;
              }
              if (extractValidationDetail(error).code === "booking_not_returned") {
                this.$notify(this.$t("errors.update_state"), this.$t("bookings.rided_requires_return"), "warning", 8000);
                this.getBooking();
                return;
              }
              this.setError(error, this.$t("errors.update_state"));
            })
            .finally(() => (this.isLoadingSaveState = false));
        } else {
          this.$notify(this.$t("errors.select_state"), "", "error", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    currentDeposit() {
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        let check_number = Number(this.booking.deposit) === this.booking.deposit;
        return check_number ? parseFloat(this.booking.deposit.toFixed(2)) : 0;
      } else if (this.booking.hourly) {
        let check_number = Number(this.booking.hourly_deposit) === this.booking.hourly_deposit;
        return check_number ? parseFloat(this.booking.hourly_deposit.toFixed(2)) : 0;
      } else if (this.booking.weekly) {
        let check_number = Number(this.booking.weekly_deposit) === this.booking.weekly_deposit;
        return check_number ? parseFloat(this.booking.weekly_deposit.toFixed(2)) : 0;
      } else if (this.booking.monthly) {
        let check_number = Number(this.booking.monthly_deposit) === this.booking.monthly_deposit;
        return check_number ? parseFloat(this.booking.monthly_deposit.toFixed(2)) : 0;
      } else {
        let check_number = Number(this.booking.deposit) === this.booking.deposit;
        return check_number ? parseFloat(this.booking.deposit.toFixed(2)) : 0;
      }
    },
    checkEnter(event, booking_id) {
      // Проверяем что нажат только Enter и отправляем сообщение
      // Если нажат Shift + Enter, то переносим строку
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage(booking_id);
      }
    },
    sendMessage(booking_id) {
      if (
        this.new_message &&
        this.new_message.length > 0 &&
        this.new_message != " " &&
        this.new_message.length <= 500 &&
        !this.send_message_loading &&
        booking_id
      ) {
        if (booking_id) {
          this.send_message_loading = true;
          this.axios
            .post("/api/v1/vseprokaty_send_message", {
              booking_id: booking_id,
              body: this.new_message,
            })
            .then((response) => {
              this.new_message = null;
              // booking-scoped vseprokaty chat (this.booking.messages); legacy global store removed (063d-3b)
              this.messages.push(response.data);
              this.send_message_loading = false;
            })
            .catch((error) => {
              this.send_message_loading = false;
              this.setError(error, this.$t("messages.error_send_message"));
              console.log(error);
            });
        } else {
          this.setError(null, this.$t("messages.error_send_message"));
        }
      }
    },
    selectIcon(sender) {
      if (sender == "User") {
        return "mdi-account-alert";
      } else if (sender == "Host") {
        return "mdi-home-account";
      } else if (sender == "Admin") {
        return "mdi-account-cog-outline";
      } else {
        return "mdi-robot-outline";
      }
    },
    returnDate(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD H:mm").format("DD MMM H:mm");
      } else {
        return "-";
      }
    },
    formatCreatedAtWithYear(date) {
      if (date) {
        return moment.parseZone(date).format("DD-MM-YY H:mm");
      } else {
        return "-";
      }
    },
    // durationNowAndCteatedAt(date) {
    //   if (date) {
    //     return moment.duration(moment().diff(moment(date).add(1, 'hours'))).asMilliseconds() * -1
    //   } else {
    //     return 0;
    //   }
    // },
    checkCashPayment() {
      if (this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company.cash_payment;
      }
    },
    checkCardToCardPayment() {
      if (this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company.card_to_card_payment;
      }
    },
    checkCashlessPayment() {
      if (this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company.cashless_payment;
      }
    },
    checkEntityPayment() {
      if (this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company.entity_payment;
      }
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("DD MMM H:mm");
    },
    formatPrologDate(date) {
      return moment.utc(date).format("DD MMM H:mm");
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        this.paymentsPanel = [];
        this.prolongsPanel = [];
        this.giftsPanel = [];
        return true;
      } else {
        this.paymentsPanel = 0;
        this.prolongsPanel = 0;
        this.giftsPanel = 0;
        this.isMobile = false;
        return false;
      }
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
    closePaymentDialog() {
      this.showAddPayment = false;
      this.payment_dialog = false;
    },
    closeArrivalDialog() {
      this.showArrivalPayments = false;
      this.showProblems = false;
      this.dont_send_review_reminder = false;
      this.showPartRejection = false;
      this.partReturnDeposit = false;
      this.giveFullDeposit = true;
      this.giveNullDeposit = false;
      this.showCleanPaid = false;
      // !!!!
      // this.client = "";
      this.arrival_payments = {
        rent: { sum: 0, icon: null, currency_id: null },
        clean: { sum: 0, icon: null, currency_id: null },
        delivery: { sum: 0, icon: null, currency_id: null },
        delivery_end: { sum: 0, icon: null, currency_id: null },
        additional_hours: { sum: 0, icon: null, currency_id: null },
        insurance: { sum: 0, icon: null, currency_id: null },
        add_drivers_cost: { sum: 0, icon: null, currency_id: null },
        gas: { sum: 0, icon: null, currency_id: null },
        equipment: { sum: 0, icon: null, currency_id: null },
        mileage: { sum: 0, icon: null, currency_id: null },
        fine: { sum: 0, icon: null, currency_id: null },
        damage: { sum: 0, icon: null, currency_id: null },
        other: { sum: 0, icon: null, currency_id: null },
        deposit: { sum: 0, icon: null, currency_id: null },
      };
      this.showArrivalDialog = false;
    },
    editDebt(id) {
      this.debt = this.debts.find((debt) => debt.id == id);
      this.editDebtDialog = true;
    },
    saveDebt() {
      if (this.isStaff) {
        let debt = this.debt;
        let self = this;
        if (debt.sum && debt.client_id && debt.group) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/debts/${debt.id}`,
              {
                debts: {
                  sum: debt.sum,
                  state: debt.state,
                  group: debt.group,
                  description: debt.description,
                  client_id: debt.client_id,
                  booking_id: debt.booking_id,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.debts.findIndex(
                (element) => element.id === debt.id
              );
              this.debts.splice(foundIndex, 1, response.data);

              this.debt = {
                sum: null,
                state: "Создан",
                description: null,
                group: "Аренда",
                client_id: null,
                booking_id: null,
              };
              this.editDebtDialog = false;

              this.$notify(this.$t("custom.success"), "", "success", 3000)
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_state_deb"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), this.$t("errors.most_field_debt"), "warning", 4000)
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    getAgents() {
      this.isLoadingGetAgents = true;
      this.axios
        .get("/api/v1/get_agents", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          let active_agents = response.data.filter(agent => agent.active == true);
          this.agents = active_agents;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong in getAgents");
        })
        .finally(() => (this.isLoadingGetAgents = false));
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    stateDebtColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Оплачен") {
        return "success";
      }
      if (state == "Не оплачен") {
        return "red";
      }
    },
    // FT-200 REQ-07 (U9): ссылку клиенту собирает api — домен проката, закодированные параметры и подписанный код
    // компании `c`. Фамилия бронирования без букв — ссылка не предлагается (clientPageLinkBlocked), запрос не уходит;
    // 422 last_name_without_letters — запасной путь, если карточка устарела. Сеть — совет проверить подключение,
    // 404/5xx — нейтральный текст. Запись в буфер начинается в жесте (copyTextWhenReady): Safari не пускает её после
    // await запроса.
    async copyClientPageLink() {
      if (this.clientPageLinkLoading || !this.booking || !this.booking.id) return;
      if (this.clientPageLinkBlocked) {
        this.$notify(this.$t("client_page.staff_link.no_last_name"), this.$t("client_page.staff_link.no_last_name_hint"), "warning");
        return;
      }
      this.clientPageLinkLoading = true;
      try {
        const linkRequest = this.axios
          .get(`/api/v1/bookings/${this.booking.id}/client_page_link`, {
            headers: { Authorization: this.$store.getters.getAuthToken },
          })
          .then((response) => (response && response.data && response.data.url) || null);
        const copied = copyTextWhenReady(
          linkRequest.then((url) => {
            if (!url) throw new Error("client_page_link_missing");
            return url;
          })
        );
        // Отказ записи (нет ссылки, отказ api) обрабатывается ниже — не «unhandled rejection» до того.
        copied.catch(() => {});
        let url;
        try {
          url = await linkRequest;
        } catch (error) {
          const response = error && error.response;
          if (response && response.status === 422 && response.data && response.data.error === "last_name_without_letters") {
            this.$notify(this.$t("client_page.staff_link.no_last_name"), this.$t("client_page.staff_link.no_last_name_hint"), "warning");
          } else {
            // Ответ сервера есть (404, 5xx, другой отказ) — с подключением всё в порядке, совет про интернет не к месту.
            const key = response ? "client_page.staff_link.unavailable" : "client_page.staff_link.failed";
            this.$notify(this.$t(key), "", "error");
          }
          return;
        }
        if (!url) {
          this.$notify(this.$t("client_page.staff_link.unavailable"), "", "error");
          return;
        }
        try {
          await copied;
          this.$notify(this.$t("custom.copy_success"), "", "success");
        } catch (error) {
          this.$notify(this.$t("custom.copy_error"), "", "error");
        }
      } finally {
        this.clientPageLinkLoading = false;
      }
    },
    goToWhatsapp(client) {
      window.open(waHref(client.phone, client.country), "_blank");
    },
    getCountryCodeByCountry(country) {
      // Словарь кодов стран
      const countryCodes = {
        // Европа
        'Russia': '7', 'Россия': '7',
        'Portugal': '351', 'Португалия': '351',
        'Spain': '34', 'Испания': '34',
        'Germany': '49', 'Германия': '49',
        'France': '33', 'Франция': '33',
        'Italy': '39', 'Италия': '39',
        'UK': '44', 'United Kingdom': '44', 'Великобритания': '44', 'England': '44', 'Англия': '44',
        'Poland': '48', 'Польша': '48',
        'Czech Republic': '420', 'Чехия': '420', 'Czechia': '420',
        'Serbia': '381', 'Сербия': '381',
        'Montenegro': '382', 'Черногория': '382',
        'Austria': '43', 'Австрия': '43',
        'Belgium': '32', 'Бельгия': '32',
        'Netherlands': '31', 'Нидерланды': '31', 'Holland': '31', 'Голландия': '31',
        'Switzerland': '41', 'Швейцария': '41',
        'Sweden': '46', 'Швеция': '46',
        'Norway': '47', 'Норвегия': '47',
        'Denmark': '45', 'Дания': '45',
        'Finland': '358', 'Финляндия': '358',
        'Greece': '30', 'Греция': '30',
        'Ireland': '353', 'Ирландия': '353',
        'Croatia': '385', 'Хорватия': '385',
        'Slovenia': '386', 'Словения': '386',
        'Slovakia': '421', 'Словакия': '421',
        'Hungary': '36', 'Венгрия': '36',
        'Romania': '40', 'Румыния': '40',
        'Bulgaria': '359', 'Болгария': '359',
        'Albania': '355', 'Албания': '355',
        'Bosnia and Herzegovina': '387', 'Босния и Герцеговина': '387',
        'North Macedonia': '389', 'Северная Македония': '389', 'Macedonia': '389', 'Македония': '389',
        'Lithuania': '370', 'Литва': '370',
        'Latvia': '371', 'Латвия': '371',
        'Estonia': '372', 'Эстония': '372',
        'Moldova': '373', 'Молдова': '373',
        'Luxembourg': '352', 'Люксембург': '352',
        'Iceland': '354', 'Исландия': '354',
        'Malta': '356', 'Мальта': '356',
        'Cyprus': '357', 'Кипр': '357',
        
        // СНГ и постсоветские страны
        'Kazakhstan': '7', 'Казахстан': '7',
        'Belarus': '375', 'Беларусь': '375',
        'Ukraine': '380', 'Украина': '380',
        'Georgia': '995', 'Грузия': '995',
        'Armenia': '374', 'Армения': '374',
        'Azerbaijan': '994', 'Азербайджан': '994',
        'Uzbekistan': '998', 'Узбекистан': '998',
        'Kyrgyzstan': '996', 'Киргизия': '996', 'Кыргызстан': '996',
        'Tajikistan': '992', 'Таджикистан': '992',
        'Turkmenistan': '993', 'Туркменистан': '993',
        
        // Ближний Восток и Северная Африка
        'Turkey': '90', 'Турция': '90',
        'UAE': '971', 'ОАЭ': '971', 'United Arab Emirates': '971',
        'Saudi Arabia': '966', 'Саудовская Аравия': '966',
        'Israel': '972', 'Израиль': '972',
        'Egypt': '20', 'Египет': '20',
        'Morocco': '212', 'Марокко': '212',
        'Tunisia': '216', 'Тунис': '216',
        'Algeria': '213', 'Алжир': '213',
        'Libya': '218', 'Ливия': '218',
        'Jordan': '962', 'Иордания': '962',
        'Lebanon': '961', 'Ливан': '961',
        'Qatar': '974', 'Катар': '974',
        'Bahrain': '973', 'Бахрейн': '973',
        'Kuwait': '965', 'Кувейт': '965',
        'Oman': '968', 'Оман': '968',
        'Iraq': '964', 'Ирак': '964',
        'Iran': '98', 'Иран': '98',
        'Syria': '963', 'Сирия': '963',
        'Yemen': '967', 'Йемен': '967',
        
        // Азия
        'Thailand': '66', 'Таиланд': '66',
        'China': '86', 'Китай': '86',
        'Japan': '81', 'Япония': '81',
        'South Korea': '82', 'Южная Корея': '82', 'Korea': '82', 'Корея': '82',
        'India': '91', 'Индия': '91',
        'Pakistan': '92', 'Пакистан': '92',
        'Bangladesh': '880', 'Бангладеш': '880',
        'Vietnam': '84', 'Вьетнам': '84',
        'Philippines': '63', 'Филиппины': '63',
        'Indonesia': '62', 'Индонезия': '62',
        'Malaysia': '60', 'Малайзия': '60',
        'Singapore': '65', 'Сингапур': '65',
        'Cambodia': '855', 'Камбоджа': '855',
        'Laos': '856', 'Лаос': '856',
        'Myanmar': '95', 'Мьянма': '95', 'Burma': '95', 'Бирма': '95',
        'Sri Lanka': '94', 'Шри-Ланка': '94',
        'Nepal': '977', 'Непал': '977',
        'Mongolia': '976', 'Монголия': '976',
        'Taiwan': '886', 'Тайвань': '886',
        'Hong Kong': '852', 'Гонконг': '852',
        'Macau': '853', 'Макао': '853',
        'Afghanistan': '93', 'Афганистан': '93',
        
        // Северная Америка
        'USA': '1', 'США': '1', 'United States': '1', 'US': '1',
        'Canada': '1', 'Канада': '1',
        'Mexico': '52', 'Мексика': '52',
        
        // Центральная Америка и Карибы
        'Cuba': '53', 'Куба': '53',
        'Dominican Republic': '1', 'Доминиканская Республика': '1',
        'Jamaica': '1', 'Ямайка': '1',
        'Haiti': '509', 'Гаити': '509',
        'Costa Rica': '506', 'Коста-Рика': '506',
        'Panama': '507', 'Панама': '507',
        'Guatemala': '502', 'Гватемала': '502',
        'Honduras': '504', 'Гондурас': '504',
        'Nicaragua': '505', 'Никарагуа': '505',
        'El Salvador': '503', 'Сальвадор': '503',
        'Belize': '501', 'Белиз': '501',
        
        // Южная Америка
        'Argentina': '54', 'Аргентина': '54',
        'Brazil': '55', 'Бразилия': '55',
        'Chile': '56', 'Чили': '56',
        'Colombia': '57', 'Колумбия': '57',
        'Ecuador': '593', 'Эквадор': '593',
        'Peru': '51', 'Перу': '51',
        'Venezuela': '58', 'Венесуэла': '58',
        'Uruguay': '598', 'Уругвай': '598',
        'Paraguay': '595', 'Парагвай': '595',
        'Bolivia': '591', 'Боливия': '591',
        'Guyana': '592', 'Гайана': '592',
        'Suriname': '597', 'Суринам': '597',
        
        // Африка
        'South Africa': '27', 'ЮАР': '27', 'Южная Африка': '27',
        'Nigeria': '234', 'Нигерия': '234',
        'Kenya': '254', 'Кения': '254',
        'Ethiopia': '251', 'Эфиопия': '251',
        'Ghana': '233', 'Гана': '233',
        'Tanzania': '255', 'Танзания': '255',
        'Uganda': '256', 'Уганда': '256',
        'Zimbabwe': '263', 'Зимбабве': '263',
        'Mozambique': '258', 'Мозамбик': '258',
        'Angola': '244', 'Ангола': '244',
        'Cameroon': '237', 'Камерун': '237',
        'Ivory Coast': '225', 'Кот-д\'Ивуар': '225',
        'Senegal': '221', 'Сенегал': '221',
        'Madagascar': '261', 'Мадагаскар': '261',
        'Zambia': '260', 'Замбия': '260',
        'Mali': '223', 'Мали': '223',
        'Namibia': '264', 'Намибия': '264',
        'Botswana': '267', 'Ботсвана': '267',
        'Rwanda': '250', 'Руанда': '250',
        
        // Океания
        'Australia': '61', 'Австралия': '61',
        'New Zealand': '64', 'Новая Зеландия': '64',
        'Fiji': '679', 'Фиджи': '679',
        'Papua New Guinea': '675', 'Папуа - Новая Гвинея': '675'
      };
      
      return countryCodes[country] || null;
    },
    translateCountGroup(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    translateState(state) {
      let group_text = "";
      switch (state) {
        case "Новая":
          group_text = this.$t("bookings_states.new");
          break;
        case "В обработке":
          group_text = this.$t("bookings_states.in_work");
          break;
        case "Отказ клиента":
          group_text = this.$t("bookings_states.decline");
          break;
        case "Нет машин":
          group_text = this.$t("bookings_states.no_cars");
          break;
        case "Недозвон":
          group_text = this.$t("bookings_states.abandoned");
          break;
        case "Ожидает ответа клиента":
          group_text = this.$t("bookings_states.wait_answer");
          break;
        case "Ожидает оплаты":
          group_text = this.$t("bookings_states.wait_pay");
          break;
        case "Активная":
          group_text = this.$t("bookings_states.active");
          break;
        case "Отмена":
          group_text = this.$t("bookings_states.cancel");
          break;
        case "Отъездила":
          group_text = this.$t("bookings_states.rided");
          break;
        case "Вернуть залог":
          group_text = this.$t("bookings_states.return_deposit");
          break;
        case "Подтверждена":
          group_text = this.$t("bookings_states.accepted");
          break;
        case "Не подтверждена":
          group_text = this.$t("bookings_states.not_accepted");
          break;
        case "Другое":
          group_text = this.$t("bookings_states.other");
          break;
      }
      return group_text;
    },
    downloadIcalendar(id) {
      this.axios.get(`/api/v1/bookings/icalendar_file/${id}`, {
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((response) => {
          const blob_data = new Blob([response.data], { type: "text/calendar" });
          if (!this.isNative) {
            saveAs(blob_data, 'booking.ics');
          } else {
            if (Filesystem.checkPermissions()) {
              const getBase64FromBlob = async (blob) => {
                return new Promise((resolve) => {
                  const reader = new FileReader();
                  reader.readAsDataURL(blob);
                  reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                  }
                });
              }
              getBase64FromBlob(blob_data).then(
                (base64) => {
                  // save file
                  async function writeFile() {
                    return await Filesystem.writeFile({
                      path: 'booking.ics',
                      data: base64,
                      directory: Directory.Documents,
                    });
                  }
                  let file_uri = null
                  let writedFile = writeFile().then((getUriResult) => {
                    // share file opened file
                    let shareFile = async () => {
                      await Share.share({
                        title: 'Download document iCalendar format',
                        files: [getUriResult.uri],
                      }).catch((error) => {
                        console.log("shareFile", error)
                      });
                    };
                    let sharedFile = shareFile();
                  }).catch((error) => {
                    console.log("shareFile", error)
                  });
                }
              );
            } else {
              Filesystem.requestPermissions();
            }
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        });
    },
    includedInPlan(service) {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan) {
          if (this.$store.getters.getMainCompany.plan.included_services) {
            // check trial period
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment()) && service != 'multicashboxes' && service != 'multicurrency') {
              return true;
            }
            return this.$store.getters.getMainCompany.plan.included_services.includes(service);
          }
        }
      }
      return false;
    },
    openSigningLink(link) {
      window.open(link, "_blank");
    },
    downloadDocusealDocument(link) {
      // Для DocuSeal документов - просто открываем внешнюю ссылку
      // Браузер автоматически предложит скачать PDF
      window.open(link, "_blank");
    },
    showTaxiPaymentModel(mode) {
      if (mode == 0) {
        return this.$t("taxi.payment_models.daily_rate");
      } else if (mode == 1) {
        return this.$t("taxi.payment_models.percent_only");
      } else if (mode == 2) {
        return this.$t("taxi.payment_models.daily_plus_percent");
      }
      return this.$t("taxi.payment_models.daily_rate");
    },
    unsubscribe() {
      // FT-066: drop the held native subs (was wrapper-based unsubscribe by channel name).
      this.subscribedBookingId = null;
      this.subscribedCompanyId = null;
      this.$cableUnsubscribe(this.bookingSub);
      this.bookingSub = null;
      this.$cableUnsubscribe(this.tinkoffSub);
      this.tinkoffSub = null;
    },
  },
  components: {
    BookingAddonsPanel,
    RentToOwnPanel,
    LoadFailedRetry,
    TaskCardSection,
    TaskFormDialog,
    BookingHeader,
    BookingDebts,
    BookingFines,
    DepositHoldBlock,
    BookingInvoices,
    DepartureDialog,
    ArrivalDialog,
    PaymentDialog,
    ProlongDialog,
    UppyCheckin,
    Gallery,
    PdfDocuments,
    OkidokiContractDialog,
    DocusealContractDialog,
    CarDamageMarker,
    BookingActIcon,
    AgentMarker,
  },
};
</script>
<style>
.vl {
  border-left: 1px solid black;
  height: auto;
  margin-right: 1% !important;
  margin-left: 1% !important;
}

.counts_payment_dialog .v-data-footer__select {
  margin-left: 0 !important;
}
</style>
<style scoped>
/* FT-108: sticky-сводка editDialog (REQ-01, REQ-05).
   Скролл-контейнер fullscreen-диалога — .v-dialog--fullscreen (overflow-y: auto),
   промежуточные v-card / v-card-text / v-container overflow не режут — sticky
   работает относительно него (OQ-01: живая проверка — за оркестратором). */
/* FT-111: три ступени кегля вместо семи — 12px подписи и контролы,
   15px числа и заголовки панелей, 20px номер брони и итог. Соседние ступени
   различались на 7-15%, и 13px подписи, 15px числа, 16px заголовки читались
   как один уровень. */
.ft108-summary h2 {
  font-size: 1.25rem;
  line-height: 1.3;
}
.ft108-summary {
  position: sticky;
  top: 0;
  /* выше контента формы (у .ft108-panels z-index: auto — см. ниже), но НИЖЕ
     инлайнового поповера vc-date-picker (z-index: 10); оверлеи Vuetify
     (menu, dialog) живут в отдельном overlay-контейнере с z-index 200+ */
  z-index: 4;
  background-color: #ffffff;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.25);
  /* внутренние отступы + воздух до тела формы — эталон: макет .summary
     (padding 14px 16px + margin-bottom); без них контент прижат к краям
     (подтверждено USER на стенде) */
  padding: 14px 16px 10px;
  margin-bottom: 12px;
}
.theme--dark .ft108-summary {
  background-color: #1e1e1e;
}
/* FT-108: базовая раскладка строки «номер + чипы +
   тумблеры» — flex независимо от isMobile (см. комментарий у разметки:
   isMobile залипает после ресайза). На desktop контент помещается в одну
   строку (эталон макета .row1: номер + чипы слева, тумблеры справа через
   spacer); wrap срабатывает только когда реально тесно. */
.ft108-summary .ft108-headline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 8px;
}
/* статусы — одной группой: на desktop продолжают строку номера, на узком
   экране уезжают своей строкой целиком (см. media-блок ниже) */
.ft108-summary .ft108-status-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
}
/* FT-108 v2: блок режимов справа в шапке — два сегмента одного размера на
   одной базовой линии; названия настроек живут в самих вариантах. */
.ft108-summary .ft108-modes {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
}
/* сегмент режима: компактные кнопки без вуетифаевского капса и разрядки —
   это выбор режима, а не призыв к действию */
.ft108-summary .ft108-mode-toggle .v-btn {
  min-width: 0;
  height: 28px;
  padding: 0 12px;
  text-transform: none;
  letter-spacing: 0;
  font-size: 0.75rem;
}

/* FT-108 v2: строка слагаемых. Подписи приглушены, числа — акцент
   (табличные цифры, чтобы суммы не «плясали» при пересчёте) */
.ft108-summary .ft108-totals {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 18px;
  margin-top: 8px;
}
.ft108-summary .ft108-t {
  font-size: 0.75rem;
  color: #757575;
  white-space: nowrap;
}
.theme--dark .ft108-summary .ft108-t {
  color: #9e9e9e;
}
.ft108-summary .ft108-t b {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  font-size: 0.9375rem;
  font-variant-numeric: tabular-nums;
}
.theme--dark .ft108-summary .ft108-t b {
  color: #ffffff;
}
/* итог отделён от слагаемых: прижат вправо и отбит линией */
.ft108-summary .ft108-rate {
  margin-left: 6px;
}
.ft108-summary .ft108-grand {
  margin-left: auto;
  padding-left: 18px;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
.theme--dark .ft108-summary .ft108-grand {
  border-left-color: rgba(255, 255, 255, 0.12);
}
.ft108-summary .ft108-grand b {
  font-size: 1.25rem;
}
.ft108-summary .ft108-grand-parts {
  margin-left: 6px;
  font-size: 0.75rem;
}
/* строка деталей режима (frozen / ручная правка): тихая строка, не алерт */
.ft108-summary .ft108-mode-hint {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: #ef6c00;
  margin-top: 4px;
}
.theme--dark .ft108-summary .ft108-mode-hint {
  color: #ffb74d;
}
.ft108-summary .ft108-mode-hint--error {
  color: #c62828;
}
.theme--dark .ft108-summary .ft108-mode-hint--error {
  color: #ef9a9a;
}
/* «Сезоны»: текстовая кнопка в строке слагаемых, прижата к правому краю */
.ft108-summary .ft108-seasons-toggle {
  background: none;
  border: 0;
  padding: 0;
  margin-left: 16px;
  font: inherit;
  font-size: 0.75rem;
  color: #1976d2;
  white-space: nowrap;
  cursor: pointer;
}
.theme--dark .ft108-summary .ft108-seasons-toggle {
  color: #64b5f6;
}
.ft108-summary .ft108-seasons-toggle:hover,
.ft108-summary .ft108-seasons-toggle:focus-visible {
  text-decoration: underline;
}
.ft108-summary .ft108-seasons {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.theme--dark .ft108-summary .ft108-seasons {
  border-top-color: rgba(255, 255, 255, 0.12);
}
/* действие в строке-подсказке — ссылка внутри фразы, а не третий тип кнопки:
   у сегментов своя роль (выбор режима), у ссылки своя (разовое действие) */
.ft108-summary .ft108-hint-action {
  background: none;
  border: 0;
  padding: 0;
  margin-left: 8px;
  font: inherit;
  color: #1976d2;
  cursor: pointer;
}
.theme--dark .ft108-summary .ft108-hint-action {
  color: #64b5f6;
}
.ft108-summary .ft108-hint-action:hover,
.ft108-summary .ft108-hint-action:focus-visible {
  text-decoration: underline;
}

/* REQ-05: компактность сводки на мобильном */
@media (max-width: 600px) {
  /* Шапка «номер + статусы + режим» на узком экране расходится ПО СТРОКАМ:
     номер / чипы статусов / сегмент режима. Раньше все три ехали одним
     потоком с переносом и row-gap 2px — чип активности оказывался впритык к
     сегменту расчёта, и верх сводки читался сплошным комом (USER
     2026-08-24). Своя строка каждой сущности + row-gap 8px разводят их.
     justify-content НЕ растягиваем: содержимое строки прижато влево. */
  .ft108-summary .ft108-headline {
    row-gap: 8px;
  }
  .ft108-summary .ft108-status-chips {
    width: 100%;
  }
  .ft108-summary .ft108-modes {
    width: 100%;
    gap: 8px;
  }
  /* Сегмент режима — во всю ширину, варианты делят её поровну. Раньше
     сегменты стояли по фактической ширине текста и на 375px оказывались
     впритык к соседнему чипу: верх сводки читался сплошным комом
     (USER 2026-08-24). Полная ширина заодно даёт варианту нормальную зону
     нажатия пальцем. */
  .ft108-summary .ft108-mode-toggle {
    width: 100%;
  }
  .ft108-summary .ft108-mode-toggle .v-btn {
    flex: 1 1 0;
    padding: 0 8px;
  }
  .ft108-summary h2 {
    font-size: 1.1rem;
  }
  /* На узком экране строка слагаемых перестаёт быть строкой: каждая пара
     встаёт своей строкой «подпись слева — число справа», как в чеке. Одним
     потоком с переносом это читалось сплошняком, а итог терял вес и выглядел
     ещё одним слагаемым. */
  .ft108-summary .ft108-totals {
    display: block;
    margin-top: 8px;
  }
  .ft108-summary .ft108-t {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 1px 0;
  }
  .ft108-summary .ft108-rate {
  margin-left: 6px;
}
.ft108-summary .ft108-grand {
    margin-left: 0;
    padding-left: 0;
    border-left: 0;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    flex-wrap: wrap;
  }
  .theme--dark .ft108-summary .ft108-grand {
    border-top-color: rgba(255, 255, 255, 0.12);
  }
  /* пояснение «без залога» — своей строкой под итогом, по правому краю */
  /* строка аренды при ложном равенстве имеет третий элемент (ставка) — без
     переноса сумма уезжала бы в середину «чековой» строки */
  .ft108-summary .ft108-t {
    flex-wrap: wrap;
  }
  .ft108-summary .ft108-rate {
    flex-basis: 100%;
    margin-left: 0;
    text-align: right;
  }
  .ft108-summary .ft108-grand-parts {
    flex-basis: 100%;
    margin-left: 0;
    text-align: right;
  }
  /* «Сезоны» — своей строкой по правому краю, чтобы не влезать между
     слагаемыми и итогом */
  .ft108-summary .ft108-seasons-toggle {
    display: block;
    width: 100%;
    margin: 4px 0 0;
    text-align: right;
  }
  /* на мобильном отступы сводки компактнее (REQ-05) */
  .ft108-summary {
    padding: 10px 12px 8px;
    margin-bottom: 8px;
  }
  .ft108-summary .ft108-totals {
    gap: 2px 12px;
  }
  /* чипы в одну строку с переносом, без раздувания вертикали */
  .ft108-summary .v-chip {
    margin-top: 2px;
    margin-bottom: 2px;
  }
  .ft108-summary .flex {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
}

/* FT-108 (REQ-05): панели секций — full-width по умолчанию */
.ft108-panels {
  margin-bottom: 12px;
  /* Vuetify даёт .v-expansion-panels (= .v-item-group: position: relative)
     z-index: 1 — это stacking context. Поповер vc-date-picker (v-calendar 2)
     рендерится ВНУТРИ панели «Даты» (position: absolute, z-index: 10), а не в
     overlay-контейнере Vuetify, поэтому снаружи весь блок панелей — слой 1,
     и sticky-сводка (z-index: 4) закрывала календарь, когда тот раскрывался
     вверх (iPhone: низкий вьюпорт, поповер флипает над полем). z-index: auto
     снимает контекст: поповер конкурирует со сводкой напрямую (10 > 4),
     а сводка по-прежнему выше тел панелей (у тех z-index auto).
     Регресс: tests/unit/bookings/editDialogPickerStacking.spec.js */
  z-index: auto;
}
.ft108-panels .ft108-panel-head {
  display: flex;
  align-items: center;
  min-width: 0;
}
.ft108-panels .ft108-panel-title {
  font-weight: 500;
  font-size: 0.9375rem;
  white-space: nowrap;
}
/* Значение секции в заголовке (STEP-04, REQ-04): обрезка с многоточием, как
   в макете (.panel-h .val) */
.ft108-panels .ft108-panel-val {
  color: #757575;
  font-size: 0.75rem;
  margin-left: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
/* ссылка на карточку клиента в заголовке панели: подчёркивание только по
   наведению — в свёрнутом виде это в первую очередь значение секции */
.ft108-panels .ft108-panel-val a {
  color: #1976d2;
  text-decoration: none;
}
.theme--dark .ft108-panels .ft108-panel-val a {
  color: #64b5f6;
}
.ft108-panels .ft108-panel-val a:hover,
.ft108-panels .ft108-panel-val a:focus-visible {
  text-decoration: underline;
}
/* STEP-04 (REQ-04): точка-индикатор изменённой секции — оранжевая 7px, как
   в макете (.panel-h .dot); держится у заголовка, не сжимается */
.ft108-panels .ft108-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #ff9800;
  display: inline-block;
  flex: 0 0 auto;
  margin-left: 6px;
}
@media (max-width: 600px) {
  /* REQ-05: компактные заголовки панелей на мобильном */
  .ft108-panels .v-expansion-panel-header {
    padding: 10px 12px;
    min-height: 44px;
  }
  /* STEP-04 (REQ-04, макет body.mobile): значение переезжает под заголовок
     отдельной строкой — flex-basis 100% + wrap; subdued-размер; ellipsis
     остаётся, вьюпорт не распирает (min-width: 0 у head) */
  .ft108-panels .ft108-panel-head {
    flex-wrap: wrap;
  }
  .ft108-panels .ft108-panel-val {
    flex-basis: 100%;
    order: 3;
    margin-left: 26px; /* под текст заголовка: ширина иконки (16px) + mr-2 */
    font-size: 0.75rem;
  }
}
</style>
